// This file is auto-generated by @hey-api/openapi-ts

import {
  type Client,
  formDataBodySerializer,
  type Options as Options2,
  type TDataShape,
} from './client';
import { client } from './client.gen';
import type {
  AcceptInvitationData,
  AcceptInvitationErrors,
  AcceptInvitationResponses,
  AcknowledgeUserAttentionData,
  AcknowledgeUserAttentionErrors,
  AcknowledgeUserAttentionResponses,
  ActivateSigningRequestData,
  ActivateSigningRequestErrors,
  ActivateSigningRequestResponses,
  AddCalendarPermissionRolesData,
  AddCalendarPermissionRolesErrors,
  AddCalendarPermissionRolesResponses,
  AddCalendarPermissionUsersData,
  AddCalendarPermissionUsersErrors,
  AddCalendarPermissionUsersResponses,
  AddCalendarReceiversData,
  AddCalendarReceiversErrors,
  AddCalendarReceiversResponses,
  AddCalendarSourceContractsData,
  AddCalendarSourceContractsErrors,
  AddCalendarSourceContractsResponses,
  AddCalendarSourceDirectoriesData,
  AddCalendarSourceDirectoriesErrors,
  AddCalendarSourceDirectoriesResponses,
  AddClauseToContractFileData,
  AddClauseToContractFileErrors,
  AddClauseToContractFileResponses,
  AddColumnData,
  AddColumnErrors,
  AddColumnResponses,
  AddContractTypeColumnsData,
  AddContractTypeColumnsErrors,
  AddContractTypeColumnsResponses,
  AddContractualPartyRepresentativeData,
  AddContractualPartyRepresentativeErrors,
  AddContractualPartyRepresentativeResponses,
  AddContractualPartyToContractFileData,
  AddContractualPartyToContractFileErrors,
  AddContractualPartyToContractFileResponses,
  AddDocumentsData,
  AddDocumentsErrors,
  AddDocumentsResponses,
  AddMatterToContractData,
  AddMatterToContractErrors,
  AddMatterToContractResponses,
  AddObligationToContractFileData,
  AddObligationToContractFileErrors,
  AddObligationToContractFileResponses,
  AddParticipantData,
  AddParticipantErrors,
  AddParticipantResponses,
  AddPlaybookEvaluationGroupEvaluationData,
  AddPlaybookEvaluationGroupEvaluationErrors,
  AddPlaybookEvaluationGroupEvaluationResponses,
  AddPromptColumnData,
  AddPromptColumnErrors,
  AddPromptColumnResponses,
  AddPromptToPromptCollectionData,
  AddPromptToPromptCollectionErrors,
  AddPromptToPromptCollectionResponses,
  AddReviewProjectMemberData,
  AddReviewProjectMemberErrors,
  AddReviewProjectMemberResponses,
  AddViewSourceContractsData,
  AddViewSourceContractsErrors,
  AddViewSourceContractsResponses,
  AddViewSourceDirectoriesData,
  AddViewSourceDirectoriesErrors,
  AddViewSourceDirectoriesResponses,
  AdminSwitchOrganisationData,
  AdminSwitchOrganisationErrors,
  AdminSwitchOrganisationResponses,
  AnswerReviewProjectQuestionExternalData,
  AnswerReviewProjectQuestionExternalErrors,
  AnswerReviewProjectQuestionExternalResponses,
  AssignUsersToRoleData,
  AssignUsersToRoleErrors,
  AssignUsersToRoleResponses,
  BulkContractShareData,
  BulkContractShareErrors,
  BulkContractShareResponses,
  BulkContractualPartyShareData,
  BulkContractualPartyShareErrors,
  BulkContractualPartyShareResponses,
  BulkMoveVaultItemsData,
  BulkMoveVaultItemsErrors,
  BulkMoveVaultItemsResponses,
  BulkReassignVaultOwnerData,
  BulkReassignVaultOwnerErrors,
  BulkReassignVaultOwnerResponses,
  BulkVaultShareData,
  BulkVaultShareErrors,
  BulkVaultShareResponses,
  CancelSigningRequestData,
  CancelSigningRequestErrors,
  CancelSigningRequestResponses,
  ConfigureSlackAgentData,
  ConfigureSlackAgentErrors,
  ConfigureSlackAgentResponses,
  ConfirmEmailVerificationData,
  ConfirmEmailVerificationErrors,
  ConfirmEmailVerificationResponses,
  ConnectJiraData,
  ConnectJiraErrors,
  ConnectJiraResponses,
  ConnectOrganisationGoogleDriveData,
  ConnectOrganisationGoogleDriveErrors,
  ConnectOrganisationGoogleDriveResponses,
  ConnectPersonalGoogleDriveData,
  ConnectPersonalGoogleDriveErrors,
  ConnectPersonalGoogleDriveResponses,
  ConnectSlackData,
  ConnectSlackErrors,
  ConnectSlackResponses,
  ConvertContractToFileData,
  ConvertContractToFileErrors,
  ConvertContractToFileResponses,
  ConvertContractToFolderData,
  ConvertContractToFolderErrors,
  ConvertContractToFolderResponses,
  ConvertPdfToDocxData,
  ConvertPdfToDocxErrors,
  ConvertPdfToDocxResponses,
  ConvertVaultFileToContractData,
  ConvertVaultFileToContractErrors,
  ConvertVaultFileToContractResponses,
  CreateAgentRun2Data,
  CreateAgentRun2Errors,
  CreateAgentRun2Responses,
  CreateAgentRunData,
  CreateAgentRunErrors,
  CreateAgentRunResponses,
  CreateAllowListEntryData,
  CreateAllowListEntryErrors,
  CreateAllowListEntryResponses,
  CreateAutoTagTaskGroupData,
  CreateAutoTagTaskGroupErrors,
  CreateAutoTagTaskGroupResponses,
  CreateChangelogData,
  CreateChangelogErrors,
  CreateChangelogResponses,
  CreateClauseData,
  CreateClauseErrors,
  CreateClauseResponses,
  CreateCollectionAiData,
  CreateCollectionAiErrors,
  CreateCollectionAiResponses,
  CreateCollectionData,
  CreateCollectionErrors,
  CreateCollectionResponses,
  CreateContractManagementCalendarData,
  CreateContractManagementCalendarErrors,
  CreateContractManagementCalendarResponses,
  CreateContractManagementClauseData,
  CreateContractManagementClauseErrors,
  CreateContractManagementClauseResponses,
  CreateContractManagementContractFileData,
  CreateContractManagementContractFileDateData,
  CreateContractManagementContractFileDateErrors,
  CreateContractManagementContractFileDateResponses,
  CreateContractManagementContractFileErrors,
  CreateContractManagementContractFileResponses,
  CreateContractManagementContractualPartyData,
  CreateContractManagementContractualPartyErrors,
  CreateContractManagementContractualPartyResponses,
  CreateContractManagementExtractionOverwriteData,
  CreateContractManagementExtractionOverwriteErrors,
  CreateContractManagementExtractionOverwriteResponses,
  CreateContractManagementMatterData,
  CreateContractManagementMatterErrors,
  CreateContractManagementMatterResponses,
  CreateContractManagementObligationData,
  CreateContractManagementObligationErrors,
  CreateContractManagementObligationResponses,
  CreateContractManagementViewData,
  CreateContractManagementViewErrors,
  CreateContractManagementViewFromPreviewData,
  CreateContractManagementViewFromPreviewErrors,
  CreateContractManagementViewFromPreviewResponses,
  CreateContractManagementViewResponses,
  CreateContractTypeData,
  CreateContractTypeErrors,
  CreateContractTypeResponses,
  CreateDataRoomDirectoryData,
  CreateDataRoomDirectoryErrors,
  CreateDataRoomDirectoryResponses,
  CreateDataRoomFileData,
  CreateDataRoomFileErrors,
  CreateDataRoomFileResponses,
  CreateDraftData,
  CreateDraftErrors,
  CreateDraftResponses,
  CreateExtractionPromptData,
  CreateExtractionPromptErrors,
  CreateExtractionPromptResponses,
  CreateFieldData,
  CreateFieldErrors,
  CreateFieldResponses,
  CreateFileReviewsData,
  CreateFileReviewsErrors,
  CreateFileReviewsResponses,
  CreateGaiaClauseData,
  CreateGaiaClauseErrors,
  CreateGaiaClauseResponses,
  CreateGaiaTokenData,
  CreateGaiaTokenErrors,
  CreateGaiaTokenResponses,
  CreateIntakeAgentData,
  CreateIntakeAgentErrors,
  CreateIntakeAgentResponses,
  CreateInvitationData,
  CreateInvitationErrors,
  CreateInvitationResponses,
  CreateKanbanCommentData,
  CreateKanbanCommentErrors,
  CreateKanbanCommentResponses,
  CreateKanbanStateData,
  CreateKanbanStateErrors,
  CreateKanbanStateResponses,
  CreateModelPricingData,
  CreateModelPricingErrors,
  CreateModelPricingResponses,
  CreateOrganisationData,
  CreateOrganisationErrors,
  CreateOrganisationMemoryData,
  CreateOrganisationMemoryErrors,
  CreateOrganisationMemoryResponses,
  CreateOrganisationResponses,
  CreateOverwriteData,
  CreateOverwriteErrors,
  CreateOverwriteResponses,
  CreateOwnOrganisationData,
  CreateOwnOrganisationErrors,
  CreateOwnOrganisationResponses,
  CreatePlaybookData,
  CreatePlaybookErrors,
  CreatePlaybookEvaluationData,
  CreatePlaybookEvaluationErrors,
  CreatePlaybookEvaluationGroupData,
  CreatePlaybookEvaluationGroupErrors,
  CreatePlaybookEvaluationGroupResponses,
  CreatePlaybookEvaluationResponses,
  CreatePlaybookFromTemplateData,
  CreatePlaybookFromTemplateErrors,
  CreatePlaybookFromTemplateResponses,
  CreatePlaybookGroupTriggerData,
  CreatePlaybookGroupTriggerErrors,
  CreatePlaybookGroupTriggerResponses,
  CreatePlaybookOptionData,
  CreatePlaybookOptionErrors,
  CreatePlaybookOptionResponses,
  CreatePlaybookResponses,
  CreatePlaybookTriggerActionData,
  CreatePlaybookTriggerActionErrors,
  CreatePlaybookTriggerActionResponses,
  CreatePlaybookTriggerData,
  CreatePlaybookTriggerErrors,
  CreatePlaybookTriggerResponses,
  CreateReportTaskGroupData,
  CreateReportTaskGroupErrors,
  CreateReportTaskGroupResponses,
  CreateReviewData,
  CreateReviewErrors,
  CreateReviewProjectAnalysisData,
  CreateReviewProjectAnalysisErrors,
  CreateReviewProjectAnalysisResponses,
  CreateReviewProjectData,
  CreateReviewProjectErrors,
  CreateReviewProjectQuestionData,
  CreateReviewProjectQuestionErrors,
  CreateReviewProjectQuestionResponses,
  CreateReviewProjectResponses,
  CreateReviewProjectTagData,
  CreateReviewProjectTagErrors,
  CreateReviewProjectTagResponses,
  CreateReviewResponses,
  CreateRoleData,
  CreateRoleErrors,
  CreateRoleResponses,
  CreateSectionData,
  CreateSectionErrors,
  CreateSectionResponses,
  CreateSigningRequestData,
  CreateSigningRequestErrors,
  CreateSigningRequestResponses,
  CreateTemplateData,
  CreateTemplateErrors,
  CreateTemplateQuestionData,
  CreateTemplateQuestionErrors,
  CreateTemplateQuestionResponses,
  CreateTemplateResponses,
  CreateTemplateVariantData,
  CreateTemplateVariantErrors,
  CreateTemplateVariantResponses,
  CreateUserMemoryData,
  CreateUserMemoryErrors,
  CreateUserMemoryResponses,
  CreateVaultDirectoryData,
  CreateVaultDirectoryErrors,
  CreateVaultDirectoryResponses,
  CreateVaultFileData,
  CreateVaultFileErrors,
  CreateVaultFileResponses,
  CreateWebsocketTicketData,
  CreateWebsocketTicketResponses,
  CreateYoutrustIntegrationData,
  CreateYoutrustIntegrationErrors,
  CreateYoutrustIntegrationResponses,
  DeleteAllowListEntryData,
  DeleteAllowListEntryErrors,
  DeleteAllowListEntryResponses,
  DeleteChangelogData,
  DeleteChangelogErrors,
  DeleteChangelogResponses,
  DeleteClauseData,
  DeleteClauseErrors,
  DeleteClauseResponses,
  DeleteCmViewQuestionColumnData,
  DeleteCmViewQuestionColumnErrors,
  DeleteCmViewQuestionColumnResponses,
  DeleteCollectionData,
  DeleteCollectionErrors,
  DeleteCollectionResponses,
  DeleteContractManagementCalendarData,
  DeleteContractManagementCalendarErrors,
  DeleteContractManagementCalendarResponses,
  DeleteContractManagementClauseData,
  DeleteContractManagementClauseErrors,
  DeleteContractManagementClauseResponses,
  DeleteContractManagementContractData,
  DeleteContractManagementContractErrors,
  DeleteContractManagementContractFileData,
  DeleteContractManagementContractFileErrors,
  DeleteContractManagementContractFileResponses,
  DeleteContractManagementContractResponses,
  DeleteContractManagementContractualPartyData,
  DeleteContractManagementContractualPartyErrors,
  DeleteContractManagementContractualPartyResponses,
  DeleteContractManagementDateData,
  DeleteContractManagementDateErrors,
  DeleteContractManagementDateResponses,
  DeleteContractManagementExtractionOverwriteData,
  DeleteContractManagementExtractionOverwriteErrors,
  DeleteContractManagementExtractionOverwriteResponses,
  DeleteContractManagementMatterData,
  DeleteContractManagementMatterErrors,
  DeleteContractManagementMatterResponses,
  DeleteContractManagementObligationData,
  DeleteContractManagementObligationErrors,
  DeleteContractManagementObligationResponses,
  DeleteContractManagementViewData,
  DeleteContractManagementViewErrors,
  DeleteContractManagementViewResponses,
  DeleteContractTypeData,
  DeleteContractTypeErrors,
  DeleteContractTypeResponses,
  DeleteDocumentData,
  DeleteDocumentErrors,
  DeleteDocumentResponses,
  DeleteExtractionPromptData,
  DeleteExtractionPromptErrors,
  DeleteExtractionPromptResponses,
  DeleteFieldData,
  DeleteFieldErrors,
  DeleteFieldResponses,
  DeleteFileReviewData,
  DeleteFileReviewErrors,
  DeleteFileReviewResponses,
  DeleteGaiaClauseData,
  DeleteGaiaClauseErrors,
  DeleteGaiaClauseResponses,
  DeleteGaiaTokenData,
  DeleteGaiaTokenResponses,
  DeleteIntakeAgentData,
  DeleteIntakeAgentErrors,
  DeleteIntakeAgentResponses,
  DeleteKanbanCommentData,
  DeleteKanbanCommentErrors,
  DeleteKanbanCommentResponses,
  DeleteKanbanStateData,
  DeleteKanbanStateErrors,
  DeleteKanbanStateResponses,
  DeleteModelPricingData,
  DeleteModelPricingErrors,
  DeleteModelPricingResponses,
  DeleteOrganisationEndpointData,
  DeleteOrganisationEndpointErrors,
  DeleteOrganisationEndpointResponses,
  DeleteOrganisationMemoryData,
  DeleteOrganisationMemoryErrors,
  DeleteOrganisationMemoryResponses,
  DeleteOverwriteData,
  DeleteOverwriteErrors,
  DeleteOverwriteResponses,
  DeleteParticipantData,
  DeleteParticipantErrors,
  DeleteParticipantResponses,
  DeletePlaybookActionData,
  DeletePlaybookActionErrors,
  DeletePlaybookActionResponses,
  DeletePlaybookData,
  DeletePlaybookErrors,
  DeletePlaybookEvaluationData,
  DeletePlaybookEvaluationErrors,
  DeletePlaybookEvaluationGroupData,
  DeletePlaybookEvaluationGroupErrors,
  DeletePlaybookEvaluationGroupResponses,
  DeletePlaybookEvaluationResponses,
  DeletePlaybookGroupTriggersData,
  DeletePlaybookGroupTriggersErrors,
  DeletePlaybookGroupTriggersResponses,
  DeletePlaybookOptionData,
  DeletePlaybookOptionErrors,
  DeletePlaybookOptionResponses,
  DeletePlaybookResponses,
  DeletePlaybookRunData,
  DeletePlaybookRunErrors,
  DeletePlaybookRunResponses,
  DeletePlaybookTriggerData,
  DeletePlaybookTriggerErrors,
  DeletePlaybookTriggerResponses,
  DeletePromptColumnData,
  DeletePromptColumnErrors,
  DeletePromptColumnResponses,
  DeletePromptFromPromptCollectionData,
  DeletePromptFromPromptCollectionErrors,
  DeletePromptFromPromptCollectionResponses,
  DeleteReviewProjectAnalysisData,
  DeleteReviewProjectAnalysisErrors,
  DeleteReviewProjectAnalysisResponses,
  DeleteReviewProjectData,
  DeleteReviewProjectErrors,
  DeleteReviewProjectQuestionData,
  DeleteReviewProjectQuestionErrors,
  DeleteReviewProjectQuestionResponses,
  DeleteReviewProjectResponses,
  DeleteReviewProjectTagData,
  DeleteReviewProjectTagErrors,
  DeleteReviewProjectTagResponses,
  DeleteReviewUuidData,
  DeleteReviewUuidErrors,
  DeleteReviewUuidResponses,
  DeleteRoleData,
  DeleteRoleErrors,
  DeleteRoleResponses,
  DeleteSectionData,
  DeleteSectionErrors,
  DeleteSectionResponses,
  DeleteSigningRequestData,
  DeleteSigningRequestErrors,
  DeleteSigningRequestResponses,
  DeleteTemplateData,
  DeleteTemplateErrors,
  DeleteTemplateFieldData,
  DeleteTemplateFieldErrors,
  DeleteTemplateFieldResponses,
  DeleteTemplateQuestionData,
  DeleteTemplateQuestionErrors,
  DeleteTemplateQuestionResponses,
  DeleteTemplateResponses,
  DeleteTemplateVariantData,
  DeleteTemplateVariantErrors,
  DeleteTemplateVariantResponses,
  DeleteThread2Data,
  DeleteThread2Errors,
  DeleteThread2Responses,
  DeleteThread3Data,
  DeleteThread3Errors,
  DeleteThread3Responses,
  DeleteThreadData,
  DeleteThreadErrors,
  DeleteThreadResponses,
  DeleteUserData,
  DeleteUserErrors,
  DeleteUserMemoryData,
  DeleteUserMemoryErrors,
  DeleteUserMemoryResponses,
  DeleteUserResponses,
  DeleteVaultDirectoryData,
  DeleteVaultDirectoryErrors,
  DeleteVaultDirectoryResponses,
  DeleteVaultFileData,
  DeleteVaultFileErrors,
  DeleteVaultFileResponses,
  DeleteVaultFileRevisionData,
  DeleteVaultFileRevisionErrors,
  DeleteVaultFileRevisionResponses,
  DeleteYoutrustIntegrationData,
  DeleteYoutrustIntegrationResponses,
  DisableJiraWebhookData,
  DisableJiraWebhookErrors,
  DisableJiraWebhookResponses,
  DisconnectJiraData,
  DisconnectJiraResponses,
  DisconnectOrganisationGoogleDriveData,
  DisconnectOrganisationGoogleDriveResponses,
  DisconnectPersonalGoogleDriveData,
  DisconnectPersonalGoogleDriveResponses,
  DisconnectSlackData,
  DisconnectSlackResponses,
  DownloadMaterializedData,
  DownloadMaterializedErrors,
  DownloadMaterializedResponses,
  DownloadVaultDirectoryZipData,
  DownloadVaultDirectoryZipErrors,
  DownloadVaultDirectoryZipResponses,
  DuplicateDraftData,
  DuplicateDraftErrors,
  DuplicateDraftResponses,
  DuplicateVaultFileNameData,
  DuplicateVaultFileNameErrors,
  DuplicateVaultFileNameResponses,
  EmailIntakeData,
  EmailIntakeErrors,
  EmailIntakeResponses,
  EnableJiraWebhookData,
  EnableJiraWebhookErrors,
  EnableJiraWebhookResponses,
  ExampleTargetPostData,
  ExampleTargetPostErrors,
  ExampleTargetPostResponses,
  ExchangeExternalAccessTokenData,
  ExchangeExternalAccessTokenErrors,
  ExchangeExternalAccessTokenResponses,
  ExitSimulationData2,
  ExitSimulationErrors,
  ExitSimulationResponses,
  ExitSimulationSpreadsheetData,
  ExitSimulationSpreadsheetErrors,
  ExitSimulationSpreadsheetResponses,
  ExportCapTableData,
  ExportCapTableErrors,
  ExportCapTableResponses,
  ExportPlaybookRunEvaluationsData,
  ExportPlaybookRunEvaluationsErrors,
  ExportPlaybookRunEvaluationsResponses,
  ExportPlaybookRunSummaryData,
  ExportPlaybookRunSummaryErrors,
  ExportPlaybookRunSummaryResponses,
  ExportVaultFileToGaiaData,
  ExportVaultFileToGaiaErrors,
  ExportVaultFileToGaiaResponses,
  ExposeToolConfirmationSchemasData,
  ExposeToolConfirmationSchemasErrors,
  ExposeToolConfirmationSchemasResponses,
  ExposeUserQuestionSchemasData,
  ExposeUserQuestionSchemasErrors,
  ExposeUserQuestionSchemasResponses,
  ExposeWebsocketSchemasData,
  ExposeWebsocketSchemasErrors,
  ExposeWebsocketSchemasResponses,
  ExtractInformationBatchData,
  ExtractInformationBatchErrors,
  ExtractInformationBatchResponses,
  ExtractInformationData,
  ExtractInformationErrors,
  ExtractInformationResponses,
  ExtractOrganisationMissingExtractionsData,
  ExtractOrganisationMissingExtractionsErrors,
  ExtractOrganisationMissingExtractionsResponses,
  FinalizeDataRoomFileUploadData,
  FinalizeDataRoomFileUploadErrors,
  FinalizeDataRoomFileUploadResponses,
  FinalizeDraftData,
  FinalizeDraftErrors,
  FinalizeDraftResponses,
  FinalizeVaultFileRevisionUploadData,
  FinalizeVaultFileRevisionUploadErrors,
  FinalizeVaultFileRevisionUploadResponses,
  FinancingSimulationFinancingSimulationData,
  FinancingSimulationFinancingSimulationErrors,
  FinancingSimulationFinancingSimulationResponses,
  FinancingSimulationProrataAmountsData,
  FinancingSimulationProrataAmountsErrors,
  FinancingSimulationProrataAmountsResponses,
  GaiaYoutrustWebhookIntakeData,
  GaiaYoutrustWebhookIntakeResponses,
  GenerateCommentedDocxData,
  GenerateCommentedDocxErrors,
  GenerateCommentedDocxResponses,
  GetAllAvailablePromptsData,
  GetAllAvailablePromptsResponses,
  GetAllOrganisationMemoriesData,
  GetAllOrganisationMemoriesResponses,
  GetAllUserMemoriesData,
  GetAllUserMemoriesResponses,
  GetAnnotationsData,
  GetAnnotationsErrors,
  GetAnnotationsResponses,
  GetAuditTrailData,
  GetAuditTrailErrors,
  GetAuditTrailResponses,
  GetAvailableCountriesData,
  GetAvailableCountriesResponses,
  GetAvailableLlmProvidersData,
  GetAvailableLlmProvidersResponses,
  GetAvailableOcrProvidersData,
  GetAvailableOcrProvidersResponses,
  GetChatStatisticsData,
  GetChatStatisticsErrors,
  GetChatStatisticsResponses,
  GetClauseContractFilesData,
  GetClauseContractFilesErrors,
  GetClauseContractFilesResponses,
  GetClauseData,
  GetClauseErrors,
  GetClauseResponses,
  GetCmViewQuestionColumnData,
  GetCmViewQuestionColumnErrors,
  GetCmViewQuestionColumnResponses,
  GetCombinedSignedDocumentData,
  GetCombinedSignedDocumentErrors,
  GetCombinedSignedDocumentResponses,
  GetContractContractualPartiesData,
  GetContractContractualPartiesErrors,
  GetContractContractualPartiesResponses,
  GetContractFilesForContractData,
  GetContractFilesForContractErrors,
  GetContractFilesForContractResponses,
  GetContractManagementCalendarData,
  GetContractManagementCalendarErrors,
  GetContractManagementCalendarExportData,
  GetContractManagementCalendarExportErrors,
  GetContractManagementCalendarExportResponses,
  GetContractManagementCalendarExportUrlData,
  GetContractManagementCalendarExportUrlErrors,
  GetContractManagementCalendarExportUrlResponses,
  GetContractManagementCalendarResponses,
  GetContractManagementClauseData,
  GetContractManagementClauseErrors,
  GetContractManagementClauseResponses,
  GetContractManagementContractData,
  GetContractManagementContractErrors,
  GetContractManagementContractFileClausesData,
  GetContractManagementContractFileClausesErrors,
  GetContractManagementContractFileClausesResponses,
  GetContractManagementContractFileContractualPartiesData,
  GetContractManagementContractFileContractualPartiesErrors,
  GetContractManagementContractFileContractualPartiesResponses,
  GetContractManagementContractFileData,
  GetContractManagementContractFileDatesData,
  GetContractManagementContractFileDatesErrors,
  GetContractManagementContractFileDatesResponses,
  GetContractManagementContractFileErrors,
  GetContractManagementContractFileObligationsData,
  GetContractManagementContractFileObligationsErrors,
  GetContractManagementContractFileObligationsResponses,
  GetContractManagementContractFileResponses,
  GetContractManagementContractResponses,
  GetContractManagementContractualPartyData,
  GetContractManagementContractualPartyErrors,
  GetContractManagementContractualPartyResponses,
  GetContractManagementMatterData,
  GetContractManagementMatterErrors,
  GetContractManagementMatterResponses,
  GetContractManagementObligationData,
  GetContractManagementObligationErrors,
  GetContractManagementObligationResponses,
  GetContractManagementViewData,
  GetContractManagementViewErrors,
  GetContractManagementViewPreviewData,
  GetContractManagementViewPreviewErrors,
  GetContractManagementViewPreviewResponses,
  GetContractManagementViewResponses,
  GetContractManagementViewTableContractFilesData,
  GetContractManagementViewTableContractFilesErrors,
  GetContractManagementViewTableContractFilesResponses,
  GetContractManagementViewTableData,
  GetContractManagementViewTableErrors,
  GetContractManagementViewTableFilterOptionsData,
  GetContractManagementViewTableFilterOptionsErrors,
  GetContractManagementViewTableFilterOptionsResponses,
  GetContractManagementViewTableResponses,
  GetContractShareByContractData,
  GetContractShareByContractErrors,
  GetContractShareByContractResponses,
  GetContractShareByRoleData,
  GetContractShareByRoleErrors,
  GetContractShareByRoleResponses,
  GetContractShareContractData,
  GetContractShareContractErrors,
  GetContractShareContractResponses,
  GetContractShareUserData,
  GetContractShareUserErrors,
  GetContractShareUserResponses,
  GetContractStatisticsData,
  GetContractStatisticsErrors,
  GetContractStatisticsResponses,
  GetContractTypeUsageData,
  GetContractTypeUsageErrors,
  GetContractTypeUsageResponses,
  GetContractualPartyContractsData,
  GetContractualPartyContractsErrors,
  GetContractualPartyContractsResponses,
  GetContractualPartyRepresentedLegalEntitiesData,
  GetContractualPartyRepresentedLegalEntitiesErrors,
  GetContractualPartyRepresentedLegalEntitiesResponses,
  GetContractualPartyShareByContractualPartyData,
  GetContractualPartyShareByContractualPartyErrors,
  GetContractualPartyShareByContractualPartyResponses,
  GetContractualPartyShareByRoleData,
  GetContractualPartyShareByRoleErrors,
  GetContractualPartyShareByRoleResponses,
  GetContractualPartyShareContractualPartyData,
  GetContractualPartyShareContractualPartyErrors,
  GetContractualPartyShareContractualPartyResponses,
  GetContractualPartyShareUserData,
  GetContractualPartyShareUserErrors,
  GetContractualPartyShareUserResponses,
  GetContractValueMatrixData,
  GetContractValueMatrixErrors,
  GetContractValueMatrixResponses,
  GetContractValuesData,
  GetContractValuesErrors,
  GetContractValuesResponses,
  GetDataRoomDirectoryData,
  GetDataRoomDirectoryErrors,
  GetDataRoomDirectoryResponses,
  GetDemoDataStatusData,
  GetDemoDataStatusErrors,
  GetDemoDataStatusResponses,
  GetDirectoryRoleSharesByDirectoryData,
  GetDirectoryRoleSharesByDirectoryErrors,
  GetDirectoryRoleSharesByDirectoryResponses,
  GetDirectoryRoleSharesByRoleData,
  GetDirectoryRoleSharesByRoleErrors,
  GetDirectoryRoleSharesByRoleResponses,
  GetDirectorySharesByDirectoryData,
  GetDirectorySharesByDirectoryErrors,
  GetDirectorySharesByDirectoryResponses,
  GetDirectorySharesByUserData,
  GetDirectorySharesByUserErrors,
  GetDirectorySharesByUserResponses,
  GetDocumentsData,
  GetDocumentsErrors,
  GetDocumentsResponses,
  GetDraftData,
  GetDraftErrors,
  GetDraftingStatisticsData,
  GetDraftingStatisticsErrors,
  GetDraftingStatisticsResponses,
  GetDraftResponses,
  GetExternalAccessProjectMetaData,
  GetExternalAccessProjectMetaErrors,
  GetExternalAccessProjectMetaResponses,
  GetExtractionByUidData,
  GetExtractionByUidErrors,
  GetExtractionByUidResponses,
  GetExtractionPromptData,
  GetExtractionPromptErrors,
  GetExtractionPromptResponses,
  GetFieldCatalogData,
  GetFieldCatalogResponses,
  GetFieldsData,
  GetFieldsErrors,
  GetFieldsResponses,
  GetFileDataData,
  GetFileDataErrors,
  GetFileDataResponses,
  GetFileLimitsData,
  GetFileLimitsErrors,
  GetFileLimitsResponses,
  GetFilePreviewDataData,
  GetFilePreviewDataErrors,
  GetFilePreviewDataResponses,
  GetFileReviewByUidData,
  GetFileReviewByUidErrors,
  GetFileReviewByUidResponses,
  GetFileRoleSharesByFileData,
  GetFileRoleSharesByFileErrors,
  GetFileRoleSharesByFileResponses,
  GetFileRoleSharesByRoleData,
  GetFileRoleSharesByRoleErrors,
  GetFileRoleSharesByRoleResponses,
  GetFileSharesByFileData,
  GetFileSharesByFileErrors,
  GetFileSharesByFileResponses,
  GetFileSharesByUserData,
  GetFileSharesByUserErrors,
  GetFileSharesByUserResponses,
  GetGaiaClauseData,
  GetGaiaClauseErrors,
  GetGaiaClauseResponses,
  GetGaiaTokenData,
  GetGaiaTokenResponses,
  GetIntakeAgentLogDetailsData,
  GetIntakeAgentLogDetailsErrors,
  GetIntakeAgentLogDetailsResponses,
  GetJiraAuthUrlData,
  GetJiraAuthUrlErrors,
  GetJiraAuthUrlResponses,
  GetJiraStatusData,
  GetJiraStatusResponses,
  GetJiraWebhookData,
  GetJiraWebhookErrors,
  GetJiraWebhookResponses,
  GetLlmUsageStatisticsData,
  GetLlmUsageStatisticsErrors,
  GetLlmUsageStatisticsResponses,
  GetMatterContractsData,
  GetMatterContractsErrors,
  GetMatterContractsResponses,
  GetObligationContractFilesData,
  GetObligationContractFilesErrors,
  GetObligationContractFilesResponses,
  GetOrganisationAllowanceUsageData,
  GetOrganisationAllowanceUsageErrors,
  GetOrganisationAllowanceUsageResponses,
  GetOrganisationData,
  GetOrganisationErrors,
  GetOrganisationGoogleDriveAuthUrlData,
  GetOrganisationGoogleDriveAuthUrlErrors,
  GetOrganisationGoogleDriveAuthUrlResponses,
  GetOrganisationGoogleDriveStatusData,
  GetOrganisationGoogleDriveStatusResponses,
  GetOrganisationMissingExtractionsData,
  GetOrganisationMissingExtractionsErrors,
  GetOrganisationMissingExtractionsResponses,
  GetOrganisationModelSettingsData,
  GetOrganisationModelSettingsErrors,
  GetOrganisationModelSettingsResponses,
  GetOrganisationResponses,
  GetOrganisationStatisticsData,
  GetOrganisationStatisticsErrors,
  GetOrganisationStatisticsResponses,
  GetOwnActiveOrganisationAllowanceUsageData,
  GetOwnActiveOrganisationAllowanceUsageResponses,
  GetOwnActiveOrganisationData,
  GetOwnActiveOrganisationResponses,
  GetOwnOrganisationsData,
  GetOwnOrganisationsResponses,
  GetOwnRolesData,
  GetOwnRolesResponses,
  GetParticipantsData,
  GetParticipantsErrors,
  GetParticipantsResponses,
  GetPersonalGoogleDriveAuthUrlData,
  GetPersonalGoogleDriveAuthUrlErrors,
  GetPersonalGoogleDriveAuthUrlResponses,
  GetPersonalGoogleDriveStatusData,
  GetPersonalGoogleDriveStatusResponses,
  GetPlaybookData,
  GetPlaybookErrors,
  GetPlaybookResponses,
  GetPlaybookRunData,
  GetPlaybookRunErrors,
  GetPlaybookRunResponses,
  GetPlaybookStatisticsData,
  GetPlaybookStatisticsErrors,
  GetPlaybookStatisticsResponses,
  GetPreviewHtmlData,
  GetPreviewHtmlErrors,
  GetPreviewHtmlResponses,
  GetPromptCollectionPromptsData,
  GetPromptCollectionPromptsErrors,
  GetPromptCollectionPromptsResponses,
  GetProviderSigningRequestStatusData,
  GetProviderSigningRequestStatusErrors,
  GetProviderSigningRequestStatusResponses,
  GetReviewByUidData,
  GetReviewByUidErrors,
  GetReviewByUidResponses,
  GetReviewCostData,
  GetReviewCostErrors,
  GetReviewCostResponses,
  GetReviewCsvExportData,
  GetReviewCsvExportErrors,
  GetReviewCsvExportResponses,
  GetReviewProjectAnalysisStatisticsData,
  GetReviewProjectAnalysisStatisticsErrors,
  GetReviewProjectAnalysisStatisticsResponses,
  GetReviewProjectData,
  GetReviewProjectErrors,
  GetReviewProjectFileStatisticsData,
  GetReviewProjectFileStatisticsErrors,
  GetReviewProjectFileStatisticsResponses,
  GetReviewProjectQuestionStatisticsData,
  GetReviewProjectQuestionStatisticsErrors,
  GetReviewProjectQuestionStatisticsResponses,
  GetReviewProjectReportData,
  GetReviewProjectReportErrors,
  GetReviewProjectReportResponses,
  GetReviewProjectResponses,
  GetReviewProjectSeenStatisticsData,
  GetReviewProjectSeenStatisticsErrors,
  GetReviewProjectSeenStatisticsResponses,
  GetReviewProjectTagStatisticsData,
  GetReviewProjectTagStatisticsErrors,
  GetReviewProjectTagStatisticsResponses,
  GetReviewProjectTaskGroupData,
  GetReviewProjectTaskGroupErrors,
  GetReviewProjectTaskGroupResponses,
  GetReviewStatisticsData,
  GetReviewStatisticsErrors,
  GetReviewStatisticsResponses,
  GetReviewTableByUidData,
  GetReviewTableByUidErrors,
  GetReviewTableByUidResponses,
  GetRoleData,
  GetRoleErrors,
  GetRoleResponses,
  GetRoleSharesByTemplateData,
  GetRoleSharesByTemplateErrors,
  GetRoleSharesByTemplateResponses,
  GetSectionData,
  GetSectionErrors,
  GetSectionFilesMetaData,
  GetSectionFilesMetaErrors,
  GetSectionFilesMetaResponses,
  GetSectionGroupsData,
  GetSectionGroupsErrors,
  GetSectionGroupsResponses,
  GetSectionResponses,
  GetSignedDocumentsData,
  GetSignedDocumentsErrors,
  GetSignedDocumentsResponses,
  GetSignerNamePatternData,
  GetSignerNamePatternResponses,
  GetSigningAttentionLinkData,
  GetSigningAttentionLinkErrors,
  GetSigningAttentionLinkResponses,
  GetSigningRequestData,
  GetSigningRequestErrors,
  GetSigningRequestResponses,
  GetSigningRequestStatusHistoryData,
  GetSigningRequestStatusHistoryErrors,
  GetSigningRequestStatusHistoryResponses,
  GetSigningStatisticsData,
  GetSigningStatisticsErrors,
  GetSigningStatisticsResponses,
  GetSlackAuthUrlData,
  GetSlackAuthUrlErrors,
  GetSlackAuthUrlResponses,
  GetSlackStatusData,
  GetSlackStatusResponses,
  GetSpecificOrganisationMemoryData,
  GetSpecificOrganisationMemoryErrors,
  GetSpecificOrganisationMemoryResponses,
  GetSpecificUserMemoryData,
  GetSpecificUserMemoryErrors,
  GetSpecificUserMemoryResponses,
  GetSummaryFileLevelDefaultData,
  GetSummaryFileLevelDefaultResponses,
  GetSystemVaultRootData,
  GetSystemVaultRootErrors,
  GetSystemVaultRootResponses,
  GetTemplateData,
  GetTemplateErrors,
  GetTemplateFieldsData,
  GetTemplateFieldsErrors,
  GetTemplateFieldsResponses,
  GetTemplateResponses,
  GetTemplateSharesByRoleData,
  GetTemplateSharesByRoleErrors,
  GetTemplateSharesByRoleResponses,
  GetTemplateVariantData,
  GetTemplateVariantErrors,
  GetTemplateVariantResponses,
  GetThreadById2Data,
  GetThreadById2Errors,
  GetThreadById2Responses,
  GetThreadById3Data,
  GetThreadById3Errors,
  GetThreadById3Responses,
  GetThreadByIdData,
  GetThreadByIdErrors,
  GetThreadByIdResponses,
  GetUserActivityStatisticsData,
  GetUserActivityStatisticsErrors,
  GetUserActivityStatisticsResponses,
  GetUserStatisticsData,
  GetUserStatisticsErrors,
  GetUserStatisticsResponses,
  GetVaultAncestorsData,
  GetVaultAncestorsErrors,
  GetVaultAncestorsResponses,
  GetVaultDirectoryData,
  GetVaultDirectoryErrors,
  GetVaultDirectoryResponses,
  GetVaultFileByRevisionData,
  GetVaultFileByRevisionErrors,
  GetVaultFileByRevisionResponses,
  GetVaultFileMetadataData,
  GetVaultFileMetadataErrors,
  GetVaultFileMetadataResponses,
  GetVaultFileRevisionDiffData,
  GetVaultFileRevisionDiffErrors,
  GetVaultFileRevisionDiffResponses,
  GetVaultStatisticsData,
  GetVaultStatisticsErrors,
  GetVaultStatisticsResponses,
  GetYoutrustStatusData,
  GetYoutrustStatusResponses,
  HeadFilePreviewDataData,
  HeadFilePreviewDataErrors,
  HeadFilePreviewDataResponses,
  HelperFunctionsLoanInterestData,
  HelperFunctionsLoanInterestErrors,
  HelperFunctionsLoanInterestResponses,
  ImportGaiaFileData,
  ImportGaiaFileErrors,
  ImportGaiaFileResponses,
  ImportGoogleDriveItemsData,
  ImportGoogleDriveItemsErrors,
  ImportGoogleDriveItemsResponses,
  InitializeDataRoomFileUploadData,
  InitializeDataRoomFileUploadErrors,
  InitializeDataRoomFileUploadResponses,
  InitializeVaultFileRevisionUploadData,
  InitializeVaultFileRevisionUploadErrors,
  InitializeVaultFileRevisionUploadResponses,
  JiraIntakeData,
  JiraIntakeErrors,
  JiraIntakeResponses,
  LeaveOwnOrganisationData,
  LeaveOwnOrganisationErrors,
  LeaveOwnOrganisationResponses,
  ListCalendarPermissionRolesData,
  ListCalendarPermissionRolesErrors,
  ListCalendarPermissionRolesResponses,
  ListCalendarPermissionUsersData,
  ListCalendarPermissionUsersErrors,
  ListCalendarPermissionUsersResponses,
  ListCalendarReceiversData,
  ListCalendarReceiversErrors,
  ListCalendarReceiversResponses,
  ListCalendarSourceContractsData,
  ListCalendarSourceContractsErrors,
  ListCalendarSourceContractsResponses,
  ListCalendarSourceDirectoriesData,
  ListCalendarSourceDirectoriesErrors,
  ListCalendarSourceDirectoriesResponses,
  ListChangelogData,
  ListChangelogErrors,
  ListChangelogResponses,
  ListContractTypesData,
  ListContractTypesResponses,
  ListInvitationsData,
  ListInvitationsErrors,
  ListInvitationsResponses,
  ListJiraSitesData,
  ListJiraSitesResponses,
  ListModelPricingData,
  ListModelPricingResponses,
  ListOrganisationGoogleDriveData,
  ListOrganisationGoogleDriveErrors,
  ListOrganisationGoogleDriveResponses,
  ListPersonalGoogleDriveData,
  ListPersonalGoogleDriveErrors,
  ListPersonalGoogleDriveResponses,
  ListPlaybookActionsData,
  ListPlaybookActionsErrors,
  ListPlaybookActionsResponses,
  ListPlaybookClausesData,
  ListPlaybookClausesErrors,
  ListPlaybookClausesResponses,
  ListPlaybookEvaluationGroupsData,
  ListPlaybookEvaluationGroupsErrors,
  ListPlaybookEvaluationGroupsResponses,
  ListPlaybookEvaluationsData,
  ListPlaybookEvaluationsErrors,
  ListPlaybookEvaluationsResponses,
  ListPlaybookGroupTriggersData,
  ListPlaybookGroupTriggersErrors,
  ListPlaybookGroupTriggersResponses,
  ListPlaybookTemplatesData,
  ListPlaybookTemplatesResponses,
  ListReviewProjectAnalysesData,
  ListReviewProjectAnalysesErrors,
  ListReviewProjectAnalysesResponses,
  ListReviewProjectMembersData,
  ListReviewProjectMembersErrors,
  ListReviewProjectMembersResponses,
  ListReviewProjectNonPlatformUsersData,
  ListReviewProjectNonPlatformUsersErrors,
  ListReviewProjectNonPlatformUsersResponses,
  ListReviewProjectTaskGroupsData,
  ListReviewProjectTaskGroupsErrors,
  ListReviewProjectTaskGroupsResponses,
  ListRolesForUserData,
  ListRolesForUserErrors,
  ListRolesForUserResponses,
  ListTemplateQuestionsData,
  ListTemplateQuestionsErrors,
  ListTemplateQuestionsResponses,
  ListTemplateVariantsData,
  ListTemplateVariantsErrors,
  ListTemplateVariantsResponses,
  ListVaultFileRevisionsData,
  ListVaultFileRevisionsErrors,
  ListVaultFileRevisionsResponses,
  ListViewSourceContractsData,
  ListViewSourceContractsErrors,
  ListViewSourceContractsResponses,
  ListViewSourceDirectoriesData,
  ListViewSourceDirectoriesErrors,
  ListViewSourceDirectoriesResponses,
  MarkReviewProjectFilePageSeenData,
  MarkReviewProjectFilePageSeenErrors,
  MarkReviewProjectFilePageSeenResponses,
  MatchTemplateVariantsData,
  MatchTemplateVariantsErrors,
  MatchTemplateVariantsResponses,
  MergeContractManagementClausesData,
  MergeContractManagementClausesErrors,
  MergeContractManagementClausesResponses,
  MergeContractManagementContractualPartiesData,
  MergeContractManagementContractualPartiesErrors,
  MergeContractManagementContractualPartiesResponses,
  MergeContractManagementMattersData,
  MergeContractManagementMattersErrors,
  MergeContractManagementMattersResponses,
  MergeContractManagementObligationsData,
  MergeContractManagementObligationsErrors,
  MergeContractManagementObligationsResponses,
  MoveContractManagementContractFileData,
  MoveContractManagementContractFileErrors,
  MoveContractManagementContractFileResponses,
  PreviewContractManagementCalendarData,
  PreviewContractManagementCalendarErrors,
  PreviewContractManagementCalendarRangeData,
  PreviewContractManagementCalendarRangeErrors,
  PreviewContractManagementCalendarRangeResponses,
  PreviewContractManagementCalendarResponses,
  PreviewWithSampleDataData,
  PreviewWithSampleDataErrors,
  PreviewWithSampleDataResponses,
  ReadActiveOrganisationUserData,
  ReadActiveOrganisationUserErrors,
  ReadActiveOrganisationUserResponses,
  ReadUserData,
  ReadUserErrors,
  ReadUserMeData,
  ReadUserMeResponses,
  ReadUserResponses,
  RefreshExternalAccessTokenData,
  RefreshExternalAccessTokenErrors,
  RefreshExternalAccessTokenResponses,
  RegenerateContractManagementCalendarExportUrlData,
  RegenerateContractManagementCalendarExportUrlErrors,
  RegenerateContractManagementCalendarExportUrlResponses,
  ReloadCacheData,
  ReloadCacheResponses,
  RemoveAllDirectoryRoleSharesByDirectoryData,
  RemoveAllDirectoryRoleSharesByDirectoryErrors,
  RemoveAllDirectoryRoleSharesByDirectoryResponses,
  RemoveAllDirectoryRoleSharesByRoleData,
  RemoveAllDirectoryRoleSharesByRoleErrors,
  RemoveAllDirectoryRoleSharesByRoleResponses,
  RemoveAllDirectorySharesByDirectoryData,
  RemoveAllDirectorySharesByDirectoryErrors,
  RemoveAllDirectorySharesByDirectoryResponses,
  RemoveAllDirectorySharesByUserData,
  RemoveAllDirectorySharesByUserErrors,
  RemoveAllDirectorySharesByUserResponses,
  RemoveAllFileRoleSharesByFileData,
  RemoveAllFileRoleSharesByFileErrors,
  RemoveAllFileRoleSharesByFileResponses,
  RemoveAllFileRoleSharesByRoleData,
  RemoveAllFileRoleSharesByRoleErrors,
  RemoveAllFileRoleSharesByRoleResponses,
  RemoveAllFileSharesByFileData,
  RemoveAllFileSharesByFileErrors,
  RemoveAllFileSharesByFileResponses,
  RemoveAllFileSharesByUserData,
  RemoveAllFileSharesByUserErrors,
  RemoveAllFileSharesByUserResponses,
  RemoveAllRoleSharesByTemplateData,
  RemoveAllRoleSharesByTemplateErrors,
  RemoveAllRoleSharesByTemplateResponses,
  RemoveAllSharesByContract2Data,
  RemoveAllSharesByContract2Errors,
  RemoveAllSharesByContract2Responses,
  RemoveAllSharesByContractData,
  RemoveAllSharesByContractErrors,
  RemoveAllSharesByContractResponses,
  RemoveAllSharesByContractualParty2Data,
  RemoveAllSharesByContractualParty2Errors,
  RemoveAllSharesByContractualParty2Responses,
  RemoveAllSharesByContractualPartyData,
  RemoveAllSharesByContractualPartyErrors,
  RemoveAllSharesByContractualPartyResponses,
  RemoveAllSharesByRole2Data,
  RemoveAllSharesByRole2Errors,
  RemoveAllSharesByRole2Responses,
  RemoveAllSharesByRoleData,
  RemoveAllSharesByRoleErrors,
  RemoveAllSharesByRoleResponses,
  RemoveAllSharesByUser2Data,
  RemoveAllSharesByUser2Errors,
  RemoveAllSharesByUser2Responses,
  RemoveAllSharesByUserData,
  RemoveAllSharesByUserErrors,
  RemoveAllSharesByUserResponses,
  RemoveAllTemplateSharesByRoleData,
  RemoveAllTemplateSharesByRoleErrors,
  RemoveAllTemplateSharesByRoleResponses,
  RemoveCalendarPermissionRolesData,
  RemoveCalendarPermissionRolesErrors,
  RemoveCalendarPermissionRolesResponses,
  RemoveCalendarPermissionUsersData,
  RemoveCalendarPermissionUsersErrors,
  RemoveCalendarPermissionUsersResponses,
  RemoveCalendarReceiversData,
  RemoveCalendarReceiversErrors,
  RemoveCalendarReceiversResponses,
  RemoveCalendarSourceContractsData,
  RemoveCalendarSourceContractsErrors,
  RemoveCalendarSourceContractsResponses,
  RemoveCalendarSourceDirectoriesData,
  RemoveCalendarSourceDirectoriesErrors,
  RemoveCalendarSourceDirectoriesResponses,
  RemoveClauseFromContractFileData,
  RemoveClauseFromContractFileErrors,
  RemoveClauseFromContractFileResponses,
  RemoveContractShare2Data,
  RemoveContractShare2Errors,
  RemoveContractShare2Responses,
  RemoveContractShareData,
  RemoveContractShareErrors,
  RemoveContractShareResponses,
  RemoveContractualPartyFromContractFileData,
  RemoveContractualPartyFromContractFileErrors,
  RemoveContractualPartyFromContractFileResponses,
  RemoveContractualPartyRepresentativeData,
  RemoveContractualPartyRepresentativeErrors,
  RemoveContractualPartyRepresentativeResponses,
  RemoveContractualPartyShare2Data,
  RemoveContractualPartyShare2Errors,
  RemoveContractualPartyShare2Responses,
  RemoveContractualPartyShareData,
  RemoveContractualPartyShareErrors,
  RemoveContractualPartyShareResponses,
  RemoveDirectoryRoleShareData,
  RemoveDirectoryRoleShareErrors,
  RemoveDirectoryRoleShareResponses,
  RemoveDirectoryShareData,
  RemoveDirectoryShareErrors,
  RemoveDirectoryShareResponses,
  RemoveFileRoleShareData,
  RemoveFileRoleShareErrors,
  RemoveFileRoleShareResponses,
  RemoveFileShareData,
  RemoveFileShareErrors,
  RemoveFileShareResponses,
  RemoveMatterFromContractData,
  RemoveMatterFromContractErrors,
  RemoveMatterFromContractResponses,
  RemoveObligationFromContractFileData,
  RemoveObligationFromContractFileErrors,
  RemoveObligationFromContractFileResponses,
  RemovePlaybookEvaluationGroupEvaluationData,
  RemovePlaybookEvaluationGroupEvaluationErrors,
  RemovePlaybookEvaluationGroupEvaluationResponses,
  RemoveReviewProjectMemberData,
  RemoveReviewProjectMemberErrors,
  RemoveReviewProjectMemberResponses,
  RemoveReviewProjectNonPlatformUserData,
  RemoveReviewProjectNonPlatformUserErrors,
  RemoveReviewProjectNonPlatformUserResponses,
  RemoveTemplateRoleShareData,
  RemoveTemplateRoleShareErrors,
  RemoveTemplateRoleShareResponses,
  RemoveUserFromActiveOrganisationData,
  RemoveUserFromActiveOrganisationErrors,
  RemoveUserFromActiveOrganisationResponses,
  RemoveUsersFromRoleData,
  RemoveUsersFromRoleErrors,
  RemoveUsersFromRoleResponses,
  RemoveViewSourceContractsData,
  RemoveViewSourceContractsErrors,
  RemoveViewSourceContractsResponses,
  RemoveViewSourceDirectoriesData,
  RemoveViewSourceDirectoriesErrors,
  RemoveViewSourceDirectoriesResponses,
  RenderTagData,
  RenderTagErrors,
  RenderTagResponses,
  RenderTemplatePreviewData,
  RenderTemplatePreviewErrors,
  RenderTemplatePreviewResponses,
  ReplaceTemplateVariantFileData,
  ReplaceTemplateVariantFileErrors,
  ReplaceTemplateVariantFileResponses,
  RepopulateContractManagementContractData,
  RepopulateContractManagementContractErrors,
  RepopulateContractManagementContractResponses,
  RequestEmailVerificationData,
  RequestEmailVerificationErrors,
  RequestEmailVerificationResponses,
  RequestExternalAccessLinkData,
  RequestExternalAccessLinkErrors,
  RequestExternalAccessLinkResponses,
  ResendInvitationData,
  ResendInvitationErrors,
  ResendInvitationResponses,
  ResolveInvitationData,
  ResolveInvitationErrors,
  ResolveInvitationResponses,
  RestartIntakeAgentLogAdminData,
  RestartIntakeAgentLogAdminErrors,
  RestartIntakeAgentLogAdminResponses,
  RetryOrganisationAgentTaskData,
  RetryOrganisationAgentTaskErrors,
  RetryOrganisationAgentTaskResponses,
  RevokeInvitationData,
  RevokeInvitationErrors,
  RevokeInvitationResponses,
  RotateJiraWebhookData,
  RotateJiraWebhookErrors,
  RotateJiraWebhookResponses,
  SearchActiveOrganisationUsersData,
  SearchActiveOrganisationUsersErrors,
  SearchActiveOrganisationUsersResponses,
  SearchAllowListData,
  SearchAllowListErrors,
  SearchAllowListResponses,
  SearchCalendarContractsData,
  SearchCalendarContractsErrors,
  SearchCalendarContractsResponses,
  SearchClauseData,
  SearchClauseErrors,
  SearchClauseResponses,
  SearchContractFileExtractionsData,
  SearchContractFileExtractionsErrors,
  SearchContractFileExtractionsResponses,
  SearchContractManagementCalendarsData,
  SearchContractManagementCalendarsErrors,
  SearchContractManagementCalendarsResponses,
  SearchContractManagementClausesData,
  SearchContractManagementClausesErrors,
  SearchContractManagementClausesResponses,
  SearchContractManagementContractFilesData,
  SearchContractManagementContractFilesErrors,
  SearchContractManagementContractFilesResponses,
  SearchContractManagementContractsData,
  SearchContractManagementContractsErrors,
  SearchContractManagementContractsResponses,
  SearchContractManagementContractualPartiesData,
  SearchContractManagementContractualPartiesErrors,
  SearchContractManagementContractualPartiesResponses,
  SearchContractManagementMattersData,
  SearchContractManagementMattersErrors,
  SearchContractManagementMattersResponses,
  SearchContractManagementObligationsData,
  SearchContractManagementObligationsErrors,
  SearchContractManagementObligationsResponses,
  SearchContractManagementViewsData,
  SearchContractManagementViewsErrors,
  SearchContractManagementViewsResponses,
  SearchContractTypeClausesData,
  SearchContractTypeClausesErrors,
  SearchContractTypeClausesResponses,
  SearchContractTypeContractsData,
  SearchContractTypeContractsErrors,
  SearchContractTypeContractsResponses,
  SearchContractTypePlaybooksData,
  SearchContractTypePlaybooksErrors,
  SearchContractTypePlaybooksResponses,
  SearchContractTypesData,
  SearchContractTypesErrors,
  SearchContractTypesResponses,
  SearchDataRoomData,
  SearchDataRoomErrors,
  SearchDataRoomResponses,
  SearchDirectoryRoleSharesByDirectoryData,
  SearchDirectoryRoleSharesByDirectoryErrors,
  SearchDirectoryRoleSharesByDirectoryResponses,
  SearchDirectoryRoleSharesByRoleData,
  SearchDirectoryRoleSharesByRoleErrors,
  SearchDirectoryRoleSharesByRoleResponses,
  SearchDirectorySharesByDirectoryData,
  SearchDirectorySharesByDirectoryErrors,
  SearchDirectorySharesByDirectoryResponses,
  SearchDirectorySharesByUserData,
  SearchDirectorySharesByUserErrors,
  SearchDirectorySharesByUserResponses,
  SearchDraftsData,
  SearchDraftsErrors,
  SearchDraftsResponses,
  SearchEquitySectionsData,
  SearchEquitySectionsErrors,
  SearchEquitySectionsResponses,
  SearchExtractionPromptsData,
  SearchExtractionPromptsErrors,
  SearchExtractionPromptsResponses,
  SearchExtractionPromptVersionsData,
  SearchExtractionPromptVersionsErrors,
  SearchExtractionPromptVersionsResponses,
  SearchExtractionsData,
  SearchExtractionsErrors,
  SearchExtractionsResponses,
  SearchFileReviewData,
  SearchFileReviewErrors,
  SearchFileReviewResponses,
  SearchFileRoleSharesByFileData,
  SearchFileRoleSharesByFileErrors,
  SearchFileRoleSharesByFileResponses,
  SearchFileRoleSharesByRoleData,
  SearchFileRoleSharesByRoleErrors,
  SearchFileRoleSharesByRoleResponses,
  SearchFileSharesByFileData,
  SearchFileSharesByFileErrors,
  SearchFileSharesByFileResponses,
  SearchFileSharesByUserData,
  SearchFileSharesByUserErrors,
  SearchFileSharesByUserResponses,
  SearchGaiaClauseData,
  SearchGaiaClauseErrors,
  SearchGaiaClauseResponses,
  SearchIntakeAgentData,
  SearchIntakeAgentErrors,
  SearchIntakeAgentLogAdminData,
  SearchIntakeAgentLogAdminErrors,
  SearchIntakeAgentLogAdminResponses,
  SearchIntakeAgentLogByAgentUidData,
  SearchIntakeAgentLogByAgentUidErrors,
  SearchIntakeAgentLogByAgentUidResponses,
  SearchIntakeAgentResponses,
  SearchKanbanCommentData,
  SearchKanbanCommentErrors,
  SearchKanbanCommentResponses,
  SearchKanbanStateData,
  SearchKanbanStateErrors,
  SearchKanbanStateResponses,
  SearchOrganisationAgentTasksData,
  SearchOrganisationAgentTasksErrors,
  SearchOrganisationAgentTasksResponses,
  SearchOrganisationData,
  SearchOrganisationErrors,
  SearchOrganisationMemoriesData,
  SearchOrganisationMemoriesErrors,
  SearchOrganisationMemoriesResponses,
  SearchOrganisationResponses,
  SearchPlaybookData,
  SearchPlaybookErrors,
  SearchPlaybookResponses,
  SearchPlaybookRunsData,
  SearchPlaybookRunsErrors,
  SearchPlaybookRunsResponses,
  SearchProjectThreadsData,
  SearchProjectThreadsErrors,
  SearchProjectThreadsResponses,
  SearchPromptCollectionData,
  SearchPromptCollectionErrors,
  SearchPromptCollectionResponses,
  SearchReviewData,
  SearchReviewErrors,
  SearchReviewProjectAnalysisDataData,
  SearchReviewProjectAnalysisDataErrors,
  SearchReviewProjectAnalysisDataResponses,
  SearchReviewProjectFilesData,
  SearchReviewProjectFilesErrors,
  SearchReviewProjectFilesResponses,
  SearchReviewProjectQuestionsData,
  SearchReviewProjectQuestionsErrors,
  SearchReviewProjectQuestionsExternalData,
  SearchReviewProjectQuestionsExternalErrors,
  SearchReviewProjectQuestionsExternalResponses,
  SearchReviewProjectQuestionsResponses,
  SearchReviewProjectsData,
  SearchReviewProjectsErrors,
  SearchReviewProjectsResponses,
  SearchReviewProjectTagsData,
  SearchReviewProjectTagsErrors,
  SearchReviewProjectTagsResponses,
  SearchReviewResponses,
  SearchRolesData,
  SearchRolesErrors,
  SearchRolesResponses,
  SearchSharesByContract2Data,
  SearchSharesByContract2Errors,
  SearchSharesByContract2Responses,
  SearchSharesByContractData,
  SearchSharesByContractErrors,
  SearchSharesByContractResponses,
  SearchSharesByContractualParty2Data,
  SearchSharesByContractualParty2Errors,
  SearchSharesByContractualParty2Responses,
  SearchSharesByContractualPartyData,
  SearchSharesByContractualPartyErrors,
  SearchSharesByContractualPartyResponses,
  SearchSharesByRole2Data,
  SearchSharesByRole2Errors,
  SearchSharesByRole2Responses,
  SearchSharesByRole3Data,
  SearchSharesByRole3Errors,
  SearchSharesByRole3Responses,
  SearchSharesByRoleData,
  SearchSharesByRoleErrors,
  SearchSharesByRoleResponses,
  SearchSharesByTemplateData,
  SearchSharesByTemplateErrors,
  SearchSharesByTemplateResponses,
  SearchSharesByUser2Data,
  SearchSharesByUser2Errors,
  SearchSharesByUser2Responses,
  SearchSharesByUserData,
  SearchSharesByUserErrors,
  SearchSharesByUserResponses,
  SearchSigningRequestData,
  SearchSigningRequestErrors,
  SearchSigningRequestResponses,
  SearchSlackChannelsData,
  SearchSlackChannelsErrors,
  SearchSlackChannelsResponses,
  SearchTemplatesData,
  SearchTemplatesErrors,
  SearchTemplatesResponses,
  SearchThreads2Data,
  SearchThreads2Errors,
  SearchThreads2Responses,
  SearchThreadsData,
  SearchThreadsErrors,
  SearchThreadsResponses,
  SearchUserAttentionData,
  SearchUserAttentionErrors,
  SearchUserAttentionResponses,
  SearchUserData,
  SearchUserErrors,
  SearchUserMemoriesData,
  SearchUserMemoriesErrors,
  SearchUserMemoriesResponses,
  SearchUserResponses,
  SearchUsersInRoleData,
  SearchUsersInRoleErrors,
  SearchUsersInRoleResponses,
  SearchVaultData,
  SearchVaultErrors,
  SearchVaultFileIntakeData,
  SearchVaultFileIntakeErrors,
  SearchVaultFileIntakeResponses,
  SearchVaultResponses,
  SelectJiraSiteData,
  SelectJiraSiteErrors,
  SelectJiraSiteResponses,
  SendParticipantReminderData,
  SendParticipantReminderErrors,
  SendParticipantReminderResponses,
  SendSlackTestMessageData,
  SendSlackTestMessageErrors,
  SendSlackTestMessageResponses,
  SetActiveOrganisationUserIsActiveData,
  SetActiveOrganisationUserIsActiveErrors,
  SetActiveOrganisationUserIsActiveResponses,
  SetContractualPartyDefaultRepresentativeData,
  SetContractualPartyDefaultRepresentativeErrors,
  SetContractualPartyDefaultRepresentativeResponses,
  SetDefaultSectionData,
  SetDefaultSectionErrors,
  SetDefaultSectionResponses,
  SetReviewProjectReportData,
  SetReviewProjectReportErrors,
  SetReviewProjectReportResponses,
  SetVariantAnswersData,
  SetVariantAnswersErrors,
  SetVariantAnswersResponses,
  SignupCmData,
  SignupCmErrors,
  SignupCmResponses,
  SignupInsightsData,
  SignupInsightsErrors,
  SignupInsightsResponses,
  SlackCommandsData,
  SlackCommandsResponses,
  SlackEventsData,
  SlackEventsResponses,
  SlackInteractionsData,
  SlackInteractionsResponses,
  SortFolderToEquitySectionData,
  SortFolderToEquitySectionErrors,
  SortFolderToEquitySectionResponses,
  StartDemoDataRemovalData,
  StartDemoDataRemovalErrors,
  StartDemoDataRemovalResponses,
  StartDemoDataSeedingData,
  StartDemoDataSeedingErrors,
  StartDemoDataSeedingResponses,
  StartPlaybookRunData,
  StartPlaybookRunErrors,
  StartPlaybookRunResponses,
  StartVaultDirectoryDownloadData,
  StartVaultDirectoryDownloadErrors,
  StartVaultDirectoryDownloadResponses,
  SwitchToOrganisationData,
  SwitchToOrganisationResponses,
  UnpackVaultFileData,
  UnpackVaultFileErrors,
  UnpackVaultFileResponses,
  UpData,
  UpdateAllowListEntryData,
  UpdateAllowListEntryErrors,
  UpdateAllowListEntryResponses,
  UpdateAnnotationsData,
  UpdateAnnotationsErrors,
  UpdateAnnotationsResponses,
  UpdateChangelogData,
  UpdateChangelogErrors,
  UpdateChangelogResponses,
  UpdateClauseData,
  UpdateClauseErrors,
  UpdateClauseResponses,
  UpdateCmViewQuestionColumnData,
  UpdateCmViewQuestionColumnErrors,
  UpdateCmViewQuestionColumnQuestionData,
  UpdateCmViewQuestionColumnQuestionErrors,
  UpdateCmViewQuestionColumnQuestionResponses,
  UpdateCmViewQuestionColumnResponses,
  UpdateCollectionData,
  UpdateCollectionErrors,
  UpdateCollectionResponses,
  UpdateContractManagementCalendarData,
  UpdateContractManagementCalendarErrors,
  UpdateContractManagementCalendarResponses,
  UpdateContractManagementClauseData,
  UpdateContractManagementClauseErrors,
  UpdateContractManagementClauseResponses,
  UpdateContractManagementContractData,
  UpdateContractManagementContractErrors,
  UpdateContractManagementContractFileData,
  UpdateContractManagementContractFileErrors,
  UpdateContractManagementContractFileResponses,
  UpdateContractManagementContractResponses,
  UpdateContractManagementContractualPartyData,
  UpdateContractManagementContractualPartyErrors,
  UpdateContractManagementContractualPartyResponses,
  UpdateContractManagementDateData,
  UpdateContractManagementDateErrors,
  UpdateContractManagementDateResponses,
  UpdateContractManagementExtractionOverwriteData,
  UpdateContractManagementExtractionOverwriteErrors,
  UpdateContractManagementExtractionOverwriteResponses,
  UpdateContractManagementMatterData,
  UpdateContractManagementMatterErrors,
  UpdateContractManagementMatterResponses,
  UpdateContractManagementObligationData,
  UpdateContractManagementObligationErrors,
  UpdateContractManagementObligationResponses,
  UpdateContractManagementViewData,
  UpdateContractManagementViewErrors,
  UpdateContractManagementViewResponses,
  UpdateContractSharePermissions2Data,
  UpdateContractSharePermissions2Errors,
  UpdateContractSharePermissions2Responses,
  UpdateContractSharePermissionsData,
  UpdateContractSharePermissionsErrors,
  UpdateContractSharePermissionsResponses,
  UpdateContractTypeData,
  UpdateContractTypeErrors,
  UpdateContractTypeResponses,
  UpdateContractualPartySharePermissions2Data,
  UpdateContractualPartySharePermissions2Errors,
  UpdateContractualPartySharePermissions2Responses,
  UpdateContractualPartySharePermissionsData,
  UpdateContractualPartySharePermissionsErrors,
  UpdateContractualPartySharePermissionsResponses,
  UpdateDraftData,
  UpdateDraftErrors,
  UpdateDraftResponses,
  UpdateExtractionByUidData,
  UpdateExtractionByUidErrors,
  UpdateExtractionByUidResponses,
  UpdateExtractionPromptData,
  UpdateExtractionPromptErrors,
  UpdateExtractionPromptResponses,
  UpdateFieldData,
  UpdateFieldErrors,
  UpdateFieldResponses,
  UpdateFileReviewData,
  UpdateFileReviewErrors,
  UpdateFileReviewResponses,
  UpdateGaiaClauseData,
  UpdateGaiaClauseErrors,
  UpdateGaiaClauseResponses,
  UpdateGaiaTokenData,
  UpdateGaiaTokenErrors,
  UpdateGaiaTokenResponses,
  UpdateIntakeAgentData,
  UpdateIntakeAgentErrors,
  UpdateIntakeAgentLogAdminData,
  UpdateIntakeAgentLogAdminErrors,
  UpdateIntakeAgentLogAdminResponses,
  UpdateIntakeAgentPlaybooksData,
  UpdateIntakeAgentPlaybooksErrors,
  UpdateIntakeAgentPlaybooksResponses,
  UpdateIntakeAgentPromptCollectionsData,
  UpdateIntakeAgentPromptCollectionsErrors,
  UpdateIntakeAgentPromptCollectionsResponses,
  UpdateIntakeAgentResponses,
  UpdateInvitationRolesData,
  UpdateInvitationRolesErrors,
  UpdateInvitationRolesResponses,
  UpdateKanbanCommentData,
  UpdateKanbanCommentErrors,
  UpdateKanbanCommentResponses,
  UpdateKanbanStateData,
  UpdateKanbanStateErrors,
  UpdateKanbanStateResponses,
  UpdateLangfuseCollectionByPromptCollectionData,
  UpdateLangfuseCollectionByPromptCollectionErrors,
  UpdateLangfuseCollectionByPromptCollectionResponses,
  UpdateModelPricingData,
  UpdateModelPricingErrors,
  UpdateModelPricingResponses,
  UpdateOrganisationData,
  UpdateOrganisationErrors,
  UpdateOrganisationFeaturesData,
  UpdateOrganisationFeaturesErrors,
  UpdateOrganisationFeaturesResponses,
  UpdateOrganisationMemoryData,
  UpdateOrganisationMemoryErrors,
  UpdateOrganisationMemoryResponses,
  UpdateOrganisationModelSettingsData,
  UpdateOrganisationModelSettingsErrors,
  UpdateOrganisationModelSettingsResponses,
  UpdateOrganisationResponses,
  UpdateOverwriteData,
  UpdateOverwriteErrors,
  UpdateOverwriteResponses,
  UpdateOwnActiveOrganisationData,
  UpdateOwnActiveOrganisationErrors,
  UpdateOwnActiveOrganisationResponses,
  UpdatePlaybookActionData,
  UpdatePlaybookActionErrors,
  UpdatePlaybookActionResponses,
  UpdatePlaybookClauseData,
  UpdatePlaybookClauseErrors,
  UpdatePlaybookClauseResponses,
  UpdatePlaybookData,
  UpdatePlaybookErrors,
  UpdatePlaybookEvaluationData,
  UpdatePlaybookEvaluationErrors,
  UpdatePlaybookEvaluationGroupData,
  UpdatePlaybookEvaluationGroupErrors,
  UpdatePlaybookEvaluationGroupResponses,
  UpdatePlaybookEvaluationResponses,
  UpdatePlaybookGroupTriggerData,
  UpdatePlaybookGroupTriggerErrors,
  UpdatePlaybookGroupTriggerResponses,
  UpdatePlaybookOptionData,
  UpdatePlaybookOptionErrors,
  UpdatePlaybookOptionResponses,
  UpdatePlaybookResponses,
  UpdatePlaybookTriggerData,
  UpdatePlaybookTriggerErrors,
  UpdatePlaybookTriggerResponses,
  UpdatePromptFromPromptCollectionData,
  UpdatePromptFromPromptCollectionErrors,
  UpdatePromptFromPromptCollectionResponses,
  UpdateReviewData,
  UpdateReviewErrors,
  UpdateReviewProjectAnalysisData,
  UpdateReviewProjectAnalysisErrors,
  UpdateReviewProjectAnalysisResponses,
  UpdateReviewProjectData,
  UpdateReviewProjectErrors,
  UpdateReviewProjectFileData,
  UpdateReviewProjectFileErrors,
  UpdateReviewProjectFileResponses,
  UpdateReviewProjectQuestionData,
  UpdateReviewProjectQuestionErrors,
  UpdateReviewProjectQuestionResponses,
  UpdateReviewProjectResponses,
  UpdateReviewProjectTagData,
  UpdateReviewProjectTagErrors,
  UpdateReviewProjectTagResponses,
  UpdateReviewResponses,
  UpdateRoleData,
  UpdateRoleErrors,
  UpdateRoleResponses,
  UpdateSigningRequestData,
  UpdateSigningRequestErrors,
  UpdateSigningRequestResponses,
  UpdateSortIndexesData,
  UpdateSortIndexesErrors,
  UpdateSortIndexesResponses,
  UpdateTemplateData,
  UpdateTemplateErrors,
  UpdateTemplateFieldsData,
  UpdateTemplateFieldsErrors,
  UpdateTemplateFieldsResponses,
  UpdateTemplateQuestionData,
  UpdateTemplateQuestionErrors,
  UpdateTemplateQuestionResponses,
  UpdateTemplateResponses,
  UpdateTemplateRoleSharePermissionsData,
  UpdateTemplateRoleSharePermissionsErrors,
  UpdateTemplateRoleSharePermissionsResponses,
  UpdateTemplateVariantData,
  UpdateTemplateVariantErrors,
  UpdateTemplateVariantResponses,
  UpdateThread2Data,
  UpdateThread2Errors,
  UpdateThread2Responses,
  UpdateThread3Data,
  UpdateThread3Errors,
  UpdateThread3Responses,
  UpdateThreadData,
  UpdateThreadErrors,
  UpdateThreadResponses,
  UpdateUserData,
  UpdateUserErrors,
  UpdateUserMeData,
  UpdateUserMeErrors,
  UpdateUserMemoryData,
  UpdateUserMemoryErrors,
  UpdateUserMemoryResponses,
  UpdateUserMeResponses,
  UpdateUserResponses,
  UpdateVaultDirectoryData,
  UpdateVaultDirectoryErrors,
  UpdateVaultDirectoryResponses,
  UpdateVaultFileData,
  UpdateVaultFileErrors,
  UpdateVaultFileResponses,
  UpdateVaultFileRevisionData,
  UpdateVaultFileRevisionErrors,
  UpdateVaultFileRevisionResponses,
  UploadDataRoomFileChunkData,
  UploadDataRoomFileChunkErrors,
  UploadDataRoomFileChunkResponses,
  UploadVaultFileChunkData,
  UploadVaultFileChunkErrors,
  UploadVaultFileChunkResponses,
  UpResponses,
  UpsertDirectoryRoleShareData,
  UpsertDirectoryRoleShareErrors,
  UpsertDirectoryRoleShareResponses,
  UpsertDirectoryShareData,
  UpsertDirectoryShareErrors,
  UpsertDirectoryShareResponses,
  UpsertFileRoleShareData,
  UpsertFileRoleShareErrors,
  UpsertFileRoleShareResponses,
  UpsertFileShareData,
  UpsertFileShareErrors,
  UpsertFileShareResponses,
  UpsertReviewProjectNonPlatformUserData,
  UpsertReviewProjectNonPlatformUserErrors,
  UpsertReviewProjectNonPlatformUserResponses,
  UpsertTemplateRoleShareData,
  UpsertTemplateRoleShareErrors,
  UpsertTemplateRoleShareResponses,
  UserSwitchOrganisationData,
  UserSwitchOrganisationErrors,
  UserSwitchOrganisationResponses,
  ValidateTemplateFileData,
  ValidateTemplateFileErrors,
  ValidateTemplateFileResponses,
  VestingCalculationLinearVestingData,
  VestingCalculationLinearVestingErrors,
  VestingCalculationLinearVestingResponses,
  VestingCalculationNonLinearVestingData,
  VestingCalculationNonLinearVestingErrors,
  VestingCalculationNonLinearVestingResponses,
  VestingCalculationPotentialValuationData,
  VestingCalculationPotentialValuationErrors,
  VestingCalculationPotentialValuationResponses,
  YoutrustWebhookIntakeData,
  YoutrustWebhookIntakeResponses,
} from './types.gen';

export type Options<
  TData extends TDataShape = TDataShape,
  ThrowOnError extends boolean = boolean,
  TResponse = unknown,
> = Options2<TData, ThrowOnError, TResponse> & {
  /**
   * You can provide a client instance returned by `createClient()` instead of
   * individual options. This might be also useful if you want to implement a
   * custom client.
   */
  client?: Client;
  /**
   * You can pass arbitrary values through the `meta` object. This can be
   * used to access values that aren't defined as part of the SDK function.
   */
  meta?: Record<string, unknown>;
};

/**
 * Up
 */
export const up = <ThrowOnError extends boolean = false>(options?: Options<UpData, ThrowOnError>) =>
  (options?.client ?? client).get<UpResponses, unknown, ThrowOnError>({ url: '/up', ...options });

/**
 * Example Target Post
 */
export const exampleTargetPost = <ThrowOnError extends boolean = false>(
  options: Options<ExampleTargetPostData, ThrowOnError>
) =>
  (options.client ?? client).post<
    ExampleTargetPostResponses,
    ExampleTargetPostErrors,
    ThrowOnError
  >({
    url: '/v1/tasks/example-target/post',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Extract Information
 */
export const extractInformation = <ThrowOnError extends boolean = false>(
  options: Options<ExtractInformationData, ThrowOnError>
) =>
  (options.client ?? client).post<
    ExtractInformationResponses,
    ExtractInformationErrors,
    ThrowOnError
  >({
    url: '/v1/tasks/extract_information',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Extract Information Batch
 */
export const extractInformationBatch = <ThrowOnError extends boolean = false>(
  options: Options<ExtractInformationBatchData, ThrowOnError>
) =>
  (options.client ?? client).post<
    ExtractInformationBatchResponses,
    ExtractInformationBatchErrors,
    ThrowOnError
  >({
    url: '/v1/tasks/extract_information_batch',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Export Cap Table
 */
export const exportCapTable = <ThrowOnError extends boolean = false>(
  options: Options<ExportCapTableData, ThrowOnError>
) =>
  (options.client ?? client).post<ExportCapTableResponses, ExportCapTableErrors, ThrowOnError>({
    url: '/v1/functions/export/cap_table',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Financing Simulation Prorata Amounts
 */
export const financingSimulationProrataAmounts = <ThrowOnError extends boolean = false>(
  options: Options<FinancingSimulationProrataAmountsData, ThrowOnError>
) =>
  (options.client ?? client).post<
    FinancingSimulationProrataAmountsResponses,
    FinancingSimulationProrataAmountsErrors,
    ThrowOnError
  >({
    url: '/v1/functions/financing_simulation/prorata_amounts',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Financing Simulation Financing Simulation
 */
export const financingSimulationFinancingSimulation = <ThrowOnError extends boolean = false>(
  options: Options<FinancingSimulationFinancingSimulationData, ThrowOnError>
) =>
  (options.client ?? client).post<
    FinancingSimulationFinancingSimulationResponses,
    FinancingSimulationFinancingSimulationErrors,
    ThrowOnError
  >({
    url: '/v1/functions/financing_simulation/financing_simulation',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Helper Functions Loan Interest
 */
export const helperFunctionsLoanInterest = <ThrowOnError extends boolean = false>(
  options: Options<HelperFunctionsLoanInterestData, ThrowOnError>
) =>
  (options.client ?? client).post<
    HelperFunctionsLoanInterestResponses,
    HelperFunctionsLoanInterestErrors,
    ThrowOnError
  >({
    url: '/v1/functions/helper_functions/loan_interest',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Exit Simulation
 */
export const exitSimulation = <ThrowOnError extends boolean = false>(
  options: Options<ExitSimulationData2, ThrowOnError>
) =>
  (options.client ?? client).post<ExitSimulationResponses, ExitSimulationErrors, ThrowOnError>({
    url: '/v1/functions/exit_simulation',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Exit Simulation Spreadsheet
 */
export const exitSimulationSpreadsheet = <ThrowOnError extends boolean = false>(
  options: Options<ExitSimulationSpreadsheetData, ThrowOnError>
) =>
  (options.client ?? client).post<
    ExitSimulationSpreadsheetResponses,
    ExitSimulationSpreadsheetErrors,
    ThrowOnError
  >({
    url: '/v1/functions/exit_simulation/spreadsheet',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Vesting Calculation Linear Vesting
 */
export const vestingCalculationLinearVesting = <ThrowOnError extends boolean = false>(
  options: Options<VestingCalculationLinearVestingData, ThrowOnError>
) =>
  (options.client ?? client).post<
    VestingCalculationLinearVestingResponses,
    VestingCalculationLinearVestingErrors,
    ThrowOnError
  >({
    url: '/v1/functions/vesting_calculation/linear_vesting',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Vesting Calculation Non Linear Vesting
 */
export const vestingCalculationNonLinearVesting = <ThrowOnError extends boolean = false>(
  options: Options<VestingCalculationNonLinearVestingData, ThrowOnError>
) =>
  (options.client ?? client).post<
    VestingCalculationNonLinearVestingResponses,
    VestingCalculationNonLinearVestingErrors,
    ThrowOnError
  >({
    url: '/v1/functions/vesting_calculation/non_linear_vesting',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Vesting Calculation Potential Valuation
 */
export const vestingCalculationPotentialValuation = <ThrowOnError extends boolean = false>(
  options: Options<VestingCalculationPotentialValuationData, ThrowOnError>
) =>
  (options.client ?? client).post<
    VestingCalculationPotentialValuationResponses,
    VestingCalculationPotentialValuationErrors,
    ThrowOnError
  >({
    url: '/v1/functions/vesting_calculation/potential_valuation',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Delete Gaia Token
 */
export const deleteGaiaToken = <ThrowOnError extends boolean = false>(
  options?: Options<DeleteGaiaTokenData, ThrowOnError>
) =>
  (options?.client ?? client).delete<DeleteGaiaTokenResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/account/user/me/active-organisation/integrations/gaia',
    ...options,
  });

/**
 * Get Gaia Token
 */
export const getGaiaToken = <ThrowOnError extends boolean = false>(
  options?: Options<GetGaiaTokenData, ThrowOnError>
) =>
  (options?.client ?? client).get<GetGaiaTokenResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/account/user/me/active-organisation/integrations/gaia',
    ...options,
  });

/**
 * Create Gaia Token
 */
export const createGaiaToken = <ThrowOnError extends boolean = false>(
  options: Options<CreateGaiaTokenData, ThrowOnError>
) =>
  (options.client ?? client).post<CreateGaiaTokenResponses, CreateGaiaTokenErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/account/user/me/active-organisation/integrations/gaia',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Update Gaia Token
 */
export const updateGaiaToken = <ThrowOnError extends boolean = false>(
  options: Options<UpdateGaiaTokenData, ThrowOnError>
) =>
  (options.client ?? client).put<UpdateGaiaTokenResponses, UpdateGaiaTokenErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/account/user/me/active-organisation/integrations/gaia',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get Section Groups
 */
export const getSectionGroups = <ThrowOnError extends boolean = false>(
  options?: Options<GetSectionGroupsData, ThrowOnError>
) =>
  (options?.client ?? client).get<GetSectionGroupsResponses, GetSectionGroupsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/account/user/me/active-organisation/integrations/gaia/section-groups',
    ...options,
  });

/**
 * Get Section
 */
export const getSection = <ThrowOnError extends boolean = false>(
  options: Options<GetSectionData, ThrowOnError>
) =>
  (options.client ?? client).get<GetSectionResponses, GetSectionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/account/user/me/active-organisation/integrations/gaia/sections/{section_id}',
    ...options,
  });

/**
 * Get Section Files Meta
 */
export const getSectionFilesMeta = <ThrowOnError extends boolean = false>(
  options: Options<GetSectionFilesMetaData, ThrowOnError>
) =>
  (options.client ?? client).post<
    GetSectionFilesMetaResponses,
    GetSectionFilesMetaErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/account/user/me/active-organisation/integrations/gaia/sections/{section_id}/files',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Export Vault File To Gaia
 */
export const exportVaultFileToGaia = <ThrowOnError extends boolean = false>(
  options: Options<ExportVaultFileToGaiaData, ThrowOnError>
) =>
  (options.client ?? client).post<
    ExportVaultFileToGaiaResponses,
    ExportVaultFileToGaiaErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/account/user/me/active-organisation/integrations/gaia/sections/{gaia_section_id}/export',
    ...options,
  });

/**
 * Import Gaia File
 */
export const importGaiaFile = <ThrowOnError extends boolean = false>(
  options: Options<ImportGaiaFileData, ThrowOnError>
) =>
  (options.client ?? client).post<ImportGaiaFileResponses, ImportGaiaFileErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/account/user/me/active-organisation/integrations/gaia/files/{file_id}/import',
    ...options,
  });

/**
 * Get Organisation Google Drive Auth Url
 *
 * The Google consent URL for connecting the organisation's Drive (admins only).
 */
export const getOrganisationGoogleDriveAuthUrl = <ThrowOnError extends boolean = false>(
  options?: Options<GetOrganisationGoogleDriveAuthUrlData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    GetOrganisationGoogleDriveAuthUrlResponses,
    GetOrganisationGoogleDriveAuthUrlErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/account/user/me/active-organisation/integrations/google-drive/auth-url',
    ...options,
  });

/**
 * List Organisation Google Drive
 *
 * Browse the organisation's Drive (members).
 *
 * Raises:
 * UnauthorizedError: If the caller is not a member of the active organisation, or the Drive
 * client refuses.
 * NotFoundError: If the organisation has no integration.
 */
export const listOrganisationGoogleDrive = <ThrowOnError extends boolean = false>(
  options?: Options<ListOrganisationGoogleDriveData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    ListOrganisationGoogleDriveResponses,
    ListOrganisationGoogleDriveErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/account/user/me/active-organisation/integrations/google-drive/items',
    ...options,
  });

/**
 * Import Google Drive Items
 *
 * Import files from Google Drive into the active organisation's vault, in the background.
 *
 * ``scope`` picks the Drive to read from: the caller's personal integration (default) or the
 * organisation's (admins only). Every imported file is converted into a contract when it can,
 * like any upload; the per-file conversion tasks show the progress.
 *
 * Raises:
 * UnauthorizedError: If ``scope=organisation`` and the caller is not an admin.
 * NotFoundError: If the selected integration does not exist.
 */
export const importGoogleDriveItems = <ThrowOnError extends boolean = false>(
  options: Options<ImportGoogleDriveItemsData, ThrowOnError>
) =>
  (options.client ?? client).post<
    ImportGoogleDriveItemsResponses,
    ImportGoogleDriveItemsErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/account/user/me/active-organisation/integrations/google-drive/import',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Connect Organisation Google Drive
 *
 * Connect the organisation's Drive with the OAuth code from the consent page (admins only).
 *
 * Raises:
 * BadRequestError: If the code is invalid or expired, or the organisation's Drive is already
 * connected (disconnect first — an organisation Drive is not silently re-pointed).
 * InternalServerError: If the token exchange fails otherwise.
 */
export const connectOrganisationGoogleDrive = <ThrowOnError extends boolean = false>(
  options: Options<ConnectOrganisationGoogleDriveData, ThrowOnError>
) =>
  (options.client ?? client).post<
    ConnectOrganisationGoogleDriveResponses,
    ConnectOrganisationGoogleDriveErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/account/user/me/active-organisation/integrations/google-drive/connect',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get Organisation Google Drive Status
 *
 * Connection status of the organisation's Drive (members).
 */
export const getOrganisationGoogleDriveStatus = <ThrowOnError extends boolean = false>(
  options?: Options<GetOrganisationGoogleDriveStatusData, ThrowOnError>
) =>
  (options?.client ?? client).get<GetOrganisationGoogleDriveStatusResponses, unknown, ThrowOnError>(
    {
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/v1/app/account/user/me/active-organisation/integrations/google-drive/status',
      ...options,
    }
  );

/**
 * Disconnect Organisation Google Drive
 *
 * Disconnect the organisation's Drive, wiping every stored token (admins only).
 *
 * Raises:
 * NotFoundError: If the organisation never connected a Drive.
 */
export const disconnectOrganisationGoogleDrive = <ThrowOnError extends boolean = false>(
  options?: Options<DisconnectOrganisationGoogleDriveData, ThrowOnError>
) =>
  (options?.client ?? client).post<
    DisconnectOrganisationGoogleDriveResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/account/user/me/active-organisation/integrations/google-drive/disconnect',
    ...options,
  });

/**
 * Get Jira Auth Url
 *
 * Build the Atlassian OAuth 2.0 (3LO) consent URL the frontend redirects the admin to.
 *
 * ``state`` is not stored server-side: the frontend keeps it and compares it against the value
 * echoed back on its ``/oauth/callback/jira`` route before posting the code to ``/connect``
 * (same contract as the Google Drive and Slack flows).
 */
export const getJiraAuthUrl = <ThrowOnError extends boolean = false>(
  options?: Options<GetJiraAuthUrlData, ThrowOnError>
) =>
  (options?.client ?? client).get<GetJiraAuthUrlResponses, GetJiraAuthUrlErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/account/user/me/active-organisation/integrations/jira/auth-url',
    ...options,
  });

/**
 * Connect Jira
 *
 * Exchange the consent callback's code and store the token set awaiting site selection.
 */
export const connectJira = <ThrowOnError extends boolean = false>(
  options: Options<ConnectJiraData, ThrowOnError>
) =>
  (options.client ?? client).post<ConnectJiraResponses, ConnectJiraErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/account/user/me/active-organisation/integrations/jira/connect',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * List Jira Sites
 *
 * The Jira sites the stored consent reaches, fetched live -- they are never persisted.
 */
export const listJiraSites = <ThrowOnError extends boolean = false>(
  options?: Options<ListJiraSitesData, ThrowOnError>
) =>
  (options?.client ?? client).get<ListJiraSitesResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/account/user/me/active-organisation/integrations/jira/sites',
    ...options,
  });

/**
 * Select Jira Site
 *
 * Commit the integration to one Jira site, which is what makes it usable.
 *
 * The authorizing Atlassian account is cached at the same time, for support only -- so someone can
 * see whose authorization the connection runs on. It takes **no** part in filtering inbound events:
 * 3LO acts as the human who granted consent, normally the org admin, who also attaches contracts,
 * so dropping their events swallows real work. Loop prevention is keyed on the objects we upload,
 * via ``JiraOutboundAttachment``. (An earlier design did filter by this account; if you find a
 * comment that still says so, it is describing something that was removed.)
 */
export const selectJiraSite = <ThrowOnError extends boolean = false>(
  options: Options<SelectJiraSiteData, ThrowOnError>
) =>
  (options.client ?? client).put<SelectJiraSiteResponses, SelectJiraSiteErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/account/user/me/active-organisation/integrations/jira/site',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get Jira Status
 */
export const getJiraStatus = <ThrowOnError extends boolean = false>(
  options?: Options<GetJiraStatusData, ThrowOnError>
) =>
  (options?.client ?? client).get<GetJiraStatusResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/account/user/me/active-organisation/integrations/jira/status',
    ...options,
  });

/**
 * Disconnect Jira
 *
 * Keep the row, clear the credentials, site and account.
 *
 * Reconnecting starts from consent and site selection again.
 */
export const disconnectJira = <ThrowOnError extends boolean = false>(
  options?: Options<DisconnectJiraData, ThrowOnError>
) =>
  (options?.client ?? client).post<DisconnectJiraResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/account/user/me/active-organisation/integrations/jira/disconnect',
    ...options,
  });

/**
 * Get Slack Auth Url
 *
 * Build the Slack OAuth V2 install URL the frontend redirects the admin to.
 *
 * ``state`` is not stored server-side: the frontend keeps it and compares it against the value
 * echoed back on its ``/oauth/callback/slack`` route before posting the code to ``/connect``
 * (same contract as the Google Drive flow).
 */
export const getSlackAuthUrl = <ThrowOnError extends boolean = false>(
  options?: Options<GetSlackAuthUrlData, ThrowOnError>
) =>
  (options?.client ?? client).get<GetSlackAuthUrlResponses, GetSlackAuthUrlErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/account/user/me/active-organisation/integrations/slack/auth-url',
    ...options,
  });

/**
 * Connect Slack
 *
 * Exchange the OAuth callback's code and store the installing workspace's bot token.
 */
export const connectSlack = <ThrowOnError extends boolean = false>(
  options: Options<ConnectSlackData, ThrowOnError>
) =>
  (options.client ?? client).post<ConnectSlackResponses, ConnectSlackErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/account/user/me/active-organisation/integrations/slack/connect',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Search Slack Channels
 *
 * Search the connected workspace's channels, for the slack action's channel picker.
 *
 * The full channel list is fetched from Slack (its API has no server-side name filter) and
 * ``query`` is applied here: case-insensitive substring match of ``text`` on the channel name,
 * sorted by name, then paginated with ``offset``/``limit``. ``sort_key`` and
 * ``similarity_threshold`` are ignored: name is the only sortable field, and matching is exact,
 * not fuzzy.
 */
export const searchSlackChannels = <ThrowOnError extends boolean = false>(
  options: Options<SearchSlackChannelsData, ThrowOnError>
) =>
  (options.client ?? client).post<
    SearchSlackChannelsResponses,
    SearchSlackChannelsErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/account/user/me/active-organisation/integrations/slack/channels/search',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Send Slack Test Message
 *
 * Post a test message to a channel, so an admin can verify the integration before using it.
 */
export const sendSlackTestMessage = <ThrowOnError extends boolean = false>(
  options: Options<SendSlackTestMessageData, ThrowOnError>
) =>
  (options.client ?? client).post<
    SendSlackTestMessageResponses,
    SendSlackTestMessageErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/account/user/me/active-organisation/integrations/slack/test-message',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get Slack Status
 */
export const getSlackStatus = <ThrowOnError extends boolean = false>(
  options?: Options<GetSlackStatusData, ThrowOnError>
) =>
  (options?.client ?? client).get<GetSlackStatusResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/account/user/me/active-organisation/integrations/slack/status',
    ...options,
  });

/**
 * Disconnect Slack
 */
export const disconnectSlack = <ThrowOnError extends boolean = false>(
  options?: Options<DisconnectSlackData, ThrowOnError>
) =>
  (options?.client ?? client).post<DisconnectSlackResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/account/user/me/active-organisation/integrations/slack/disconnect',
    ...options,
  });

/**
 * Delete Youtrust Integration
 */
export const deleteYoutrustIntegration = <ThrowOnError extends boolean = false>(
  options?: Options<DeleteYoutrustIntegrationData, ThrowOnError>
) =>
  (options?.client ?? client).delete<DeleteYoutrustIntegrationResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/account/user/me/active-organisation/integrations/youtrust',
    ...options,
  });

/**
 * Create Youtrust Integration
 */
export const createYoutrustIntegration = <ThrowOnError extends boolean = false>(
  options: Options<CreateYoutrustIntegrationData, ThrowOnError>
) =>
  (options.client ?? client).post<
    CreateYoutrustIntegrationResponses,
    CreateYoutrustIntegrationErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/account/user/me/active-organisation/integrations/youtrust',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get Youtrust Status
 */
export const getYoutrustStatus = <ThrowOnError extends boolean = false>(
  options?: Options<GetYoutrustStatusData, ThrowOnError>
) =>
  (options?.client ?? client).get<GetYoutrustStatusResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/account/user/me/active-organisation/integrations/youtrust/status',
    ...options,
  });

/**
 * List Invitations
 *
 * List invitations of the current organisation, newest first.
 *
 * Args:
 * postgresql_session: Database session for PostgreSQL operations
 * current_user: Currently authenticated org admin
 * status: Only return invitations with one of these statuses (repeatable,
 * e.g. ``?status=pending&status=expired``); omit for all statuses
 *
 * Returns:
 * The invitations of the organisation, lapsed pending ones flipped to expired
 */
export const listInvitations = <ThrowOnError extends boolean = false>(
  options?: Options<ListInvitationsData, ThrowOnError>
) =>
  (options?.client ?? client).get<ListInvitationsResponses, ListInvitationsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/account/user/me/active-organisation/users/invitations',
    ...options,
  });

/**
 * Create Invitation
 *
 * Invite an email address to the current organisation.
 *
 * Optionally selects roles granted at accept time on top of the member role.
 * Protected roles (incl. the admin role) are allowed — the caller is an org
 * admin and could assign them after joining anyway; the organisation scope is
 * the only gate.
 *
 * Args:
 * postgresql_session: Database session for PostgreSQL operations
 * settings: Application static settings
 * current_user: Currently authenticated org admin
 * invitation_in: The email address, name and role uids to invite with
 *
 * Returns:
 * The created pending invitation
 *
 * Raises:
 * AlreadyExistsError: If the email already belongs to an organisation member,
 * or a pending invitation for it exists (resend instead).
 * NotFoundError: If a role uid resolves to no role.
 * UnauthorizedError: If a role belongs to another organisation.
 */
export const createInvitation = <ThrowOnError extends boolean = false>(
  options: Options<CreateInvitationData, ThrowOnError>
) =>
  (options.client ?? client).post<CreateInvitationResponses, CreateInvitationErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/account/user/me/active-organisation/users/invitations',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Update Invitation Roles
 *
 * Replace the roles of a pending invitation (empty set clears them).
 *
 * Args:
 * postgresql_session: Database session for PostgreSQL operations
 * current_user: Currently authenticated org admin
 * uid: UID of the invitation to update
 * roles_in: The new role uids
 *
 * Returns:
 * The updated pending invitation
 *
 * Raises:
 * NotFoundError: If the invitation does not exist in the current
 * organisation, or a role uid resolves to no role
 * BadRequestError: If the invitation is not pending
 * UnauthorizedError: If a role belongs to another organisation
 */
export const updateInvitationRoles = <ThrowOnError extends boolean = false>(
  options: Options<UpdateInvitationRolesData, ThrowOnError>
) =>
  (options.client ?? client).put<
    UpdateInvitationRolesResponses,
    UpdateInvitationRolesErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/account/user/me/active-organisation/users/invitations/{uid}/roles',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Resend Invitation
 *
 * Rotate the token of a pending or expired invitation, refresh its expiry and re-send the mail.
 *
 * Args:
 * postgresql_session: Database session for PostgreSQL operations
 * settings: Application static settings
 * current_user: Currently authenticated org admin
 * uid: UID of the invitation to resend
 *
 * Returns:
 * The refreshed pending invitation
 *
 * Raises:
 * NotFoundError: If the invitation does not exist in the current organisation
 * BadRequestError: If the invitation was already accepted or revoked
 */
export const resendInvitation = <ThrowOnError extends boolean = false>(
  options: Options<ResendInvitationData, ThrowOnError>
) =>
  (options.client ?? client).post<ResendInvitationResponses, ResendInvitationErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/account/user/me/active-organisation/users/invitations/{uid}/resend',
    ...options,
  });

/**
 * Revoke Invitation
 *
 * Revoke a pending invitation.
 *
 * Args:
 * postgresql_session: Database session for PostgreSQL operations
 * current_user: Currently authenticated org admin
 * uid: UID of the invitation to revoke
 *
 * Returns:
 * ApplicationMessage: Success message
 *
 * Raises:
 * NotFoundError: If the invitation does not exist in the current organisation
 * BadRequestError: If the invitation is not pending
 */
export const revokeInvitation = <ThrowOnError extends boolean = false>(
  options: Options<RevokeInvitationData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    RevokeInvitationResponses,
    RevokeInvitationErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/account/user/me/active-organisation/users/invitations/{uid}',
    ...options,
  });

/**
 * Search Organisation Agent Tasks
 *
 * Filterable, searchable list of the active organisation's agent tasks. Org-admin only.
 */
export const searchOrganisationAgentTasks = <ThrowOnError extends boolean = false>(
  options: Options<SearchOrganisationAgentTasksData, ThrowOnError>
) =>
  (options.client ?? client).post<
    SearchOrganisationAgentTasksResponses,
    SearchOrganisationAgentTasksErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/account/user/me/active-organisation/agent-tasks/search',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Retry Organisation Agent Task
 *
 * Reset a FAILED/CANCELLED/WARNING agent task to PENDING and dispatch it again. Org-admin only.
 */
export const retryOrganisationAgentTask = <ThrowOnError extends boolean = false>(
  options: Options<RetryOrganisationAgentTaskData, ThrowOnError>
) =>
  (options.client ?? client).post<
    RetryOrganisationAgentTaskResponses,
    RetryOrganisationAgentTaskErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/account/user/me/active-organisation/agent-tasks/{uid}/retry',
    ...options,
  });

/**
 * Create User Memory
 *
 * Create a memory for the current user in their active organisation.
 */
export const createUserMemory = <ThrowOnError extends boolean = false>(
  options: Options<CreateUserMemoryData, ThrowOnError>
) =>
  (options.client ?? client).post<CreateUserMemoryResponses, CreateUserMemoryErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/account/user/me/active-organisation/memories/create',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Delete User Memory
 *
 * Delete one of the current user's memories in their active organisation.
 */
export const deleteUserMemory = <ThrowOnError extends boolean = false>(
  options: Options<DeleteUserMemoryData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    DeleteUserMemoryResponses,
    DeleteUserMemoryErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/account/user/me/active-organisation/memories/{uid}',
    ...options,
  });

/**
 * Get Specific User Memory
 *
 * Get one of the current user's memories in their active organisation.
 */
export const getSpecificUserMemory = <ThrowOnError extends boolean = false>(
  options: Options<GetSpecificUserMemoryData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetSpecificUserMemoryResponses,
    GetSpecificUserMemoryErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/account/user/me/active-organisation/memories/{uid}',
    ...options,
  });

/**
 * Update User Memory
 *
 * Update one of the current user's memories in their active organisation.
 */
export const updateUserMemory = <ThrowOnError extends boolean = false>(
  options: Options<UpdateUserMemoryData, ThrowOnError>
) =>
  (options.client ?? client).put<UpdateUserMemoryResponses, UpdateUserMemoryErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/account/user/me/active-organisation/memories/{uid}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get All User Memories
 *
 * Get all of the current user's memories in their active organisation.
 */
export const getAllUserMemories = <ThrowOnError extends boolean = false>(
  options?: Options<GetAllUserMemoriesData, ThrowOnError>
) =>
  (options?.client ?? client).get<GetAllUserMemoriesResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/account/user/me/active-organisation/memories/',
    ...options,
  });

/**
 * Search User Memories
 *
 * Search the current user's memories in their active organisation.
 */
export const searchUserMemories = <ThrowOnError extends boolean = false>(
  options: Options<SearchUserMemoriesData, ThrowOnError>
) =>
  (options.client ?? client).post<
    SearchUserMemoriesResponses,
    SearchUserMemoriesErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/account/user/me/active-organisation/memories/search',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get Own Active Organisation
 *
 * Get the currently active organisation for the authenticated user.
 */
export const getOwnActiveOrganisation = <ThrowOnError extends boolean = false>(
  options?: Options<GetOwnActiveOrganisationData, ThrowOnError>
) =>
  (options?.client ?? client).get<GetOwnActiveOrganisationResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/account/user/me/active-organisation',
    ...options,
  });

/**
 * Update Own Active Organisation
 *
 * Change the active organisation's name, description, default signing expiration or default
 * signing provider. Omitted fields stay as they are, and so do null ones — except the provider,
 * which null clears (one-click sends then use the first provider the organisation can use). A
 * provider must be one the organisation can use now; it is checked again on every send, so a later
 * disconnect just falls back to the next available one.
 *
 * Raises:
 * InvalidDataError: If the organisation cannot sign with that provider
 */
export const updateOwnActiveOrganisation = <ThrowOnError extends boolean = false>(
  options: Options<UpdateOwnActiveOrganisationData, ThrowOnError>
) =>
  (options.client ?? client).put<
    UpdateOwnActiveOrganisationResponses,
    UpdateOwnActiveOrganisationErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/account/user/me/active-organisation',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get Own Active Organisation Allowance Usage
 *
 * Retrieve how many credits my organisation has used in the current billing period.
 *
 * Returns:
 * The number of credits used in the current billing period; None if no billing start
 * date is set for the organisation.
 */
export const getOwnActiveOrganisationAllowanceUsage = <ThrowOnError extends boolean = false>(
  options?: Options<GetOwnActiveOrganisationAllowanceUsageData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    GetOwnActiveOrganisationAllowanceUsageResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/account/user/me/active-organisation/allowance_usage',
    ...options,
  });

/**
 * Search Active Organisation Users
 *
 * Search users in the currently active organisation.
 */
export const searchActiveOrganisationUsers = <ThrowOnError extends boolean = false>(
  options: Options<SearchActiveOrganisationUsersData, ThrowOnError>
) =>
  (options.client ?? client).post<
    SearchActiveOrganisationUsersResponses,
    SearchActiveOrganisationUsersErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/account/user/me/active-organisation/users/search',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Remove User From Active Organisation
 *
 * Remove a user from the current active organisation.
 *
 * Raises:
 * NotFoundError: If user not found
 * UnauthorizedError: If the user cannot be removed from the organisation
 */
export const removeUserFromActiveOrganisation = <ThrowOnError extends boolean = false>(
  options: Options<RemoveUserFromActiveOrganisationData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    RemoveUserFromActiveOrganisationResponses,
    RemoveUserFromActiveOrganisationErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/account/user/me/active-organisation/users/{uid}',
    ...options,
  });

/**
 * Read Active Organisation User
 *
 * Get a specific user by ID, only if they belong to the active organisation.
 *
 * Raises:
 * NotFoundError: If user not found
 * UnauthorizedError: If the requested user is not in the active organisation
 */
export const readActiveOrganisationUser = <ThrowOnError extends boolean = false>(
  options: Options<ReadActiveOrganisationUserData, ThrowOnError>
) =>
  (options.client ?? client).get<
    ReadActiveOrganisationUserResponses,
    ReadActiveOrganisationUserErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/account/user/me/active-organisation/users/{uid}',
    ...options,
  });

/**
 * Set Active Organisation User Is Active
 *
 * Activate or deactivate a user of the current active organisation.
 *
 * The flag is platform-wide: a user who belongs to several organisations is
 * deactivated for all of them (accepted trade-off for now). Idempotent —
 * setting the state the user already has is a no-op.
 *
 * Deactivating every admin of an organisation is allowed: deactivation keeps
 * role membership intact, so the "organisation must keep at least one admin"
 * invariant (enforced on removal) still holds and any admin can be reactivated.
 *
 * Raises:
 * NotFoundError: If user not found
 * UnauthorizedError: If the target is not in the active organisation, is
 * the caller themselves, or is a platform admin (while the caller is
 * not)
 */
export const setActiveOrganisationUserIsActive = <ThrowOnError extends boolean = false>(
  options: Options<SetActiveOrganisationUserIsActiveData, ThrowOnError>
) =>
  (options.client ?? client).put<
    SetActiveOrganisationUserIsActiveResponses,
    SetActiveOrganisationUserIsActiveErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/account/user/me/active-organisation/users/{uid}/is-active',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get Personal Google Drive Auth Url
 *
 * The Google consent URL for connecting the caller's own Drive.
 */
export const getPersonalGoogleDriveAuthUrl = <ThrowOnError extends boolean = false>(
  options?: Options<GetPersonalGoogleDriveAuthUrlData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    GetPersonalGoogleDriveAuthUrlResponses,
    GetPersonalGoogleDriveAuthUrlErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/account/user/me/integrations/google-drive/auth-url',
    ...options,
  });

/**
 * List Personal Google Drive
 *
 * Browse the caller's own Drive.
 *
 * Raises:
 * NotFoundError: If the caller has no personal integration.
 * UnauthorizedError: If the Drive client refuses (authorization required).
 */
export const listPersonalGoogleDrive = <ThrowOnError extends boolean = false>(
  options?: Options<ListPersonalGoogleDriveData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    ListPersonalGoogleDriveResponses,
    ListPersonalGoogleDriveErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/account/user/me/integrations/google-drive/items',
    ...options,
  });

/**
 * Connect Personal Google Drive
 *
 * Connect (or re-connect) the caller's own Drive with the OAuth code from the consent page.
 *
 * Raises:
 * BadRequestError: If the code is invalid or expired.
 * InternalServerError: If the token exchange fails otherwise.
 */
export const connectPersonalGoogleDrive = <ThrowOnError extends boolean = false>(
  options: Options<ConnectPersonalGoogleDriveData, ThrowOnError>
) =>
  (options.client ?? client).post<
    ConnectPersonalGoogleDriveResponses,
    ConnectPersonalGoogleDriveErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/account/user/me/integrations/google-drive/connect',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get Personal Google Drive Status
 *
 * Connection status of the caller's own Drive (disconnected shape when never connected).
 */
export const getPersonalGoogleDriveStatus = <ThrowOnError extends boolean = false>(
  options?: Options<GetPersonalGoogleDriveStatusData, ThrowOnError>
) =>
  (options?.client ?? client).get<GetPersonalGoogleDriveStatusResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/account/user/me/integrations/google-drive/status',
    ...options,
  });

/**
 * Disconnect Personal Google Drive
 *
 * Disconnect the caller's own Drive, wiping every stored token.
 *
 * Raises:
 * NotFoundError: If the caller never connected a personal Drive (the row stays after a
 * disconnect, so disconnecting twice is fine).
 */
export const disconnectPersonalGoogleDrive = <ThrowOnError extends boolean = false>(
  options?: Options<DisconnectPersonalGoogleDriveData, ThrowOnError>
) =>
  (options?.client ?? client).post<DisconnectPersonalGoogleDriveResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/account/user/me/integrations/google-drive/disconnect',
    ...options,
  });

/**
 * Search User Attention
 *
 * The current user's attention items, newest first, optionally narrowed by organisation and type.
 */
export const searchUserAttention = <ThrowOnError extends boolean = false>(
  options: Options<SearchUserAttentionData, ThrowOnError>
) =>
  (options.client ?? client).post<
    SearchUserAttentionResponses,
    SearchUserAttentionErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/account/user/me/attention/search',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Acknowledge User Attention
 *
 * Dismiss one item without following it — for the kinds the user may dismiss.
 *
 * A chat item is the user's own notification, so seeing it is enough. A signing item is not:
 * it stays until the turn really moves on (signed, approved, cancelled, expired …), so
 * acknowledging one is refused.
 */
export const acknowledgeUserAttention = <ThrowOnError extends boolean = false>(
  options: Options<AcknowledgeUserAttentionData, ThrowOnError>
) =>
  (options.client ?? client).post<
    AcknowledgeUserAttentionResponses,
    AcknowledgeUserAttentionErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/account/user/me/attention/{attention_uid}/acknowledge',
    ...options,
  });

/**
 * Get Signing Attention Link
 *
 * The provider page for the user to sign or approve on, fetched fresh from the provider.
 *
 * Only ever for the participant the item is about, and the item must be the caller's — that is
 * the whole gate: being that participant is what entitles the caller to the link, not membership
 * of the request's organisation (a counterparty may not have one). The link is not stored: the
 * provider expires it, so every click reads the current one.
 */
export const getSigningAttentionLink = <ThrowOnError extends boolean = false>(
  options: Options<GetSigningAttentionLinkData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetSigningAttentionLinkResponses,
    GetSigningAttentionLinkErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/account/user/me/attention/{attention_uid}/signing-link',
    ...options,
  });

/**
 * Read User Me
 *
 * Get the current user's profile information.
 *
 * Works without an active organisation (``organisations`` is then empty and
 * ``active_organisation`` null).
 *
 * Args:
 * current_user: Currently authenticated user
 * static_settings: Application static settings
 *
 * Returns:
 * UserInDBMe: Current user profile
 */
export const readUserMe = <ThrowOnError extends boolean = false>(
  options?: Options<ReadUserMeData, ThrowOnError>
) =>
  (options?.client ?? client).get<ReadUserMeResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/account/user/me',
    ...options,
  });

/**
 * Update User Me
 *
 * Update the current user's profile information.
 *
 * Args:
 * postgresql_session: Database session for PostgreSQL operations
 * current_user: Currently authenticated user
 * update_data: Data to update the user with
 *
 * Returns:
 * User: Updated user object
 */
export const updateUserMe = <ThrowOnError extends boolean = false>(
  options: Options<UpdateUserMeData, ThrowOnError>
) =>
  (options.client ?? client).put<UpdateUserMeResponses, UpdateUserMeErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/account/user/me',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get Own Organisations
 *
 * Get all organisations the current user belongs to.
 *
 * Args:
 * current_user: Currently authenticated user
 *
 * Returns:
 * list[Organisation]: List of organisations the user belongs to (empty for an org-less user)
 */
export const getOwnOrganisations = <ThrowOnError extends boolean = false>(
  options?: Options<GetOwnOrganisationsData, ThrowOnError>
) =>
  (options?.client ?? client).get<GetOwnOrganisationsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/account/user/me/organisations',
    ...options,
  });

/**
 * Create Own Organisation
 *
 * Self-service organisation creation, behind ``SELF_SERVICE_ORGANISATION_CREATION``.
 *
 * Open to any active user, with or without an organisation — this is the way out of the org-less
 * state when no invitation is on the table. Provisions the same default tier as sign-up (shared
 * recipe), makes the caller member + admin, and switches their active organisation to the new one
 * unconditionally (the creator asked for it; it is not only a fallback for the org-less case).
 *
 * Args:
 * postgresql_session: Database session for PostgreSQL operations
 * static_settings: Application static settings
 * current_user: Currently authenticated user
 * body: Name, optional description and hosting zone
 *
 * Returns:
 * Organisation: The new organisation
 *
 * Raises:
 * SelfServiceOrganisationCreationDisabledError: 403 with code
 * ``self_service_organisation_creation_disabled`` if the deployment has the flag off.
 */
export const createOwnOrganisation = <ThrowOnError extends boolean = false>(
  options: Options<CreateOwnOrganisationData, ThrowOnError>
) =>
  (options.client ?? client).post<
    CreateOwnOrganisationResponses,
    CreateOwnOrganisationErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/account/user/me/organisations',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Leave Own Organisation
 *
 * Leave an organisation the caller is a member of — the active one or any other.
 *
 * The direct cut (membership, the organisation's roles, the active pointer) commits here;
 * the active organisation falls back to the next remaining one, or to none. Leaving the
 * last organisation leaves the caller org-less: ``GET /me`` keeps working, the org-scoped
 * surface answers the coded 403 ``no_active_organisation``, and the way back is an
 * invitation, ``POST /me/switch-org`` after re-joining, or ``POST /me/organisations``.
 * Every other reference the caller holds in that organisation (drafts, memories, chat
 * threads, attribution pointers…) is severed asynchronously by
 * ``remove_org_access_references``.
 *
 * The "at least one admin" invariant is the same one the admin-side removal enforces:
 * the organisation's last admin must hand over first (or delete the organisation).
 *
 * Args:
 * postgresql_session: Database session for PostgreSQL operations
 * static_settings: Application static settings
 * organisation_uid: Organisation UID to leave
 * current_user: Currently authenticated user making the request
 *
 * Returns:
 * UserInDBMe: The caller's profile after leaving (switcher state in one response)
 *
 * Raises:
 * NotFoundError: If the organisation does not exist
 * UnauthorizedError: If the caller is not a member, or is the organisation's last admin
 */
export const leaveOwnOrganisation = <ThrowOnError extends boolean = false>(
  options: Options<LeaveOwnOrganisationData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    LeaveOwnOrganisationResponses,
    LeaveOwnOrganisationErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/account/user/me/organisations/{organisation_uid}',
    ...options,
  });

/**
 * Get Own Roles
 *
 * Get all roles of users.
 *
 * Args:
 * postgresql_session: Database session for PostgreSQL operations
 * current_user: Currently authenticated user
 *
 * Returns:
 * list[PermissionRole]: List of roles assigned to the user in the current organisation
 */
export const getOwnRoles = <ThrowOnError extends boolean = false>(
  options?: Options<GetOwnRolesData, ThrowOnError>
) =>
  (options?.client ?? client).get<GetOwnRolesResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/account/user/me/roles',
    ...options,
  });

/**
 * User Switch Organisation
 *
 * Switch to a specific Organisation you are member of.
 *
 * Args:
 * postgresql_session: Database session for PostgreSQL operations
 * organisation_uid: Organisation UID to switch to
 * current_user: Currently authenticated user making the request
 *
 * Returns:
 * The org you want to switch to
 */
export const userSwitchOrganisation = <ThrowOnError extends boolean = false>(
  options: Options<UserSwitchOrganisationData, ThrowOnError>
) =>
  (options.client ?? client).post<
    UserSwitchOrganisationResponses,
    UserSwitchOrganisationErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/account/user/me/switch-org',
    ...options,
  });

/**
 * Signup Insights
 *
 * Provision the backend user for a verified Firebase identity.
 *
 * Identity (uid + email) comes exclusively from the verified ID token — the
 * body carries profile data only. Idempotent: retrying after a mid-flow crash
 * resumes instead of failing, and legacy rows without a ``firebase_uid`` are
 * claimed instead of duplicated. Recaptcha (header dependency) is bot
 * friction only; the security boundary is the email-verified Firebase account.
 *
 * A brand-new organisation also gets demo data seeded in the background, covering the areas its
 * enabled features reach (see ``SIGNUP_SEED_DEMO_DATA``), so the workspace is not empty on arrival.
 *
 * Args:
 * postgresql_session: Database session for PostgreSQL operations
 * loaded_static_settings: The static settings
 * identity: The verified Firebase token identity
 * signup: The profile data required to fulfill the signup
 * _rate_limited: Rate-limit gate (raises 429 when exceeded)
 * _recaptcha_solved: Recaptcha gate (raises 403 without a valid token)
 *
 * Returns:
 * User: The provisioned (or already existing) user
 */
export const signupInsights = <ThrowOnError extends boolean = false>(
  options: Options<SignupInsightsData, ThrowOnError>
) =>
  (options.client ?? client).post<SignupInsightsResponses, SignupInsightsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/account/user/sign_up',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Signup Cm
 *
 * Fire a product notification for a Contract Management signup request.
 *
 * Unauthenticated marketing-form endpoint; the recaptcha and rate-limit
 * gates are its only protection against notification spam.
 *
 * Args:
 * signup: The data required to fulfill the signup
 * _rate_limited: Rate-limit gate (raises 429 when exceeded)
 * _recaptcha_solved: Recaptcha gate (raises 403 without a valid token)
 *
 * Returns:
 * dict: Confirmation message
 */
export const signupCm = <ThrowOnError extends boolean = false>(
  options: Options<SignupCmData, ThrowOnError>
) =>
  (options.client ?? client).post<SignupCmResponses, SignupCmErrors, ThrowOnError>({
    url: '/v1/app/account/user/sign_up/cm',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Request Email Verification
 *
 * Send (or re-send) the email verification mail for a password account.
 *
 * Uses the decode-only identity dependency: the caller is authenticated but by
 * definition not yet email-verified. Always answers 204 — already-verified
 * accounts and non-password providers are silent no-ops, and resending is
 * simply calling this again.
 *
 * Args:
 * settings: Application static settings
 * identity: The decoded Firebase token identity (verification not required)
 * _rate_limited: Rate-limit gate (raises 429 when exceeded)
 * _recaptcha_solved: Recaptcha gate (raises 403 without a valid token)
 *
 * Returns:
 * Response: Empty 204 response
 */
export const requestEmailVerification = <ThrowOnError extends boolean = false>(
  options?: Options<RequestEmailVerificationData, ThrowOnError>
) =>
  (options?.client ?? client).post<
    RequestEmailVerificationResponses,
    RequestEmailVerificationErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/account/user/sign_up/email-verification/request',
    ...options,
  });

/**
 * Confirm Email Verification
 *
 * Confirm an email verification token and flip the flag on the Firebase account.
 *
 * Public (the single-use token is the credential). After a 204 the frontend
 * must force-refresh the ID token so the new ``email_verified: true`` claim
 * reaches the backend gate.
 *
 * Args:
 * settings: Application static settings
 * confirm_data: The plaintext verification token from the email link
 * _rate_limited: Rate-limit gate (raises 429 when exceeded)
 * _recaptcha_solved: Recaptcha gate (raises 403 without a valid token)
 *
 * Returns:
 * Response: Empty 204 response
 *
 * Raises:
 * EmailVerificationTokenInvalidError: If the token is unknown, expired or already used.
 */
export const confirmEmailVerification = <ThrowOnError extends boolean = false>(
  options: Options<ConfirmEmailVerificationData, ThrowOnError>
) =>
  (options.client ?? client).post<
    ConfirmEmailVerificationResponses,
    ConfirmEmailVerificationErrors,
    ThrowOnError
  >({
    url: '/v1/app/account/user/sign_up/email-verification/confirm',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Search User
 *
 * Search for users.
 *
 * Args:
 * postgresql_session: Database session for PostgreSQL operations
 * current_user: Currently authenticated user
 * query: Search query parameters
 *
 * Returns:
 * dict: Dictionary containing result count and list of matching users
 */
export const searchUser = <ThrowOnError extends boolean = false>(
  options: Options<SearchUserData, ThrowOnError>
) =>
  (options.client ?? client).post<SearchUserResponses, SearchUserErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/account/user/search',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Read User
 *
 * Get a specific user by ID.
 *
 * Args:
 * uid: UUID of user to retrieve
 * current_user: Currently authenticated user
 * postgresql_session: Database session for PostgreSQL operations
 *
 * Returns:
 * User: Requested user object
 *
 * Raises:
 * NotFoundError: If user not found
 */
export const readUser = <ThrowOnError extends boolean = false>(
  options: Options<ReadUserData, ThrowOnError>
) =>
  (options.client ?? client).get<ReadUserResponses, ReadUserErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/account/user/{uid}',
    ...options,
  });

/**
 * Update User
 *
 * Update a user's information.
 *
 * Args:
 * postgresql_session: Database session for PostgreSQL operations
 * uid: UUID of user to update
 * user_in: Updated user data
 * current_user: Currently authenticated user
 *
 * Returns:
 * User: Updated user object
 *
 * Raises:
 * NotFoundError: If user not found
 */
export const updateUser = <ThrowOnError extends boolean = false>(
  options: Options<UpdateUserData, ThrowOnError>
) =>
  (options.client ?? client).put<UpdateUserResponses, UpdateUserErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/account/user/{uid}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Delete User
 *
 * Delete a user.
 *
 * Args:
 * postgresql_session: Database session for PostgreSQL operations
 * user_uid: UUID of user to delete
 * current_user: Currently authenticated user
 *
 * Returns:
 * ApplicationMessage: Success message
 *
 * Raises:
 * NotFoundError: If user not found
 * UnauthorizedError: If user cannot be deleted
 */
export const deleteUser = <ThrowOnError extends boolean = false>(
  options: Options<DeleteUserData, ThrowOnError>
) =>
  (options.client ?? client).delete<DeleteUserResponses, DeleteUserErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/account/user/{user_uid}',
    ...options,
  });

/**
 * Create Organisation Memory
 *
 * Create an organisation memory.
 */
export const createOrganisationMemory = <ThrowOnError extends boolean = false>(
  options: Options<CreateOrganisationMemoryData, ThrowOnError>
) =>
  (options.client ?? client).post<
    CreateOrganisationMemoryResponses,
    CreateOrganisationMemoryErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/account/organisation/memories/create',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Delete Organisation Memory
 *
 * Delete an organisation memory.
 */
export const deleteOrganisationMemory = <ThrowOnError extends boolean = false>(
  options: Options<DeleteOrganisationMemoryData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    DeleteOrganisationMemoryResponses,
    DeleteOrganisationMemoryErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/account/organisation/memories/{uid}',
    ...options,
  });

/**
 * Get Specific Organisation Memory
 *
 * Get one of the organisation's memories.
 */
export const getSpecificOrganisationMemory = <ThrowOnError extends boolean = false>(
  options: Options<GetSpecificOrganisationMemoryData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetSpecificOrganisationMemoryResponses,
    GetSpecificOrganisationMemoryErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/account/organisation/memories/{uid}',
    ...options,
  });

/**
 * Update Organisation Memory
 *
 * Update an organisation memory.
 */
export const updateOrganisationMemory = <ThrowOnError extends boolean = false>(
  options: Options<UpdateOrganisationMemoryData, ThrowOnError>
) =>
  (options.client ?? client).put<
    UpdateOrganisationMemoryResponses,
    UpdateOrganisationMemoryErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/account/organisation/memories/{uid}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get All Organisation Memories
 *
 * Get all of the organisation's memories.
 */
export const getAllOrganisationMemories = <ThrowOnError extends boolean = false>(
  options?: Options<GetAllOrganisationMemoriesData, ThrowOnError>
) =>
  (options?.client ?? client).get<GetAllOrganisationMemoriesResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/account/organisation/memories/',
    ...options,
  });

/**
 * Search Organisation Memories
 *
 * Search the organisation's memories, optionally filtered by scope.
 */
export const searchOrganisationMemories = <ThrowOnError extends boolean = false>(
  options: Options<SearchOrganisationMemoriesData, ThrowOnError>
) =>
  (options.client ?? client).post<
    SearchOrganisationMemoriesResponses,
    SearchOrganisationMemoriesErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/account/organisation/memories/search',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Create Organisation
 *
 * Create a fully provisioned organisation — one transaction, all-or-nothing.
 *
 * Args:
 * postgresql_session: Database session for PostgreSQL operations
 * organisation_in: Organisation creation schema, its initially enabled features included
 * model_settings: The organisation's initial model settings
 * current_user: Currently authenticated user making the request
 * member_access: The organisation-wide access bits, set on its member role (NONE when omitted)
 *
 * Returns:
 * The newly created organisation
 */
export const createOrganisation = <ThrowOnError extends boolean = false>(
  options: Options<CreateOrganisationData, ThrowOnError>
) =>
  (options.client ?? client).post<
    CreateOrganisationResponses,
    CreateOrganisationErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/account/organisation/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Search Organisation
 *
 * Search for organisations with filtering and sorting.
 *
 * Args:
 * postgresql_session: Database session for PostgreSQL operations
 * current_user: Currently authenticated user making the request
 * query: Search query parameters
 *
 * Returns:
 * Dict containing total count and list of matching organisations
 */
export const searchOrganisation = <ThrowOnError extends boolean = false>(
  options: Options<SearchOrganisationData, ThrowOnError>
) =>
  (options.client ?? client).post<
    SearchOrganisationResponses,
    SearchOrganisationErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/account/organisation/search',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Delete Organisation Endpoint
 *
 * Schedule asynchronous deletion of an organisation and all its resources.
 *
 * Raises:
 * NotFoundError: If organisation not found
 */
export const deleteOrganisationEndpoint = <ThrowOnError extends boolean = false>(
  options: Options<DeleteOrganisationEndpointData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    DeleteOrganisationEndpointResponses,
    DeleteOrganisationEndpointErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/account/organisation/{uid}',
    ...options,
  });

/**
 * Get Organisation
 *
 * Retrieve a specific organisation by UID.
 *
 * Raises:
 * NotFoundError: If organisation with given UID does not exist
 */
export const getOrganisation = <ThrowOnError extends boolean = false>(
  options: Options<GetOrganisationData, ThrowOnError>
) =>
  (options.client ?? client).get<GetOrganisationResponses, GetOrganisationErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/account/organisation/{uid}',
    ...options,
  });

/**
 * Update Organisation
 *
 * Update an existing organisation's details.
 *
 * Raises:
 * NotFoundError: If organisation with given UID does not exist
 */
export const updateOrganisation = <ThrowOnError extends boolean = false>(
  options: Options<UpdateOrganisationData, ThrowOnError>
) =>
  (options.client ?? client).put<
    UpdateOrganisationResponses,
    UpdateOrganisationErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/account/organisation/{uid}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Update Organisation Features
 *
 * Replace an organisation's enabled features — platform admins only; members read them off
 * ``OrganisationInDB.features``.
 *
 * Switching ``gaia_signing`` on or off (an actual change, not a re-send) registers or removes
 * GAIA's Youtrust webhooks for the organisation.
 *
 * Raises:
 * NotFoundError: If the organisation does not exist
 */
export const updateOrganisationFeatures = <ThrowOnError extends boolean = false>(
  options: Options<UpdateOrganisationFeaturesData, ThrowOnError>
) =>
  (options.client ?? client).put<
    UpdateOrganisationFeaturesResponses,
    UpdateOrganisationFeaturesErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/account/organisation/{uid}/features',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get Organisation Model Settings
 *
 * Fetch an organisation's current LLM model settings.
 *
 * Raises:
 * NotFoundError: If the organisation or its model settings do not exist
 */
export const getOrganisationModelSettings = <ThrowOnError extends boolean = false>(
  options: Options<GetOrganisationModelSettingsData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetOrganisationModelSettingsResponses,
    GetOrganisationModelSettingsErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/account/organisation/{uid}/model_settings',
    ...options,
  });

/**
 * Update Organisation Model Settings
 *
 * Update an existing organisation's model settings.
 *
 * Raises:
 * NotFoundError: If the organisation or its model settings do not exist
 */
export const updateOrganisationModelSettings = <ThrowOnError extends boolean = false>(
  options: Options<UpdateOrganisationModelSettingsData, ThrowOnError>
) =>
  (options.client ?? client).put<
    UpdateOrganisationModelSettingsResponses,
    UpdateOrganisationModelSettingsErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/account/organisation/{uid}/model_settings',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get Organisation Allowance Usage
 *
 * Retrieve how many credits an organisation has used in the current billing period.
 *
 * Returns:
 * The number of credits used in the current billing period; None if no billing start
 * date is set for the organisation.
 *
 * Raises:
 * NotFoundError: If organisation with given UID does not exist
 */
export const getOrganisationAllowanceUsage = <ThrowOnError extends boolean = false>(
  options: Options<GetOrganisationAllowanceUsageData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetOrganisationAllowanceUsageResponses,
    GetOrganisationAllowanceUsageErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/account/organisation/{uid}/allowance_usage',
    ...options,
  });

/**
 * Get Organisation Missing Extractions
 *
 * How many calendar and view-column extractions the organisation's contract files are missing.
 *
 * Extractions do not run while ``contract_management`` is off, and switching it back on does not
 * catch up by itself. Read this before ``POST .../missing-extractions/extract``: each missing
 * extraction costs one insights credit, and view columns are counted against EVERY contract in
 * their view, whatever extraction scope the column was created with.
 *
 * Raises:
 * NotFoundError: If organisation with given UID does not exist
 */
export const getOrganisationMissingExtractions = <ThrowOnError extends boolean = false>(
  options: Options<GetOrganisationMissingExtractionsData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetOrganisationMissingExtractionsResponses,
    GetOrganisationMissingExtractionsErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/account/organisation/{uid}/missing-extractions',
    ...options,
  });

/**
 * Extract Organisation Missing Extractions
 *
 * Back-fill the organisation's missing calendar and view-column extractions in the background.
 *
 * Returns what is being dispatched, as counted at request time (the worker re-derives it with the
 * same plan, so anything asked in between is not asked twice).
 *
 * Raises:
 * NotFoundError: If organisation with given UID does not exist
 * BadRequestError: If ``contract_management`` is off — the extractions would be skipped
 */
export const extractOrganisationMissingExtractions = <ThrowOnError extends boolean = false>(
  options: Options<ExtractOrganisationMissingExtractionsData, ThrowOnError>
) =>
  (options.client ?? client).post<
    ExtractOrganisationMissingExtractionsResponses,
    ExtractOrganisationMissingExtractionsErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/account/organisation/{uid}/missing-extractions/extract',
    ...options,
  });

/**
 * Remove All Shares By Contract
 *
 * Remove every user share on a contract.
 */
export const removeAllSharesByContract = <ThrowOnError extends boolean = false>(
  options: Options<RemoveAllSharesByContractData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    RemoveAllSharesByContractResponses,
    RemoveAllSharesByContractErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/account/permissions/contract-share/contract/{contract_uid}',
    ...options,
  });

/**
 * Get Contract Share Contract
 *
 * Get all user shares for a contract.
 */
export const getContractShareContract = <ThrowOnError extends boolean = false>(
  options: Options<GetContractShareContractData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetContractShareContractResponses,
    GetContractShareContractErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/account/permissions/contract-share/contract/{contract_uid}',
    ...options,
  });

/**
 * Remove All Shares By User
 *
 * Remove every contract share held by a user.
 *
 * Allowed for an org admin **or the user themselves** — a member may revoke their own
 * access. The role-share equivalent is org-admin only; that asymmetry is deliberate.
 */
export const removeAllSharesByUser = <ThrowOnError extends boolean = false>(
  options: Options<RemoveAllSharesByUserData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    RemoveAllSharesByUserResponses,
    RemoveAllSharesByUserErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/account/permissions/contract-share/user/{user_uid}',
    ...options,
  });

/**
 * Get Contract Share User
 *
 * Get all contract shares held by a user.
 */
export const getContractShareUser = <ThrowOnError extends boolean = false>(
  options: Options<GetContractShareUserData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetContractShareUserResponses,
    GetContractShareUserErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/account/permissions/contract-share/user/{user_uid}',
    ...options,
  });

/**
 * Search Shares By Contract
 *
 * Search a contract's user shares. The search text matches the shared-with **user**.
 */
export const searchSharesByContract = <ThrowOnError extends boolean = false>(
  options: Options<SearchSharesByContractData, ThrowOnError>
) =>
  (options.client ?? client).post<
    SearchSharesByContractResponses,
    SearchSharesByContractErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/account/permissions/contract-share/contract/{contract_uid}/search',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Search Shares By User
 *
 * Search a user's contract shares. The search text matches the **contract**.
 */
export const searchSharesByUser = <ThrowOnError extends boolean = false>(
  options: Options<SearchSharesByUserData, ThrowOnError>
) =>
  (options.client ?? client).post<
    SearchSharesByUserResponses,
    SearchSharesByUserErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/account/permissions/contract-share/user/{user_uid}/search',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Remove Contract Share
 *
 * Remove one user's share on one contract.
 */
export const removeContractShare = <ThrowOnError extends boolean = false>(
  options: Options<RemoveContractShareData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    RemoveContractShareResponses,
    RemoveContractShareErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/account/permissions/contract-share/contract/{contract_uid}/user/{user_uid}',
    ...options,
  });

/**
 * Update Contract Share Permissions
 *
 * Update the permissions of one user's share on one contract.
 */
export const updateContractSharePermissions = <ThrowOnError extends boolean = false>(
  options: Options<UpdateContractSharePermissionsData, ThrowOnError>
) =>
  (options.client ?? client).put<
    UpdateContractSharePermissionsResponses,
    UpdateContractSharePermissionsErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/account/permissions/contract-share/contract/{contract_uid}/user/{user_uid}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Remove All Shares By Contract
 *
 * Remove every role share on a contract.
 */
export const removeAllSharesByContract2 = <ThrowOnError extends boolean = false>(
  options: Options<RemoveAllSharesByContract2Data, ThrowOnError>
) =>
  (options.client ?? client).delete<
    RemoveAllSharesByContract2Responses,
    RemoveAllSharesByContract2Errors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/account/permissions/contract-role-share/contract/{contract_uid}',
    ...options,
  });

/**
 * Get Contract Share By Contract
 *
 * Get all role shares for a contract.
 */
export const getContractShareByContract = <ThrowOnError extends boolean = false>(
  options: Options<GetContractShareByContractData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetContractShareByContractResponses,
    GetContractShareByContractErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/account/permissions/contract-role-share/contract/{contract_uid}',
    ...options,
  });

/**
 * Remove All Shares By Role
 *
 * Remove every contract share held by a role. **Org admins only** — unlike the user
 * variant, a holder of the role cannot revoke the role's shares.
 */
export const removeAllSharesByRole = <ThrowOnError extends boolean = false>(
  options: Options<RemoveAllSharesByRoleData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    RemoveAllSharesByRoleResponses,
    RemoveAllSharesByRoleErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/account/permissions/contract-role-share/role/{role_uid}',
    ...options,
  });

/**
 * Get Contract Share By Role
 *
 * Get all contract shares held by a role.
 */
export const getContractShareByRole = <ThrowOnError extends boolean = false>(
  options: Options<GetContractShareByRoleData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetContractShareByRoleResponses,
    GetContractShareByRoleErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/account/permissions/contract-role-share/role/{role_uid}',
    ...options,
  });

/**
 * Search Shares By Contract
 *
 * Search a contract's role shares. The search text matches the shared-with **role**.
 */
export const searchSharesByContract2 = <ThrowOnError extends boolean = false>(
  options: Options<SearchSharesByContract2Data, ThrowOnError>
) =>
  (options.client ?? client).post<
    SearchSharesByContract2Responses,
    SearchSharesByContract2Errors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/account/permissions/contract-role-share/contract/{contract_uid}/search',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Search Shares By Role
 *
 * Search a role's contract shares. The search text matches the **contract**.
 */
export const searchSharesByRole = <ThrowOnError extends boolean = false>(
  options: Options<SearchSharesByRoleData, ThrowOnError>
) =>
  (options.client ?? client).post<
    SearchSharesByRoleResponses,
    SearchSharesByRoleErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/account/permissions/contract-role-share/role/{role_uid}/search',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Remove Contract Share
 *
 * Remove one role's share on one contract.
 */
export const removeContractShare2 = <ThrowOnError extends boolean = false>(
  options: Options<RemoveContractShare2Data, ThrowOnError>
) =>
  (options.client ?? client).delete<
    RemoveContractShare2Responses,
    RemoveContractShare2Errors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/account/permissions/contract-role-share/contract/{contract_uid}/role/{role_uid}',
    ...options,
  });

/**
 * Update Contract Share Permissions
 *
 * Update the permissions of one role's share on one contract.
 */
export const updateContractSharePermissions2 = <ThrowOnError extends boolean = false>(
  options: Options<UpdateContractSharePermissions2Data, ThrowOnError>
) =>
  (options.client ?? client).put<
    UpdateContractSharePermissions2Responses,
    UpdateContractSharePermissions2Errors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/account/permissions/contract-role-share/contract/{contract_uid}/role/{role_uid}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Remove All Shares By Contractual Party
 *
 * Remove every user share on a contractual party.
 */
export const removeAllSharesByContractualParty = <ThrowOnError extends boolean = false>(
  options: Options<RemoveAllSharesByContractualPartyData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    RemoveAllSharesByContractualPartyResponses,
    RemoveAllSharesByContractualPartyErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/account/permissions/contractual-party-share/contractual-party/{contractual_party_uid}',
    ...options,
  });

/**
 * Get Contractual Party Share Contractual Party
 *
 * Get all user shares for a contractual party.
 */
export const getContractualPartyShareContractualParty = <ThrowOnError extends boolean = false>(
  options: Options<GetContractualPartyShareContractualPartyData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetContractualPartyShareContractualPartyResponses,
    GetContractualPartyShareContractualPartyErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/account/permissions/contractual-party-share/contractual-party/{contractual_party_uid}',
    ...options,
  });

/**
 * Remove All Shares By User
 *
 * Remove every contractual party share held by a user.
 *
 * Allowed for an org admin **or the user themselves** — a member may revoke their own
 * access. The role-share equivalent is org-admin only; that asymmetry is deliberate.
 */
export const removeAllSharesByUser2 = <ThrowOnError extends boolean = false>(
  options: Options<RemoveAllSharesByUser2Data, ThrowOnError>
) =>
  (options.client ?? client).delete<
    RemoveAllSharesByUser2Responses,
    RemoveAllSharesByUser2Errors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/account/permissions/contractual-party-share/user/{user_uid}',
    ...options,
  });

/**
 * Get Contractual Party Share User
 *
 * Get all contractual party shares held by a user.
 */
export const getContractualPartyShareUser = <ThrowOnError extends boolean = false>(
  options: Options<GetContractualPartyShareUserData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetContractualPartyShareUserResponses,
    GetContractualPartyShareUserErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/account/permissions/contractual-party-share/user/{user_uid}',
    ...options,
  });

/**
 * Search Shares By Contractual Party
 *
 * Search a contractual party's user shares. The search text matches the shared-with **user**.
 */
export const searchSharesByContractualParty = <ThrowOnError extends boolean = false>(
  options: Options<SearchSharesByContractualPartyData, ThrowOnError>
) =>
  (options.client ?? client).post<
    SearchSharesByContractualPartyResponses,
    SearchSharesByContractualPartyErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/account/permissions/contractual-party-share/contractual-party/{contractual_party_uid}/search',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Search Shares By User
 *
 * Search a user's contractual party shares. The search text matches the **contractual party**.
 */
export const searchSharesByUser2 = <ThrowOnError extends boolean = false>(
  options: Options<SearchSharesByUser2Data, ThrowOnError>
) =>
  (options.client ?? client).post<
    SearchSharesByUser2Responses,
    SearchSharesByUser2Errors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/account/permissions/contractual-party-share/user/{user_uid}/search',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Remove Contractual Party Share
 *
 * Remove one user's share on one contractual party.
 */
export const removeContractualPartyShare = <ThrowOnError extends boolean = false>(
  options: Options<RemoveContractualPartyShareData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    RemoveContractualPartyShareResponses,
    RemoveContractualPartyShareErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/account/permissions/contractual-party-share/contractual-party/{contractual_party_uid}/user/{user_uid}',
    ...options,
  });

/**
 * Update Contractual Party Share Permissions
 *
 * Update the permissions of one user's share on one contractual party.
 */
export const updateContractualPartySharePermissions = <ThrowOnError extends boolean = false>(
  options: Options<UpdateContractualPartySharePermissionsData, ThrowOnError>
) =>
  (options.client ?? client).put<
    UpdateContractualPartySharePermissionsResponses,
    UpdateContractualPartySharePermissionsErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/account/permissions/contractual-party-share/contractual-party/{contractual_party_uid}/user/{user_uid}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Remove All Shares By Contractual Party
 *
 * Remove every role share on a contractual party.
 */
export const removeAllSharesByContractualParty2 = <ThrowOnError extends boolean = false>(
  options: Options<RemoveAllSharesByContractualParty2Data, ThrowOnError>
) =>
  (options.client ?? client).delete<
    RemoveAllSharesByContractualParty2Responses,
    RemoveAllSharesByContractualParty2Errors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/account/permissions/contractual-party-role-share/contractual-party/{contractual_party_uid}',
    ...options,
  });

/**
 * Get Contractual Party Share By Contractual Party
 *
 * Get all role shares for a contractual party.
 */
export const getContractualPartyShareByContractualParty = <ThrowOnError extends boolean = false>(
  options: Options<GetContractualPartyShareByContractualPartyData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetContractualPartyShareByContractualPartyResponses,
    GetContractualPartyShareByContractualPartyErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/account/permissions/contractual-party-role-share/contractual-party/{contractual_party_uid}',
    ...options,
  });

/**
 * Remove All Shares By Role
 *
 * Remove every contractual party share held by a role. **Org admins only** — unlike the user
 * variant, a holder of the role cannot revoke the role's shares.
 */
export const removeAllSharesByRole2 = <ThrowOnError extends boolean = false>(
  options: Options<RemoveAllSharesByRole2Data, ThrowOnError>
) =>
  (options.client ?? client).delete<
    RemoveAllSharesByRole2Responses,
    RemoveAllSharesByRole2Errors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/account/permissions/contractual-party-role-share/role/{role_uid}',
    ...options,
  });

/**
 * Get Contractual Party Share By Role
 *
 * Get all contractual party shares held by a role.
 */
export const getContractualPartyShareByRole = <ThrowOnError extends boolean = false>(
  options: Options<GetContractualPartyShareByRoleData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetContractualPartyShareByRoleResponses,
    GetContractualPartyShareByRoleErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/account/permissions/contractual-party-role-share/role/{role_uid}',
    ...options,
  });

/**
 * Search Shares By Contractual Party
 *
 * Search a contractual party's role shares. The search text matches the shared-with **role**.
 */
export const searchSharesByContractualParty2 = <ThrowOnError extends boolean = false>(
  options: Options<SearchSharesByContractualParty2Data, ThrowOnError>
) =>
  (options.client ?? client).post<
    SearchSharesByContractualParty2Responses,
    SearchSharesByContractualParty2Errors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/account/permissions/contractual-party-role-share/contractual-party/{contractual_party_uid}/search',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Search Shares By Role
 *
 * Search a role's contractual party shares. The search text matches the **contractual party**.
 */
export const searchSharesByRole2 = <ThrowOnError extends boolean = false>(
  options: Options<SearchSharesByRole2Data, ThrowOnError>
) =>
  (options.client ?? client).post<
    SearchSharesByRole2Responses,
    SearchSharesByRole2Errors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/account/permissions/contractual-party-role-share/role/{role_uid}/search',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Remove Contractual Party Share
 *
 * Remove one role's share on one contractual party.
 */
export const removeContractualPartyShare2 = <ThrowOnError extends boolean = false>(
  options: Options<RemoveContractualPartyShare2Data, ThrowOnError>
) =>
  (options.client ?? client).delete<
    RemoveContractualPartyShare2Responses,
    RemoveContractualPartyShare2Errors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/account/permissions/contractual-party-role-share/contractual-party/{contractual_party_uid}/role/{role_uid}',
    ...options,
  });

/**
 * Update Contractual Party Share Permissions
 *
 * Update the permissions of one role's share on one contractual party.
 */
export const updateContractualPartySharePermissions2 = <ThrowOnError extends boolean = false>(
  options: Options<UpdateContractualPartySharePermissions2Data, ThrowOnError>
) =>
  (options.client ?? client).put<
    UpdateContractualPartySharePermissions2Responses,
    UpdateContractualPartySharePermissions2Errors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/account/permissions/contractual-party-role-share/contractual-party/{contractual_party_uid}/role/{role_uid}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Create Role
 *
 * Create a new role.
 */
export const createRole = <ThrowOnError extends boolean = false>(
  options: Options<CreateRoleData, ThrowOnError>
) =>
  (options.client ?? client).post<CreateRoleResponses, CreateRoleErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/account/permissions/role/new',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Search Roles
 *
 * Search roles within the active organisation.
 */
export const searchRoles = <ThrowOnError extends boolean = false>(
  options: Options<SearchRolesData, ThrowOnError>
) =>
  (options.client ?? client).post<SearchRolesResponses, SearchRolesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/account/permissions/role/search',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * List Roles For User
 *
 * List roles assigned to a user for the active organisation.
 *
 * Raises:
 * NotFoundError: If user not found
 * UnauthorizedError: If user not in organisation
 */
export const listRolesForUser = <ThrowOnError extends boolean = false>(
  options: Options<ListRolesForUserData, ThrowOnError>
) =>
  (options.client ?? client).get<ListRolesForUserResponses, ListRolesForUserErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/account/permissions/role/user/{user_uid}',
    ...options,
  });

/**
 * Delete Role
 *
 * Delete a role.
 *
 * Raises:
 * NotFoundError: If role not found
 * UnauthorizedError: If role not in organisation
 * BadRequestError: If attempting to delete a protected role
 */
export const deleteRole = <ThrowOnError extends boolean = false>(
  options: Options<DeleteRoleData, ThrowOnError>
) =>
  (options.client ?? client).delete<DeleteRoleResponses, DeleteRoleErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/account/permissions/role/{uid}',
    ...options,
  });

/**
 * Get Role
 *
 * Get a role by UID.
 *
 * Raises:
 * NotFoundError: If role not found
 * UnauthorizedError: If role not in organisation
 */
export const getRole = <ThrowOnError extends boolean = false>(
  options: Options<GetRoleData, ThrowOnError>
) =>
  (options.client ?? client).get<GetRoleResponses, GetRoleErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/account/permissions/role/{uid}',
    ...options,
  });

/**
 * Update Role
 *
 * Update a role's metadata.
 *
 * A protected role keeps its name, which identifies it. The protected admin role also keeps
 * its capability flags (admins bypass every flag anyway), so only its description changes.
 * Resending an unchanged value is accepted.
 *
 * Raises:
 * NotFoundError: If role not found
 * UnauthorizedError: If role not in organisation
 * BadRequestError: If attempting to change a locked field of a protected role
 */
export const updateRole = <ThrowOnError extends boolean = false>(
  options: Options<UpdateRoleData, ThrowOnError>
) =>
  (options.client ?? client).put<UpdateRoleResponses, UpdateRoleErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/account/permissions/role/{uid}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Assign Users To Role
 *
 * Assign one or more users to a role.
 *
 * Handles both single and bulk assignment; the response reports success or failure per
 * user (e.g. already assigned, not in organisation). The batch settles in one transaction.
 */
export const assignUsersToRole = <ThrowOnError extends boolean = false>(
  options: Options<AssignUsersToRoleData, ThrowOnError>
) =>
  (options.client ?? client).post<
    AssignUsersToRoleResponses,
    AssignUsersToRoleErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/account/permissions/role/{role_uid}/users',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Remove Users From Role
 *
 * Remove one or more users from a role.
 *
 * Handles both single and bulk removal; the response reports success or failure per user
 * (e.g. not assigned to role, not in organisation). The batch settles in one transaction.
 */
export const removeUsersFromRole = <ThrowOnError extends boolean = false>(
  options: Options<RemoveUsersFromRoleData, ThrowOnError>
) =>
  (options.client ?? client).post<
    RemoveUsersFromRoleResponses,
    RemoveUsersFromRoleErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/account/permissions/role/{role_uid}/users/remove',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Search Users In Role
 *
 * Search the users assigned to a role, paginated.
 *
 * Visible to the organisation's admins and to the role's own members (checked through the
 * role repo).
 *
 * Raises:
 * NotFoundError: If role not found in the active organisation
 * UnauthorizedError: If the caller is neither an org admin nor a member of the role
 */
export const searchUsersInRole = <ThrowOnError extends boolean = false>(
  options: Options<SearchUsersInRoleData, ThrowOnError>
) =>
  (options.client ?? client).post<
    SearchUsersInRoleResponses,
    SearchUsersInRoleErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/account/permissions/role/{role_uid}/users/search',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Remove Template Role Share
 */
export const removeTemplateRoleShare = <ThrowOnError extends boolean = false>(
  options: Options<RemoveTemplateRoleShareData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    RemoveTemplateRoleShareResponses,
    RemoveTemplateRoleShareErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/account/permissions/template-role-share/template/{template_uid}/role/{role_uid}',
    ...options,
  });

/**
 * Upsert Template Role Share
 *
 * Grant a permission group access to a template (or update if already granted).
 */
export const upsertTemplateRoleShare = <ThrowOnError extends boolean = false>(
  options: Options<UpsertTemplateRoleShareData, ThrowOnError>
) =>
  (options.client ?? client).post<
    UpsertTemplateRoleShareResponses,
    UpsertTemplateRoleShareErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/account/permissions/template-role-share/template/{template_uid}/role/{role_uid}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Update Template Role Share Permissions
 */
export const updateTemplateRoleSharePermissions = <ThrowOnError extends boolean = false>(
  options: Options<UpdateTemplateRoleSharePermissionsData, ThrowOnError>
) =>
  (options.client ?? client).put<
    UpdateTemplateRoleSharePermissionsResponses,
    UpdateTemplateRoleSharePermissionsErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/account/permissions/template-role-share/template/{template_uid}/role/{role_uid}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Remove All Role Shares By Template
 */
export const removeAllRoleSharesByTemplate = <ThrowOnError extends boolean = false>(
  options: Options<RemoveAllRoleSharesByTemplateData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    RemoveAllRoleSharesByTemplateResponses,
    RemoveAllRoleSharesByTemplateErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/account/permissions/template-role-share/template/{template_uid}',
    ...options,
  });

/**
 * Get Role Shares By Template
 *
 * List every role share for a template.
 */
export const getRoleSharesByTemplate = <ThrowOnError extends boolean = false>(
  options: Options<GetRoleSharesByTemplateData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetRoleSharesByTemplateResponses,
    GetRoleSharesByTemplateErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/account/permissions/template-role-share/template/{template_uid}',
    ...options,
  });

/**
 * Remove All Template Shares By Role
 */
export const removeAllTemplateSharesByRole = <ThrowOnError extends boolean = false>(
  options: Options<RemoveAllTemplateSharesByRoleData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    RemoveAllTemplateSharesByRoleResponses,
    RemoveAllTemplateSharesByRoleErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/account/permissions/template-role-share/role/{role_uid}',
    ...options,
  });

/**
 * Get Template Shares By Role
 *
 * List every template share for a role (org admins or role members).
 */
export const getTemplateSharesByRole = <ThrowOnError extends boolean = false>(
  options: Options<GetTemplateSharesByRoleData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetTemplateSharesByRoleResponses,
    GetTemplateSharesByRoleErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/account/permissions/template-role-share/role/{role_uid}',
    ...options,
  });

/**
 * Search Shares By Template
 */
export const searchSharesByTemplate = <ThrowOnError extends boolean = false>(
  options: Options<SearchSharesByTemplateData, ThrowOnError>
) =>
  (options.client ?? client).post<
    SearchSharesByTemplateResponses,
    SearchSharesByTemplateErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/account/permissions/template-role-share/template/{template_uid}/search',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Search Shares By Role
 */
export const searchSharesByRole3 = <ThrowOnError extends boolean = false>(
  options: Options<SearchSharesByRole3Data, ThrowOnError>
) =>
  (options.client ?? client).post<
    SearchSharesByRole3Responses,
    SearchSharesByRole3Errors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/account/permissions/template-role-share/role/{role_uid}/search',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Remove All File Shares By File
 *
 * Remove every user share on a vault file.
 */
export const removeAllFileSharesByFile = <ThrowOnError extends boolean = false>(
  options: Options<RemoveAllFileSharesByFileData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    RemoveAllFileSharesByFileResponses,
    RemoveAllFileSharesByFileErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/account/permissions/file-share/file/{file_uid}',
    ...options,
  });

/**
 * Get File Shares By File
 *
 * Get all user shares on a vault file.
 */
export const getFileSharesByFile = <ThrowOnError extends boolean = false>(
  options: Options<GetFileSharesByFileData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetFileSharesByFileResponses,
    GetFileSharesByFileErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/account/permissions/file-share/file/{file_uid}',
    ...options,
  });

/**
 * Remove All File Shares By User
 *
 * Remove every vault file share held by a user.
 *
 * Allowed for an org admin **or the user themselves** — as for contract shares, a member may
 * revoke their own access.
 */
export const removeAllFileSharesByUser = <ThrowOnError extends boolean = false>(
  options: Options<RemoveAllFileSharesByUserData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    RemoveAllFileSharesByUserResponses,
    RemoveAllFileSharesByUserErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/account/permissions/file-share/user/{user_uid}',
    ...options,
  });

/**
 * Get File Shares By User
 *
 * Get all vault file shares held by a user.
 */
export const getFileSharesByUser = <ThrowOnError extends boolean = false>(
  options: Options<GetFileSharesByUserData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetFileSharesByUserResponses,
    GetFileSharesByUserErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/account/permissions/file-share/user/{user_uid}',
    ...options,
  });

/**
 * Search File Shares By File
 *
 * Search a vault file's user shares. The search text matches the shared-with **user**.
 */
export const searchFileSharesByFile = <ThrowOnError extends boolean = false>(
  options: Options<SearchFileSharesByFileData, ThrowOnError>
) =>
  (options.client ?? client).post<
    SearchFileSharesByFileResponses,
    SearchFileSharesByFileErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/account/permissions/file-share/file/{file_uid}/search',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Search File Shares By User
 *
 * Search a user's vault file shares. The search text matches the file's **current revision**.
 */
export const searchFileSharesByUser = <ThrowOnError extends boolean = false>(
  options: Options<SearchFileSharesByUserData, ThrowOnError>
) =>
  (options.client ?? client).post<
    SearchFileSharesByUserResponses,
    SearchFileSharesByUserErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/account/permissions/file-share/user/{user_uid}/search',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Remove File Share
 *
 * Remove one user's share on one vault file.
 */
export const removeFileShare = <ThrowOnError extends boolean = false>(
  options: Options<RemoveFileShareData, ThrowOnError>
) =>
  (options.client ?? client).delete<RemoveFileShareResponses, RemoveFileShareErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/account/permissions/file-share/file/{file_uid}/user/{user_uid}',
    ...options,
  });

/**
 * Upsert File Share
 *
 * Set one user's permissions on one vault file, creating the share when it does not exist.
 *
 * ``permissions: null`` leaves an existing share alone and is refused (400) for a new one.
 */
export const upsertFileShare = <ThrowOnError extends boolean = false>(
  options: Options<UpsertFileShareData, ThrowOnError>
) =>
  (options.client ?? client).put<UpsertFileShareResponses, UpsertFileShareErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/account/permissions/file-share/file/{file_uid}/user/{user_uid}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Remove All File Role Shares By File
 *
 * Remove every role share on a vault file.
 */
export const removeAllFileRoleSharesByFile = <ThrowOnError extends boolean = false>(
  options: Options<RemoveAllFileRoleSharesByFileData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    RemoveAllFileRoleSharesByFileResponses,
    RemoveAllFileRoleSharesByFileErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/account/permissions/file-role-share/file/{file_uid}',
    ...options,
  });

/**
 * Get File Role Shares By File
 *
 * Get all role shares on a vault file.
 */
export const getFileRoleSharesByFile = <ThrowOnError extends boolean = false>(
  options: Options<GetFileRoleSharesByFileData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetFileRoleSharesByFileResponses,
    GetFileRoleSharesByFileErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/account/permissions/file-role-share/file/{file_uid}',
    ...options,
  });

/**
 * Remove All File Role Shares By Role
 *
 * Remove every vault file share held by a role. **Org admins only** — unlike the user
 * variant, a holder of the role cannot revoke the role's shares.
 */
export const removeAllFileRoleSharesByRole = <ThrowOnError extends boolean = false>(
  options: Options<RemoveAllFileRoleSharesByRoleData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    RemoveAllFileRoleSharesByRoleResponses,
    RemoveAllFileRoleSharesByRoleErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/account/permissions/file-role-share/role/{role_uid}',
    ...options,
  });

/**
 * Get File Role Shares By Role
 *
 * Get all vault file shares held by a role.
 */
export const getFileRoleSharesByRole = <ThrowOnError extends boolean = false>(
  options: Options<GetFileRoleSharesByRoleData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetFileRoleSharesByRoleResponses,
    GetFileRoleSharesByRoleErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/account/permissions/file-role-share/role/{role_uid}',
    ...options,
  });

/**
 * Search File Role Shares By File
 *
 * Search a vault file's role shares. The search text matches the shared-with **role**.
 */
export const searchFileRoleSharesByFile = <ThrowOnError extends boolean = false>(
  options: Options<SearchFileRoleSharesByFileData, ThrowOnError>
) =>
  (options.client ?? client).post<
    SearchFileRoleSharesByFileResponses,
    SearchFileRoleSharesByFileErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/account/permissions/file-role-share/file/{file_uid}/search',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Search File Role Shares By Role
 *
 * Search a role's vault file shares. The search text matches the file's **current revision**.
 */
export const searchFileRoleSharesByRole = <ThrowOnError extends boolean = false>(
  options: Options<SearchFileRoleSharesByRoleData, ThrowOnError>
) =>
  (options.client ?? client).post<
    SearchFileRoleSharesByRoleResponses,
    SearchFileRoleSharesByRoleErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/account/permissions/file-role-share/role/{role_uid}/search',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Remove File Role Share
 *
 * Remove one role's share on one vault file.
 */
export const removeFileRoleShare = <ThrowOnError extends boolean = false>(
  options: Options<RemoveFileRoleShareData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    RemoveFileRoleShareResponses,
    RemoveFileRoleShareErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/account/permissions/file-role-share/file/{file_uid}/role/{role_uid}',
    ...options,
  });

/**
 * Upsert File Role Share
 *
 * Set one role's permissions on one vault file, creating the share when it does not exist.
 *
 * ``permissions: null`` leaves an existing share alone and is refused (400) for a new one.
 */
export const upsertFileRoleShare = <ThrowOnError extends boolean = false>(
  options: Options<UpsertFileRoleShareData, ThrowOnError>
) =>
  (options.client ?? client).put<
    UpsertFileRoleShareResponses,
    UpsertFileRoleShareErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/account/permissions/file-role-share/file/{file_uid}/role/{role_uid}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Remove All Directory Shares By Directory
 *
 * Remove every user share on a vault directory.
 */
export const removeAllDirectorySharesByDirectory = <ThrowOnError extends boolean = false>(
  options: Options<RemoveAllDirectorySharesByDirectoryData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    RemoveAllDirectorySharesByDirectoryResponses,
    RemoveAllDirectorySharesByDirectoryErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/account/permissions/directory-share/directory/{directory_uid}',
    ...options,
  });

/**
 * Get Directory Shares By Directory
 *
 * Get all user shares on a vault directory.
 */
export const getDirectorySharesByDirectory = <ThrowOnError extends boolean = false>(
  options: Options<GetDirectorySharesByDirectoryData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetDirectorySharesByDirectoryResponses,
    GetDirectorySharesByDirectoryErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/account/permissions/directory-share/directory/{directory_uid}',
    ...options,
  });

/**
 * Remove All Directory Shares By User
 *
 * Remove every vault directory share held by a user.
 *
 * Allowed for an org admin **or the user themselves** — as for contract shares, a member may
 * revoke their own access.
 */
export const removeAllDirectorySharesByUser = <ThrowOnError extends boolean = false>(
  options: Options<RemoveAllDirectorySharesByUserData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    RemoveAllDirectorySharesByUserResponses,
    RemoveAllDirectorySharesByUserErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/account/permissions/directory-share/user/{user_uid}',
    ...options,
  });

/**
 * Get Directory Shares By User
 *
 * Get all vault directory shares held by a user.
 */
export const getDirectorySharesByUser = <ThrowOnError extends boolean = false>(
  options: Options<GetDirectorySharesByUserData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetDirectorySharesByUserResponses,
    GetDirectorySharesByUserErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/account/permissions/directory-share/user/{user_uid}',
    ...options,
  });

/**
 * Search Directory Shares By Directory
 *
 * Search a vault directory's user shares. The search text matches the shared-with **user**.
 */
export const searchDirectorySharesByDirectory = <ThrowOnError extends boolean = false>(
  options: Options<SearchDirectorySharesByDirectoryData, ThrowOnError>
) =>
  (options.client ?? client).post<
    SearchDirectorySharesByDirectoryResponses,
    SearchDirectorySharesByDirectoryErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/account/permissions/directory-share/directory/{directory_uid}/search',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Search Directory Shares By User
 *
 * Search a user's vault directory shares. The search text matches the **directory name**.
 */
export const searchDirectorySharesByUser = <ThrowOnError extends boolean = false>(
  options: Options<SearchDirectorySharesByUserData, ThrowOnError>
) =>
  (options.client ?? client).post<
    SearchDirectorySharesByUserResponses,
    SearchDirectorySharesByUserErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/account/permissions/directory-share/user/{user_uid}/search',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Remove Directory Share
 *
 * Remove one user's share on one vault directory.
 */
export const removeDirectoryShare = <ThrowOnError extends boolean = false>(
  options: Options<RemoveDirectoryShareData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    RemoveDirectoryShareResponses,
    RemoveDirectoryShareErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/account/permissions/directory-share/directory/{directory_uid}/user/{user_uid}',
    ...options,
  });

/**
 * Upsert Directory Share
 *
 * Set one user's permissions on one vault directory, creating the share when it does not exist.
 *
 * ``permissions: null`` leaves an existing share alone and is refused (400) for a new one.
 */
export const upsertDirectoryShare = <ThrowOnError extends boolean = false>(
  options: Options<UpsertDirectoryShareData, ThrowOnError>
) =>
  (options.client ?? client).put<
    UpsertDirectoryShareResponses,
    UpsertDirectoryShareErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/account/permissions/directory-share/directory/{directory_uid}/user/{user_uid}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Remove All Directory Role Shares By Directory
 *
 * Remove every role share on a vault directory.
 */
export const removeAllDirectoryRoleSharesByDirectory = <ThrowOnError extends boolean = false>(
  options: Options<RemoveAllDirectoryRoleSharesByDirectoryData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    RemoveAllDirectoryRoleSharesByDirectoryResponses,
    RemoveAllDirectoryRoleSharesByDirectoryErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/account/permissions/directory-role-share/directory/{directory_uid}',
    ...options,
  });

/**
 * Get Directory Role Shares By Directory
 *
 * Get all role shares on a vault directory.
 */
export const getDirectoryRoleSharesByDirectory = <ThrowOnError extends boolean = false>(
  options: Options<GetDirectoryRoleSharesByDirectoryData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetDirectoryRoleSharesByDirectoryResponses,
    GetDirectoryRoleSharesByDirectoryErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/account/permissions/directory-role-share/directory/{directory_uid}',
    ...options,
  });

/**
 * Remove All Directory Role Shares By Role
 *
 * Remove every vault directory share held by a role. **Org admins only** — unlike the user
 * variant, a holder of the role cannot revoke the role's shares.
 */
export const removeAllDirectoryRoleSharesByRole = <ThrowOnError extends boolean = false>(
  options: Options<RemoveAllDirectoryRoleSharesByRoleData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    RemoveAllDirectoryRoleSharesByRoleResponses,
    RemoveAllDirectoryRoleSharesByRoleErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/account/permissions/directory-role-share/role/{role_uid}',
    ...options,
  });

/**
 * Get Directory Role Shares By Role
 *
 * Get all vault directory shares held by a role.
 */
export const getDirectoryRoleSharesByRole = <ThrowOnError extends boolean = false>(
  options: Options<GetDirectoryRoleSharesByRoleData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetDirectoryRoleSharesByRoleResponses,
    GetDirectoryRoleSharesByRoleErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/account/permissions/directory-role-share/role/{role_uid}',
    ...options,
  });

/**
 * Search Directory Role Shares By Directory
 *
 * Search a vault directory's role shares. The search text matches the shared-with **role**.
 */
export const searchDirectoryRoleSharesByDirectory = <ThrowOnError extends boolean = false>(
  options: Options<SearchDirectoryRoleSharesByDirectoryData, ThrowOnError>
) =>
  (options.client ?? client).post<
    SearchDirectoryRoleSharesByDirectoryResponses,
    SearchDirectoryRoleSharesByDirectoryErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/account/permissions/directory-role-share/directory/{directory_uid}/search',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Search Directory Role Shares By Role
 *
 * Search a role's vault directory shares. The search text matches the **directory name**.
 */
export const searchDirectoryRoleSharesByRole = <ThrowOnError extends boolean = false>(
  options: Options<SearchDirectoryRoleSharesByRoleData, ThrowOnError>
) =>
  (options.client ?? client).post<
    SearchDirectoryRoleSharesByRoleResponses,
    SearchDirectoryRoleSharesByRoleErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/account/permissions/directory-role-share/role/{role_uid}/search',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Remove Directory Role Share
 *
 * Remove one role's share on one vault directory.
 */
export const removeDirectoryRoleShare = <ThrowOnError extends boolean = false>(
  options: Options<RemoveDirectoryRoleShareData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    RemoveDirectoryRoleShareResponses,
    RemoveDirectoryRoleShareErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/account/permissions/directory-role-share/directory/{directory_uid}/role/{role_uid}',
    ...options,
  });

/**
 * Upsert Directory Role Share
 *
 * Set one role's permissions on one vault directory, creating the share when it does not exist.
 *
 * ``permissions: null`` leaves an existing share alone and is refused (400) for a new one.
 */
export const upsertDirectoryRoleShare = <ThrowOnError extends boolean = false>(
  options: Options<UpsertDirectoryRoleShareData, ThrowOnError>
) =>
  (options.client ?? client).put<
    UpsertDirectoryRoleShareResponses,
    UpsertDirectoryRoleShareErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/account/permissions/directory-role-share/directory/{directory_uid}/role/{role_uid}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Bulk Contract Share
 *
 * Share contracts with users and roles.
 *
 * Every listed contract is shared with every listed user and role, applying the given
 * permissions. Existing shares get their permissions overwritten. Requires admin
 * permission on every contract. Sharing a single contract is a bulk share with one element.
 */
export const bulkContractShare = <ThrowOnError extends boolean = false>(
  options: Options<BulkContractShareData, ThrowOnError>
) =>
  (options.client ?? client).post<
    BulkContractShareResponses,
    BulkContractShareErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/account/permissions/bulk-contract-share',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Bulk Contractual Party Share
 *
 * Share contractual parties with users and roles — :func:`bulk_contract_share` for parties.
 *
 * Every listed party is shared with every listed user and role, applying the given
 * permissions. Existing shares get their permissions overwritten. Requires admin
 * permission on every party.
 */
export const bulkContractualPartyShare = <ThrowOnError extends boolean = false>(
  options: Options<BulkContractualPartyShareData, ThrowOnError>
) =>
  (options.client ?? client).post<
    BulkContractualPartyShareResponses,
    BulkContractualPartyShareErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/account/permissions/bulk-contractual-party-share',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Bulk Vault Share
 *
 * Share vault files and directories with users and roles.
 *
 * The vault twin of :func:`bulk_contract_share`: every listed file and directory is shared with
 * every listed user and role, applying the given permissions; existing shares get their
 * permissions overwritten. Requires ADMIN on every item. Items of another organisation, items
 * the caller does not administrate, and unknown users and roles all read as absent (404).
 * Contract member files, anything in the system vault and the vault roots cannot be shared (400).
 */
export const bulkVaultShare = <ThrowOnError extends boolean = false>(
  options: Options<BulkVaultShareData, ThrowOnError>
) =>
  (options.client ?? client).post<BulkVaultShareResponses, BulkVaultShareErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/account/permissions/bulk-vault-share',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Resolve Invitation
 *
 * Resolve a plaintext invitation token for the accept page (unauthenticated).
 *
 * Returns only what the page needs to render. The rate-limit and recaptcha
 * gates are defense-in-depth against token guessing — the 512-bit token space
 * is not enumerable anyway.
 *
 * Args:
 * postgresql_session: Database session for PostgreSQL operations
 * token: The plaintext invitation token from the email link
 * _rate_limited: Rate-limit gate (raises 429 when exceeded)
 * _recaptcha_solved: Recaptcha gate (raises 403 without a valid token)
 *
 * Returns:
 * The public rendering data of the invitation
 *
 * Raises:
 * InvitationNotFoundError: If the token resolves to nothing
 * InvitationRevokedError: If the invitation was revoked
 * InvitationExpiredError: If the invitation expired
 */
export const resolveInvitation = <ThrowOnError extends boolean = false>(
  options: Options<ResolveInvitationData, ThrowOnError>
) =>
  (options.client ?? client).get<ResolveInvitationResponses, ResolveInvitationErrors, ThrowOnError>(
    { url: '/v1/app/account/invitations/{token}', ...options }
  );

/**
 * Accept Invitation
 *
 * Accept an invitation with a verified Firebase identity.
 *
 * The identity's email must match the invited email — proof of ownership plus
 * explicit consent. Creates the backend user in the inviting organisation, or
 * adds an existing user (someone with an account in another organisation) to
 * it, with the member role plus any roles selected on the invitation.
 *
 * Args:
 * postgresql_session: Database session for PostgreSQL operations
 * identity: The verified Firebase token identity of the acceptor
 * token: The plaintext invitation token from the email link
 *
 * Returns:
 * User: The created or updated user
 *
 * Raises:
 * InvitationNotFoundError: If the token resolves to nothing
 * InvitationRevokedError: If the invitation was revoked
 * InvitationExpiredError: If the invitation expired
 * InvitationEmailMismatchError: If the identity email does not match the invitation
 * AlreadyExistsError: If the invitation was already accepted by someone else
 */
export const acceptInvitation = <ThrowOnError extends boolean = false>(
  options: Options<AcceptInvitationData, ThrowOnError>
) =>
  (options.client ?? client).post<AcceptInvitationResponses, AcceptInvitationErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/account/invitations/{token}/accept',
    ...options,
  });

/**
 * Get User Statistics
 */
export const getUserStatistics = <ThrowOnError extends boolean = false>(
  options?: Options<GetUserStatisticsData, ThrowOnError>
) =>
  (options?.client ?? client).post<
    GetUserStatisticsResponses,
    GetUserStatisticsErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/admin/statistics/user',
    ...options,
  });

/**
 * Get User Activity Statistics
 *
 * Daily active users plus peak/total activity heatmap series, platform-wide and per organisation.
 *
 * Each authenticated request is weighted 0-3 by its app area's declared
 * activity score (``core/fastapi/shared/activity_scoring.py``): 0 baseline,
 * 1 chores, 2 looking at data, 3 productive work. A user's day keeps the
 * highest weight (peak) and the summed weights (total); ``min_points``
 * thresholds only the daily-active-users count, never the heatmap series.
 */
export const getUserActivityStatistics = <ThrowOnError extends boolean = false>(
  options?: Options<GetUserActivityStatisticsData, ThrowOnError>
) =>
  (options?.client ?? client).post<
    GetUserActivityStatisticsResponses,
    GetUserActivityStatisticsErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/admin/statistics/user-activity',
    ...options,
  });

/**
 * Get Organisation Statistics
 */
export const getOrganisationStatistics = <ThrowOnError extends boolean = false>(
  options?: Options<GetOrganisationStatisticsData, ThrowOnError>
) =>
  (options?.client ?? client).post<
    GetOrganisationStatisticsResponses,
    GetOrganisationStatisticsErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/admin/statistics/organisation',
    ...options,
  });

/**
 * Get Vault Statistics
 */
export const getVaultStatistics = <ThrowOnError extends boolean = false>(
  options?: Options<GetVaultStatisticsData, ThrowOnError>
) =>
  (options?.client ?? client).post<
    GetVaultStatisticsResponses,
    GetVaultStatisticsErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/admin/statistics/vault',
    ...options,
  });

/**
 * Get Review Statistics
 */
export const getReviewStatistics = <ThrowOnError extends boolean = false>(
  options?: Options<GetReviewStatisticsData, ThrowOnError>
) =>
  (options?.client ?? client).post<
    GetReviewStatisticsResponses,
    GetReviewStatisticsErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/admin/statistics/review',
    ...options,
  });

/**
 * Get Contract Statistics
 */
export const getContractStatistics = <ThrowOnError extends boolean = false>(
  options?: Options<GetContractStatisticsData, ThrowOnError>
) =>
  (options?.client ?? client).post<
    GetContractStatisticsResponses,
    GetContractStatisticsErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/admin/statistics/contracts',
    ...options,
  });

/**
 * Get Drafting Statistics
 */
export const getDraftingStatistics = <ThrowOnError extends boolean = false>(
  options?: Options<GetDraftingStatisticsData, ThrowOnError>
) =>
  (options?.client ?? client).post<
    GetDraftingStatisticsResponses,
    GetDraftingStatisticsErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/admin/statistics/drafting',
    ...options,
  });

/**
 * Get Playbook Statistics
 */
export const getPlaybookStatistics = <ThrowOnError extends boolean = false>(
  options?: Options<GetPlaybookStatisticsData, ThrowOnError>
) =>
  (options?.client ?? client).post<
    GetPlaybookStatisticsResponses,
    GetPlaybookStatisticsErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/admin/statistics/playbooks',
    ...options,
  });

/**
 * Get Chat Statistics
 */
export const getChatStatistics = <ThrowOnError extends boolean = false>(
  options?: Options<GetChatStatisticsData, ThrowOnError>
) =>
  (options?.client ?? client).post<
    GetChatStatisticsResponses,
    GetChatStatisticsErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/admin/statistics/chat',
    ...options,
  });

/**
 * Get Signing Statistics
 */
export const getSigningStatistics = <ThrowOnError extends boolean = false>(
  options?: Options<GetSigningStatisticsData, ThrowOnError>
) =>
  (options?.client ?? client).post<
    GetSigningStatisticsResponses,
    GetSigningStatisticsErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/admin/statistics/signing',
    ...options,
  });

/**
 * Get Llm Usage Statistics
 *
 * Raw daily AI-usage rows for frontend-side cost attribution.
 *
 * Returns one row per ``usage_bucket`` entry (kept at daily granularity, not
 * collapsed) with cost and org/user data embedded, plus grand totals. The
 * frontend aggregates by whatever dimensions it needs (day, org, user, model,
 * purpose). ``insights`` org/user identifiers are resolved to names;
 * ``equity_management`` identifiers are returned raw.
 */
export const getLlmUsageStatistics = <ThrowOnError extends boolean = false>(
  options?: Options<GetLlmUsageStatisticsData, ThrowOnError>
) =>
  (options?.client ?? client).post<
    GetLlmUsageStatisticsResponses,
    GetLlmUsageStatisticsErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/admin/statistics/llm-usage',
    ...options,
  });

/**
 * List Model Pricing
 *
 * Return every pricing row (all providers/models, including closed-out).
 */
export const listModelPricing = <ThrowOnError extends boolean = false>(
  options?: Options<ListModelPricingData, ThrowOnError>
) =>
  (options?.client ?? client).get<ListModelPricingResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/admin/model-pricing',
    ...options,
  });

/**
 * Create Model Pricing
 *
 * Insert a new pricing row.
 */
export const createModelPricing = <ThrowOnError extends boolean = false>(
  options: Options<CreateModelPricingData, ThrowOnError>
) =>
  (options.client ?? client).post<
    CreateModelPricingResponses,
    CreateModelPricingErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/admin/model-pricing',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Delete Model Pricing
 *
 * Delete a pricing row by uid.
 *
 * Safe to delete at any time: ``usage_bucket`` rows are not linked to pricing by id — cost
 * is matched by ``(provider, model)`` + effective window at query time. After deletion,
 * affected days reprice from whatever pricing rows remain, reading as zero cost where no
 * row covers the day.
 */
export const deleteModelPricing = <ThrowOnError extends boolean = false>(
  options: Options<DeleteModelPricingData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    DeleteModelPricingResponses,
    DeleteModelPricingErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/admin/model-pricing/{uid}',
    ...options,
  });

/**
 * Update Model Pricing
 *
 * Update a pricing row by uid. Typical use: set ``effective_to`` to close out a row.
 */
export const updateModelPricing = <ThrowOnError extends boolean = false>(
  options: Options<UpdateModelPricingData, ThrowOnError>
) =>
  (options.client ?? client).put<
    UpdateModelPricingResponses,
    UpdateModelPricingErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/admin/model-pricing/{uid}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Start Demo Data Removal
 *
 * Kick off an async background removal of all demo data from the given organisation.
 *
 * Every area factory deletes exactly the named entities it seeds, in reverse dependency order.
 * The client subscribes to the returned ``seed_uid`` over the websocket to receive one progress
 * event per cleared area and a final "done"/"failed" event. Safe to trigger repeatedly.
 */
export const startDemoDataRemoval = <ThrowOnError extends boolean = false>(
  options: Options<StartDemoDataRemovalData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    StartDemoDataRemovalResponses,
    StartDemoDataRemovalErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/admin/demo-data',
    ...options,
  });

/**
 * Get Demo Data Status
 *
 * Report per seedable area whether the given organisation already holds demo data.
 *
 * Lets the admin UI show which areas are already seeded before kicking off another
 * seeding or removal run. An area reads ``True`` as long as anything a seeding run
 * created (or a failed removal left behind) is still in place.
 */
export const getDemoDataStatus = <ThrowOnError extends boolean = false>(
  options: Options<GetDemoDataStatusData, ThrowOnError>
) =>
  (options.client ?? client).get<GetDemoDataStatusResponses, GetDemoDataStatusErrors, ThrowOnError>(
    {
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/v1/app/admin/demo-data',
      ...options,
    }
  );

/**
 * Start Demo Data Seeding
 *
 * Kick off an async background seeding of demo data into the given organisation.
 *
 * Seeding builds vault files and dozens of domain rows, so the work is handed to a Celery task.
 * The client subscribes to the returned ``seed_uid`` over the websocket to receive one progress
 * event per finished area and a final "done"/"failed" event. Seeding is idempotent per
 * organisation: re-seeding an area skips everything that already exists. Seeded artifacts are
 * owned by the calling admin where ownership applies.
 */
export const startDemoDataSeeding = <ThrowOnError extends boolean = false>(
  options: Options<StartDemoDataSeedingData, ThrowOnError>
) =>
  (options.client ?? client).post<
    StartDemoDataSeedingResponses,
    StartDemoDataSeedingErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/admin/demo-data',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Admin Switch Organisation
 *
 * Switch to a specific Organisation as admin.
 *
 * Args:
 * postgresql_session: Database session for PostgreSQL operations
 * organisation_uid: Organisation UID to switch to
 * current_user: Currently authenticated user making the request
 *
 * Returns:
 * The org you where switched to
 */
export const adminSwitchOrganisation = <ThrowOnError extends boolean = false>(
  options: Options<AdminSwitchOrganisationData, ThrowOnError>
) =>
  (options.client ?? client).post<
    AdminSwitchOrganisationResponses,
    AdminSwitchOrganisationErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/admin/switch-org',
    ...options,
  });

/**
 * Switch To Organisation
 *
 * Switch to the admin Organisation.
 *
 * Args:
 * postgresql_session: Database session for PostgreSQL operations
 * current_user: Currently authenticated user making the request
 *
 * Returns:
 * The org you where switched to
 */
export const switchToOrganisation = <ThrowOnError extends boolean = false>(
  options?: Options<SwitchToOrganisationData, ThrowOnError>
) =>
  (options?.client ?? client).post<SwitchToOrganisationResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/admin/switch-to-admin-org',
    ...options,
  });

/**
 * List Changelog
 *
 * Return changelog entries newest-first, optionally only those created after ``since``.
 *
 * ``result_count`` is the total number of matching entries (ignoring
 * ``limit``/``offset``) so the frontend knows when the infinite scroll is
 * exhausted.
 */
export const listChangelog = <ThrowOnError extends boolean = false>(
  options?: Options<ListChangelogData, ThrowOnError>
) =>
  (options?.client ?? client).get<ListChangelogResponses, ListChangelogErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/changelog',
    ...options,
  });

/**
 * Create Changelog
 *
 * Insert a new changelog entry.
 */
export const createChangelog = <ThrowOnError extends boolean = false>(
  options: Options<CreateChangelogData, ThrowOnError>
) =>
  (options.client ?? client).post<CreateChangelogResponses, CreateChangelogErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/changelog',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Delete Changelog
 *
 * Delete a changelog entry by uid.
 */
export const deleteChangelog = <ThrowOnError extends boolean = false>(
  options: Options<DeleteChangelogData, ThrowOnError>
) =>
  (options.client ?? client).delete<DeleteChangelogResponses, DeleteChangelogErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/changelog/{uid}',
    ...options,
  });

/**
 * Update Changelog
 *
 * Update a changelog entry by uid.
 */
export const updateChangelog = <ThrowOnError extends boolean = false>(
  options: Options<UpdateChangelogData, ThrowOnError>
) =>
  (options.client ?? client).put<UpdateChangelogResponses, UpdateChangelogErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/changelog/{uid}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Create Template
 *
 * Create a new template from an uploaded .docx (multipart: ``file``, ``name``, ``variant_name``,
 * optional ``description`` — flat form fields).
 *
 * The source goes straight into the system vault (``Templates/{name}/``), in ONE transaction
 * with the template row and its first variant: it is a system file, so it never passes
 * through anyone's vault or becomes a contract. Validation runs asynchronously (the variant
 * starts at ``template_status="running"`` and the queued task flips it to done/failed).
 */
export const createTemplate = <ThrowOnError extends boolean = false>(
  options: Options<CreateTemplateData, ThrowOnError>
) =>
  (options.client ?? client).post<CreateTemplateResponses, CreateTemplateErrors, ThrowOnError>({
    ...formDataBodySerializer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/contract-generation/template/new',
    ...options,
    headers: {
      'Content-Type': null,
      ...options.headers,
    },
  });

/**
 * Delete Template
 *
 * Delete a template with its variants' files, and the drafts made from it (``astage_drafts_removal``); the
 * documents saved from those drafts stay.
 */
export const deleteTemplate = <ThrowOnError extends boolean = false>(
  options: Options<DeleteTemplateData, ThrowOnError>
) =>
  (options.client ?? client).delete<DeleteTemplateResponses, DeleteTemplateErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/contract-generation/template/{uid}',
    ...options,
  });

/**
 * Get Template
 */
export const getTemplate = <ThrowOnError extends boolean = false>(
  options: Options<GetTemplateData, ThrowOnError>
) =>
  (options.client ?? client).get<GetTemplateResponses, GetTemplateErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/contract-generation/template/{uid}',
    ...options,
  });

/**
 * Update Template
 */
export const updateTemplate = <ThrowOnError extends boolean = false>(
  options: Options<UpdateTemplateData, ThrowOnError>
) =>
  (options.client ?? client).put<UpdateTemplateResponses, UpdateTemplateErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/contract-generation/template/{uid}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Search Templates
 */
export const searchTemplates = <ThrowOnError extends boolean = false>(
  options: Options<SearchTemplatesData, ThrowOnError>
) =>
  (options.client ?? client).post<SearchTemplatesResponses, SearchTemplatesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/contract-generation/template/search',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Create Template Variant
 *
 * Add a variant to an existing template from an uploaded .docx (multipart: ``file`` plus
 * ``name``).
 *
 * WRITE on the template is the whole gate: the source goes straight into the template's
 * system-vault directory in the same transaction as the row, so no vault permission is
 * involved. Validation runs asynchronously (``template_status="running"`` until the queued
 * task flips it).
 */
export const createTemplateVariant = <ThrowOnError extends boolean = false>(
  options: Options<CreateTemplateVariantData, ThrowOnError>
) =>
  (options.client ?? client).post<
    CreateTemplateVariantResponses,
    CreateTemplateVariantErrors,
    ThrowOnError
  >({
    ...formDataBodySerializer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/contract-generation/template/{template_uid}/variant',
    ...options,
    headers: {
      'Content-Type': null,
      ...options.headers,
    },
  });

/**
 * Replace Template Variant File
 *
 * Upload a fixed version of a variant's .docx (multipart ``file``).
 *
 * It becomes a new revision of the variant's source file; every variant on that file is
 * re-pointed at it and re-validated (``template_status="running"`` until the queued task
 * flips it). Gated on WRITE on the template, like adding a variant — the source lives in the
 * system vault, which a template editor cannot write through the vault routes.
 */
export const replaceTemplateVariantFile = <ThrowOnError extends boolean = false>(
  options: Options<ReplaceTemplateVariantFileData, ThrowOnError>
) =>
  (options.client ?? client).put<
    ReplaceTemplateVariantFileResponses,
    ReplaceTemplateVariantFileErrors,
    ThrowOnError
  >({
    ...formDataBodySerializer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/contract-generation/template/{template_uid}/variant/{variant_uid}/file',
    ...options,
    headers: {
      'Content-Type': null,
      ...options.headers,
    },
  });

/**
 * Delete Template Variant
 *
 * Delete a variant with its file, and the drafts made from it (``astage_drafts_removal``); the documents saved
 * from those drafts stay.
 */
export const deleteTemplateVariant = <ThrowOnError extends boolean = false>(
  options: Options<DeleteTemplateVariantData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    DeleteTemplateVariantResponses,
    DeleteTemplateVariantErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/contract-generation/template/{template_uid}/variant/{variant_uid}',
    ...options,
  });

/**
 * Get Template Variant
 *
 * The full detail view: the extracted structure plus the metadata an author wrote about it.
 *
 * The two travel side by side. ``extracted_schema`` is exactly what it has always been, and
 * ``field_metadata`` carries the label, description, guidance and resolved order
 * per field path — including for fields nobody has authored yet, so the caller always has a
 * ``sort_position`` to sort on.
 */
export const getTemplateVariant = <ThrowOnError extends boolean = false>(
  options: Options<GetTemplateVariantData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetTemplateVariantResponses,
    GetTemplateVariantErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/contract-generation/template/{template_uid}/variant/{variant_uid}',
    ...options,
  });

/**
 * Update Template Variant
 */
export const updateTemplateVariant = <ThrowOnError extends boolean = false>(
  options: Options<UpdateTemplateVariantData, ThrowOnError>
) =>
  (options.client ?? client).put<
    UpdateTemplateVariantResponses,
    UpdateTemplateVariantErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/contract-generation/template/{template_uid}/variant/{variant_uid}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * List Template Variants
 *
 * Return the slim per-variant overview — no extracted_schema.
 *
 * The frontend uses `vault_file_revision_uid` to call the existing vault-file
 * preview endpoint when the user wants to preview the underlying .docx.
 */
export const listTemplateVariants = <ThrowOnError extends boolean = false>(
  options: Options<ListTemplateVariantsData, ThrowOnError>
) =>
  (options.client ?? client).get<
    ListTemplateVariantsResponses,
    ListTemplateVariantsErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/contract-generation/template/{template_uid}/variants',
    ...options,
  });

/**
 * List Template Questions
 *
 * What this template asks, where every variant stands, and whether it can be used.
 */
export const listTemplateQuestions = <ThrowOnError extends boolean = false>(
  options: Options<ListTemplateQuestionsData, ThrowOnError>
) =>
  (options.client ?? client).get<
    ListTemplateQuestionsResponses,
    ListTemplateQuestionsErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/contract-generation/template/{template_uid}/questions',
    ...options,
  });

/**
 * Create Template Question
 *
 * Add a question, appended last in ask-order.
 *
 * Existing variants keep working: none of them answers it yet, and an unanswered question does
 * not constrain a variant. Only ``required_for_variants`` changes that, which is why it defaults
 * to off — adding a question is never, by itself, a breaking change.
 *
 * A selection question starts with nothing to pick from, which is the intended state rather than
 * an incomplete one: its values arrive as the variants are answered.
 *
 * An ordered question may declare boundaries, inclusive at both ends, limiting the range every
 * later answer — and every later drafting value — is allowed to name. This is the only route that
 * sets them; see the update request for why they do not move afterwards.
 */
export const createTemplateQuestion = <ThrowOnError extends boolean = false>(
  options: Options<CreateTemplateQuestionData, ThrowOnError>
) =>
  (options.client ?? client).post<
    CreateTemplateQuestionResponses,
    CreateTemplateQuestionErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/contract-generation/template/{template_uid}/questions',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Delete Template Question
 *
 * Remove a question. Every variant's answer to it goes with it, by FK cascade.
 *
 * Always allowed. The variants that answered it simply stop being constrained by something that
 * no longer exists, which is a coherent state rather than a dangling one — and since a question's
 * values live on those same answers, nothing is left pointing at a value that no longer has a
 * question.
 */
export const deleteTemplateQuestion = <ThrowOnError extends boolean = false>(
  options: Options<DeleteTemplateQuestionData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    DeleteTemplateQuestionResponses,
    DeleteTemplateQuestionErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/contract-generation/template/{template_uid}/question/{question_uid}',
    ...options,
  });

/**
 * Update Template Question
 *
 * Rename a question, change its hint, or make it one every variant must answer.
 *
 * The type is not changeable. It is the discriminator every answer to this question is mapped by,
 * so changing it would strand each of them as the wrong kind of row — delete the question and
 * make a new one instead.
 */
export const updateTemplateQuestion = <ThrowOnError extends boolean = false>(
  options: Options<UpdateTemplateQuestionData, ThrowOnError>
) =>
  (options.client ?? client).put<
    UpdateTemplateQuestionResponses,
    UpdateTemplateQuestionErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/contract-generation/template/{template_uid}/question/{question_uid}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Set Variant Answers
 *
 * Say what one variant stands for — its complete set of constraints.
 *
 * Replace, not merge: a question absent from the list is unanswered afterwards, which is the only
 * way to express "this variant does not care about that question". Two variants may state exactly
 * the same thing; that is legitimate, and matching returns both.
 *
 * **This is the only way a selection question acquires a value.** The text is free — a value no
 * other variant has used is how the picker grows — but it is folded onto what the siblings
 * already answer before it is stored, so "female" typed here against a "Female" elsewhere joins
 * that answer instead of forking the list. That fold reads the *other* variants' answers, which
 * is why it happens here, where the whole template is loaded, rather than in the repo.
 */
export const setVariantAnswers = <ThrowOnError extends boolean = false>(
  options: Options<SetVariantAnswersData, ThrowOnError>
) =>
  (options.client ?? client).put<SetVariantAnswersResponses, SetVariantAnswersErrors, ThrowOnError>(
    {
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/v1/app/contract-generation/template/{template_uid}/variant/{variant_uid}/answers',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    }
  );

/**
 * Match Template Variants
 *
 * Which of this template's variants fit these answers.
 *
 * A read, not a write — it narrows, it does not resolve. Several variants matching is the
 * designed outcome and the caller picks; zero is an ordinary result, returned as an empty list
 * rather than an error, because nothing about the request was wrong.
 *
 * 422 for an answer set that cannot be evaluated at all — an unknown question, a number where a
 * value was asked for, a value no variant of this template answers with, or a number or date
 * outside the boundaries its question declares. The last two are deliberately not empty results:
 * a picker offers a closed list built from the variants' own answers and a bounded question
 * covers a stated range, so falling outside either means the caller is working from something
 * stale, and saying so beats a silent zero. 409 only when the template itself is not ready.
 */
export const matchTemplateVariants = <ThrowOnError extends boolean = false>(
  options: Options<MatchTemplateVariantsData, ThrowOnError>
) =>
  (options.client ?? client).post<
    MatchTemplateVariantsResponses,
    MatchTemplateVariantsErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/contract-generation/template/{template_uid}/match',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Render Template Preview
 *
 * Render a template with context data and stream the .docx result as a preview.
 *
 * This does not persist anything — it's a stateless preview for the user to review
 * while filling the form. Persisting the entered values is the draft resource's job
 * (``/draft``), which is also where the final document is produced.
 */
export const renderTemplatePreview = <ThrowOnError extends boolean = false>(
  options: Options<RenderTemplatePreviewData, ThrowOnError>
) =>
  (options.client ?? client).post<
    RenderTemplatePreviewResponses,
    RenderTemplatePreviewErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/contract-generation/render/template-preview',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Create Draft
 *
 * Start a draft against one variant: a vault file in the chosen folder (the organisation's vault root when none
 * is given), named uniquely there, whose templated revision holds the entered values.
 *
 * The variant is named outright. Deciding *which* variant is a separate question, answered by
 * ``POST /template/{uid}/match`` — matching narrows rather than resolving, so several variants
 * can fit one set of answers and the choice belongs to whoever is drafting.
 *
 * The template has to be usable now (404 unknown/unreadable, 409 still validating, 422 broken) —
 * there is no point letting a user fill in fields that were never extracted.
 */
export const createDraft = <ThrowOnError extends boolean = false>(
  options: Options<CreateDraftData, ThrowOnError>
) =>
  (options.client ?? client).post<CreateDraftResponses, CreateDraftErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/contract-generation/draft/new',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get Draft
 *
 * Open a draft — the entered values plus the template it came from.
 *
 * Deliberately NOT gated on template readiness: a draft whose template has since broken or
 * re-entered validation must still open, so the frontend can say why instead of 404ing the
 * user's work. ``template_status`` on the response carries that state.
 */
export const getDraft = <ThrowOnError extends boolean = false>(
  options: Options<GetDraftData, ThrowOnError>
) =>
  (options.client ?? client).get<GetDraftResponses, GetDraftErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/contract-generation/draft/{uid}',
    ...options,
  });

/**
 * Update Draft
 *
 * The autosave endpoint: the draft's templated revision changes in place, its document rendering the new
 * values from the next read on.
 *
 * Not gated on the draft's *current* template being ready — a template re-entering validation
 * mid-draft must never start rejecting the user's saves. Re-pointing the draft IS gated: the
 * newly chosen variant has to be usable, and it has to belong to the same template.
 */
export const updateDraft = <ThrowOnError extends boolean = false>(
  options: Options<UpdateDraftData, ThrowOnError>
) =>
  (options.client ?? client).put<UpdateDraftResponses, UpdateDraftErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/contract-generation/draft/{uid}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Search Drafts
 *
 * The drafts page: the vault files the caller can read whose current revision is templated.
 */
export const searchDrafts = <ThrowOnError extends boolean = false>(
  options: Options<SearchDraftsData, ThrowOnError>
) =>
  (options.client ?? client).post<SearchDraftsResponses, SearchDraftsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/contract-generation/draft/search',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Duplicate Draft
 *
 * Copy a draft — or a document saved from one, its variant and values read from the newest templated or saved
 * draft revision in its history, so a signed or re-uploaded one still duplicates — into a fresh draft next to it,
 * under the same name made unique there. A document whose template is gone has nothing to render a copy from.
 */
export const duplicateDraft = <ThrowOnError extends boolean = false>(
  options: Options<DuplicateDraftData, ThrowOnError>
) =>
  (options.client ?? client).post<DuplicateDraftResponses, DuplicateDraftErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/contract-generation/draft/{uid}/duplicate',
    ...options,
  });

/**
 * Finalize Draft
 *
 * The "Save": render the draft once and store it as its file's new current revision, a ``templated_uploaded``
 * one keeping its values — and, with ``signing``, send it for signing. The templated revision stays in the file's
 * history; the file is a draft no more.
 *
 * The draft is its contract's file from the start, and nothing was extracted from it while in draft: the stored
 * revision is processed like an upload, which backfills the contract's extractions. The slots' parties are known,
 * so they are linked to the file and the party extraction is skipped.
 *
 * ``signing`` is "finish draft = send for signing": the party of each signing slot of the template
 * (``{{ signature("<slot>") }}``) becomes a signer, in template order — one person filling two slots
 * is one signer with two signatures — and the render turns each tag into a signature marker naming
 * its signer. Everything sending needs is checked before anything is written. The activation task
 * waits for the document's preview, turns the markers into signature fields and hands the request
 * to the provider; a signer whose marker is missing fails the activation, back to the signing UI.
 */
export const finalizeDraft = <ThrowOnError extends boolean = false>(
  options: Options<FinalizeDraftData, ThrowOnError>
) =>
  (options.client ?? client).post<FinalizeDraftResponses, FinalizeDraftErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/contract-generation/draft/{uid}/finalize',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get Field Catalog
 *
 * Return the catalog of entities, primitive types, and filters the picker can offer.
 */
export const getFieldCatalog = <ThrowOnError extends boolean = false>(
  options?: Options<GetFieldCatalogData, ThrowOnError>
) =>
  (options?.client ?? client).get<GetFieldCatalogResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/contract-generation/template-authoring/field-catalog',
    ...options,
  });

/**
 * Render Tag
 *
 * Render the exact Jinja string the materializer would emit for this annotation.
 *
 * Single source of truth for the popover's live preview as the user edits a tag.
 * No DB roundtrip — purely deterministic from the request payload.
 */
export const renderTag = <ThrowOnError extends boolean = false>(
  options: Options<RenderTagData, ThrowOnError>
) =>
  (options.client ?? client).post<RenderTagResponses, RenderTagErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/contract-generation/template-authoring/render-tag',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Validate Template File
 *
 * Validate uploaded .docx template bytes statelessly.
 *
 * The Word add-in posts the live (possibly unsaved) document here so the
 * author can check their edits before saving back to the vault. Runs the
 * same extraction the async `ValidateTemplateVariant` task runs, so
 * the returned schema and `validation_errors` match what a save would
 * persist.
 */
export const validateTemplateFile = <ThrowOnError extends boolean = false>(
  options: Options<ValidateTemplateFileData, ThrowOnError>
) =>
  (options.client ?? client).post<
    ValidateTemplateFileResponses,
    ValidateTemplateFileErrors,
    ThrowOnError
  >({
    ...formDataBodySerializer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/contract-generation/template-authoring/validate',
    ...options,
    headers: {
      'Content-Type': null,
      ...options.headers,
    },
  });

/**
 * Preview With Sample Data
 *
 * Render uploaded .docx template bytes with generated sample values and stream a paginated PDF.
 *
 * The Word add-in posts the live (possibly unsaved) document here so the author
 * can check the filled-in layout without providing any form data. Template
 * defaults (`{{ name | default("…") }}`) are used where declared; every other
 * field gets a meaningful placeholder (sample person, company, text, number,
 * date, …). Renders non-strict, like the wizard's live preview, so a field the
 * sample generator can't satisfy skips its section instead of failing.
 *
 * The sample-filled docx is converted to PDF with LibreOffice so the preview
 * modal can show exact page breaks — no JavaScript docx renderer can compute
 * Word's automatic pagination. The conversion runs in a thread because it is
 * a blocking subprocess serialized per host via a Redis lock.
 */
export const previewWithSampleData = <ThrowOnError extends boolean = false>(
  options: Options<PreviewWithSampleDataData, ThrowOnError>
) =>
  (options.client ?? client).post<
    PreviewWithSampleDataResponses,
    PreviewWithSampleDataErrors,
    ThrowOnError
  >({
    ...formDataBodySerializer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/contract-generation/template-authoring/preview-sample',
    ...options,
    headers: {
      'Content-Type': null,
      ...options.headers,
    },
  });

/**
 * Get Preview Html
 *
 * Return an HTML preview of the .docx in its current authored state.
 */
export const getPreviewHtml = <ThrowOnError extends boolean = false>(
  options: Options<GetPreviewHtmlData, ThrowOnError>
) =>
  (options.client ?? client).get<GetPreviewHtmlResponses, GetPreviewHtmlErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/contract-generation/template-authoring/{variant_uid}/preview-html',
    ...options,
  });

/**
 * Get Annotations
 *
 * Return the annotations discovered in the current vault revision.
 */
export const getAnnotations = <ThrowOnError extends boolean = false>(
  options: Options<GetAnnotationsData, ThrowOnError>
) =>
  (options.client ?? client).get<GetAnnotationsResponses, GetAnnotationsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/contract-generation/template-authoring/{variant_uid}/annotations',
    ...options,
  });

/**
 * Update Annotations
 *
 * Materialize the given annotation list onto the vault file in one step.
 *
 * Saving annotations means "rewrite the .docx so it reflects this list of tags".
 * The endpoint creates a new vault file revision with the materialized bytes
 * and returns the annotations as re-discovered from that revision — the docx
 * is the single source of truth, so subsequent GET cycles dedup cleanly.
 *
 * ``field_metadata`` rides along so the merged editor saves tags and guidance together.
 * That has to happen here rather than in a following ``PUT /fields`` call: rewriting the
 * document nulls ``extracted_schema`` and flips the template to running, which makes that
 * route answer 409 until the worker lands the new schema. Paths are therefore checked
 * mainly against the tags in the *rewritten* document, and any guidance whose tag this save
 * renamed is carried to the new path in the same transaction.
 */
export const updateAnnotations = <ThrowOnError extends boolean = false>(
  options: Options<UpdateAnnotationsData, ThrowOnError>
) =>
  (options.client ?? client).put<UpdateAnnotationsResponses, UpdateAnnotationsErrors, ThrowOnError>(
    {
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/v1/app/contract-generation/template-authoring/{variant_uid}/annotations',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    }
  );

/**
 * Download Materialized
 *
 * Stream the current materialized .docx (the latest vault file revision).
 */
export const downloadMaterialized = <ThrowOnError extends boolean = false>(
  options: Options<DownloadMaterializedData, ThrowOnError>
) =>
  (options.client ?? client).get<
    DownloadMaterializedResponses,
    DownloadMaterializedErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/contract-generation/template-authoring/{variant_uid}/materialize/download',
    ...options,
  });

/**
 * Get Template Fields
 *
 * Every field of this variant with whatever an author has written about it.
 *
 * Deliberately NOT gated on the template being validated. Every re-extraction blanks the
 * schema before the worker lands the new one, and a failed extract leaves it blank — gating
 * would empty the authoring panel for a whole round trip in the first case and permanently in
 * the second, exactly when an author most needs to look at it.
 *
 * ``orphaned`` carries rows whose path no field owns any more, which almost always means the
 * tag was renamed. Their prose is kept so it can be moved onto the new field.
 */
export const getTemplateFields = <ThrowOnError extends boolean = false>(
  options: Options<GetTemplateFieldsData, ThrowOnError>
) =>
  (options.client ?? client).get<GetTemplateFieldsResponses, GetTemplateFieldsErrors, ThrowOnError>(
    {
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/v1/app/contract-generation/template-authoring/{variant_uid}/fields',
      ...options,
    }
  );

/**
 * Update Template Fields
 *
 * Write the authored metadata for this variant's fields in one transaction.
 *
 * Each entry states a field's complete authored state, so an omitted value clears whatever
 * was stored. ``order_index`` values are absolute and taken as given — no server-side
 * re-sequencing, matching how every other ordered collection here works. Paths absent from
 * the payload keep what they had.
 *
 * Refuses a write against a path no field owns, rather than storing prose for something that
 * does not exist.
 */
export const updateTemplateFields = <ThrowOnError extends boolean = false>(
  options: Options<UpdateTemplateFieldsData, ThrowOnError>
) =>
  (options.client ?? client).put<
    UpdateTemplateFieldsResponses,
    UpdateTemplateFieldsErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/contract-generation/template-authoring/{variant_uid}/fields',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Delete Template Field
 *
 * Discard an orphaned metadata row — the author has decided its prose is not worth keeping.
 *
 * The reconcile keeps a row forever once anyone has written on it, because a field can vanish
 * transiently and losing someone's writing to a re-extraction would be worse than showing a
 * row nobody reads. That is the right default and it needs this way out, or orphans only ever
 * accumulate.
 *
 * Gated on the template being validated, unlike the read beside it. Telling an orphan from a
 * live field needs a readable schema, and without one this would delete either — including a
 * row describing a field that is very much alive. There is nothing lost by waiting: while the
 * schema is blank ``build_authoring_view`` reports every row as live and no orphans at all,
 * so the window this closes is one in which the frontend has no orphan to act on anyway.
 *
 * Refuses a path the current schema still owns. Emptying a live field is
 * ``PUT /fields`` with nulls, which keeps the row and its place in the tree; deleting it here
 * would only have the reconcile put a blank one straight back.
 *
 * ``path`` is a `:path` parameter because field paths contain dots and brackets
 * (``services[].monthly_fee``); the frontend URL-encodes them.
 */
export const deleteTemplateField = <ThrowOnError extends boolean = false>(
  options: Options<DeleteTemplateFieldData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    DeleteTemplateFieldResponses,
    DeleteTemplateFieldErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/contract-generation/template-authoring/{variant_uid}/fields/{path}',
    ...options,
  });

/**
 * Create Contract Management Calendar
 *
 * Create a new contract management calendar.
 *
 * Only organisation admins may create calendars; the calendar is owned by the admin's
 * active organisation. Related models are managed via the dedicated sub-routes.
 */
export const createContractManagementCalendar = <ThrowOnError extends boolean = false>(
  options: Options<CreateContractManagementCalendarData, ThrowOnError>
) =>
  (options.client ?? client).post<
    CreateContractManagementCalendarResponses,
    CreateContractManagementCalendarErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/contract-management/calendar/new',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Delete Contract Management Calendar
 *
 * Delete a contract management calendar.
 */
export const deleteContractManagementCalendar = <ThrowOnError extends boolean = false>(
  options: Options<DeleteContractManagementCalendarData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    DeleteContractManagementCalendarResponses,
    DeleteContractManagementCalendarErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/contract-management/calendar/{calendar_uid}',
    ...options,
  });

/**
 * Get Contract Management Calendar
 *
 * Get a specific contract management calendar by UID.
 */
export const getContractManagementCalendar = <ThrowOnError extends boolean = false>(
  options: Options<GetContractManagementCalendarData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetContractManagementCalendarResponses,
    GetContractManagementCalendarErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/contract-management/calendar/{calendar_uid}',
    ...options,
  });

/**
 * Update Contract Management Calendar
 *
 * Update an existing contract management calendar's scalar fields.
 *
 * Only organisation admins may update calendars. The READ-level permission check is a
 * deliberate quirk (sibling mutators check WRITE).
 */
export const updateContractManagementCalendar = <ThrowOnError extends boolean = false>(
  options: Options<UpdateContractManagementCalendarData, ThrowOnError>
) =>
  (options.client ?? client).put<
    UpdateContractManagementCalendarResponses,
    UpdateContractManagementCalendarErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/contract-management/calendar/{calendar_uid}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Search Contract Management Calendars
 *
 * Search contract management calendars the user is allowed to read.
 */
export const searchContractManagementCalendars = <ThrowOnError extends boolean = false>(
  options: Options<SearchContractManagementCalendarsData, ThrowOnError>
) =>
  (options.client ?? client).post<
    SearchContractManagementCalendarsResponses,
    SearchContractManagementCalendarsErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/contract-management/calendar/search',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Preview Contract Management Calendar
 *
 * Preview the (contract file, extraction, fixed dates) rows a calendar currently resolves to.
 */
export const previewContractManagementCalendar = <ThrowOnError extends boolean = false>(
  options: Options<PreviewContractManagementCalendarData, ThrowOnError>
) =>
  (options.client ?? client).post<
    PreviewContractManagementCalendarResponses,
    PreviewContractManagementCalendarErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/contract-management/calendar/{calendar_uid}/preview',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Preview Contract Management Calendar Range
 *
 * All (contract file, extraction, fixed dates) rows of a calendar with an occurrence in
 * ``[start, end)`` — the month view, unpaginated.
 */
export const previewContractManagementCalendarRange = <ThrowOnError extends boolean = false>(
  options: Options<PreviewContractManagementCalendarRangeData, ThrowOnError>
) =>
  (options.client ?? client).post<
    PreviewContractManagementCalendarRangeResponses,
    PreviewContractManagementCalendarRangeErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/contract-management/calendar/{calendar_uid}/preview/range',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get Contract Management Calendar Export Url
 *
 * The caller's personal feed URL (created on first request).
 */
export const getContractManagementCalendarExportUrl = <ThrowOnError extends boolean = false>(
  options: Options<GetContractManagementCalendarExportUrlData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetContractManagementCalendarExportUrlResponses,
    GetContractManagementCalendarExportUrlErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/contract-management/calendar/{calendar_uid}/sync/url',
    ...options,
  });

/**
 * Regenerate Contract Management Calendar Export Url
 *
 * Rotate the caller's personal feed token (creating one when absent).
 */
export const regenerateContractManagementCalendarExportUrl = <ThrowOnError extends boolean = false>(
  options: Options<RegenerateContractManagementCalendarExportUrlData, ThrowOnError>
) =>
  (options.client ?? client).post<
    RegenerateContractManagementCalendarExportUrlResponses,
    RegenerateContractManagementCalendarExportUrlErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/contract-management/calendar/{calendar_uid}/sync/url/regenerate',
    ...options,
  });

/**
 * Add Calendar Receivers
 *
 * Add one or more receiver users to a calendar (org admins only).
 */
export const addCalendarReceivers = <ThrowOnError extends boolean = false>(
  options: Options<AddCalendarReceiversData, ThrowOnError>
) =>
  (options.client ?? client).post<
    AddCalendarReceiversResponses,
    AddCalendarReceiversErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/contract-management/calendar/{calendar_uid}/receivers/add',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Remove Calendar Receivers
 *
 * Remove one or more receiver users from a calendar (org admins only).
 */
export const removeCalendarReceivers = <ThrowOnError extends boolean = false>(
  options: Options<RemoveCalendarReceiversData, ThrowOnError>
) =>
  (options.client ?? client).post<
    RemoveCalendarReceiversResponses,
    RemoveCalendarReceiversErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/contract-management/calendar/{calendar_uid}/receivers/remove',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * List Calendar Receivers
 *
 * List a calendar's receiver users.
 */
export const listCalendarReceivers = <ThrowOnError extends boolean = false>(
  options: Options<ListCalendarReceiversData, ThrowOnError>
) =>
  (options.client ?? client).get<
    ListCalendarReceiversResponses,
    ListCalendarReceiversErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/contract-management/calendar/{calendar_uid}/receivers',
    ...options,
  });

/**
 * Add Calendar Permission Users
 *
 * Add one or more permission users to a calendar (org admins only).
 */
export const addCalendarPermissionUsers = <ThrowOnError extends boolean = false>(
  options: Options<AddCalendarPermissionUsersData, ThrowOnError>
) =>
  (options.client ?? client).post<
    AddCalendarPermissionUsersResponses,
    AddCalendarPermissionUsersErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/contract-management/calendar/{calendar_uid}/permission-users/add',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Remove Calendar Permission Users
 *
 * Remove one or more permission users from a calendar (org admins only).
 */
export const removeCalendarPermissionUsers = <ThrowOnError extends boolean = false>(
  options: Options<RemoveCalendarPermissionUsersData, ThrowOnError>
) =>
  (options.client ?? client).post<
    RemoveCalendarPermissionUsersResponses,
    RemoveCalendarPermissionUsersErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/contract-management/calendar/{calendar_uid}/permission-users/remove',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * List Calendar Permission Users
 *
 * List a calendar's permission users.
 */
export const listCalendarPermissionUsers = <ThrowOnError extends boolean = false>(
  options: Options<ListCalendarPermissionUsersData, ThrowOnError>
) =>
  (options.client ?? client).get<
    ListCalendarPermissionUsersResponses,
    ListCalendarPermissionUsersErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/contract-management/calendar/{calendar_uid}/permission-users',
    ...options,
  });

/**
 * Add Calendar Permission Roles
 *
 * Add one or more permission roles to a calendar (org admins only).
 */
export const addCalendarPermissionRoles = <ThrowOnError extends boolean = false>(
  options: Options<AddCalendarPermissionRolesData, ThrowOnError>
) =>
  (options.client ?? client).post<
    AddCalendarPermissionRolesResponses,
    AddCalendarPermissionRolesErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/contract-management/calendar/{calendar_uid}/permission-roles/add',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Remove Calendar Permission Roles
 *
 * Remove one or more permission roles from a calendar (org admins only).
 */
export const removeCalendarPermissionRoles = <ThrowOnError extends boolean = false>(
  options: Options<RemoveCalendarPermissionRolesData, ThrowOnError>
) =>
  (options.client ?? client).post<
    RemoveCalendarPermissionRolesResponses,
    RemoveCalendarPermissionRolesErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/contract-management/calendar/{calendar_uid}/permission-roles/remove',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * List Calendar Permission Roles
 *
 * List a calendar's permission roles.
 */
export const listCalendarPermissionRoles = <ThrowOnError extends boolean = false>(
  options: Options<ListCalendarPermissionRolesData, ThrowOnError>
) =>
  (options.client ?? client).get<
    ListCalendarPermissionRolesResponses,
    ListCalendarPermissionRolesErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/contract-management/calendar/{calendar_uid}/permission-roles',
    ...options,
  });

/**
 * Search Calendar Contracts
 *
 * Search every contract the calendar sees — its creator's readable contracts in its selected
 * directories or files, or matching its criteria. Each carries the caller's own bits
 * (``permissions``, 0 where they may not open it).
 */
export const searchCalendarContracts = <ThrowOnError extends boolean = false>(
  options: Options<SearchCalendarContractsData, ThrowOnError>
) =>
  (options.client ?? client).post<
    SearchCalendarContractsResponses,
    SearchCalendarContractsErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/contract-management/calendar/{calendar_uid}/contracts',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Add Calendar Source Directories
 *
 * Add one or more source directories to a calendar (org admins only).
 *
 * A source widens what the calendar sees: the directories whose subtree's contracts the calendar reads.
 */
export const addCalendarSourceDirectories = <ThrowOnError extends boolean = false>(
  options: Options<AddCalendarSourceDirectoriesData, ThrowOnError>
) =>
  (options.client ?? client).post<
    AddCalendarSourceDirectoriesResponses,
    AddCalendarSourceDirectoriesErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/contract-management/calendar/{calendar_uid}/source-directories/add',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Remove Calendar Source Directories
 *
 * Remove one or more source directories from a calendar (org admins only).
 */
export const removeCalendarSourceDirectories = <ThrowOnError extends boolean = false>(
  options: Options<RemoveCalendarSourceDirectoriesData, ThrowOnError>
) =>
  (options.client ?? client).post<
    RemoveCalendarSourceDirectoriesResponses,
    RemoveCalendarSourceDirectoriesErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/contract-management/calendar/{calendar_uid}/source-directories/remove',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * List Calendar Source Directories
 *
 * List a calendar's source directories.
 */
export const listCalendarSourceDirectories = <ThrowOnError extends boolean = false>(
  options: Options<ListCalendarSourceDirectoriesData, ThrowOnError>
) =>
  (options.client ?? client).get<
    ListCalendarSourceDirectoriesResponses,
    ListCalendarSourceDirectoriesErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/contract-management/calendar/{calendar_uid}/source-directories',
    ...options,
  });

/**
 * Add Calendar Source Contracts
 *
 * Add one or more source contracts to a calendar (org admins only).
 *
 * A source widens what the calendar sees: every file of the contract, at its current revision.
 */
export const addCalendarSourceContracts = <ThrowOnError extends boolean = false>(
  options: Options<AddCalendarSourceContractsData, ThrowOnError>
) =>
  (options.client ?? client).post<
    AddCalendarSourceContractsResponses,
    AddCalendarSourceContractsErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/contract-management/calendar/{calendar_uid}/source-contracts/add',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Remove Calendar Source Contracts
 *
 * Remove one or more source contracts from a calendar (org admins only).
 */
export const removeCalendarSourceContracts = <ThrowOnError extends boolean = false>(
  options: Options<RemoveCalendarSourceContractsData, ThrowOnError>
) =>
  (options.client ?? client).post<
    RemoveCalendarSourceContractsResponses,
    RemoveCalendarSourceContractsErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/contract-management/calendar/{calendar_uid}/source-contracts/remove',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * List Calendar Source Contracts
 *
 * List a calendar's source contracts.
 */
export const listCalendarSourceContracts = <ThrowOnError extends boolean = false>(
  options: Options<ListCalendarSourceContractsData, ThrowOnError>
) =>
  (options.client ?? client).get<
    ListCalendarSourceContractsResponses,
    ListCalendarSourceContractsErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/contract-management/calendar/{calendar_uid}/source-contracts',
    ...options,
  });

/**
 * Get Contract Management Calendar Export
 *
 * The unauthenticated ICS feed: the URL token identifies (and impersonates) its
 * owning user, whose READ permission on the calendar guards the feed.
 */
export const getContractManagementCalendarExport = <ThrowOnError extends boolean = false>(
  options: Options<GetContractManagementCalendarExportData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetContractManagementCalendarExportResponses,
    GetContractManagementCalendarExportErrors,
    ThrowOnError
  >({
    url: '/v1/app/contract-management/calendar/{calendar_uid}/sync/{token}/export.ics',
    ...options,
  });

/**
 * Create Contract Management Clause
 *
 * Create a new contract management clause.
 */
export const createContractManagementClause = <ThrowOnError extends boolean = false>(
  options: Options<CreateContractManagementClauseData, ThrowOnError>
) =>
  (options.client ?? client).post<
    CreateContractManagementClauseResponses,
    CreateContractManagementClauseErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/contract-management/clause/new',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Merge Contract Management Clauses
 *
 * Merge two contract management clauses into a new one; both sources are deleted.
 */
export const mergeContractManagementClauses = <ThrowOnError extends boolean = false>(
  options: Options<MergeContractManagementClausesData, ThrowOnError>
) =>
  (options.client ?? client).post<
    MergeContractManagementClausesResponses,
    MergeContractManagementClausesErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/contract-management/clause/merge',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Delete Contract Management Clause
 *
 * Delete a contract management clause.
 */
export const deleteContractManagementClause = <ThrowOnError extends boolean = false>(
  options: Options<DeleteContractManagementClauseData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    DeleteContractManagementClauseResponses,
    DeleteContractManagementClauseErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/contract-management/clause/{uid}',
    ...options,
  });

/**
 * Get Contract Management Clause
 *
 * Get a specific contract management clause by UID.
 */
export const getContractManagementClause = <ThrowOnError extends boolean = false>(
  options: Options<GetContractManagementClauseData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetContractManagementClauseResponses,
    GetContractManagementClauseErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/contract-management/clause/{uid}',
    ...options,
  });

/**
 * Update Contract Management Clause
 *
 * Update an existing contract management clause.
 */
export const updateContractManagementClause = <ThrowOnError extends boolean = false>(
  options: Options<UpdateContractManagementClauseData, ThrowOnError>
) =>
  (options.client ?? client).put<
    UpdateContractManagementClauseResponses,
    UpdateContractManagementClauseErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/contract-management/clause/{uid}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Search Contract Management Clauses
 *
 * Search contract management clauses.
 */
export const searchContractManagementClauses = <ThrowOnError extends boolean = false>(
  options: Options<SearchContractManagementClausesData, ThrowOnError>
) =>
  (options.client ?? client).post<
    SearchContractManagementClausesResponses,
    SearchContractManagementClausesErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/contract-management/clause/search',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get Clause Contract Files
 *
 * Contract files related to a contract management clause, with contracts, vault files, and pages.
 */
export const getClauseContractFiles = <ThrowOnError extends boolean = false>(
  options: Options<GetClauseContractFilesData, ThrowOnError>
) =>
  (options.client ?? client).post<
    GetClauseContractFilesResponses,
    GetClauseContractFilesErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/contract-management/clause/{uid}/contract-files',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Add Clause To Contract File
 *
 * Add a clause to a contract file (idempotent).
 */
export const addClauseToContractFile = <ThrowOnError extends boolean = false>(
  options: Options<AddClauseToContractFileData, ThrowOnError>
) =>
  (options.client ?? client).post<
    AddClauseToContractFileResponses,
    AddClauseToContractFileErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/contract-management/clause/add-to-contract-file',
    ...options,
  });

/**
 * Remove Clause From Contract File
 *
 * Remove a clause from a contract file (idempotent).
 */
export const removeClauseFromContractFile = <ThrowOnError extends boolean = false>(
  options: Options<RemoveClauseFromContractFileData, ThrowOnError>
) =>
  (options.client ?? client).post<
    RemoveClauseFromContractFileResponses,
    RemoveClauseFromContractFileErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/contract-management/clause/remove-from-contract-file',
    ...options,
  });

/**
 * Create Contract Management Matter
 *
 * Create a new contract management matter.
 */
export const createContractManagementMatter = <ThrowOnError extends boolean = false>(
  options: Options<CreateContractManagementMatterData, ThrowOnError>
) =>
  (options.client ?? client).post<
    CreateContractManagementMatterResponses,
    CreateContractManagementMatterErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/contract-management/matter/new',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Merge Contract Management Matters
 *
 * Merge two contract management matters into a new one holding both's contracts; both sources are deleted.
 */
export const mergeContractManagementMatters = <ThrowOnError extends boolean = false>(
  options: Options<MergeContractManagementMattersData, ThrowOnError>
) =>
  (options.client ?? client).post<
    MergeContractManagementMattersResponses,
    MergeContractManagementMattersErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/contract-management/matter/merge',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Delete Contract Management Matter
 *
 * Delete a contract management matter.
 */
export const deleteContractManagementMatter = <ThrowOnError extends boolean = false>(
  options: Options<DeleteContractManagementMatterData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    DeleteContractManagementMatterResponses,
    DeleteContractManagementMatterErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/contract-management/matter/{uid}',
    ...options,
  });

/**
 * Get Contract Management Matter
 *
 * Get a specific contract management matter by UID.
 */
export const getContractManagementMatter = <ThrowOnError extends boolean = false>(
  options: Options<GetContractManagementMatterData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetContractManagementMatterResponses,
    GetContractManagementMatterErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/contract-management/matter/{uid}',
    ...options,
  });

/**
 * Update Contract Management Matter
 *
 * Update an existing contract management matter.
 */
export const updateContractManagementMatter = <ThrowOnError extends boolean = false>(
  options: Options<UpdateContractManagementMatterData, ThrowOnError>
) =>
  (options.client ?? client).put<
    UpdateContractManagementMatterResponses,
    UpdateContractManagementMatterErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/contract-management/matter/{uid}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Search Contract Management Matters
 *
 * Search contract management matters.
 */
export const searchContractManagementMatters = <ThrowOnError extends boolean = false>(
  options: Options<SearchContractManagementMattersData, ThrowOnError>
) =>
  (options.client ?? client).post<
    SearchContractManagementMattersResponses,
    SearchContractManagementMattersErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/contract-management/matter/search',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Add Matter To Contract
 *
 * Link a matter to a contract (idempotent).
 */
export const addMatterToContract = <ThrowOnError extends boolean = false>(
  options: Options<AddMatterToContractData, ThrowOnError>
) =>
  (options.client ?? client).post<
    AddMatterToContractResponses,
    AddMatterToContractErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/contract-management/matter/add-to-contract',
    ...options,
  });

/**
 * Remove Matter From Contract
 *
 * Unlink a matter from a contract (idempotent). A matter left without contracts is deleted.
 */
export const removeMatterFromContract = <ThrowOnError extends boolean = false>(
  options: Options<RemoveMatterFromContractData, ThrowOnError>
) =>
  (options.client ?? client).post<
    RemoveMatterFromContractResponses,
    RemoveMatterFromContractErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/contract-management/matter/remove-from-contract',
    ...options,
  });

/**
 * Get Matter Contracts
 *
 * Get contracts related to a matter (searchable, filterable, paginated).
 */
export const getMatterContracts = <ThrowOnError extends boolean = false>(
  options: Options<GetMatterContractsData, ThrowOnError>
) =>
  (options.client ?? client).post<
    GetMatterContractsResponses,
    GetMatterContractsErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/contract-management/matter/{uid}/contracts',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Create Contract Management Obligation
 *
 * Create a new contract management obligation.
 */
export const createContractManagementObligation = <ThrowOnError extends boolean = false>(
  options: Options<CreateContractManagementObligationData, ThrowOnError>
) =>
  (options.client ?? client).post<
    CreateContractManagementObligationResponses,
    CreateContractManagementObligationErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/contract-management/obligation/new',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Merge Contract Management Obligations
 *
 * Merge two contract management obligations into a new one; both sources are deleted.
 */
export const mergeContractManagementObligations = <ThrowOnError extends boolean = false>(
  options: Options<MergeContractManagementObligationsData, ThrowOnError>
) =>
  (options.client ?? client).post<
    MergeContractManagementObligationsResponses,
    MergeContractManagementObligationsErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/contract-management/obligation/merge',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Delete Contract Management Obligation
 *
 * Delete a contract management obligation.
 */
export const deleteContractManagementObligation = <ThrowOnError extends boolean = false>(
  options: Options<DeleteContractManagementObligationData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    DeleteContractManagementObligationResponses,
    DeleteContractManagementObligationErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/contract-management/obligation/{uid}',
    ...options,
  });

/**
 * Get Contract Management Obligation
 *
 * Get a specific contract management obligation by UID.
 */
export const getContractManagementObligation = <ThrowOnError extends boolean = false>(
  options: Options<GetContractManagementObligationData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetContractManagementObligationResponses,
    GetContractManagementObligationErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/contract-management/obligation/{uid}',
    ...options,
  });

/**
 * Update Contract Management Obligation
 *
 * Update an existing contract management obligation.
 */
export const updateContractManagementObligation = <ThrowOnError extends boolean = false>(
  options: Options<UpdateContractManagementObligationData, ThrowOnError>
) =>
  (options.client ?? client).put<
    UpdateContractManagementObligationResponses,
    UpdateContractManagementObligationErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/contract-management/obligation/{uid}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Search Contract Management Obligations
 *
 * Search contract management obligations.
 */
export const searchContractManagementObligations = <ThrowOnError extends boolean = false>(
  options: Options<SearchContractManagementObligationsData, ThrowOnError>
) =>
  (options.client ?? client).post<
    SearchContractManagementObligationsResponses,
    SearchContractManagementObligationsErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/contract-management/obligation/search',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get Obligation Contract Files
 *
 * Contract files related to a contract management obligation, with contracts, vault files, and pages.
 */
export const getObligationContractFiles = <ThrowOnError extends boolean = false>(
  options: Options<GetObligationContractFilesData, ThrowOnError>
) =>
  (options.client ?? client).post<
    GetObligationContractFilesResponses,
    GetObligationContractFilesErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/contract-management/obligation/{uid}/contract-files',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Add Obligation To Contract File
 *
 * Add a obligation to a contract file (idempotent).
 */
export const addObligationToContractFile = <ThrowOnError extends boolean = false>(
  options: Options<AddObligationToContractFileData, ThrowOnError>
) =>
  (options.client ?? client).post<
    AddObligationToContractFileResponses,
    AddObligationToContractFileErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/contract-management/obligation/add-to-contract-file',
    ...options,
  });

/**
 * Remove Obligation From Contract File
 *
 * Remove a obligation from a contract file (idempotent).
 */
export const removeObligationFromContractFile = <ThrowOnError extends boolean = false>(
  options: Options<RemoveObligationFromContractFileData, ThrowOnError>
) =>
  (options.client ?? client).post<
    RemoveObligationFromContractFileResponses,
    RemoveObligationFromContractFileErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/contract-management/obligation/remove-from-contract-file',
    ...options,
  });

/**
 * Delete Contract Management Date
 *
 * Delete a contract management date.
 */
export const deleteContractManagementDate = <ThrowOnError extends boolean = false>(
  options: Options<DeleteContractManagementDateData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    DeleteContractManagementDateResponses,
    DeleteContractManagementDateErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/contract-management/date/{uid}',
    ...options,
  });

/**
 * Update Contract Management Date
 *
 * Update an existing contract management date.
 */
export const updateContractManagementDate = <ThrowOnError extends boolean = false>(
  options: Options<UpdateContractManagementDateData, ThrowOnError>
) =>
  (options.client ?? client).put<
    UpdateContractManagementDateResponses,
    UpdateContractManagementDateErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/contract-management/date/{uid}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Delete Contract Management Contract
 *
 * Delete a contract with all its contract files and their vault files — a contract is a
 * leaf in the vault like a file, so deleting it deletes what it holds.
 */
export const deleteContractManagementContract = <ThrowOnError extends boolean = false>(
  options: Options<DeleteContractManagementContractData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    DeleteContractManagementContractResponses,
    DeleteContractManagementContractErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/contract-management/contract/{uid}',
    ...options,
  });

/**
 * Get Contract Management Contract
 *
 * Get a specific contract management contract by UID.
 */
export const getContractManagementContract = <ThrowOnError extends boolean = false>(
  options: Options<GetContractManagementContractData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetContractManagementContractResponses,
    GetContractManagementContractErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/contract-management/contract/{uid}',
    ...options,
  });

/**
 * Update Contract Management Contract
 *
 * Update an existing contract management contract.
 */
export const updateContractManagementContract = <ThrowOnError extends boolean = false>(
  options: Options<UpdateContractManagementContractData, ThrowOnError>
) =>
  (options.client ?? client).put<
    UpdateContractManagementContractResponses,
    UpdateContractManagementContractErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/contract-management/contract/{uid}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Search Contract Management Contracts
 *
 * Search contract management contracts.
 */
export const searchContractManagementContracts = <ThrowOnError extends boolean = false>(
  options: Options<SearchContractManagementContractsData, ThrowOnError>
) =>
  (options.client ?? client).post<
    SearchContractManagementContractsResponses,
    SearchContractManagementContractsErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/contract-management/contract/search',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get Contract Contractual Parties
 *
 * The contract's unique parties across its files (read-only; parties are linked to the files).
 */
export const getContractContractualParties = <ThrowOnError extends boolean = false>(
  options: Options<GetContractContractualPartiesData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetContractContractualPartiesResponses,
    GetContractContractualPartiesErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/contract-management/contract/{uid}/contractual-parties',
    ...options,
  });

/**
 * Get Contract Files For Contract
 *
 * Get contract files for a specific contract.
 */
export const getContractFilesForContract = <ThrowOnError extends boolean = false>(
  options: Options<GetContractFilesForContractData, ThrowOnError>
) =>
  (options.client ?? client).post<
    GetContractFilesForContractResponses,
    GetContractFilesForContractErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/contract-management/contract/{uid}/contract-files',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get Contract Values
 *
 * The contract's effective values, one per prompt and value type: the value of the contract file
 * that answers for the contract today (``ContractValueResolver``).
 */
export const getContractValues = <ThrowOnError extends boolean = false>(
  options: Options<GetContractValuesData, ThrowOnError>
) =>
  (options.client ?? client).post<
    GetContractValuesResponses,
    GetContractValuesErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/contract-management/contract/{uid}/values',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get Contract Value Matrix
 *
 * The contract's effective values (as ``/values``) with every contract file's own value per
 * prompt — a row per value, a column per file.
 */
export const getContractValueMatrix = <ThrowOnError extends boolean = false>(
  options: Options<GetContractValueMatrixData, ThrowOnError>
) =>
  (options.client ?? client).post<
    GetContractValueMatrixResponses,
    GetContractValueMatrixErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/contract-management/contract/{uid}/values/matrix',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Repopulate Contract Management Contract
 *
 * Start a background task that repopulates a contract's details from its files.
 *
 * Requires WRITE access to the contract. Only one repopulate task may be active per contract at a
 * time — a second request while one is PENDING/RUNNING is rejected.
 */
export const repopulateContractManagementContract = <ThrowOnError extends boolean = false>(
  options: Options<RepopulateContractManagementContractData, ThrowOnError>
) =>
  (options.client ?? client).post<
    RepopulateContractManagementContractResponses,
    RepopulateContractManagementContractErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/contract-management/contract/{uid}/repopulate',
    ...options,
  });

/**
 * Convert Contract To File
 *
 * Turn a one-file contract into a plain file in its place.
 *
 * The file takes the contract's owner and shares; the contract and its contract-file row are
 * deleted, the file and everything extracted from it stay.
 *
 * Raises:
 * NotFoundError: If the contract is not found
 * UnauthorizedError: If the user lacks ADMIN on the contract
 * InvalidDataError: If the contract holds more than one file or a draft, or sits in the system vault
 */
export const convertContractToFile = <ThrowOnError extends boolean = false>(
  options: Options<ConvertContractToFileData, ThrowOnError>
) =>
  (options.client ?? client).post<
    ConvertContractToFileResponses,
    ConvertContractToFileErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/contract-management/contract/{uid}/convert-to-file',
    ...options,
  });

/**
 * Convert Contract To Folder
 *
 * Turn a contract into a folder of the same name in its place, holding its files as plain files.
 *
 * The folder takes the contract's owner and shares; the files are owned by the contract's owner
 * and inherit the shares from the folder. The contract and its contract-file rows are deleted,
 * the files and everything extracted from them stay.
 *
 * Raises:
 * NotFoundError: If the contract is not found
 * UnauthorizedError: If the user lacks ADMIN on the contract
 * InvalidDataError: If the contract holds a draft or sits in the system vault
 */
export const convertContractToFolder = <ThrowOnError extends boolean = false>(
  options: Options<ConvertContractToFolderData, ThrowOnError>
) =>
  (options.client ?? client).post<
    ConvertContractToFolderResponses,
    ConvertContractToFolderErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/contract-management/contract/{uid}/convert-to-folder',
    ...options,
  });

/**
 * Search Contract Management Contract Files
 */
export const searchContractManagementContractFiles = <ThrowOnError extends boolean = false>(
  options: Options<SearchContractManagementContractFilesData, ThrowOnError>
) =>
  (options.client ?? client).post<
    SearchContractManagementContractFilesResponses,
    SearchContractManagementContractFilesErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/contract-management/contract-file/search',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Create Contract Management Contract File
 *
 * File a vault file into a contract as a new contract file.
 *
 * The user names only the file and the contract: the classification task fills the type and the
 * description from the document (the states start as draft / not yet active), then starts the
 * contract's extraction. All of them can be edited afterwards.
 */
export const createContractManagementContractFile = <ThrowOnError extends boolean = false>(
  options: Options<CreateContractManagementContractFileData, ThrowOnError>
) =>
  (options.client ?? client).post<
    CreateContractManagementContractFileResponses,
    CreateContractManagementContractFileErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/contract-management/contract-file/new',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Delete Contract Management Contract File
 *
 * Delete a contract file together with its vault file — the file exists only within the
 * contract — and the contract too when it was its last file.
 */
export const deleteContractManagementContractFile = <ThrowOnError extends boolean = false>(
  options: Options<DeleteContractManagementContractFileData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    DeleteContractManagementContractFileResponses,
    DeleteContractManagementContractFileErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/contract-management/contract-file/{uid}',
    ...options,
  });

/**
 * Get Contract Management Contract File
 *
 * Get a specific contract management contract file by UID.
 */
export const getContractManagementContractFile = <ThrowOnError extends boolean = false>(
  options: Options<GetContractManagementContractFileData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetContractManagementContractFileResponses,
    GetContractManagementContractFileErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/contract-management/contract-file/{uid}',
    ...options,
  });

/**
 * Update Contract Management Contract File
 *
 * Update an existing contract management contract file: its role, description and the
 * document state of its current revision.
 *
 * The vault file it holds is fixed (see ``ContractManagementContractFileUpdateUser``).
 *
 * Raises:
 * InvalidDataError: If the document state move is the system's to make
 */
export const updateContractManagementContractFile = <ThrowOnError extends boolean = false>(
  options: Options<UpdateContractManagementContractFileData, ThrowOnError>
) =>
  (options.client ?? client).put<
    UpdateContractManagementContractFileResponses,
    UpdateContractManagementContractFileErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/contract-management/contract-file/{uid}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Move Contract Management Contract File
 *
 * Move a contract file to another contract (existing or newly created).
 *
 * Use either target_contract_uid to move to an existing contract, or new_contract
 * to create a new contract next to the source and move the file there.
 * The whole move is ONE transaction; extraction dispatches follow the commit.
 */
export const moveContractManagementContractFile = <ThrowOnError extends boolean = false>(
  options: Options<MoveContractManagementContractFileData, ThrowOnError>
) =>
  (options.client ?? client).post<
    MoveContractManagementContractFileResponses,
    MoveContractManagementContractFileErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/contract-management/contract-file/{uid}/move',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get Contract Management Contract File Clauses
 *
 * Get the clauses of a contract file (optionally scoped to one revision).
 */
export const getContractManagementContractFileClauses = <ThrowOnError extends boolean = false>(
  options: Options<GetContractManagementContractFileClausesData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetContractManagementContractFileClausesResponses,
    GetContractManagementContractFileClausesErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/contract-management/contract-file/{uid}/clauses',
    ...options,
  });

/**
 * Get Contract Management Contract File Obligations
 *
 * Get the obligations of a contract file (optionally scoped to one revision).
 */
export const getContractManagementContractFileObligations = <ThrowOnError extends boolean = false>(
  options: Options<GetContractManagementContractFileObligationsData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetContractManagementContractFileObligationsResponses,
    GetContractManagementContractFileObligationsErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/contract-management/contract-file/{uid}/obligations',
    ...options,
  });

/**
 * Get Contract Management Contract File Dates
 *
 * Get the fixed-type dates of a contract file (optionally scoped to one revision).
 */
export const getContractManagementContractFileDates = <ThrowOnError extends boolean = false>(
  options: Options<GetContractManagementContractFileDatesData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetContractManagementContractFileDatesResponses,
    GetContractManagementContractFileDatesErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/contract-management/contract-file/{uid}/dates',
    ...options,
  });

/**
 * Create Contract Management Contract File Date
 *
 * Add a fixed-type date to a contract file's current revision (or the given one). A revision may hold
 * several dates of one type; the result must pass ``ContractStateResolver.check_effective_dates`` (422).
 */
export const createContractManagementContractFileDate = <ThrowOnError extends boolean = false>(
  options: Options<CreateContractManagementContractFileDateData, ThrowOnError>
) =>
  (options.client ?? client).post<
    CreateContractManagementContractFileDateResponses,
    CreateContractManagementContractFileDateErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/contract-management/contract-file/{uid}/dates',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get Contract Management Contract File Contractual Parties
 *
 * Get the contractual parties of a contract file.
 */
export const getContractManagementContractFileContractualParties = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetContractManagementContractFileContractualPartiesData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetContractManagementContractFileContractualPartiesResponses,
    GetContractManagementContractFileContractualPartiesErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/contract-management/contract-file/{uid}/contractual_parties',
    ...options,
  });

/**
 * Search Contract File Extractions
 *
 * Search extractions of a contract file's vault file revision.
 *
 * Note:
 * Extractions are stored at the vault file level, not contract file level.
 * A vault file can be associated with multiple contract files, so this endpoint
 * returns all extractions for the vault file linked to the specified contract file.
 */
export const searchContractFileExtractions = <ThrowOnError extends boolean = false>(
  options: Options<SearchContractFileExtractionsData, ThrowOnError>
) =>
  (options.client ?? client).post<
    SearchContractFileExtractionsResponses,
    SearchContractFileExtractionsErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/contract-management/contract-file/{uid}/extractions',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * List Contract Types
 *
 * Every contract type of the active organisation, by name, each with its extraction prompt
 * count — for pickers.
 */
export const listContractTypes = <ThrowOnError extends boolean = false>(
  options?: Options<ListContractTypesData, ThrowOnError>
) =>
  (options?.client ?? client).get<ListContractTypesResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/contract-management/contract-type/',
    ...options,
  });

/**
 * Search Contract Types
 *
 * Search the active organisation's contract types by name and description, paginated, each
 * with its extraction prompt count.
 */
export const searchContractTypes = <ThrowOnError extends boolean = false>(
  options: Options<SearchContractTypesData, ThrowOnError>
) =>
  (options.client ?? client).post<
    SearchContractTypesResponses,
    SearchContractTypesErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/contract-management/contract-type/search',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Create Contract Type
 *
 * Create a contract type in the active organisation; names are unique per organisation.
 */
export const createContractType = <ThrowOnError extends boolean = false>(
  options: Options<CreateContractTypeData, ThrowOnError>
) =>
  (options.client ?? client).post<
    CreateContractTypeResponses,
    CreateContractTypeErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/contract-management/contract-type/new',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Delete Contract Type
 *
 * Delete a contract type.
 *
 * With ``replacement_uid`` its contracts, playbooks, clauses and extraction prompts move to the
 * replacement first (a merge). Without one, its contracts are left untyped and its playbook,
 * clause and extraction prompt links are removed; a playbook or clause without any type is not
 * restricted to one, an extraction prompt without any stays as a standalone prompt.
 */
export const deleteContractType = <ThrowOnError extends boolean = false>(
  options: Options<DeleteContractTypeData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    DeleteContractTypeResponses,
    DeleteContractTypeErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/contract-management/contract-type/{uid}',
    ...options,
  });

/**
 * Update Contract Type
 *
 * Rename or re-describe a contract type. A rename re-syncs the calendars, whose criteria match
 * contracts by type name; saved filters on the old name stop matching.
 */
export const updateContractType = <ThrowOnError extends boolean = false>(
  options: Options<UpdateContractTypeData, ThrowOnError>
) =>
  (options.client ?? client).put<
    UpdateContractTypeResponses,
    UpdateContractTypeErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/contract-management/contract-type/{uid}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get Contract Type Usage
 *
 * What references the contract type — for the warning before a delete.
 */
export const getContractTypeUsage = <ThrowOnError extends boolean = false>(
  options: Options<GetContractTypeUsageData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetContractTypeUsageResponses,
    GetContractTypeUsageErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/contract-management/contract-type/{uid}/usage',
    ...options,
  });

/**
 * Search Contract Type Contracts
 *
 * The contracts of the contract type the user can read, searched by their text fields, paginated.
 */
export const searchContractTypeContracts = <ThrowOnError extends boolean = false>(
  options: Options<SearchContractTypeContractsData, ThrowOnError>
) =>
  (options.client ?? client).post<
    SearchContractTypeContractsResponses,
    SearchContractTypeContractsErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/contract-management/contract-type/{uid}/contracts',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Search Contract Type Playbooks
 *
 * The playbooks linked to the contract type, searched by their text fields, paginated.
 */
export const searchContractTypePlaybooks = <ThrowOnError extends boolean = false>(
  options: Options<SearchContractTypePlaybooksData, ThrowOnError>
) =>
  (options.client ?? client).post<
    SearchContractTypePlaybooksResponses,
    SearchContractTypePlaybooksErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/contract-management/contract-type/{uid}/playbooks',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Search Contract Type Clauses
 *
 * The library clauses linked to the contract type, searched by their text fields, paginated.
 */
export const searchContractTypeClauses = <ThrowOnError extends boolean = false>(
  options: Options<SearchContractTypeClausesData, ThrowOnError>
) =>
  (options.client ?? client).post<
    SearchContractTypeClausesResponses,
    SearchContractTypeClausesErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/contract-management/contract-type/{uid}/clauses',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Search Extraction Prompts
 *
 * Search the active organisation's extraction prompts by name, display name and prompt text, paginated;
 * with ``contract_type_uids`` only those linked to any of the types, with ``without_contract_type`` only
 * the standalone ones; given both, either. With ``view_uid`` (readable by the user), each result lists the
 * columns of that view asking it.
 */
export const searchExtractionPrompts = <ThrowOnError extends boolean = false>(
  options: Options<SearchExtractionPromptsData, ThrowOnError>
) =>
  (options.client ?? client).post<
    SearchExtractionPromptsResponses,
    SearchExtractionPromptsErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/contract-management/extraction-prompt/search',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Delete Extraction Prompt
 *
 * Delete an extraction prompt; its contract type links and versions go with it. Refused while a
 * view column asks it.
 */
export const deleteExtractionPrompt = <ThrowOnError extends boolean = false>(
  options: Options<DeleteExtractionPromptData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    DeleteExtractionPromptResponses,
    DeleteExtractionPromptErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/contract-management/extraction-prompt/{uid}',
    ...options,
  });

/**
 * Get Extraction Prompt
 */
export const getExtractionPrompt = <ThrowOnError extends boolean = false>(
  options: Options<GetExtractionPromptData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetExtractionPromptResponses,
    GetExtractionPromptErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/contract-management/extraction-prompt/{uid}',
    ...options,
  });

/**
 * Update Extraction Prompt
 *
 * Edit an extraction prompt; a changed question is its next version.
 *
 * A changed question re-extracts, with ``extraction_scope``, every view column asking the prompt;
 * such a column's filters are reset when they no longer fit a changed response type. Until then a
 * column shows the older versions' answers. Name and contract type edits re-extract nothing; a
 * rename renames the display name too while it is still the old name (unless one is sent).
 * Refused (409) when a view asking the prompt has another column asking the new question.
 */
export const updateExtractionPrompt = <ThrowOnError extends boolean = false>(
  options: Options<UpdateExtractionPromptData, ThrowOnError>
) =>
  (options.client ?? client).put<
    UpdateExtractionPromptResponses,
    UpdateExtractionPromptErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/contract-management/extraction-prompt/{uid}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Create Extraction Prompt
 *
 * Create an extraction prompt in the active organisation, linked to ``contract_type_uids``
 * (none: a standalone prompt).
 */
export const createExtractionPrompt = <ThrowOnError extends boolean = false>(
  options: Options<CreateExtractionPromptData, ThrowOnError>
) =>
  (options.client ?? client).post<
    CreateExtractionPromptResponses,
    CreateExtractionPromptErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/contract-management/extraction-prompt/new',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Search Extraction Prompt Versions
 *
 * Search the versions (the questions asked) of an extraction prompt by prompt text, newest first.
 */
export const searchExtractionPromptVersions = <ThrowOnError extends boolean = false>(
  options: Options<SearchExtractionPromptVersionsData, ThrowOnError>
) =>
  (options.client ?? client).post<
    SearchExtractionPromptVersionsResponses,
    SearchExtractionPromptVersionsErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/contract-management/extraction-prompt/{uid}/versions/search',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Create Contract Management Contractual Party
 *
 * Create a new contractual party (natural person or legal entity, by ``kind``).
 */
export const createContractManagementContractualParty = <ThrowOnError extends boolean = false>(
  options: Options<CreateContractManagementContractualPartyData, ThrowOnError>
) =>
  (options.client ?? client).post<
    CreateContractManagementContractualPartyResponses,
    CreateContractManagementContractualPartyErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/contract-management/contractual-party/new',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Merge Contract Management Contractual Parties
 *
 * Merge two contract management contractual parties of the same kind into a new one; both sources are deleted.
 */
export const mergeContractManagementContractualParties = <ThrowOnError extends boolean = false>(
  options: Options<MergeContractManagementContractualPartiesData, ThrowOnError>
) =>
  (options.client ?? client).post<
    MergeContractManagementContractualPartiesResponses,
    MergeContractManagementContractualPartiesErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/contract-management/contractual-party/merge',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Delete Contract Management Contractual Party
 *
 * Delete a contractual party; its contract-file and representative links go with it, the files stay.
 */
export const deleteContractManagementContractualParty = <ThrowOnError extends boolean = false>(
  options: Options<DeleteContractManagementContractualPartyData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    DeleteContractManagementContractualPartyResponses,
    DeleteContractManagementContractualPartyErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/contract-management/contractual-party/{uid}',
    ...options,
  });

/**
 * Get Contract Management Contractual Party
 *
 * Get a specific contractual party by UID.
 */
export const getContractManagementContractualParty = <ThrowOnError extends boolean = false>(
  options: Options<GetContractManagementContractualPartyData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetContractManagementContractualPartyResponses,
    GetContractManagementContractualPartyErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/contract-management/contractual-party/{uid}',
    ...options,
  });

/**
 * Update Contract Management Contractual Party
 *
 * Update an existing contractual party; the body's ``kind`` must match the party's.
 */
export const updateContractManagementContractualParty = <ThrowOnError extends boolean = false>(
  options: Options<UpdateContractManagementContractualPartyData, ThrowOnError>
) =>
  (options.client ?? client).put<
    UpdateContractManagementContractualPartyResponses,
    UpdateContractManagementContractualPartyErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/contract-management/contractual-party/{uid}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Search Contract Management Contractual Parties
 *
 * Search contractual parties.
 */
export const searchContractManagementContractualParties = <ThrowOnError extends boolean = false>(
  options: Options<SearchContractManagementContractualPartiesData, ThrowOnError>
) =>
  (options.client ?? client).post<
    SearchContractManagementContractualPartiesResponses,
    SearchContractManagementContractualPartiesErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/contract-management/contractual-party/search',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Add Contractual Party To Contract File
 *
 * Link a party to a contract file (idempotent).
 */
export const addContractualPartyToContractFile = <ThrowOnError extends boolean = false>(
  options: Options<AddContractualPartyToContractFileData, ThrowOnError>
) =>
  (options.client ?? client).post<
    AddContractualPartyToContractFileResponses,
    AddContractualPartyToContractFileErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/contract-management/contractual-party/add-to-contract-file',
    ...options,
  });

/**
 * Remove Contractual Party From Contract File
 *
 * Unlink a party from a contract file (idempotent).
 */
export const removeContractualPartyFromContractFile = <ThrowOnError extends boolean = false>(
  options: Options<RemoveContractualPartyFromContractFileData, ThrowOnError>
) =>
  (options.client ?? client).post<
    RemoveContractualPartyFromContractFileResponses,
    RemoveContractualPartyFromContractFileErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/contract-management/contractual-party/remove-from-contract-file',
    ...options,
  });

/**
 * Get Contractual Party Contracts
 *
 * The contracts with a file the party is linked to (searchable, filterable, paginated), only those the caller
 * may read.
 */
export const getContractualPartyContracts = <ThrowOnError extends boolean = false>(
  options: Options<GetContractualPartyContractsData, ThrowOnError>
) =>
  (options.client ?? client).post<
    GetContractualPartyContractsResponses,
    GetContractualPartyContractsErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/contract-management/contractual-party/{uid}/contracts',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get Contractual Party Represented Legal Entities
 *
 * The legal entities a natural person represents (searchable, filterable, paginated) — only those the caller
 * may read: seeing a representative never reveals the legal entity.
 */
export const getContractualPartyRepresentedLegalEntities = <ThrowOnError extends boolean = false>(
  options: Options<GetContractualPartyRepresentedLegalEntitiesData, ThrowOnError>
) =>
  (options.client ?? client).post<
    GetContractualPartyRepresentedLegalEntitiesResponses,
    GetContractualPartyRepresentedLegalEntitiesErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/contract-management/contractual-party/{uid}/represented-legal-entities',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Add Contractual Party Representative
 *
 * Add a natural person party as a representative of a legal entity party (idempotent).
 */
export const addContractualPartyRepresentative = <ThrowOnError extends boolean = false>(
  options: Options<AddContractualPartyRepresentativeData, ThrowOnError>
) =>
  (options.client ?? client).post<
    AddContractualPartyRepresentativeResponses,
    AddContractualPartyRepresentativeErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/contract-management/contractual-party/add-representative',
    ...options,
  });

/**
 * Remove Contractual Party Representative
 *
 * Remove a representative from a legal entity party (idempotent).
 */
export const removeContractualPartyRepresentative = <ThrowOnError extends boolean = false>(
  options: Options<RemoveContractualPartyRepresentativeData, ThrowOnError>
) =>
  (options.client ?? client).post<
    RemoveContractualPartyRepresentativeResponses,
    RemoveContractualPartyRepresentativeErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/contract-management/contractual-party/remove-representative',
    ...options,
  });

/**
 * Set Contractual Party Default Representative
 *
 * Make one of a legal entity party's representatives its default (preselected for signing); without
 * ``representative_uid`` the default is cleared.
 */
export const setContractualPartyDefaultRepresentative = <ThrowOnError extends boolean = false>(
  options: Options<SetContractualPartyDefaultRepresentativeData, ThrowOnError>
) =>
  (options.client ?? client).post<
    SetContractualPartyDefaultRepresentativeResponses,
    SetContractualPartyDefaultRepresentativeErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/contract-management/contractual-party/set-default-representative',
    ...options,
  });

/**
 * Get Contract Management View Preview
 *
 * Get a full table preview for the view creation wizard.
 *
 * Returns table data in the same structure as the actual view table endpoint. Dynamic
 * columns show matching existing extractions (or None); static columns show real data.
 */
export const getContractManagementViewPreview = <ThrowOnError extends boolean = false>(
  options: Options<GetContractManagementViewPreviewData, ThrowOnError>
) =>
  (options.client ?? client).post<
    GetContractManagementViewPreviewResponses,
    GetContractManagementViewPreviewErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/contract-management/views/preview',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Create Contract Management View From Preview
 *
 * Create a view + its columns + their questions (new or existing extraction prompts) from the
 * preview configuration, then dispatch one extraction task per column. Refused (409) when two
 * columns ask the same question (prompt, example data, response type).
 */
export const createContractManagementViewFromPreview = <ThrowOnError extends boolean = false>(
  options: Options<CreateContractManagementViewFromPreviewData, ThrowOnError>
) =>
  (options.client ?? client).post<
    CreateContractManagementViewFromPreviewResponses,
    CreateContractManagementViewFromPreviewErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/contract-management/views/preview/create',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Create Contract Management View
 *
 * Create a new contract management view scoped by the given directories and contracts
 * (nothing picked: every contract in the main vault).
 */
export const createContractManagementView = <ThrowOnError extends boolean = false>(
  options: Options<CreateContractManagementViewData, ThrowOnError>
) =>
  (options.client ?? client).post<
    CreateContractManagementViewResponses,
    CreateContractManagementViewErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/contract-management/views/new',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Delete Contract Management View
 *
 * Delete a contract management view, and the view-owned prompts no contract type or other
 * column keeps; unused library prompts too with ``delete_unused_library_prompts`` (org admins
 * only).
 */
export const deleteContractManagementView = <ThrowOnError extends boolean = false>(
  options: Options<DeleteContractManagementViewData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    DeleteContractManagementViewResponses,
    DeleteContractManagementViewErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/contract-management/views/{view_uid}',
    ...options,
  });

/**
 * Get Contract Management View
 *
 * Get a specific contract management view by UID.
 */
export const getContractManagementView = <ThrowOnError extends boolean = false>(
  options: Options<GetContractManagementViewData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetContractManagementViewResponses,
    GetContractManagementViewErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/contract-management/views/{view_uid}',
    ...options,
  });

/**
 * Update Contract Management View
 *
 * Update an existing contract management view.
 */
export const updateContractManagementView = <ThrowOnError extends boolean = false>(
  options: Options<UpdateContractManagementViewData, ThrowOnError>
) =>
  (options.client ?? client).put<
    UpdateContractManagementViewResponses,
    UpdateContractManagementViewErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/contract-management/views/{view_uid}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get Contract Management View Table
 *
 * Get paginated table data for a view: contracts + per-column values and the total
 * count (the filter options are their own endpoint: they do not depend on the query).
 */
export const getContractManagementViewTable = <ThrowOnError extends boolean = false>(
  options: Options<GetContractManagementViewTableData, ThrowOnError>
) =>
  (options.client ?? client).post<
    GetContractManagementViewTableResponses,
    GetContractManagementViewTableErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/contract-management/views/{view_uid}/table',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get Contract Management View Table Filter Options
 *
 * The per-column filter options of a view's table: the distinct values within the view's
 * scope (its stored filters applied) that the user may read.
 */
export const getContractManagementViewTableFilterOptions = <ThrowOnError extends boolean = false>(
  options: Options<GetContractManagementViewTableFilterOptionsData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetContractManagementViewTableFilterOptionsResponses,
    GetContractManagementViewTableFilterOptionsErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/contract-management/views/{view_uid}/table/filter-options',
    ...options,
  });

/**
 * Get Contract Management View Table Contract Files
 *
 * Get the contract files of one contract in the view, with per-column values.
 */
export const getContractManagementViewTableContractFiles = <ThrowOnError extends boolean = false>(
  options: Options<GetContractManagementViewTableContractFilesData, ThrowOnError>
) =>
  (options.client ?? client).post<
    GetContractManagementViewTableContractFilesResponses,
    GetContractManagementViewTableContractFilesErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/contract-management/views/{view_uid}/table/{contract_uid}/contract-files',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Search Contract Management Views
 *
 * Search contract management views.
 */
export const searchContractManagementViews = <ThrowOnError extends boolean = false>(
  options: Options<SearchContractManagementViewsData, ThrowOnError>
) =>
  (options.client ?? client).post<
    SearchContractManagementViewsResponses,
    SearchContractManagementViewsErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/contract-management/views/search',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Add Column
 *
 * Add a column to a view and dispatch its extraction. Its question is a new extraction prompt
 * named the question's ``name``, else after the column (one of them is required), or an existing
 * one of the view's organisation. Refused (409) when a column of the view already asks that
 * question (prompt, example data, response type).
 */
export const addColumn = <ThrowOnError extends boolean = false>(
  options: Options<AddColumnData, ThrowOnError>
) =>
  (options.client ?? client).post<AddColumnResponses, AddColumnErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/contract-management/views/{view_uid}/add_column',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Add Contract Type Columns
 *
 * Add a column per extraction prompt of the contract type and dispatch their extraction.
 *
 * Each new column asks the prompt, shows its display name (no name of its own: it follows prompt
 * renames) and is appended visible, after the view's columns, in display name order. Idempotent:
 * a prompt whose question (prompt, example data, response type) a column of the view already asks
 * is skipped; that column is listed in ``existing``.
 */
export const addContractTypeColumns = <ThrowOnError extends boolean = false>(
  options: Options<AddContractTypeColumnsData, ThrowOnError>
) =>
  (options.client ?? client).post<
    AddContractTypeColumnsResponses,
    AddContractTypeColumnsErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/contract-management/views/{view_uid}/add_contract_type_columns',
    ...options,
  });

/**
 * Add View Source Directories
 *
 * Pick one or more directories (each with its whole subtree) for a view's scope.
 *
 * The first pick narrows a view that picked nothing (the whole main vault) to its picks.
 */
export const addViewSourceDirectories = <ThrowOnError extends boolean = false>(
  options: Options<AddViewSourceDirectoriesData, ThrowOnError>
) =>
  (options.client ?? client).post<
    AddViewSourceDirectoriesResponses,
    AddViewSourceDirectoriesErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/contract-management/views/{view_uid}/source-directories/add',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Remove View Source Directories
 *
 * Drop one or more directories from a view's scope. Removing the last pick widens the view
 * to the whole main vault.
 */
export const removeViewSourceDirectories = <ThrowOnError extends boolean = false>(
  options: Options<RemoveViewSourceDirectoriesData, ThrowOnError>
) =>
  (options.client ?? client).post<
    RemoveViewSourceDirectoriesResponses,
    RemoveViewSourceDirectoriesErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/contract-management/views/{view_uid}/source-directories/remove',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * List View Source Directories
 *
 * List a view's picked directories.
 */
export const listViewSourceDirectories = <ThrowOnError extends boolean = false>(
  options: Options<ListViewSourceDirectoriesData, ThrowOnError>
) =>
  (options.client ?? client).get<
    ListViewSourceDirectoriesResponses,
    ListViewSourceDirectoriesErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/contract-management/views/{view_uid}/source-directories',
    ...options,
  });

/**
 * Add View Source Contracts
 *
 * Pick one or more contracts for a view's scope, wherever they sit in the vault.
 *
 * The first pick narrows a view that picked nothing (the whole main vault) to its picks.
 */
export const addViewSourceContracts = <ThrowOnError extends boolean = false>(
  options: Options<AddViewSourceContractsData, ThrowOnError>
) =>
  (options.client ?? client).post<
    AddViewSourceContractsResponses,
    AddViewSourceContractsErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/contract-management/views/{view_uid}/source-contracts/add',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Remove View Source Contracts
 *
 * Drop one or more contracts from a view's scope. Removing the last pick widens the view to
 * the whole main vault.
 */
export const removeViewSourceContracts = <ThrowOnError extends boolean = false>(
  options: Options<RemoveViewSourceContractsData, ThrowOnError>
) =>
  (options.client ?? client).post<
    RemoveViewSourceContractsResponses,
    RemoveViewSourceContractsErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/contract-management/views/{view_uid}/source-contracts/remove',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * List View Source Contracts
 *
 * List a view's picked contracts.
 */
export const listViewSourceContracts = <ThrowOnError extends boolean = false>(
  options: Options<ListViewSourceContractsData, ThrowOnError>
) =>
  (options.client ?? client).get<
    ListViewSourceContractsResponses,
    ListViewSourceContractsErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/contract-management/views/{view_uid}/source-contracts',
    ...options,
  });

/**
 * Delete Cm View Question Column
 *
 * Delete a contract management view_column, and the view-owned prompts no contract type or
 * other column keeps; unused library prompts too with ``delete_unused_library_prompts`` (org
 * admins only).
 */
export const deleteCmViewQuestionColumn = <ThrowOnError extends boolean = false>(
  options: Options<DeleteCmViewQuestionColumnData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    DeleteCmViewQuestionColumnResponses,
    DeleteCmViewQuestionColumnErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/contract-management/views/columns/{view_column_uid}',
    ...options,
  });

/**
 * Get Cm View Question Column
 *
 * Get a specific contract management view_column by UID.
 */
export const getCmViewQuestionColumn = <ThrowOnError extends boolean = false>(
  options: Options<GetCmViewQuestionColumnData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetCmViewQuestionColumnResponses,
    GetCmViewQuestionColumnErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/contract-management/views/columns/{view_column_uid}',
    ...options,
  });

/**
 * Update Cm View Question Column
 *
 * Update an existing contract management view_column.
 */
export const updateCmViewQuestionColumn = <ThrowOnError extends boolean = false>(
  options: Options<UpdateCmViewQuestionColumnData, ThrowOnError>
) =>
  (options.client ?? client).put<
    UpdateCmViewQuestionColumnResponses,
    UpdateCmViewQuestionColumnErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/contract-management/views/columns/{view_column_uid}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Update Cm View Question Column Question
 *
 * Change the column's question, and dispatch the extraction with the requested scope.
 *
 * - A new question is the next version of the column's prompt: every column asking that prompt
 * follows and is re-extracted (its filters reset when they no longer fit a changed response
 * type). Editing a prompt used beyond this column — a library prompt, one linked to a contract
 * type or asked by another column — needs an organisation admin; ``contract_type_uids`` and
 * ``name`` do not apply (they are edited on the prompt).
 * - ``extraction_prompt_uid`` switches the column to that prompt of the view's organisation; the
 * previous prompt goes when it is view-owned and nothing else uses it.
 *
 * Refused (409) when another column of the view — or, for a new version, of any view asking the
 * prompt — asks the new question.
 */
export const updateCmViewQuestionColumnQuestion = <ThrowOnError extends boolean = false>(
  options: Options<UpdateCmViewQuestionColumnQuestionData, ThrowOnError>
) =>
  (options.client ?? client).put<
    UpdateCmViewQuestionColumnQuestionResponses,
    UpdateCmViewQuestionColumnQuestionErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/contract-management/views/columns/{view_column_uid}/question',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Create Contract Management Extraction Overwrite
 */
export const createContractManagementExtractionOverwrite = <ThrowOnError extends boolean = false>(
  options: Options<CreateContractManagementExtractionOverwriteData, ThrowOnError>
) =>
  (options.client ?? client).post<
    CreateContractManagementExtractionOverwriteResponses,
    CreateContractManagementExtractionOverwriteErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/contract-management/views/overwrite/{contract_management_extraction_uid}/create',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Delete Contract Management Extraction Overwrite
 */
export const deleteContractManagementExtractionOverwrite = <ThrowOnError extends boolean = false>(
  options: Options<DeleteContractManagementExtractionOverwriteData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    DeleteContractManagementExtractionOverwriteResponses,
    DeleteContractManagementExtractionOverwriteErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/contract-management/views/overwrite/{contract_management_extraction_uid}',
    ...options,
  });

/**
 * Update Contract Management Extraction Overwrite
 */
export const updateContractManagementExtractionOverwrite = <ThrowOnError extends boolean = false>(
  options: Options<UpdateContractManagementExtractionOverwriteData, ThrowOnError>
) =>
  (options.client ?? client).put<
    UpdateContractManagementExtractionOverwriteResponses,
    UpdateContractManagementExtractionOverwriteErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/contract-management/views/overwrite/{contract_management_extraction_uid}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Search Clause
 *
 * Search the active organisation's clause library.
 */
export const searchClause = <ThrowOnError extends boolean = false>(
  options: Options<SearchClauseData, ThrowOnError>
) =>
  (options.client ?? client).post<SearchClauseResponses, SearchClauseErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/repository/clause/clause/search',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Create Clause
 *
 * Create a clause in the caller's active organisation.
 */
export const createClause = <ThrowOnError extends boolean = false>(
  options: Options<CreateClauseData, ThrowOnError>
) =>
  (options.client ?? client).post<CreateClauseResponses, CreateClauseErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/repository/clause/clause/new',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Delete Clause
 *
 * Delete a clause.
 */
export const deleteClause = <ThrowOnError extends boolean = false>(
  options: Options<DeleteClauseData, ThrowOnError>
) =>
  (options.client ?? client).delete<DeleteClauseResponses, DeleteClauseErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/repository/clause/clause/{clause_uid}',
    ...options,
  });

/**
 * Get Clause
 *
 * Get a clause.
 */
export const getClause = <ThrowOnError extends boolean = false>(
  options: Options<GetClauseData, ThrowOnError>
) =>
  (options.client ?? client).get<GetClauseResponses, GetClauseErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/repository/clause/clause/{clause_uid}',
    ...options,
  });

/**
 * Update Clause
 *
 * Update an existing clause.
 */
export const updateClause = <ThrowOnError extends boolean = false>(
  options: Options<UpdateClauseData, ThrowOnError>
) =>
  (options.client ?? client).put<UpdateClauseResponses, UpdateClauseErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/repository/clause/clause/{clause_uid}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Search Gaia Clause
 *
 * Search the global GAIA clause library.
 */
export const searchGaiaClause = <ThrowOnError extends boolean = false>(
  options: Options<SearchGaiaClauseData, ThrowOnError>
) =>
  (options.client ?? client).post<SearchGaiaClauseResponses, SearchGaiaClauseErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/repository/clause/gaia-clause/search',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Create Gaia Clause
 *
 * Add a clause to the global library.
 */
export const createGaiaClause = <ThrowOnError extends boolean = false>(
  options: Options<CreateGaiaClauseData, ThrowOnError>
) =>
  (options.client ?? client).post<CreateGaiaClauseResponses, CreateGaiaClauseErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/repository/clause/gaia-clause/new',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Delete Gaia Clause
 *
 * Remove a clause from the global library.
 */
export const deleteGaiaClause = <ThrowOnError extends boolean = false>(
  options: Options<DeleteGaiaClauseData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    DeleteGaiaClauseResponses,
    DeleteGaiaClauseErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/repository/clause/gaia-clause/{gaia_clause_uid}',
    ...options,
  });

/**
 * Get Gaia Clause
 *
 * Get one clause of the global library.
 */
export const getGaiaClause = <ThrowOnError extends boolean = false>(
  options: Options<GetGaiaClauseData, ThrowOnError>
) =>
  (options.client ?? client).get<GetGaiaClauseResponses, GetGaiaClauseErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/repository/clause/gaia-clause/{gaia_clause_uid}',
    ...options,
  });

/**
 * Update Gaia Clause
 *
 * Update a clause of the global library.
 */
export const updateGaiaClause = <ThrowOnError extends boolean = false>(
  options: Options<UpdateGaiaClauseData, ThrowOnError>
) =>
  (options.client ?? client).put<UpdateGaiaClauseResponses, UpdateGaiaClauseErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/repository/clause/gaia-clause/{gaia_clause_uid}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Reload Cache
 */
export const reloadCache = <ThrowOnError extends boolean = false>(
  options?: Options<ReloadCacheData, ThrowOnError>
) =>
  (options?.client ?? client).post<ReloadCacheResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/repository/prompt/data/reload-cache',
    ...options,
  });

/**
 * Get Summary File Level Default
 */
export const getSummaryFileLevelDefault = <ThrowOnError extends boolean = false>(
  options?: Options<GetSummaryFileLevelDefaultData, ThrowOnError>
) =>
  (options?.client ?? client).get<GetSummaryFileLevelDefaultResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/repository/prompt/data/summary_file_level_default',
    ...options,
  });

/**
 * Get All Available Prompts
 */
export const getAllAvailablePrompts = <ThrowOnError extends boolean = false>(
  options?: Options<GetAllAvailablePromptsData, ThrowOnError>
) =>
  (options?.client ?? client).get<GetAllAvailablePromptsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/repository/prompt/data/all',
    ...options,
  });

/**
 * Update Langfuse Collection By Prompt Collection
 */
export const updateLangfuseCollectionByPromptCollection = <ThrowOnError extends boolean = false>(
  options: Options<UpdateLangfuseCollectionByPromptCollectionData, ThrowOnError>
) =>
  (options.client ?? client).post<
    UpdateLangfuseCollectionByPromptCollectionResponses,
    UpdateLangfuseCollectionByPromptCollectionErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/repository/prompt/data/update-collection-by-prompt-collection/{collection_uid}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Search Prompt Collection
 *
 * Search the active organisation's prompt collections, each with its prompt count.
 */
export const searchPromptCollection = <ThrowOnError extends boolean = false>(
  options: Options<SearchPromptCollectionData, ThrowOnError>
) =>
  (options.client ?? client).post<
    SearchPromptCollectionResponses,
    SearchPromptCollectionErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/repository/prompt/prompt-collection/search',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Create Collection
 *
 * Create a new prompt collection in the caller's active organisation.
 */
export const createCollection = <ThrowOnError extends boolean = false>(
  options: Options<CreateCollectionData, ThrowOnError>
) =>
  (options.client ?? client).post<CreateCollectionResponses, CreateCollectionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/repository/prompt/prompt-collection/new',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Create Collection Ai
 *
 * Create a prompt collection whose prompts an LLM generates from the instructions.
 */
export const createCollectionAi = <ThrowOnError extends boolean = false>(
  options: Options<CreateCollectionAiData, ThrowOnError>
) =>
  (options.client ?? client).post<
    CreateCollectionAiResponses,
    CreateCollectionAiErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/repository/prompt/prompt-collection/new_ai',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Delete Collection
 *
 * Delete a prompt collection and all its prompts.
 */
export const deleteCollection = <ThrowOnError extends boolean = false>(
  options: Options<DeleteCollectionData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    DeleteCollectionResponses,
    DeleteCollectionErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/repository/prompt/prompt-collection/{prompt_collection_uid}',
    ...options,
  });

/**
 * Update Collection
 *
 * Update an existing prompt collection.
 */
export const updateCollection = <ThrowOnError extends boolean = false>(
  options: Options<UpdateCollectionData, ThrowOnError>
) =>
  (options.client ?? client).put<UpdateCollectionResponses, UpdateCollectionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/repository/prompt/prompt-collection/{prompt_collection_uid}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get Prompt Collection Prompts
 *
 * List a prompt collection's prompts, newest first.
 */
export const getPromptCollectionPrompts = <ThrowOnError extends boolean = false>(
  options: Options<GetPromptCollectionPromptsData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetPromptCollectionPromptsResponses,
    GetPromptCollectionPromptsErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/repository/prompt/prompt-collection/{prompt_collection_uid}/prompts',
    ...options,
  });

/**
 * Add Prompt To Prompt Collection
 *
 * Add a new prompt to a prompt collection.
 */
export const addPromptToPromptCollection = <ThrowOnError extends boolean = false>(
  options: Options<AddPromptToPromptCollectionData, ThrowOnError>
) =>
  (options.client ?? client).post<
    AddPromptToPromptCollectionResponses,
    AddPromptToPromptCollectionErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/repository/prompt/prompt-collection/{prompt_collection_uid}/prompts/add',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Delete Prompt From Prompt Collection
 *
 * Delete a prompt from a prompt collection.
 */
export const deletePromptFromPromptCollection = <ThrowOnError extends boolean = false>(
  options: Options<DeletePromptFromPromptCollectionData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    DeletePromptFromPromptCollectionResponses,
    DeletePromptFromPromptCollectionErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/repository/prompt/prompt-collection/{prompt_collection_uid}/prompts/{prompt_uid}',
    ...options,
  });

/**
 * Update Prompt From Prompt Collection
 *
 * Update a prompt in a prompt collection.
 *
 * ``ignore_unset=False``, so a field the client omits is written as NULL rather than left
 * alone.
 */
export const updatePromptFromPromptCollection = <ThrowOnError extends boolean = false>(
  options: Options<UpdatePromptFromPromptCollectionData, ThrowOnError>
) =>
  (options.client ?? client).put<
    UpdatePromptFromPromptCollectionResponses,
    UpdatePromptFromPromptCollectionErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/repository/prompt/prompt-collection/{prompt_collection_uid}/prompts/{prompt_uid}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get Vault Directory
 *
 * Get a vault directory or create root if it doesn't exist.
 *
 * Its child folders, contracts and plain files come as one page of *limit* items from *offset*,
 * the three kinds interleaved and sorted by *sort_key* (name, case-insensitive; the owner's email,
 * unowned last; the type label; a timestamp; or a contract / amendment state, worst first) in
 * *sort_direction*; ties break by kind, then uid. With *contract_states* / *amendment_states* only
 * the contracts whose states are among them are listed (either list matches any of its values;
 * both must hold).
 * A folder the caller cannot READ opens when it is on the path to something they may read: it
 * shows only that path and what they may read in it, with ``permissions`` 0.
 *
 * Raises:
 * NotFoundError: If organisation or directory not found
 * UnauthorizedError: If user not authorized for organisation
 */
export const getVaultDirectory = <ThrowOnError extends boolean = false>(
  options?: Options<GetVaultDirectoryData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    GetVaultDirectoryResponses,
    GetVaultDirectoryErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/repository/vault/directory/directory',
    ...options,
  });

/**
 * Create Vault Directory
 *
 * Create a new directory in the vault.
 *
 * Raises:
 * NotFoundError: If organisation or parent directory not found
 * UnauthorizedError: If user not authorized for organisation
 */
export const createVaultDirectory = <ThrowOnError extends boolean = false>(
  options: Options<CreateVaultDirectoryData, ThrowOnError>
) =>
  (options.client ?? client).post<
    CreateVaultDirectoryResponses,
    CreateVaultDirectoryErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/repository/vault/directory/directory',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get System Vault Root
 *
 * Get the root of the organisation's system vault (org admins only), sorted like ``/directory``.
 *
 * The system vault holds the platform-managed content (Templates, Intake Agent);
 * everything below its root is browsed with the ordinary uid-addressed endpoints.
 *
 * Raises:
 * NotFoundError: If the directory cannot be re-read
 * UnauthorizedError: If the user is not an admin of the active organisation
 */
export const getSystemVaultRoot = <ThrowOnError extends boolean = false>(
  options?: Options<GetSystemVaultRootData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    GetSystemVaultRootResponses,
    GetSystemVaultRootErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/repository/vault/directory/directory/system',
    ...options,
  });

/**
 * Delete Vault Directory
 *
 * Delete a vault directory and all its contents recursively.
 *
 * Raises:
 * NotFoundError: If organisation or directory not found
 * UnauthorizedError: If user not authorized for organisation
 * InvalidDataError: If trying to delete root directory
 */
export const deleteVaultDirectory = <ThrowOnError extends boolean = false>(
  options: Options<DeleteVaultDirectoryData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    DeleteVaultDirectoryResponses,
    DeleteVaultDirectoryErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/repository/vault/directory/directory/{uid}',
    ...options,
  });

/**
 * Update Vault Directory
 *
 * Update a vault directory.
 *
 * Raises:
 * NotFoundError: If organisation or directory not found
 * UnauthorizedError: If user not authorized for organisation
 * InvalidDataError: If trying to modify root
 */
export const updateVaultDirectory = <ThrowOnError extends boolean = false>(
  options: Options<UpdateVaultDirectoryData, ThrowOnError>
) =>
  (options.client ?? client).put<
    UpdateVaultDirectoryResponses,
    UpdateVaultDirectoryErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/repository/vault/directory/directory/{uid}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Start Vault Directory Download
 *
 * Kick off an async background zip of a directory's subtree (only content the user can read).
 *
 * Building a large recursive zip inline would exceed request timeouts, so the work is handed to a Celery
 * task. The client subscribes to the returned ``download_uid`` over the websocket to receive "zipping N of M"
 * progress and a final "ready" event carrying the artifact id, then downloads the built zip via
 * ``GET /directory/download/{artifact_uid}``.
 *
 * Raises:
 * NotFoundError: If the directory does not exist
 * UnauthorizedError: If the user lacks read access to the directory
 */
export const startVaultDirectoryDownload = <ThrowOnError extends boolean = false>(
  options: Options<StartVaultDirectoryDownloadData, ThrowOnError>
) =>
  (options.client ?? client).post<
    StartVaultDirectoryDownloadResponses,
    StartVaultDirectoryDownloadErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/repository/vault/directory/directory/{uid}/download',
    ...options,
  });

/**
 * Download Vault Directory Zip
 *
 * Stream a previously-built folder-zip download artifact by its uid.
 *
 * The lookup is scoped to the requesting user and their current organisation, so the uid is safe to expose:
 * anything that isn't a download artifact built for this user + org simply resolves to 404 — no blob is
 * fetched, and real vault files are never reachable here.
 *
 * Raises:
 * NotFoundError: If no matching download artifact exists for the requesting user + organisation
 */
export const downloadVaultDirectoryZip = <ThrowOnError extends boolean = false>(
  options: Options<DownloadVaultDirectoryZipData, ThrowOnError>
) =>
  (options.client ?? client).get<
    DownloadVaultDirectoryZipResponses,
    DownloadVaultDirectoryZipErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/repository/vault/directory/download/{artifact_uid}',
    ...options,
  });

/**
 * Create Vault File
 *
 * Create an empty vault file anchor with no revision, in a folder or straight in a contract.
 *
 * The file has no content until a revision is uploaded via the revision upload flow. In a folder,
 * the first revision turns it into a contract of its own; in a contract, the file joins it as a
 * contract file without a type, which the first revision's classification fills.
 *
 * Raises:
 * NotFoundError: If the parent directory or the contract is not found
 * UnauthorizedError: If the user lacks WRITE permission on the parent directory or the contract
 */
export const createVaultFile = <ThrowOnError extends boolean = false>(
  options: Options<CreateVaultFileData, ThrowOnError>
) =>
  (options.client ?? client).post<CreateVaultFileResponses, CreateVaultFileErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/repository/vault/file',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Duplicate Vault File Name
 *
 * Check whether a file name already exists in a directory.
 *
 * Returns true if a file whose current revision has the given name already
 * exists in the specified directory, false otherwise.
 *
 * Raises:
 * NotFoundError: If the parent directory is not found
 * UnauthorizedError: If the user lacks READ permission on the directory
 */
export const duplicateVaultFileName = <ThrowOnError extends boolean = false>(
  options: Options<DuplicateVaultFileNameData, ThrowOnError>
) =>
  (options.client ?? client).post<
    DuplicateVaultFileNameResponses,
    DuplicateVaultFileNameErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/repository/vault/file/duplicate-vault-file-name',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get Vault File Metadata
 *
 * Get a vault file.
 */
export const getVaultFileMetadata = <ThrowOnError extends boolean = false>(
  options: Options<GetVaultFileMetadataData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetVaultFileMetadataResponses,
    GetVaultFileMetadataErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/repository/vault/file/{file_uid}/metadata',
    ...options,
  });

/**
 * Delete Vault File
 *
 * Delete a vault file.
 *
 * Raises:
 * NotFoundError: If organisation or file not found
 * UnauthorizedError: If user not authorized for organisation
 * TemplateFileError: If the file belongs to a template (delete the template instead)
 */
export const deleteVaultFile = <ThrowOnError extends boolean = false>(
  options: Options<DeleteVaultFileData, ThrowOnError>
) =>
  (options.client ?? client).delete<DeleteVaultFileResponses, DeleteVaultFileErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/repository/vault/file/{uid}',
    ...options,
  });

/**
 * Update Vault File
 *
 * Update a vault file.
 *
 * Only file owner or organisation admin may reassign owner. Single-file update
 * cannot unassign owner (use bulk reassign for that).
 *
 * Raises:
 * NotFoundError: If organisation or file not found
 * UnauthorizedError: If user not authorized for organisation
 */
export const updateVaultFile = <ThrowOnError extends boolean = false>(
  options: Options<UpdateVaultFileData, ThrowOnError>
) =>
  (options.client ?? client).put<UpdateVaultFileResponses, UpdateVaultFileErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/repository/vault/file/{uid}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Convert Vault File To Contract
 *
 * Start converting a plain vault file into a new contract holding it, in its place.
 *
 * The creation agent runs in the worker; the returned task tracks it. Until the task ends the
 * file is marked ``converting`` and locked against moves, edits, deletes and filing. Needs ADMIN
 * on the file, as filing it into a contract does: the contract takes over its owner and shares.
 *
 * Raises:
 * NotFoundError: If the file is not found
 * UnauthorizedError: If the user lacks ADMIN on the file
 * InvalidDataError: If the file already belongs to a contract or sits in the system vault
 * FileBeingConvertedError: If the file is already being converted
 */
export const convertVaultFileToContract = <ThrowOnError extends boolean = false>(
  options: Options<ConvertVaultFileToContractData, ThrowOnError>
) =>
  (options.client ?? client).post<
    ConvertVaultFileToContractResponses,
    ConvertVaultFileToContractErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/repository/vault/file/{uid}/convert-to-contract',
    ...options,
  });

/**
 * Unpack Vault File
 *
 * Unpack an archive vault file, and the archives inside it up to ``MAX_ARCHIVE_UNPACK_DEPTH`` levels.
 *
 * The response lists the unpacked directory plus the nested archives left packed, with the reason.
 *
 * Raises:
 * InvalidDataError: If the file is not an archive, or cannot be unpacked (the detail is the
 * ``ArchiveSkipReason``)
 */
export const unpackVaultFile = <ThrowOnError extends boolean = false>(
  options: Options<UnpackVaultFileData, ThrowOnError>
) =>
  (options.client ?? client).post<UnpackVaultFileResponses, UnpackVaultFileErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/repository/vault/file/{uid}/unpack',
    ...options,
  });

/**
 * Get File Data
 */
export const getFileData = <ThrowOnError extends boolean = false>(
  options: Options<GetFileDataData, ThrowOnError>
) =>
  (options.client ?? client).get<GetFileDataResponses, GetFileDataErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/repository/vault/file/revision/{revision_uid}',
    ...options,
  });

/**
 * Get Vault File By Revision
 *
 * Resolve the parent vault file for a given revision uid.
 *
 * A revision uid is all a caller (e.g. a file review) may hold, but flows that
 * prefill from a vault file need the parent file's uid and current revision.
 */
export const getVaultFileByRevision = <ThrowOnError extends boolean = false>(
  options: Options<GetVaultFileByRevisionData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetVaultFileByRevisionResponses,
    GetVaultFileByRevisionErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/repository/vault/file/revision/{revision_uid}/file',
    ...options,
  });

/**
 * Get File Preview Data
 *
 * The revision's PDF preview: its stored one, or a draft's rendered and converted on the spot.
 */
export const getFilePreviewData = <ThrowOnError extends boolean = false>(
  options: Options<GetFilePreviewDataData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetFilePreviewDataResponses,
    GetFilePreviewDataErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/repository/vault/file/revision/{revision_uid}/preview',
    ...options,
  });

/**
 * Head File Preview Data
 */
export const headFilePreviewData = <ThrowOnError extends boolean = false>(
  options: Options<HeadFilePreviewDataData, ThrowOnError>
) =>
  (options.client ?? client).head<
    HeadFilePreviewDataResponses,
    HeadFilePreviewDataErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/repository/vault/file/revision/{revision_uid}/preview',
    ...options,
  });

/**
 * List Vault File Revisions
 *
 * List revisions of a vault file ordered by version_number (paginated).
 *
 * Raises:
 * NotFoundError: If file not found
 * UnauthorizedError: If user lacks READ permission
 */
export const listVaultFileRevisions = <ThrowOnError extends boolean = false>(
  options: Options<ListVaultFileRevisionsData, ThrowOnError>
) =>
  (options.client ?? client).get<
    ListVaultFileRevisionsResponses,
    ListVaultFileRevisionsErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/repository/vault/file/{uid}/revisions',
    ...options,
  });

/**
 * Initialize Vault File Revision Upload
 *
 * Initialize a chunked upload for a new revision of a vault file.
 *
 * Raises:
 * NotFoundError: If file not found
 * UnauthorizedError: If user lacks WRITE permission
 * InvalidDataError: If proposed file size exceeds the configured upload limit, or the
 * chosen document state is not the user's to set
 */
export const initializeVaultFileRevisionUpload = <ThrowOnError extends boolean = false>(
  options: Options<InitializeVaultFileRevisionUploadData, ThrowOnError>
) =>
  (options.client ?? client).post<
    InitializeVaultFileRevisionUploadResponses,
    InitializeVaultFileRevisionUploadErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/repository/vault/file/{uid}/revision/initialize',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Upload Vault File Chunk
 *
 * Upload a chunk of a file.
 *
 * Raises:
 * NotFoundError: If upload ID not found
 * InvalidDataError: If the cumulative upload size exceeds the configured limit
 */
export const uploadVaultFileChunk = <ThrowOnError extends boolean = false>(
  options: Options<UploadVaultFileChunkData, ThrowOnError>
) =>
  (options.client ?? client).post<
    UploadVaultFileChunkResponses,
    UploadVaultFileChunkErrors,
    ThrowOnError
  >({
    ...formDataBodySerializer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/repository/vault/file/chunk/{upload_id}',
    ...options,
    headers: {
      'Content-Type': null,
      ...options.headers,
    },
  });

/**
 * Finalize Vault File Revision Upload
 *
 * Finalize a chunked upload to create a new revision of a vault file.
 *
 * Raises:
 * NotFoundError: If upload ID or file not found
 * UnauthorizedError: If user lacks WRITE permission
 * InvalidDataError: If file upload is incomplete or exceeds the configured upload limit
 */
export const finalizeVaultFileRevisionUpload = <ThrowOnError extends boolean = false>(
  options: Options<FinalizeVaultFileRevisionUploadData, ThrowOnError>
) =>
  (options.client ?? client).post<
    FinalizeVaultFileRevisionUploadResponses,
    FinalizeVaultFileRevisionUploadErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/repository/vault/file/{uid}/revision/finalize/{upload_id}',
    ...options,
  });

/**
 * Delete Vault File Revision
 *
 * Delete a specific revision of a vault file.
 *
 * Cannot delete the last remaining revision — delete the whole file instead.
 *
 * Raises:
 * NotFoundError: If file or revision not found, or revision does not belong to file
 * UnauthorizedError: If user lacks ADMIN permission
 * InvalidDataError: If this is the only revision
 */
export const deleteVaultFileRevision = <ThrowOnError extends boolean = false>(
  options: Options<DeleteVaultFileRevisionData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    DeleteVaultFileRevisionResponses,
    DeleteVaultFileRevisionErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/repository/vault/file/{uid}/revision/{revision_uid}',
    ...options,
  });

/**
 * Update Vault File Revision
 *
 * Update a vault file revision.
 *
 * Raises:
 * NotFoundError: If file or revision not found, or revision does not belong to file
 * UnauthorizedError: If user lacks WRITE permission
 * InvalidDataError: If the document state move is the system's to make
 */
export const updateVaultFileRevision = <ThrowOnError extends boolean = false>(
  options: Options<UpdateVaultFileRevisionData, ThrowOnError>
) =>
  (options.client ?? client).put<
    UpdateVaultFileRevisionResponses,
    UpdateVaultFileRevisionErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/repository/vault/file/{uid}/revision/{revision_uid}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get Vault File Revision Diff
 *
 * Get a structured diff between two revisions of a vault file.
 *
 * Raises:
 * NotFoundError: If file, revision, or compare_to revision not found
 * UnauthorizedError: If user lacks READ permission
 */
export const getVaultFileRevisionDiff = <ThrowOnError extends boolean = false>(
  options: Options<GetVaultFileRevisionDiffData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetVaultFileRevisionDiffResponses,
    GetVaultFileRevisionDiffErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/repository/vault/file/{uid}/revision/{revision_uid}/diff',
    ...options,
  });

/**
 * Convert Pdf To Docx
 *
 * Convert the current PDF revision of a vault file to DOCX, stored as a new revision.
 *
 * The conversion runs asynchronously via ConvertAPI. Scanned/image-only PDFs are rejected up front
 * since they cannot be converted to an editable DOCX.
 *
 * Raises:
 * NotFoundError: If the file or its current revision is not found
 * UnauthorizedError: If user lacks WRITE permission
 * InvalidDataError: If the current revision is not a PDF, exceeds 200 MB, appears to be
 * scanned/image-only, or has not finished preprocessing
 */
export const convertPdfToDocx = <ThrowOnError extends boolean = false>(
  options: Options<ConvertPdfToDocxData, ThrowOnError>
) =>
  (options.client ?? client).post<ConvertPdfToDocxResponses, ConvertPdfToDocxErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/repository/vault/file/{uid}/convert-pdf-to-docx',
    ...options,
  });

/**
 * Search Vault File Intake
 *
 * The main-vault files the caller can read that went into the contract pipeline (uploads, unpacked archive
 * members, intake-agent files, uploads into a contract), newest first by default: where each one
 * went and what was extracted from it. ``text`` matches the file, contract and party names;
 * ``column_filters`` take the contract's filterable fields (type, tags), whose options come back
 * in ``filter_options``; ``sources``, ``owner_user_uids``, ``created_by_user_uids`` (a creator of
 * any of the file's revisions), the upload dates and ``statuses`` narrow further (``filter_options["status"]``:
 * the statuses that occur; ``["source"]``: the origins that occur; ``["owner_user"]`` /
 * ``["created_by_user"]``: the owners / creators that occur). ``sort_key="status"`` sorts in the pipeline's order;
 * ``"effective_from"`` / ``"effective_to"`` sort on the row's date of that type, undated files last.
 * Each row carries the caller's own bits (``vault_file`` / ``contract`` / ``directory`` ``.permissions``,
 * 0 without access to the folder).
 */
export const searchVaultFileIntake = <ThrowOnError extends boolean = false>(
  options: Options<SearchVaultFileIntakeData, ThrowOnError>
) =>
  (options.client ?? client).post<
    SearchVaultFileIntakeResponses,
    SearchVaultFileIntakeErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/repository/vault/intake/search',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Sort Folder To Equity Section
 */
export const sortFolderToEquitySection = <ThrowOnError extends boolean = false>(
  options: Options<SortFolderToEquitySectionData, ThrowOnError>
) =>
  (options.client ?? client).post<
    SortFolderToEquitySectionResponses,
    SortFolderToEquitySectionErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/repository/vault/sorting/sort_folder_to_equity_section/{vault_directory_uid}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Search Vault
 *
 * Search one of the organisation's vaults for plain files, contracts and folders.
 *
 * A contract's files never show as file results: the contract does, matched on its own fields
 * or on any of its files' names. Folders match when the caller may browse into them — READ, or on
 * the path to something they may read. Every result carries the caller's effective permission
 * bits (0 on a folder only on a path).
 *
 * Raises:
 * UnauthorizedError: If a non-admin searches the system vault
 */
export const searchVault = <ThrowOnError extends boolean = false>(
  options: Options<SearchVaultData, ThrowOnError>
) =>
  (options.client ?? client).post<SearchVaultResponses, SearchVaultErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/repository/vault/search',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Bulk Move Vault Items
 *
 * Move plain vault files, contracts and directories to a target directory.
 *
 * Requires admin permission on every moved item — a move changes who inherits access to it —
 * and write permission on the target directory. Moving a single item is a bulk move with one
 * element. A contract moves with all of its files (they have no directory of their own); a
 * contract's file cannot be moved on its own.
 *
 * Raises:
 * NotFoundError: If the target directory or any listed file/contract/directory not found
 * UnauthorizedError: If user lacks admin permission on an item or write on the target,
 * or an item/target belongs to another organisation
 * InvalidDataError: If moving a vault root, a pinned (platform-managed) directory, a
 * directory into its own subtree or a contract's file on its own, or moving anything
 * into the system vault
 */
export const bulkMoveVaultItems = <ThrowOnError extends boolean = false>(
  options: Options<BulkMoveVaultItemsData, ThrowOnError>
) =>
  (options.client ?? client).post<
    BulkMoveVaultItemsResponses,
    BulkMoveVaultItemsErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/repository/vault/bulk-move',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Bulk Reassign Vault Owner
 *
 * Reassign or unassign the owner of vault files, contracts and directories. Org admins only.
 *
 * ``owner_user_uid`` must be a member of the organisation (whatever their active one is); None
 * unassigns. A contract's files take the contract's new owner and cannot be listed on their own.
 * With ``recursive`` (the default) a listed directory brings its subdirectories, plain files and
 * contracts. The vault roots always stay unowned.
 *
 * Raises:
 * NotFoundError: If an item, or (when reassigning) the owner within the organisation, is not found
 * UnauthorizedError: If an item belongs to another organisation
 * InvalidDataError: If a contract's file is listed on its own
 * FileBeingConvertedError: If a file is still being converted
 */
export const bulkReassignVaultOwner = <ThrowOnError extends boolean = false>(
  options: Options<BulkReassignVaultOwnerData, ThrowOnError>
) =>
  (options.client ?? client).post<
    BulkReassignVaultOwnerResponses,
    BulkReassignVaultOwnerErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/repository/vault/bulk-reassign-owner',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get Vault Ancestors
 *
 * The breadcrumb trail of any vault object, root-first, without the object itself.
 *
 * ``kind`` says which uid *uid* is: a folder's, a contract's, a vault file's or a contract file's.
 * The trail is its folders and, for a file that belongs to a contract, that contract last
 * (``dir1 / dir2 / contract``). It needs READ on the object (on a folder: that it may be browsed
 * into). Every folder above something the caller may READ is on its path and may be browsed into,
 * so the trail runs up to the root. Walking up, it still stops at the first folder the caller may
 * not browse into or contract they cannot READ, so it never reveals a name they could not reach by
 * browsing.
 *
 * Raises:
 * NotFoundError: If the object does not exist
 * UnauthorizedError: If the caller cannot READ the object (browse into the folder)
 */
export const getVaultAncestors = <ThrowOnError extends boolean = false>(
  options: Options<GetVaultAncestorsData, ThrowOnError>
) =>
  (options.client ?? client).get<GetVaultAncestorsResponses, GetVaultAncestorsErrors, ThrowOnError>(
    {
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/v1/app/repository/vault/ancestors',
      ...options,
    }
  );

/**
 * Search Allow List
 *
 * Search one agent's allow list.
 */
export const searchAllowList = <ThrowOnError extends boolean = false>(
  options: Options<SearchAllowListData, ThrowOnError>
) =>
  (options.client ?? client).post<SearchAllowListResponses, SearchAllowListErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/review/intake-agent/allow-list/{intake_agent_uid}/search',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Create Allow List Entry
 *
 * Add a sender. The owning agent comes from the PATH, never the payload.
 */
export const createAllowListEntry = <ThrowOnError extends boolean = false>(
  options: Options<CreateAllowListEntryData, ThrowOnError>
) =>
  (options.client ?? client).post<
    CreateAllowListEntryResponses,
    CreateAllowListEntryErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/review/intake-agent/allow-list/{intake_agent_uid}/new',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Delete Allow List Entry
 *
 * Remove an allow list entry.
 */
export const deleteAllowListEntry = <ThrowOnError extends boolean = false>(
  options: Options<DeleteAllowListEntryData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    DeleteAllowListEntryResponses,
    DeleteAllowListEntryErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/review/intake-agent/allow-list/{allow_list_entry_uid}',
    ...options,
  });

/**
 * Update Allow List Entry
 *
 * Update an allow list entry.
 */
export const updateAllowListEntry = <ThrowOnError extends boolean = false>(
  options: Options<UpdateAllowListEntryData, ThrowOnError>
) =>
  (options.client ?? client).put<
    UpdateAllowListEntryResponses,
    UpdateAllowListEntryErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/review/intake-agent/allow-list/{allow_list_entry_uid}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Search Intake Agent
 *
 * Search the active organisation's agents.
 */
export const searchIntakeAgent = <ThrowOnError extends boolean = false>(
  options: Options<SearchIntakeAgentData, ThrowOnError>
) =>
  (options.client ?? client).post<
    SearchIntakeAgentResponses,
    SearchIntakeAgentErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/review/intake-agent/agent/search',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Create Intake Agent
 *
 * Create an agent and mint its inbound address.
 *
 * ``new_data.owner_organisation_id`` is ignored: the agent is always bound to the
 * caller's active organisation, whose identifier also seeds the address prefix.
 */
export const createIntakeAgent = <ThrowOnError extends boolean = false>(
  options: Options<CreateIntakeAgentData, ThrowOnError>
) =>
  (options.client ?? client).post<
    CreateIntakeAgentResponses,
    CreateIntakeAgentErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/review/intake-agent/agent/new',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Delete Intake Agent
 *
 * Delete an agent. Org admin only — the one privileged route on this router.
 */
export const deleteIntakeAgent = <ThrowOnError extends boolean = false>(
  options: Options<DeleteIntakeAgentData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    DeleteIntakeAgentResponses,
    DeleteIntakeAgentErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/review/intake-agent/agent/{intake_agent_uid}',
    ...options,
  });

/**
 * Update Intake Agent
 *
 * Update an agent.
 *
 * ``callback_webhook`` is the one field an explicit ``null`` clears — every other unset
 * field is left alone.
 */
export const updateIntakeAgent = <ThrowOnError extends boolean = false>(
  options: Options<UpdateIntakeAgentData, ThrowOnError>
) =>
  (options.client ?? client).put<UpdateIntakeAgentResponses, UpdateIntakeAgentErrors, ThrowOnError>(
    {
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/v1/app/review/intake-agent/agent/{intake_agent_uid}',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    }
  );

/**
 * Configure Slack Agent
 *
 * Allow workspace users to select this agent in /insights-submit.
 */
export const configureSlackAgent = <ThrowOnError extends boolean = false>(
  options: Options<ConfigureSlackAgentData, ThrowOnError>
) =>
  (options.client ?? client).put<
    ConfigureSlackAgentResponses,
    ConfigureSlackAgentErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/review/intake-agent/agent/{intake_agent_uid}/slack',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Update Intake Agent Prompt Collections
 *
 * Replace the agent's prompt collections. Each must belong to the caller's org.
 */
export const updateIntakeAgentPromptCollections = <ThrowOnError extends boolean = false>(
  options: Options<UpdateIntakeAgentPromptCollectionsData, ThrowOnError>
) =>
  (options.client ?? client).put<
    UpdateIntakeAgentPromptCollectionsResponses,
    UpdateIntakeAgentPromptCollectionsErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/review/intake-agent/agent/{intake_agent_uid}/prompt-collections',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Update Intake Agent Playbooks
 *
 * Replace the agent's playbooks. Each must belong to the caller's org.
 */
export const updateIntakeAgentPlaybooks = <ThrowOnError extends boolean = false>(
  options: Options<UpdateIntakeAgentPlaybooksData, ThrowOnError>
) =>
  (options.client ?? client).put<
    UpdateIntakeAgentPlaybooksResponses,
    UpdateIntakeAgentPlaybooksErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/review/intake-agent/agent/{intake_agent_uid}/playbooks',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get Jira Webhook
 *
 * The agent's Jira webhook URL and the events to register alongside it.
 */
export const getJiraWebhook = <ThrowOnError extends boolean = false>(
  options: Options<GetJiraWebhookData, ThrowOnError>
) =>
  (options.client ?? client).get<GetJiraWebhookResponses, GetJiraWebhookErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/review/intake-agent/agent/{intake_agent_uid}/jira-webhook',
    ...options,
  });

/**
 * Enable Jira Webhook
 *
 * Mint the agent's webhook token if it has none, and turn the webhook on.
 *
 * Re-enabling an agent that still holds a token keeps that token, so a URL already registered
 * in Jira keeps working. Use ``/rotate`` to replace it.
 */
export const enableJiraWebhook = <ThrowOnError extends boolean = false>(
  options: Options<EnableJiraWebhookData, ThrowOnError>
) =>
  (options.client ?? client).post<
    EnableJiraWebhookResponses,
    EnableJiraWebhookErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/review/intake-agent/agent/{intake_agent_uid}/jira-webhook/enable',
    ...options,
  });

/**
 * Rotate Jira Webhook
 *
 * Replace the agent's webhook token.
 *
 * The old token stops working immediately, so the new URL has to be registered in Jira before
 * events flow again.
 */
export const rotateJiraWebhook = <ThrowOnError extends boolean = false>(
  options: Options<RotateJiraWebhookData, ThrowOnError>
) =>
  (options.client ?? client).post<
    RotateJiraWebhookResponses,
    RotateJiraWebhookErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/review/intake-agent/agent/{intake_agent_uid}/jira-webhook/rotate',
    ...options,
  });

/**
 * Disable Jira Webhook
 *
 * Turn the webhook off and drop the token, so the registered URL stops resolving.
 */
export const disableJiraWebhook = <ThrowOnError extends boolean = false>(
  options: Options<DisableJiraWebhookData, ThrowOnError>
) =>
  (options.client ?? client).post<
    DisableJiraWebhookResponses,
    DisableJiraWebhookErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/review/intake-agent/agent/{intake_agent_uid}/jira-webhook/disable',
    ...options,
  });

/**
 * Search Intake Agent Log By Agent Uid
 *
 * Search one agent's logs. Scoped to the caller's organisation.
 */
export const searchIntakeAgentLogByAgentUid = <ThrowOnError extends boolean = false>(
  options: Options<SearchIntakeAgentLogByAgentUidData, ThrowOnError>
) =>
  (options.client ?? client).post<
    SearchIntakeAgentLogByAgentUidResponses,
    SearchIntakeAgentLogByAgentUidErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/review/intake-agent/logs/search/agent/{intake_agent_uid}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Search Intake Agent Log Admin
 *
 * Search every agent's logs, across organisations. Platform admin only.
 */
export const searchIntakeAgentLogAdmin = <ThrowOnError extends boolean = false>(
  options: Options<SearchIntakeAgentLogAdminData, ThrowOnError>
) =>
  (options.client ?? client).post<
    SearchIntakeAgentLogAdminResponses,
    SearchIntakeAgentLogAdminErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/review/intake-agent/logs/search/admin',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get Intake Agent Log Details
 *
 * One log with its payload and vault files. Platform admin only.
 */
export const getIntakeAgentLogDetails = <ThrowOnError extends boolean = false>(
  options: Options<GetIntakeAgentLogDetailsData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetIntakeAgentLogDetailsResponses,
    GetIntakeAgentLogDetailsErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/review/intake-agent/logs/{intake_agent_log_uid}',
    ...options,
  });

/**
 * Update Intake Agent Log Admin
 *
 * Update a log. Platform admin only.
 */
export const updateIntakeAgentLogAdmin = <ThrowOnError extends boolean = false>(
  options: Options<UpdateIntakeAgentLogAdminData, ThrowOnError>
) =>
  (options.client ?? client).put<
    UpdateIntakeAgentLogAdminResponses,
    UpdateIntakeAgentLogAdminErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/review/intake-agent/logs/{intake_agent_log_uid}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Restart Intake Agent Log Admin
 *
 * Re-run an intake. Platform admin only.
 *
 * A GET that mutates (the client contract). The restart mints fresh
 * intake/processing task rows, so the old non-terminal ones are cancelled first —
 * otherwise the task list shows zombie PENDING/RUNNING rows. The cancellations and the
 * dispatch are ordered: the worker must see committed rows.
 */
export const restartIntakeAgentLogAdmin = <ThrowOnError extends boolean = false>(
  options: Options<RestartIntakeAgentLogAdminData, ThrowOnError>
) =>
  (options.client ?? client).get<
    RestartIntakeAgentLogAdminResponses,
    RestartIntakeAgentLogAdminErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/review/intake-agent/logs/{intake_agent_log_uid}/restart',
    ...options,
  });

/**
 * Search Equity Sections
 *
 * Search one agent's equity sections.
 */
export const searchEquitySections = <ThrowOnError extends boolean = false>(
  options: Options<SearchEquitySectionsData, ThrowOnError>
) =>
  (options.client ?? client).post<
    SearchEquitySectionsResponses,
    SearchEquitySectionsErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/review/intake-agent/equity-sections/{intake_agent_uid}/search',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Set Default Section
 *
 * Replace the agent's default section.
 *
 * Two pinned quirks. The body is REQUIRED (the parameter has no default), so a literal
 * JSON ``null`` answers 422 and the ``new_data is None`` branch below is unreachable
 * over HTTP — a default section can be replaced but never cleared. And a default section
 * is stored on ``default_intake_agent_id`` with a NULL owner, which is why
 * ``DELETE /{section_uid}`` 404s for one.
 */
export const setDefaultSection = <ThrowOnError extends boolean = false>(
  options: Options<SetDefaultSectionData, ThrowOnError>
) =>
  (options.client ?? client).post<
    SetDefaultSectionResponses,
    SetDefaultSectionErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/review/intake-agent/equity-sections/{intake_agent_uid}/default',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Create Section
 *
 * Add a listed equity section to the agent.
 */
export const createSection = <ThrowOnError extends boolean = false>(
  options: Options<CreateSectionData, ThrowOnError>
) =>
  (options.client ?? client).post<CreateSectionResponses, CreateSectionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/review/intake-agent/equity-sections/{intake_agent_uid}/new',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Delete Section
 *
 * Delete a listed section.
 *
 * A DEFAULT section has no ``owner_intake_agent`` and therefore answers 404 here — see
 * :func:`set_default_section`.
 */
export const deleteSection = <ThrowOnError extends boolean = false>(
  options: Options<DeleteSectionData, ThrowOnError>
) =>
  (options.client ?? client).delete<DeleteSectionResponses, DeleteSectionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/review/intake-agent/equity-sections/{section_uid}',
    ...options,
  });

/**
 * Get Data Room Directory
 *
 * Browse a data-room directory: one page of *limit* items from *offset* — its subdirectories,
 * contracts (with their files; current revisions only) and plain files, the three kinds
 * interleaved like the vault's listing and sorted by *sort_key* (name, case-insensitive; the type
 * label; or a timestamp) in *sort_direction*. Counts count items, a contract once.
 *
 * Without ``directory_uid`` the data room root is browsed. The breadcrumb chain is
 * trimmed at the data room root — nothing above it exists for non-platform users.
 *
 * Raises:
 * UnauthorizedError: If the bearer token is invalid, bound to another project, or the
 * person may not use the data room.
 * NotFoundError: If the directory does not exist or is outside the data room.
 */
export const getDataRoomDirectory = <ThrowOnError extends boolean = false>(
  options: Options<GetDataRoomDirectoryData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetDataRoomDirectoryResponses,
    GetDataRoomDirectoryErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/review/project/{external_uid}/external-access/data-room/directory',
    ...options,
  });

/**
 * Create Data Room Directory
 *
 * Create a subdirectory in the data room (e.g. for folder-structure uploads).
 *
 * Raises:
 * UnauthorizedError: If the bearer token is invalid, bound to another project, or the
 * person may not use the data room.
 * NotFoundError: If the parent directory is outside the data room.
 */
export const createDataRoomDirectory = <ThrowOnError extends boolean = false>(
  options: Options<CreateDataRoomDirectoryData, ThrowOnError>
) =>
  (options.client ?? client).post<
    CreateDataRoomDirectoryResponses,
    CreateDataRoomDirectoryErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/review/project/{external_uid}/external-access/data-room/directory',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Search Data Room
 *
 * Search the data room's plain files, contracts and directories.
 *
 * Free text matches only each file's current revision (file name and mime type), contract
 * names (a contract also matches on any of its files' names; its files never show as file
 * results) and directory names, matching what non-platform users can see. The search is bounded by the
 * subtree and carries no permission filter — the subtree IS the permission.
 *
 * Raises:
 * UnauthorizedError: If the bearer token is invalid, bound to another project, or the
 * person may not use the data room.
 */
export const searchDataRoom = <ThrowOnError extends boolean = false>(
  options: Options<SearchDataRoomData, ThrowOnError>
) =>
  (options.client ?? client).post<SearchDataRoomResponses, SearchDataRoomErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/review/project/{external_uid}/external-access/data-room/search',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Create Data Room File
 *
 * Create an empty vault file anchor in the data room.
 *
 * The file has no content until a revision is uploaded via the initialize/chunk/finalize
 * flow.
 *
 * Raises:
 * UnauthorizedError: If the bearer token is invalid, bound to another project, or the
 * person may not use the data room.
 * NotFoundError: If the parent directory is outside the data room.
 */
export const createDataRoomFile = <ThrowOnError extends boolean = false>(
  options: Options<CreateDataRoomFileData, ThrowOnError>
) =>
  (options.client ?? client).post<
    CreateDataRoomFileResponses,
    CreateDataRoomFileErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/review/project/{external_uid}/external-access/data-room/file',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Initialize Data Room File Upload
 *
 * Initialize a chunked upload for a data-room file without content.
 *
 * Non-platform users can only fill file anchors that have no revision yet — existing
 * documents can never be altered externally. The upload session is bound to this guest
 * and this file; nobody else can append to it or finalize it.
 *
 * Raises:
 * UnauthorizedError: If the bearer token is invalid, bound to another project, or the
 * person may not use the data room.
 * NotFoundError: If the file does not exist or is outside the data room.
 * AlreadyExistsError: If the file already has content (409).
 * TooManyRequestsError: If the person's upload rate limit is exceeded.
 * InvalidDataError: If proposed file size exceeds the configured upload limit, or the
 * guest tries to set the signing mark.
 */
export const initializeDataRoomFileUpload = <ThrowOnError extends boolean = false>(
  options: Options<InitializeDataRoomFileUploadData, ThrowOnError>
) =>
  (options.client ?? client).post<
    InitializeDataRoomFileUploadResponses,
    InitializeDataRoomFileUploadErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/review/project/{external_uid}/external-access/data-room/file/{file_uid}/revision/initialize',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Upload Data Room File Chunk
 *
 * Upload a chunk of a staged data-room file upload.
 *
 * The session must have been opened by THIS guest, in THIS project — an upload id alone
 * is not a capability; otherwise any guest of any project who learned an id could append
 * bytes to a stranger's in-flight upload, which its owner then finalizes into their own
 * file.
 *
 * Re-deriving the capability here (rather than trusting the one checked at initialize)
 * also means a revoked guest stops mid-upload instead of at finalize.
 *
 * Raises:
 * UnauthorizedError: If the bearer token is invalid, bound to another project, or the
 * person may not use the data room.
 * NotFoundError: If the upload ID is unknown or was not opened by this guest.
 * InvalidDataError: If the cumulative upload size exceeds the configured limit.
 */
export const uploadDataRoomFileChunk = <ThrowOnError extends boolean = false>(
  options: Options<UploadDataRoomFileChunkData, ThrowOnError>
) =>
  (options.client ?? client).post<
    UploadDataRoomFileChunkResponses,
    UploadDataRoomFileChunkErrors,
    ThrowOnError
  >({
    ...formDataBodySerializer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/review/project/{external_uid}/external-access/data-room/file/chunk/{upload_id}',
    ...options,
    headers: {
      'Content-Type': null,
      ...options.headers,
    },
  });

/**
 * Finalize Data Room File Upload
 *
 * Finalize a chunked upload into the data-room file's first revision.
 *
 * One session, one transaction: the ``FOR UPDATE`` on the file and the finalize core's
 * ``INSERT INTO vault_file_revision`` (which needs ``FOR KEY SHARE`` on that very row) run
 * on the same connection. Split across two sessions the insert would wait on a transaction
 * that is itself waiting on the client — a hang Postgres' deadlock detector never sees.
 *
 * Raises:
 * UnauthorizedError: If the bearer token is invalid, bound to another project, or the
 * person may not use the data room.
 * NotFoundError: If the upload ID is unknown, was not opened by this guest for this
 * file, or the file is outside the data room.
 * AlreadyExistsError: If the file already has content (409).
 * InvalidDataError: If the upload is incomplete or exceeds the configured size limit.
 */
export const finalizeDataRoomFileUpload = <ThrowOnError extends boolean = false>(
  options: Options<FinalizeDataRoomFileUploadData, ThrowOnError>
) =>
  (options.client ?? client).post<
    FinalizeDataRoomFileUploadResponses,
    FinalizeDataRoomFileUploadErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/review/project/{external_uid}/external-access/data-room/file/{file_uid}/revision/finalize/{upload_id}',
    ...options,
  });

/**
 * Get External Access Project Meta
 *
 * Basic display metadata of the review project plus the person's current capabilities.
 *
 * Capabilities are recomputed from the database, so the response always reflects what the
 * person may currently do — regardless of the (possibly stale) claims in their JWT. This
 * is the one guest route that needs only EITHER capability: it says nothing about the
 * project beyond its name and the tenant's.
 *
 * Raises:
 * UnauthorizedError: If the bearer token is invalid, bound to another project, the
 * project does not exist, or the person no longer has any capability on it.
 */
export const getExternalAccessProjectMeta = <ThrowOnError extends boolean = false>(
  options: Options<GetExternalAccessProjectMetaData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetExternalAccessProjectMetaResponses,
    GetExternalAccessProjectMetaErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/review/project/{external_uid}/external-access/meta',
    ...options,
  });

/**
 * Search Review Project Questions External
 *
 * Search the Q&A entries of a review project as a paginated list.
 *
 * Same semantics as the internal search endpoint (free text matches question and answer;
 * the special ``answered`` column filter selects answered or open questions), but serves
 * the slim external projection without internal user data.
 *
 * Raises:
 * UnauthorizedError: If the bearer token is invalid, bound to another project, or the
 * person may not answer QA on the project.
 */
export const searchReviewProjectQuestionsExternal = <ThrowOnError extends boolean = false>(
  options: Options<SearchReviewProjectQuestionsExternalData, ThrowOnError>
) =>
  (options.client ?? client).post<
    SearchReviewProjectQuestionsExternalResponses,
    SearchReviewProjectQuestionsExternalErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/review/project/{external_uid}/external-access/question/search',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Answer Review Project Question External
 *
 * Answer an open Q&A entry; the requesting non-platform user is recorded as answerer.
 *
 * Only the answer can be set, and only while the question has none (``None`` or empty
 * string) — everything else about the question is read-only for non-platform users.
 *
 * Raises:
 * UnauthorizedError: If the bearer token is invalid, bound to another project, or the
 * person may not answer QA on the project.
 * NotFoundError: If the question does not exist on the project.
 * AlreadyExistsError: If the question is already answered (409).
 */
export const answerReviewProjectQuestionExternal = <ThrowOnError extends boolean = false>(
  options: Options<AnswerReviewProjectQuestionExternalData, ThrowOnError>
) =>
  (options.client ?? client).post<
    AnswerReviewProjectQuestionExternalResponses,
    AnswerReviewProjectQuestionExternalErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/review/project/{external_uid}/external-access/question/{question_uid}/answer',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Request External Access Link
 *
 * Request an external access link for a review project by email.
 *
 * The project is addressed by its public external access uid — the internal
 * uid is never part of the external surface. If a non-platform user with the
 * given email is allowed on the project (with the matching public flag
 * enabled), a one-time action link is sent to them via email. The response is
 * 204 regardless of whether the email matched, so the endpoint leaks no
 * information about who is invited.
 *
 * Args:
 * external_uid: The external access uid of the review project
 * postgresql_session: Database session
 * settings: Application static settings
 * request_data: The email address to send the access link to
 *
 * Raises:
 * NotFoundError: If no review project with the given external access uid exists
 * TooManyRequestsError: If the email/project combination is rate limited
 */
export const requestExternalAccessLink = <ThrowOnError extends boolean = false>(
  options: Options<RequestExternalAccessLinkData, ThrowOnError>
) =>
  (options.client ?? client).post<
    RequestExternalAccessLinkResponses,
    RequestExternalAccessLinkErrors,
    ThrowOnError
  >({
    url: '/v1/app/review/project/{external_uid}/external-access/request-link',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Exchange External Access Token
 *
 * Exchange an emailed one-time token for an external access JWT.
 *
 * The one-time token is consumed on first use. Capabilities are recomputed
 * from the database at exchange time and returned both as JWT claims and in
 * the response body.
 *
 * Args:
 * external_uid: The external access uid of the review project
 * postgresql_session: Database session
 * settings: Application static settings
 * exchange_data: The one-time token from the emailed action link
 *
 * Returns:
 * ExternalAccessToken: The JWT plus the person's current capabilities
 *
 * Raises:
 * UnauthorizedError: If the token is unknown/expired/used, bound to a
 * different project, or the person has no capability anymore
 */
export const exchangeExternalAccessToken = <ThrowOnError extends boolean = false>(
  options: Options<ExchangeExternalAccessTokenData, ThrowOnError>
) =>
  (options.client ?? client).post<
    ExchangeExternalAccessTokenResponses,
    ExchangeExternalAccessTokenErrors,
    ThrowOnError
  >({
    url: '/v1/app/review/project/{external_uid}/external-access/token',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Refresh External Access Token
 *
 * Refresh a still-valid external access JWT.
 *
 * Capabilities are recomputed from the database, so access ends at the next
 * refresh once the person is removed from the project or the public flags
 * are disabled.
 *
 * Args:
 * external_uid: The external access uid of the review project
 * postgresql_session: Database session
 * settings: Application static settings
 * verified_non_platform_user: The authenticated non-platform user and token payload
 *
 * Returns:
 * ExternalAccessToken: A fresh JWT plus the person's current capabilities
 *
 * Raises:
 * UnauthorizedError: If the bearer token is invalid/expired, bound to a
 * different project, or the person has no capability anymore
 */
export const refreshExternalAccessToken = <ThrowOnError extends boolean = false>(
  options: Options<RefreshExternalAccessTokenData, ThrowOnError>
) =>
  (options.client ?? client).post<
    RefreshExternalAccessTokenResponses,
    RefreshExternalAccessTokenErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/review/project/{external_uid}/external-access/refresh',
    ...options,
  });

/**
 * Create Overwrite
 *
 * Override a machine extraction. One overwrite per extraction.
 */
export const createOverwrite = <ThrowOnError extends boolean = false>(
  options: Options<CreateOverwriteData, ThrowOnError>
) =>
  (options.client ?? client).post<CreateOverwriteResponses, CreateOverwriteErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/review/{review_uid}/file-review/{file_review_uid}/extraction/{extraction_uid}/overwrite',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Delete Overwrite
 *
 * Drop an overwrite, restoring the machine answer.
 */
export const deleteOverwrite = <ThrowOnError extends boolean = false>(
  options: Options<DeleteOverwriteData, ThrowOnError>
) =>
  (options.client ?? client).delete<DeleteOverwriteResponses, DeleteOverwriteErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/review/{review_uid}/file-review/{file_review_uid}/extraction/{extraction_uid}/overwrite/{extraction_overwrite_uid}',
    ...options,
  });

/**
 * Update Overwrite
 *
 * Replace an overwrite.
 *
 * A full replacement, not a patch: the update runs with ``ignore_unset=False``, so an
 * omitted field is written as NULL.
 */
export const updateOverwrite = <ThrowOnError extends boolean = false>(
  options: Options<UpdateOverwriteData, ThrowOnError>
) =>
  (options.client ?? client).put<UpdateOverwriteResponses, UpdateOverwriteErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/review/{review_uid}/file-review/{file_review_uid}/extraction/{extraction_uid}/overwrite/{extraction_overwrite_uid}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Search Extractions
 *
 * Search one file review's extraction cells.
 */
export const searchExtractions = <ThrowOnError extends boolean = false>(
  options: Options<SearchExtractionsData, ThrowOnError>
) =>
  (options.client ?? client).post<
    SearchExtractionsResponses,
    SearchExtractionsErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/review/{review_uid}/file-review/{file_review_uid}/extraction/search',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get Extraction By Uid
 *
 * One extraction cell.
 */
export const getExtractionByUid = <ThrowOnError extends boolean = false>(
  options: Options<GetExtractionByUidData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetExtractionByUidResponses,
    GetExtractionByUidErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/review/{review_uid}/file-review/{file_review_uid}/extraction/{extraction_uid}',
    ...options,
  });

/**
 * Update Extraction By Uid
 *
 * Approve or un-approve an extraction.
 *
 * ``approved`` is the only user-settable field: the route rebuilds the update schema
 * from that key alone, so anything else in the payload is discarded.
 */
export const updateExtractionByUid = <ThrowOnError extends boolean = false>(
  options: Options<UpdateExtractionByUidData, ThrowOnError>
) =>
  (options.client ?? client).put<
    UpdateExtractionByUidResponses,
    UpdateExtractionByUidErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/review/{review_uid}/file-review/{file_review_uid}/extraction/{extraction_uid}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Generate Commented Docx
 *
 * Stream the source DOCX back with the review's extractions as comments.
 *
 * READ is sufficient — this exports content the caller may already read.
 */
export const generateCommentedDocx = <ThrowOnError extends boolean = false>(
  options: Options<GenerateCommentedDocxData, ThrowOnError>
) =>
  (options.client ?? client).post<
    GenerateCommentedDocxResponses,
    GenerateCommentedDocxErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/review/{review_uid}/file-review/{file_review_uid}/extraction/generate-commented-docx',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Create File Reviews
 *
 * Add documents to a review, one row per file, pinned to its current revision.
 *
 * Everything settles in ONE transaction, and the batch tasks dispatch only after the
 * commit, so a worker never observes pre-write state.
 */
export const createFileReviews = <ThrowOnError extends boolean = false>(
  options: Options<CreateFileReviewsData, ThrowOnError>
) =>
  (options.client ?? client).post<
    CreateFileReviewsResponses,
    CreateFileReviewsErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/review/{review_uid}/file-review',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Search File Review
 *
 * Search a review's file reviews.
 *
 * The review read is organisation-scoped, so a foreign review answers 404 rather than
 * 200 with an empty page.
 */
export const searchFileReview = <ThrowOnError extends boolean = false>(
  options: Options<SearchFileReviewData, ThrowOnError>
) =>
  (options.client ?? client).post<SearchFileReviewResponses, SearchFileReviewErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/review/{review_uid}/file-review/search',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Delete File Review
 *
 * Delete a file review and its cells.
 */
export const deleteFileReview = <ThrowOnError extends boolean = false>(
  options: Options<DeleteFileReviewData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    DeleteFileReviewResponses,
    DeleteFileReviewErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/review/{review_uid}/file-review/{file_review_uid}',
    ...options,
  });

/**
 * Get File Review By Uid
 *
 * One file review.
 */
export const getFileReviewByUid = <ThrowOnError extends boolean = false>(
  options: Options<GetFileReviewByUidData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetFileReviewByUidResponses,
    GetFileReviewByUidErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/review/{review_uid}/file-review/{file_review_uid}',
    ...options,
  });

/**
 * Update File Review
 *
 * Update a file review's summary or OCR provider.
 *
 * A full replacement (``ignore_unset=False``), so the route back-fills ``summary_prompt``
 * and ``ocr_provider`` from the row when they are omitted — without that they would be
 * NULLed. ``markdown_summary`` has no such back-fill, so omitting it clears it.
 */
export const updateFileReview = <ThrowOnError extends boolean = false>(
  options: Options<UpdateFileReviewData, ThrowOnError>
) =>
  (options.client ?? client).put<UpdateFileReviewResponses, UpdateFileReviewErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/review/{review_uid}/file-review/{file_review_uid}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Search Kanban State
 *
 * Search the active organisation's board columns.
 *
 * Hidden columns are included — the board relies on that.
 */
export const searchKanbanState = <ThrowOnError extends boolean = false>(
  options: Options<SearchKanbanStateData, ThrowOnError>
) =>
  (options.client ?? client).post<
    SearchKanbanStateResponses,
    SearchKanbanStateErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/review/kanban/kanban-state/search',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Create Kanban State
 *
 * Create a board column in the caller's active organisation.
 *
 * ``new_data.organisation_id`` is deliberately NOT honoured: honouring it would be an
 * unvalidated cross-organisation write.
 */
export const createKanbanState = <ThrowOnError extends boolean = false>(
  options: Options<CreateKanbanStateData, ThrowOnError>
) =>
  (options.client ?? client).post<
    CreateKanbanStateResponses,
    CreateKanbanStateErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/review/kanban/kanban-state/new',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Delete Kanban State
 *
 * Delete a board column of the caller's active organisation.
 */
export const deleteKanbanState = <ThrowOnError extends boolean = false>(
  options: Options<DeleteKanbanStateData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    DeleteKanbanStateResponses,
    DeleteKanbanStateErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/review/kanban/kanban-state/{kanban_state_uid}',
    ...options,
  });

/**
 * Update Kanban State
 *
 * Update a board column of the caller's active organisation.
 */
export const updateKanbanState = <ThrowOnError extends boolean = false>(
  options: Options<UpdateKanbanStateData, ThrowOnError>
) =>
  (options.client ?? client).put<UpdateKanbanStateResponses, UpdateKanbanStateErrors, ThrowOnError>(
    {
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/v1/app/review/kanban/kanban-state/{kanban_state_uid}',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    }
  );

/**
 * Update Sort Indexes
 *
 * Move reviews into this column at the given positions.
 *
 * No position arithmetic happens here — the caller sends the positions it wants. All of
 * the moves settle in ONE transaction.
 *
 * A review of another organisation answers 404 rather than 401: the read is
 * organisation-scoped, so a foreign uid is indistinguishable from an unknown one.
 */
export const updateSortIndexes = <ThrowOnError extends boolean = false>(
  options: Options<UpdateSortIndexesData, ThrowOnError>
) =>
  (options.client ?? client).post<
    UpdateSortIndexesResponses,
    UpdateSortIndexesErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/review/kanban/kanban-state/{kanban_state_uid}/update-sort-indexes',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Search Kanban Comment
 *
 * Search one review's comments.
 */
export const searchKanbanComment = <ThrowOnError extends boolean = false>(
  options: Options<SearchKanbanCommentData, ThrowOnError>
) =>
  (options.client ?? client).post<
    SearchKanbanCommentResponses,
    SearchKanbanCommentErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/review/kanban/kanban-comment/{review_uid}/search',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Create Kanban Comment
 *
 * Comment on a review, stamped with the caller's address.
 */
export const createKanbanComment = <ThrowOnError extends boolean = false>(
  options: Options<CreateKanbanCommentData, ThrowOnError>
) =>
  (options.client ?? client).post<
    CreateKanbanCommentResponses,
    CreateKanbanCommentErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/review/kanban/kanban-comment/new',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Delete Kanban Comment
 *
 * Delete a comment. Author only, unless the caller is a platform admin.
 */
export const deleteKanbanComment = <ThrowOnError extends boolean = false>(
  options: Options<DeleteKanbanCommentData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    DeleteKanbanCommentResponses,
    DeleteKanbanCommentErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/review/kanban/kanban-comment/{kanban_comment_uid}',
    ...options,
  });

/**
 * Update Kanban Comment
 *
 * Edit a comment. Author only, unless the caller is a platform admin.
 */
export const updateKanbanComment = <ThrowOnError extends boolean = false>(
  options: Options<UpdateKanbanCommentData, ThrowOnError>
) =>
  (options.client ?? client).put<
    UpdateKanbanCommentResponses,
    UpdateKanbanCommentErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/review/kanban/kanban-comment/{kanban_comment_uid}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Create Review Project
 *
 * Create a new review project owned by the current user, over a vault folder they pick.
 *
 * The picked folder becomes the project's data room: every member gets READ|WRITE on
 * everything inside it. It must be an ordinary folder of the main vault that overlaps no
 * other data room, and a non-admin creator must already hold READ|WRITE on all of it (an
 * empty folder always qualifies).
 *
 * Args:
 * current_user: The authenticated user making the request
 * postgresql_session: Database session
 * new_data: Data for creating the new review project, including the data-room folder
 *
 * Returns:
 * ReviewProject: The newly created review project
 *
 * Raises:
 * UnauthorizedError: If user lacks the can_use_review_projects permission, or READ|WRITE
 * on anything inside the picked folder
 * NotFoundError: If the picked folder does not exist in the active organisation
 * InvalidDataError: If the picked folder cannot be a data room
 * AlreadyExistsError: If a review project with the same name already exists in the
 * organisation
 */
export const createReviewProject = <ThrowOnError extends boolean = false>(
  options: Options<CreateReviewProjectData, ThrowOnError>
) =>
  (options.client ?? client).post<
    CreateReviewProjectResponses,
    CreateReviewProjectErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/review/project/new',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Delete Review Project
 *
 * Delete a review project.
 *
 * The data room stays exactly as it is — it is the user's own vault folder, which from
 * now on follows the ordinary vault rules alone. Connected non-platform users lose their
 * connection, and anyone left without a connection to any project is deleted too, in ONE
 * transaction with the removal.
 *
 * Args:
 * uid: The unique identifier of the review project
 * current_user: The authenticated user making the request
 * postgresql_session: Database session
 *
 * Returns:
 * ReviewProjectInDB: The deleted project, snapshotted before the row went away
 *
 * Raises:
 * NotFoundError: If review project with given UID does not exist
 * UnauthorizedError: If user has no ADMIN permission on the review project
 */
export const deleteReviewProject = <ThrowOnError extends boolean = false>(
  options: Options<DeleteReviewProjectData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    DeleteReviewProjectResponses,
    DeleteReviewProjectErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/review/project/{uid}',
    ...options,
  });

/**
 * Get Review Project
 *
 * Get a specific review project by UID.
 *
 * Args:
 * uid: The unique identifier of the review project
 * current_user: The authenticated user making the request
 * postgresql_session: Database session
 *
 * Returns:
 * ReviewProject: The requested review project, with its data room root
 *
 * Raises:
 * NotFoundError: If review project with given UID does not exist
 * UnauthorizedError: If user has no READ permission on the review project
 */
export const getReviewProject = <ThrowOnError extends boolean = false>(
  options: Options<GetReviewProjectData, ThrowOnError>
) =>
  (options.client ?? client).get<GetReviewProjectResponses, GetReviewProjectErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/review/project/{uid}',
    ...options,
  });

/**
 * Update Review Project
 *
 * Update an existing review project. Its data room — the user's vault folder — keeps
 * its own name.
 *
 * Args:
 * uid: The unique identifier of the review project
 * current_user: The authenticated user making the request
 * postgresql_session: Database session
 * new_data: Updated data for the review project
 *
 * Returns:
 * ReviewProject: The updated review project
 *
 * Raises:
 * NotFoundError: If review project with given UID does not exist
 * UnauthorizedError: If user has no WRITE permission on the review project (ADMIN when the
 * request switches guest access)
 * AlreadyExistsError: If renaming to a name already used by another project
 */
export const updateReviewProject = <ThrowOnError extends boolean = false>(
  options: Options<UpdateReviewProjectData, ThrowOnError>
) =>
  (options.client ?? client).put<
    UpdateReviewProjectResponses,
    UpdateReviewProjectErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/review/project/{uid}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Search Review Projects
 *
 * Search review projects the user owns or is a member of.
 *
 * Org admins see every project of their active organisation. The visibility predicate
 * is built once and shared by the page, the count and the filter options.
 *
 * Args:
 * current_user: The authenticated user making the request
 * postgresql_session: Database session
 * query: Search query parameters
 *
 * Returns:
 * ReviewProjectSearchResult: Search results with review projects and count
 *
 * Raises:
 * UnauthorizedError: If user lacks the can_use_review_projects permission
 */
export const searchReviewProjects = <ThrowOnError extends boolean = false>(
  options: Options<SearchReviewProjectsData, ThrowOnError>
) =>
  (options.client ?? client).post<
    SearchReviewProjectsResponses,
    SearchReviewProjectsErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/review/project/search',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * List Review Project Members
 *
 * List the members of a review project.
 *
 * Args:
 * uid: The unique identifier of the review project
 * current_user: The authenticated user making the request
 * postgresql_session: Database session
 *
 * Returns:
 * list[User]: The members of the review project
 *
 * Raises:
 * NotFoundError: If review project with given UID does not exist
 * UnauthorizedError: If user has no READ permission on the review project
 */
export const listReviewProjectMembers = <ThrowOnError extends boolean = false>(
  options: Options<ListReviewProjectMembersData, ThrowOnError>
) =>
  (options.client ?? client).get<
    ListReviewProjectMembersResponses,
    ListReviewProjectMembersErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/review/project/{uid}/members',
    ...options,
  });

/**
 * Remove Review Project Member
 *
 * Remove a member from a review project.
 *
 * The project owner cannot be removed. The target user is deliberately NOT required to
 * still belong to the organisation, so stale members stay removable.
 *
 * Args:
 * uid: The unique identifier of the review project
 * user_uid: The unique identifier of the user to remove
 * current_user: The authenticated user making the request
 * postgresql_session: Database session
 *
 * Returns:
 * ReviewProject: The review project with the updated member list
 *
 * Raises:
 * NotFoundError: If the review project or the user does not exist
 * UnauthorizedError: If user has no ADMIN permission on the review project
 * BadRequestError: If the target user is the project owner
 */
export const removeReviewProjectMember = <ThrowOnError extends boolean = false>(
  options: Options<RemoveReviewProjectMemberData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    RemoveReviewProjectMemberResponses,
    RemoveReviewProjectMemberErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/review/project/{uid}/members/{user_uid}',
    ...options,
  });

/**
 * Add Review Project Member
 *
 * Add a user of the owning organisation as a member of a review project.
 *
 * Adding someone who already is a member is a no-op. Only the project owner (or an org
 * admin) can manage membership.
 *
 * Args:
 * uid: The unique identifier of the review project
 * user_uid: The unique identifier of the user to add
 * current_user: The authenticated user making the request
 * postgresql_session: Database session
 *
 * Returns:
 * ReviewProject: The review project with the updated member list
 *
 * Raises:
 * NotFoundError: If the review project or the user does not exist, or the user is
 * not part of the owning organisation
 * UnauthorizedError: If user has no ADMIN permission on the review project
 */
export const addReviewProjectMember = <ThrowOnError extends boolean = false>(
  options: Options<AddReviewProjectMemberData, ThrowOnError>
) =>
  (options.client ?? client).post<
    AddReviewProjectMemberResponses,
    AddReviewProjectMemberErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/review/project/{uid}/members/{user_uid}',
    ...options,
  });

/**
 * List Review Project Non Platform Users
 *
 * List the non-platform user connections of a review project.
 *
 * Args:
 * uid: The unique identifier of the review project
 * current_user: The authenticated user making the request
 * postgresql_session: Database session
 *
 * Returns:
 * list[ReviewProjectNonPlatformUserLink]: The project's guest connections
 *
 * Raises:
 * NotFoundError: If review project with given UID does not exist
 * UnauthorizedError: If user has no READ permission on the review project
 */
export const listReviewProjectNonPlatformUsers = <ThrowOnError extends boolean = false>(
  options: Options<ListReviewProjectNonPlatformUsersData, ThrowOnError>
) =>
  (options.client ?? client).get<
    ListReviewProjectNonPlatformUsersResponses,
    ListReviewProjectNonPlatformUsersErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/review/project/{uid}/non-platform-users',
    ...options,
  });

/**
 * Upsert Review Project Non Platform User
 *
 * Create or update a non-platform user connection on a review project.
 *
 * If no non-platform user with the given email exists yet, one is created. Either way
 * the person is connected to the owning organisation and their connection to the project
 * is created or updated with the given capability flags. Only the project owner (or an
 * org admin) can manage connections.
 *
 * All three writes settle together, so a failure cannot leave a person who belongs to an
 * organisation but no project.
 *
 * Args:
 * uid: The unique identifier of the review project
 * current_user: The authenticated user making the request
 * postgresql_session: Database session
 * new_data: Email (and optional full name) of the person plus the capability flags
 *
 * Returns:
 * ReviewProjectNonPlatformUserLink: The created or updated connection
 *
 * Raises:
 * NotFoundError: If review project with given UID does not exist
 * UnauthorizedError: If user has no ADMIN permission on the review project
 */
export const upsertReviewProjectNonPlatformUser = <ThrowOnError extends boolean = false>(
  options: Options<UpsertReviewProjectNonPlatformUserData, ThrowOnError>
) =>
  (options.client ?? client).put<
    UpsertReviewProjectNonPlatformUserResponses,
    UpsertReviewProjectNonPlatformUserErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/review/project/{uid}/non-platform-users',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Remove Review Project Non Platform User
 *
 * Remove a non-platform user connection from a review project.
 *
 * Once the person has no connection to any review project left, their record is deleted.
 * Removing a connection that does not exist is a silent no-op — only the PERSON has to
 * exist.
 *
 * Args:
 * uid: The unique identifier of the review project
 * non_platform_user_uid: The unique identifier of the person to disconnect
 * current_user: The authenticated user making the request
 * postgresql_session: Database session
 *
 * Returns:
 * Response: 204 No Content
 *
 * Raises:
 * NotFoundError: If the review project or the non-platform user does not exist
 * UnauthorizedError: If user has no ADMIN permission on the review project
 */
export const removeReviewProjectNonPlatformUser = <ThrowOnError extends boolean = false>(
  options: Options<RemoveReviewProjectNonPlatformUserData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    RemoveReviewProjectNonPlatformUserResponses,
    RemoveReviewProjectNonPlatformUserErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/review/project/{uid}/non-platform-users/{non_platform_user_uid}',
    ...options,
  });

/**
 * List Review Project Analyses
 *
 * List all analyses of a review project, oldest first.
 *
 * Args:
 * project_uid: The unique identifier of the review project
 * current_user: The authenticated user making the request
 * postgresql_session: Database session
 *
 * Returns:
 * list[ReviewProjectAnalysis]: All analyses of the review project
 *
 * Raises:
 * NotFoundError: If review project with given UID does not exist
 * UnauthorizedError: If user has no READ permission on the review project
 */
export const listReviewProjectAnalyses = <ThrowOnError extends boolean = false>(
  options: Options<ListReviewProjectAnalysesData, ThrowOnError>
) =>
  (options.client ?? client).get<
    ListReviewProjectAnalysesResponses,
    ListReviewProjectAnalysesErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/review/project/{project_uid}/analysis',
    ...options,
  });

/**
 * Create Review Project Analysis
 *
 * Create a new analysis for a review project.
 *
 * Args:
 * project_uid: The unique identifier of the review project
 * current_user: The authenticated user making the request
 * postgresql_session: Database session
 * event_dispatcher: Dispatcher for websocket events
 * new_data: Data for creating the new analysis
 *
 * Returns:
 * ReviewProjectAnalysis: The newly created analysis
 *
 * Raises:
 * NotFoundError: If the review project does not exist, or the referenced playbook
 * does not exist or belongs to another organisation
 * UnauthorizedError: If user has no WRITE permission on the review project
 * AlreadyExistsError: If an analysis with the same name already exists in the project
 */
export const createReviewProjectAnalysis = <ThrowOnError extends boolean = false>(
  options: Options<CreateReviewProjectAnalysisData, ThrowOnError>
) =>
  (options.client ?? client).post<
    CreateReviewProjectAnalysisResponses,
    CreateReviewProjectAnalysisErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/review/project/{project_uid}/analysis/new',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Delete Review Project Analysis
 *
 * Delete a review project analysis.
 *
 * Args:
 * project_uid: The unique identifier of the review project
 * analysis_uid: The unique identifier of the analysis
 * current_user: The authenticated user making the request
 * postgresql_session: Database session
 * event_dispatcher: Dispatcher for websocket events
 *
 * Returns:
 * ReviewProjectAnalysisInDB: The deleted analysis, snapshotted before the row went away
 *
 * Raises:
 * NotFoundError: If the review project or analysis does not exist, or the analysis
 * belongs to another review project
 * UnauthorizedError: If user has no WRITE permission on the review project
 */
export const deleteReviewProjectAnalysis = <ThrowOnError extends boolean = false>(
  options: Options<DeleteReviewProjectAnalysisData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    DeleteReviewProjectAnalysisResponses,
    DeleteReviewProjectAnalysisErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/review/project/{project_uid}/analysis/{analysis_uid}',
    ...options,
  });

/**
 * Update Review Project Analysis
 *
 * Update a review project analysis: its name, its playbook link, or both.
 *
 * ``playbook_uid`` is only touched when the payload names it, so a rename cannot
 * silently detach the playbook.
 *
 * Args:
 * project_uid: The unique identifier of the review project
 * analysis_uid: The unique identifier of the analysis
 * current_user: The authenticated user making the request
 * postgresql_session: Database session
 * event_dispatcher: Dispatcher for websocket events
 * new_data: Updated data for the analysis
 *
 * Returns:
 * ReviewProjectAnalysis: The updated analysis
 *
 * Raises:
 * NotFoundError: If the review project or analysis does not exist, the analysis
 * belongs to another review project, or the referenced playbook does not exist
 * or belongs to another organisation
 * UnauthorizedError: If user has no WRITE permission on the review project
 * AlreadyExistsError: If renaming to a name already used by another analysis
 */
export const updateReviewProjectAnalysis = <ThrowOnError extends boolean = false>(
  options: Options<UpdateReviewProjectAnalysisData, ThrowOnError>
) =>
  (options.client ?? client).put<
    UpdateReviewProjectAnalysisResponses,
    UpdateReviewProjectAnalysisErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/review/project/{project_uid}/analysis/{analysis_uid}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Search Review Project Analysis Data
 *
 * Search the runs of the analysis's playbook attached to this review project.
 *
 * A run matches when it was started for this project (runs carry an optional project
 * attachment). All matching runs are returned, so a file may appear in several runs and
 * files without runs do not appear at all.
 *
 * No per-run visibility filter is applied — ``visibility=None``: access is decided once, by
 * READ on the project, and the analysis table then shows every run of that project.
 *
 * Args:
 * project_uid: The unique identifier of the review project
 * analysis_uid: The unique identifier of the analysis
 * current_user: The authenticated user making the request
 * postgresql_session: Database session
 * query: Search query with pagination, sorting and column filters
 *
 * Returns:
 * PlaybookRunSearchResult: The matching playbook runs
 *
 * Raises:
 * NotFoundError: If the review project or analysis does not exist, or the analysis
 * belongs to another review project
 * UnauthorizedError: If user has no READ permission on the review project
 * BadRequestError: If the analysis has no connected playbook
 */
export const searchReviewProjectAnalysisData = <ThrowOnError extends boolean = false>(
  options: Options<SearchReviewProjectAnalysisDataData, ThrowOnError>
) =>
  (options.client ?? client).post<
    SearchReviewProjectAnalysisDataResponses,
    SearchReviewProjectAnalysisDataErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/review/project/{project_uid}/analysis/{analysis_uid}/data/search',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Search Review Project Files
 *
 * Search the file revisions of a review project's data room as a flat list.
 *
 * The list has one entry per revision of each vault file in the data room (a file with
 * three revisions yields three entries) and reflects the CURRENT content: link rows are
 * reconciled with the data room subtree first. Free text matches the file's tags, the
 * revision's file name and mime type, and the revision's body text. Each result bundles
 * the review project file, its revision, and the pages the requesting user has seen.
 *
 * Args:
 * project_uid: The unique identifier of the review project
 * current_user: The authenticated user making the request
 * postgresql_session: Database session
 * query: Search query parameters with optional column filters
 *
 * Returns:
 * ReviewProjectFileSearchResult: Search results with files, count, and filter options
 *
 * Raises:
 * NotFoundError: If review project with given UID does not exist
 * UnauthorizedError: If user has no READ permission on the review project
 */
export const searchReviewProjectFiles = <ThrowOnError extends boolean = false>(
  options: Options<SearchReviewProjectFilesData, ThrowOnError>
) =>
  (options.client ?? client).post<
    SearchReviewProjectFilesResponses,
    SearchReviewProjectFilesErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/review/project/{project_uid}/file/search',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Update Review Project File
 *
 * Update a review project file (tag set, ``fully_reviewed``, ``notes``).
 *
 * ``tag_uids`` replaces the file's tag set — and the tags are resolved WITHIN the
 * project, so a tag of another project cannot be attached by uid.
 * ``fully_reviewed`` and ``notes`` are applied only when present in the payload;
 * ``notes`` explicitly set to None clears the notes.
 *
 * Args:
 * project_uid: The unique identifier of the review project
 * file_uid: The unique identifier of the review project file
 * current_user: The authenticated user making the request
 * postgresql_session: Database session
 * event_dispatcher: Dispatcher for websocket events
 * new_data: Updated data for the review project file
 *
 * Returns:
 * ReviewProjectFile: The updated review project file
 *
 * Raises:
 * NotFoundError: If the review project, the file, or any referenced tag does not
 * exist or belongs to another review project
 * UnauthorizedError: If user has no WRITE permission on the review project
 */
export const updateReviewProjectFile = <ThrowOnError extends boolean = false>(
  options: Options<UpdateReviewProjectFileData, ThrowOnError>
) =>
  (options.client ?? client).put<
    UpdateReviewProjectFileResponses,
    UpdateReviewProjectFileErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/review/project/{project_uid}/file/{file_uid}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Mark Review Project File Page Seen
 *
 * Record that the current user has seen a page of a review project file.
 *
 * The file is identified by its review project file uid, its vault file revision uid, or
 * both (which must then reference the same file). When only the revision uid is given
 * and no link row exists yet, the data room is synced first so a freshly uploaded
 * revision resolves without a prior search.
 *
 * One record per user and page: repeated calls overwrite the seen time (last write
 * wins), now as a single ``ON CONFLICT DO UPDATE`` instead of a read, an insert and an
 * integrity-error recovery.
 *
 * Args:
 * project_uid: The unique identifier of the review project
 * page_number: The 1-based page number that was seen
 * current_user: The authenticated user making the request
 * postgresql_session: Database session
 * event_dispatcher: Dispatcher for websocket events
 * identifiers: The review project file uid and/or vault file revision uid
 *
 * Returns:
 * ReviewProjectFilePageViewInDB: The recorded page view
 *
 * Raises:
 * NotFoundError: If the review project or the referenced file does not exist, or the
 * file belongs to another review project
 * UnauthorizedError: If user has no WRITE permission on the review project
 * BadRequestError: If no identifier is given, or both are given but do not reference
 * the same file
 */
export const markReviewProjectFilePageSeen = <ThrowOnError extends boolean = false>(
  options: Options<MarkReviewProjectFilePageSeenData, ThrowOnError>
) =>
  (options.client ?? client).post<
    MarkReviewProjectFilePageSeenResponses,
    MarkReviewProjectFilePageSeenErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/review/project/{project_uid}/file/page/{page_number}/seen',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Search Review Project Questions
 *
 * Search the Q&A entries of a review project as a paginated list.
 *
 * Free text matches question and answer; the special ``answered`` column filter
 * ("true"/"false") selects answered or open questions.
 *
 * Raises:
 * NotFoundError: If review project with given UID does not exist.
 * UnauthorizedError: If user has no READ permission on the review project.
 */
export const searchReviewProjectQuestions = <ThrowOnError extends boolean = false>(
  options: Options<SearchReviewProjectQuestionsData, ThrowOnError>
) =>
  (options.client ?? client).post<
    SearchReviewProjectQuestionsResponses,
    SearchReviewProjectQuestionsErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/review/project/{project_uid}/question/search',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Create Review Project Question
 *
 * Create a new Q&A entry; the requesting user is recorded as the asker.
 *
 * ``asked_via_chat`` is forced to False here — the due-diligence chat sets it through
 * its own tool, and a client claiming otherwise would corrupt the provenance.
 *
 * Raises:
 * NotFoundError: If review project with given UID does not exist.
 * UnauthorizedError: If user has no WRITE permission on the review project.
 */
export const createReviewProjectQuestion = <ThrowOnError extends boolean = false>(
  options: Options<CreateReviewProjectQuestionData, ThrowOnError>
) =>
  (options.client ?? client).post<
    CreateReviewProjectQuestionResponses,
    CreateReviewProjectQuestionErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/review/project/{project_uid}/question/new',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Delete Review Project Question
 *
 * Delete a Q&A entry and return it.
 *
 * Raises:
 * NotFoundError: If the review project or question does not exist.
 * UnauthorizedError: If user has no WRITE permission on the review project.
 */
export const deleteReviewProjectQuestion = <ThrowOnError extends boolean = false>(
  options: Options<DeleteReviewProjectQuestionData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    DeleteReviewProjectQuestionResponses,
    DeleteReviewProjectQuestionErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/review/project/{project_uid}/question/{question_uid}',
    ...options,
  });

/**
 * Update Review Project Question
 *
 * Update a Q&A entry.
 *
 * Setting an answer attributes it to the requesting user and stamps ``answered_at``
 * (unless given explicitly); clearing the answer clears the answered metadata.
 *
 * Raises:
 * NotFoundError: If the review project or question does not exist.
 * UnauthorizedError: If user has no WRITE permission on the review project.
 */
export const updateReviewProjectQuestion = <ThrowOnError extends boolean = false>(
  options: Options<UpdateReviewProjectQuestionData, ThrowOnError>
) =>
  (options.client ?? client).put<
    UpdateReviewProjectQuestionResponses,
    UpdateReviewProjectQuestionErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/review/project/{project_uid}/question/{question_uid}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get Review Project Report
 *
 * Get the report of a review project, creating an empty one on first read.
 *
 * Args:
 * project_uid: The unique identifier of the review project
 * current_user: The authenticated user making the request
 * postgresql_session: Database session
 *
 * Returns:
 * ReviewProjectReport: The project's report
 *
 * Raises:
 * NotFoundError: If review project with given UID does not exist
 * UnauthorizedError: If user has no READ permission on the review project
 */
export const getReviewProjectReport = <ThrowOnError extends boolean = false>(
  options: Options<GetReviewProjectReportData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetReviewProjectReportResponses,
    GetReviewProjectReportErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/review/project/{project_uid}/report',
    ...options,
  });

/**
 * Set Review Project Report
 *
 * Set the report of a review project, creating it if it does not exist yet.
 *
 * Args:
 * project_uid: The unique identifier of the review project
 * current_user: The authenticated user making the request
 * postgresql_session: Database session
 * event_dispatcher: Dispatcher for websocket events
 * new_data: The new report content
 *
 * Returns:
 * ReviewProjectReport: The created or updated report
 *
 * Raises:
 * NotFoundError: If review project with given UID does not exist
 * UnauthorizedError: If user has no WRITE permission on the review project
 */
export const setReviewProjectReport = <ThrowOnError extends boolean = false>(
  options: Options<SetReviewProjectReportData, ThrowOnError>
) =>
  (options.client ?? client).put<
    SetReviewProjectReportResponses,
    SetReviewProjectReportErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/review/project/{project_uid}/report',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get Review Project File Statistics
 *
 * File statistics of the project's data room.
 *
 * Total / usable / non-usable file counts, first and last upload timestamps, and
 * breakdowns by mime type and human-readable file category. The link rows are
 * reconciled with the data room first (a cheap no-op when unchanged) so the numbers
 * reflect the current content.
 *
 * Raises:
 * NotFoundError: If review project with given UID does not exist.
 * UnauthorizedError: If user has no READ permission on the review project.
 */
export const getReviewProjectFileStatistics = <ThrowOnError extends boolean = false>(
  options: Options<GetReviewProjectFileStatisticsData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetReviewProjectFileStatisticsResponses,
    GetReviewProjectFileStatisticsErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/review/project/{project_uid}/statistics/files',
    ...options,
  });

/**
 * Get Review Project Seen Statistics
 *
 * Review coverage of the project's data room, aggregated across all users.
 *
 * Distinct seen pages vs. total pages, plus fully / partially / never seen file counts.
 * A page counts as seen when ANY user viewed it.
 *
 * Raises:
 * NotFoundError: If review project with given UID does not exist.
 * UnauthorizedError: If user has no READ permission on the review project.
 */
export const getReviewProjectSeenStatistics = <ThrowOnError extends boolean = false>(
  options: Options<GetReviewProjectSeenStatisticsData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetReviewProjectSeenStatisticsResponses,
    GetReviewProjectSeenStatisticsErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/review/project/{project_uid}/statistics/seen',
    ...options,
  });

/**
 * Get Review Project Tag Statistics
 *
 * Tag usage across the project's files.
 *
 * Per-tag file counts (tags with zero files included) plus the number of untagged files.
 *
 * Raises:
 * NotFoundError: If review project with given UID does not exist.
 * UnauthorizedError: If user has no READ permission on the review project.
 */
export const getReviewProjectTagStatistics = <ThrowOnError extends boolean = false>(
  options: Options<GetReviewProjectTagStatisticsData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetReviewProjectTagStatisticsResponses,
    GetReviewProjectTagStatisticsErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/review/project/{project_uid}/statistics/tags',
    ...options,
  });

/**
 * Get Review Project Question Statistics
 *
 * Q&A progress of the project.
 *
 * Total / answered / unanswered counts, answered percent, and the mean time from asking
 * to answering. Questions live outside the data room, so no sync is needed here.
 *
 * Raises:
 * NotFoundError: If review project with given UID does not exist.
 * UnauthorizedError: If user has no READ permission on the review project.
 */
export const getReviewProjectQuestionStatistics = <ThrowOnError extends boolean = false>(
  options: Options<GetReviewProjectQuestionStatisticsData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetReviewProjectQuestionStatisticsResponses,
    GetReviewProjectQuestionStatisticsErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/review/project/{project_uid}/statistics/questions',
    ...options,
  });

/**
 * Get Review Project Analysis Statistics
 *
 * Playbook run statistics of the project, grouped per analysis.
 *
 * Per analysis: distinct files run, run counts by status, runs with errors, and
 * uncommons finding counts by severity — status, error and severity counts consider only
 * the latest run per input file. Runs reference file revisions directly, so no
 * data-room sync is needed here.
 *
 * Raises:
 * NotFoundError: If review project with given UID does not exist.
 * UnauthorizedError: If user has no READ permission on the review project.
 */
export const getReviewProjectAnalysisStatistics = <ThrowOnError extends boolean = false>(
  options: Options<GetReviewProjectAnalysisStatisticsData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetReviewProjectAnalysisStatisticsResponses,
    GetReviewProjectAnalysisStatisticsErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/review/project/{project_uid}/statistics/analyses',
    ...options,
  });

/**
 * Search Review Project Tags
 *
 * Search the tags of a review project as a paginated list.
 *
 * Args:
 * project_uid: The unique identifier of the review project
 * current_user: The authenticated user making the request
 * postgresql_session: Database session
 * query: Search query parameters
 *
 * Returns:
 * ReviewProjectTagSearchResult: Search results with tags, count, and filter options
 *
 * Raises:
 * NotFoundError: If review project with given UID does not exist
 * UnauthorizedError: If user has no READ permission on the review project
 */
export const searchReviewProjectTags = <ThrowOnError extends boolean = false>(
  options: Options<SearchReviewProjectTagsData, ThrowOnError>
) =>
  (options.client ?? client).post<
    SearchReviewProjectTagsResponses,
    SearchReviewProjectTagsErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/review/project/{project_uid}/tag/search',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Create Review Project Tag
 *
 * Create a new tag for a review project.
 *
 * Args:
 * project_uid: The unique identifier of the review project
 * current_user: The authenticated user making the request
 * postgresql_session: Database session
 * new_data: Data for creating the new tag
 *
 * Returns:
 * ReviewProjectTag: The newly created tag
 *
 * Raises:
 * NotFoundError: If review project with given UID does not exist
 * UnauthorizedError: If user has no WRITE permission on the review project
 * AlreadyExistsError: If a tag with the same name already exists in the project
 */
export const createReviewProjectTag = <ThrowOnError extends boolean = false>(
  options: Options<CreateReviewProjectTagData, ThrowOnError>
) =>
  (options.client ?? client).post<
    CreateReviewProjectTagResponses,
    CreateReviewProjectTagErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/review/project/{project_uid}/tag/new',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Delete Review Project Tag
 *
 * Delete a review project tag, detaching it from all files.
 *
 * The affected files are named before the delete (their link rows are gone afterwards)
 * and re-read with their new tag sets once, rather than re-serialized one by one off
 * commit-expired instances.
 *
 * Args:
 * project_uid: The unique identifier of the review project
 * tag_uid: The unique identifier of the tag
 * current_user: The authenticated user making the request
 * postgresql_session: Database session
 * event_dispatcher: Dispatcher for websocket events
 *
 * Returns:
 * ReviewProjectTagInDB: The deleted tag, snapshotted before the row went away
 *
 * Raises:
 * NotFoundError: If the review project or tag does not exist, or the tag
 * belongs to another review project
 * UnauthorizedError: If user has no WRITE permission on the review project
 */
export const deleteReviewProjectTag = <ThrowOnError extends boolean = false>(
  options: Options<DeleteReviewProjectTagData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    DeleteReviewProjectTagResponses,
    DeleteReviewProjectTagErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/review/project/{project_uid}/tag/{tag_uid}',
    ...options,
  });

/**
 * Update Review Project Tag
 *
 * Update a review project tag (name and/or color).
 *
 * Args:
 * project_uid: The unique identifier of the review project
 * tag_uid: The unique identifier of the tag
 * current_user: The authenticated user making the request
 * postgresql_session: Database session
 * new_data: Updated data for the tag
 *
 * Returns:
 * ReviewProjectTag: The updated tag
 *
 * Raises:
 * NotFoundError: If the review project or tag does not exist, or the tag
 * belongs to another review project
 * UnauthorizedError: If user has no WRITE permission on the review project
 * AlreadyExistsError: If renaming to a name already used by another tag of the project
 */
export const updateReviewProjectTag = <ThrowOnError extends boolean = false>(
  options: Options<UpdateReviewProjectTagData, ThrowOnError>
) =>
  (options.client ?? client).put<
    UpdateReviewProjectTagResponses,
    UpdateReviewProjectTagErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/review/project/{project_uid}/tag/{tag_uid}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Create Auto Tag Task Group
 *
 * Create an auto-tag task group and immediately start executing it.
 *
 * The data room is synced first, then the file selection is resolved into one task per
 * usable file. Options reference project tags by name; missing tags are created. The
 * per-file classification runs asynchronously — poll the GET endpoints for progress.
 *
 * Args:
 * project_uid: The unique identifier of the review project
 * current_user: The authenticated user making the request
 * postgresql_session: Database session
 * new_data: Options, the single/multi-select and mandatory flags, and the selection
 *
 * Returns:
 * ReviewProjectTaskGroup: The created (running) task group with its tasks
 *
 * Raises:
 * NotFoundError: If the review project does not exist, or a selected file does not
 * exist or belongs to another review project
 * UnauthorizedError: If user has no WRITE permission on the review project
 * BadRequestError: If the selection matches no usable file or contains unusable files
 */
export const createAutoTagTaskGroup = <ThrowOnError extends boolean = false>(
  options: Options<CreateAutoTagTaskGroupData, ThrowOnError>
) =>
  (options.client ?? client).post<
    CreateAutoTagTaskGroupResponses,
    CreateAutoTagTaskGroupErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/review/project/{project_uid}/task-group/auto-tag',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Create Report Task Group
 *
 * Create a report-generation task group and immediately start executing it.
 *
 * Dispatches the background report agent, which writes (``mode=full_write``, replacing
 * the whole report including manual edits) or updates (``mode=edit``) the project's
 * report from its extracted data. Generation runs asynchronously — poll the GET
 * endpoints; the report itself is announced via ``REVIEW_PROJECT_REPORT_UPDATED``.
 *
 * One generation at a time, and that guard is now race-free: the project row is locked
 * for the duration of the check-and-insert, so two concurrent posts take turns and the
 * second sees the first one's group instead of dispatching a duplicate.
 *
 * Args:
 * project_uid: The unique identifier of the review project
 * current_user: The authenticated user making the request
 * postgresql_session: Database session
 * new_data: The instruction for the report agent, the mode, and the report type
 *
 * Returns:
 * ReviewProjectTaskGroup: The created (running) task group with its single task
 *
 * Raises:
 * NotFoundError: If the review project does not exist
 * UnauthorizedError: If user has no WRITE permission on the review project
 * BadRequestError: If a report generation is already running for the project
 */
export const createReportTaskGroup = <ThrowOnError extends boolean = false>(
  options: Options<CreateReportTaskGroupData, ThrowOnError>
) =>
  (options.client ?? client).post<
    CreateReportTaskGroupResponses,
    CreateReportTaskGroupErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/review/project/{project_uid}/task-group/report',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * List Review Project Task Groups
 *
 * List all task groups of a review project, newest first (without their task rows).
 *
 * The task rows are still LOADED even though the summary schema drops them:
 * ``task_status_counts`` is a property over exactly that collection.
 *
 * Args:
 * project_uid: The unique identifier of the review project
 * current_user: The authenticated user making the request
 * postgresql_session: Database session
 *
 * Returns:
 * list[ReviewProjectTaskGroup]: All task groups of the review project
 *
 * Raises:
 * NotFoundError: If review project with given UID does not exist
 * UnauthorizedError: If user has no READ permission on the review project
 */
export const listReviewProjectTaskGroups = <ThrowOnError extends boolean = false>(
  options: Options<ListReviewProjectTaskGroupsData, ThrowOnError>
) =>
  (options.client ?? client).get<
    ListReviewProjectTaskGroupsResponses,
    ListReviewProjectTaskGroupsErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/review/project/{project_uid}/task-group',
    ...options,
  });

/**
 * Get Review Project Task Group
 *
 * Get a task group of a review project including its task rows.
 *
 * Args:
 * project_uid: The unique identifier of the review project
 * task_group_uid: The unique identifier of the task group
 * current_user: The authenticated user making the request
 * postgresql_session: Database session
 *
 * Returns:
 * ReviewProjectTaskGroup: The task group with its tasks
 *
 * Raises:
 * NotFoundError: If the review project or task group does not exist, or the task
 * group belongs to another review project
 * UnauthorizedError: If user has no READ permission on the review project
 */
export const getReviewProjectTaskGroup = <ThrowOnError extends boolean = false>(
  options: Options<GetReviewProjectTaskGroupData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetReviewProjectTaskGroupResponses,
    GetReviewProjectTaskGroupErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/review/project/{project_uid}/task-group/{task_group_uid}',
    ...options,
  });

/**
 * Create Review
 *
 * Create a review, resolving its prompt columns and filing it on the board.
 */
export const createReview = <ThrowOnError extends boolean = false>(
  options: Options<CreateReviewData, ThrowOnError>
) =>
  (options.client ?? client).post<CreateReviewResponses, CreateReviewErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/review',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Search Review
 *
 * Search reviews.
 *
 * SECURITY: the search is permission-filtered in ONE anchored statement, kanban-column
 * matching included, so there is no second arm for the predicate to miss (an unfiltered
 * column-name arm would let any organisation member surface every review). The statement
 * is ordered.
 */
export const searchReview = <ThrowOnError extends boolean = false>(
  options: Options<SearchReviewData, ThrowOnError>
) =>
  (options.client ?? client).post<SearchReviewResponses, SearchReviewErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/review/search',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get Review Cost
 *
 * Estimate the credit cost of running N files, from a collection or an existing review.
 */
export const getReviewCost = <ThrowOnError extends boolean = false>(
  options: Options<GetReviewCostData, ThrowOnError>
) =>
  (options.client ?? client).get<GetReviewCostResponses, GetReviewCostErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/review/cost',
    ...options,
  });

/**
 * Delete Review Uuid
 *
 * Delete a review.
 */
export const deleteReviewUuid = <ThrowOnError extends boolean = false>(
  options: Options<DeleteReviewUuidData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    DeleteReviewUuidResponses,
    DeleteReviewUuidErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/review/{review_uid}',
    ...options,
  });

/**
 * Get Review By Uid
 *
 * One review, with its extraction progress counts.
 */
export const getReviewByUid = <ThrowOnError extends boolean = false>(
  options: Options<GetReviewByUidData, ThrowOnError>
) =>
  (options.client ?? client).get<GetReviewByUidResponses, GetReviewByUidErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/review/{review_uid}',
    ...options,
  });

/**
 * Update Review
 *
 * Update a review.
 *
 * A full replacement (``ignore_unset=False``), so the route re-pins the board column and
 * position by hand — without that a PUT omitting ``kanban_state_uid`` would drop the
 * review off the board.
 */
export const updateReview = <ThrowOnError extends boolean = false>(
  options: Options<UpdateReviewData, ThrowOnError>
) =>
  (options.client ?? client).put<UpdateReviewResponses, UpdateReviewErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/review/{review_uid}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get Review Table By Uid
 *
 * A page of the review table: rows are documents, columns are prompt answers.
 */
export const getReviewTableByUid = <ThrowOnError extends boolean = false>(
  options: Options<GetReviewTableByUidData, ThrowOnError>
) =>
  (options.client ?? client).post<
    GetReviewTableByUidResponses,
    GetReviewTableByUidErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/review/{review_uid}/table',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get Review Csv Export
 *
 * The whole table as CSV.
 */
export const getReviewCsvExport = <ThrowOnError extends boolean = false>(
  options: Options<GetReviewCsvExportData, ThrowOnError>
) =>
  (options.client ?? client).post<
    GetReviewCsvExportResponses,
    GetReviewCsvExportErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/review/{review_uid}/csv',
    ...options,
  });

/**
 * Delete Prompt Column
 *
 * Remove a prompt column and every extraction that belonged to it. One transaction.
 */
export const deletePromptColumn = <ThrowOnError extends boolean = false>(
  options: Options<DeletePromptColumnData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    DeletePromptColumnResponses,
    DeletePromptColumnErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/review/{review_uid}/column',
    ...options,
  });

/**
 * Add Prompt Column
 *
 * Add a prompt column and enqueue an extraction for every document already in it.
 *
 * One transaction: the credits update, the column link, its JSONB snapshot and every new
 * extraction settle together, and the per-file tasks dispatch only afterwards (the worker
 * reads the rows on another connection).
 */
export const addPromptColumn = <ThrowOnError extends boolean = false>(
  options: Options<AddPromptColumnData, ThrowOnError>
) =>
  (options.client ?? client).post<AddPromptColumnResponses, AddPromptColumnErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/review/{review_uid}/column',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get Documents
 */
export const getDocuments = <ThrowOnError extends boolean = false>(
  options: Options<GetDocumentsData, ThrowOnError>
) =>
  (options.client ?? client).get<GetDocumentsResponses, GetDocumentsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/signing/{signing_request_uid}/documents',
    ...options,
  });

/**
 * Get Signed Documents
 */
export const getSignedDocuments = <ThrowOnError extends boolean = false>(
  options: Options<GetSignedDocumentsData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetSignedDocumentsResponses,
    GetSignedDocumentsErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/signing/{signing_request_uid}/signed-documents',
    ...options,
  });

/**
 * Add Documents
 */
export const addDocuments = <ThrowOnError extends boolean = false>(
  options: Options<AddDocumentsData, ThrowOnError>
) =>
  (options.client ?? client).post<AddDocumentsResponses, AddDocumentsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/signing/{signing_request_uid}/documents/add',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Delete Document
 *
 * Detach one document from a draft signing request; the vault file revision itself is kept.
 *
 * Signature fields pinned to the detached document are deleted with it.
 */
export const deleteDocument = <ThrowOnError extends boolean = false>(
  options: Options<DeleteDocumentData, ThrowOnError>
) =>
  (options.client ?? client).delete<DeleteDocumentResponses, DeleteDocumentErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/signing/{signing_request_uid}/documents/{vault_file_revision_uid}',
    ...options,
  });

/**
 * Get Combined Signed Document
 */
export const getCombinedSignedDocument = <ThrowOnError extends boolean = false>(
  options: Options<GetCombinedSignedDocumentData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetCombinedSignedDocumentResponses,
    GetCombinedSignedDocumentErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/signing/{signing_request_uid}/signed-documents/combined',
    ...options,
  });

/**
 * Get Fields
 */
export const getFields = <ThrowOnError extends boolean = false>(
  options: Options<GetFieldsData, ThrowOnError>
) =>
  (options.client ?? client).get<GetFieldsResponses, GetFieldsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/signing/{signing_request_uid}/participants/{participant_uid}/fields',
    ...options,
  });

/**
 * Create Field
 */
export const createField = <ThrowOnError extends boolean = false>(
  options: Options<CreateFieldData, ThrowOnError>
) =>
  (options.client ?? client).post<CreateFieldResponses, CreateFieldErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/signing/{signing_request_uid}/participants/{participant_uid}/fields/add',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Delete Field
 */
export const deleteField = <ThrowOnError extends boolean = false>(
  options: Options<DeleteFieldData, ThrowOnError>
) =>
  (options.client ?? client).delete<DeleteFieldResponses, DeleteFieldErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/signing/{signing_request_uid}/participants/{participant_uid}/fields/{signature_field_uid}',
    ...options,
  });

/**
 * Update Field
 */
export const updateField = <ThrowOnError extends boolean = false>(
  options: Options<UpdateFieldData, ThrowOnError>
) =>
  (options.client ?? client).put<UpdateFieldResponses, UpdateFieldErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/signing/{signing_request_uid}/participants/{participant_uid}/fields/{signature_field_uid}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get Participants
 */
export const getParticipants = <ThrowOnError extends boolean = false>(
  options: Options<GetParticipantsData, ThrowOnError>
) =>
  (options.client ?? client).get<GetParticipantsResponses, GetParticipantsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/signing/{signing_request_uid}/participants',
    ...options,
  });

/**
 * Add Participant
 */
export const addParticipant = <ThrowOnError extends boolean = false>(
  options: Options<AddParticipantData, ThrowOnError>
) =>
  (options.client ?? client).post<AddParticipantResponses, AddParticipantErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/signing/{signing_request_uid}/participants/add',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Delete Participant
 */
export const deleteParticipant = <ThrowOnError extends boolean = false>(
  options: Options<DeleteParticipantData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    DeleteParticipantResponses,
    DeleteParticipantErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/signing/{signing_request_uid}/participants/{participant_uid}',
    ...options,
  });

/**
 * Send Participant Reminder
 */
export const sendParticipantReminder = <ThrowOnError extends boolean = false>(
  options: Options<SendParticipantReminderData, ThrowOnError>
) =>
  (options.client ?? client).post<
    SendParticipantReminderResponses,
    SendParticipantReminderErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/signing/{signing_request_uid}/participants/{participant_uid}/send_reminder',
    ...options,
  });

/**
 * Create Signing Request
 */
export const createSigningRequest = <ThrowOnError extends boolean = false>(
  options: Options<CreateSigningRequestData, ThrowOnError>
) =>
  (options.client ?? client).post<
    CreateSigningRequestResponses,
    CreateSigningRequestErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/signing/create',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Delete Signing Request
 *
 * Discard a draft signing request outright, participants and document links included.
 *
 * Draft-only, so there is nothing to withdraw from the provider. Once a request has been activated
 * the way out is ``cancel`` (with the provider) or ``archived`` (to file it away), not deletion.
 */
export const deleteSigningRequest = <ThrowOnError extends boolean = false>(
  options: Options<DeleteSigningRequestData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    DeleteSigningRequestResponses,
    DeleteSigningRequestErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/signing/{signing_request_uid}',
    ...options,
  });

/**
 * Get Signing Request
 */
export const getSigningRequest = <ThrowOnError extends boolean = false>(
  options: Options<GetSigningRequestData, ThrowOnError>
) =>
  (options.client ?? client).get<GetSigningRequestResponses, GetSigningRequestErrors, ThrowOnError>(
    {
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/v1/app/signing/{signing_request_uid}',
      ...options,
    }
  );

/**
 * Update Signing Request
 */
export const updateSigningRequest = <ThrowOnError extends boolean = false>(
  options: Options<UpdateSigningRequestData, ThrowOnError>
) =>
  (options.client ?? client).put<
    UpdateSigningRequestResponses,
    UpdateSigningRequestErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/signing/{signing_request_uid}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Activate Signing Request
 *
 * Hand the request to the provider — dispatch only, NO database writes (pinned).
 */
export const activateSigningRequest = <ThrowOnError extends boolean = false>(
  options: Options<ActivateSigningRequestData, ThrowOnError>
) =>
  (options.client ?? client).post<
    ActivateSigningRequestResponses,
    ActivateSigningRequestErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/signing/{signing_request_uid}/activate',
    ...options,
  });

/**
 * Cancel Signing Request
 */
export const cancelSigningRequest = <ThrowOnError extends boolean = false>(
  options: Options<CancelSigningRequestData, ThrowOnError>
) =>
  (options.client ?? client).post<
    CancelSigningRequestResponses,
    CancelSigningRequestErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/signing/{signing_request_uid}/cancel',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Search Signing Request
 */
export const searchSigningRequest = <ThrowOnError extends boolean = false>(
  options: Options<SearchSigningRequestData, ThrowOnError>
) =>
  (options.client ?? client).post<
    SearchSigningRequestResponses,
    SearchSigningRequestErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/signing/search',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get Provider Signing Request Status
 */
export const getProviderSigningRequestStatus = <ThrowOnError extends boolean = false>(
  options: Options<GetProviderSigningRequestStatusData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetProviderSigningRequestStatusResponses,
    GetProviderSigningRequestStatusErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/signing/{signing_request_uid}/provider-status',
    ...options,
  });

/**
 * Get Signing Request Status History
 */
export const getSigningRequestStatusHistory = <ThrowOnError extends boolean = false>(
  options: Options<GetSigningRequestStatusHistoryData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetSigningRequestStatusHistoryResponses,
    GetSigningRequestStatusHistoryErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/signing/{signing_request_uid}/status-history',
    ...options,
  });

/**
 * Get Audit Trail
 */
export const getAuditTrail = <ThrowOnError extends boolean = false>(
  options: Options<GetAuditTrailData, ThrowOnError>
) =>
  (options.client ?? client).get<GetAuditTrailResponses, GetAuditTrailErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/signing/{signing_request_uid}/audit-trail',
    ...options,
  });

/**
 * Get Available Llm Providers
 */
export const getAvailableLlmProviders = <ThrowOnError extends boolean = false>(
  options?: Options<GetAvailableLlmProvidersData, ThrowOnError>
) =>
  (options?.client ?? client).get<GetAvailableLlmProvidersResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/technical/information/llm/available',
    ...options,
  });

/**
 * Get Available Ocr Providers
 */
export const getAvailableOcrProviders = <ThrowOnError extends boolean = false>(
  options?: Options<GetAvailableOcrProvidersData, ThrowOnError>
) =>
  (options?.client ?? client).get<GetAvailableOcrProvidersResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/technical/information/ocr/available',
    ...options,
  });

/**
 * Get Available Countries
 */
export const getAvailableCountries = <ThrowOnError extends boolean = false>(
  options?: Options<GetAvailableCountriesData, ThrowOnError>
) =>
  (options?.client ?? client).get<GetAvailableCountriesResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/technical/information/countries/available',
    ...options,
  });

/**
 * Get File Limits
 */
export const getFileLimits = <ThrowOnError extends boolean = false>(
  options: Options<GetFileLimitsData, ThrowOnError>
) =>
  (options.client ?? client).get<GetFileLimitsResponses, GetFileLimitsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/technical/information/signing/file-limits',
    ...options,
  });

/**
 * Get Signer Name Pattern
 */
export const getSignerNamePattern = <ThrowOnError extends boolean = false>(
  options?: Options<GetSignerNamePatternData, ThrowOnError>
) =>
  (options?.client ?? client).get<GetSignerNamePatternResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/technical/information/signing/name-pattern',
    ...options,
  });

/**
 * Email Intake
 *
 * Webhook endpoint for receiving email data.
 *
 * This endpoint processes incoming email data, extracts relevant information,
 * and stores it in the database as IntakeAgentLog.
 */
export const emailIntake = <ThrowOnError extends boolean = false>(
  options: Options<EmailIntakeData, ThrowOnError>
) =>
  (options.client ?? client).post<EmailIntakeResponses, EmailIntakeErrors, ThrowOnError>({
    url: '/v1/app/technical/webhooks/brevo/email-intake',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Create Agent Run
 *
 * API endpoint for triggering an agent workflow (usually triggered via email).
 *
 * This endpoint allows users to programmatically trigger an agent that has been set up
 * using the interface. The agent is automatically determined through authentication,
 * eliminating the need to specify which agent to use. This enables automation and
 * integration scenarios where you want to trigger agent processing workflows via API calls.
 *
 * ## Purpose
 * - **Agent Triggering**: Start an agent workflow programmatically via API
 * - **Email Alternative**: Provides API access to functionality normally triggered by email
 * - **Integration Support**: Enables automation and third-party system integration
 * - **Workflow Control**: Gives users direct control over when and how agents are triggered
 *
 * ## Process Flow
 * 1. **Agent Authentication**:
 * - Agent is automatically determined through the `VerifiedIntakeAgent` dependency
 * - Validates that the agent exists and allows API requests
 * - Verifies the agent's organization and permissions
 *
 * 2. **Intake Scheduling** (asynchronous):
 * - Creates the agent's daily intake directory and, when the agent has prompt collections,
 * the per-request Review
 * - Creates one file-intake task per provided URL; each task downloads and stores its file,
 * extracts ZIP archives, and dispatches preprocessing plus the per-file processing tasks
 * for the agent's enabled options (review classification, equity sections, CLM import,
 * playbooks)
 * - Per-file status and errors are tracked on the organisation agent tasks
 *
 * 3. **Response Generation**:
 * - **With Review**: Returns evaluation UID and evaluation URL for tracking
 * - **Without Review**: Returns success status but no evaluation details
 *
 * ## Key Requirements
 * - **Agent Setup**: The agent must be pre-configured in the interface
 * - **Authentication**: User must be authenticated and authorized to access the specific agent
 * - **API Permissions**: Agent must have `allow_api_requests` enabled
 * - **File URLs Required**: At least one valid file URL is mandatory
 *
 * ## Response Details
 * - **Success**: Always returns status and message
 * - **With Review**: Additional evaluation_uid and evaluation_url for tracking
 * - **Evaluation UID**: Unique identifier for the created evaluation (only if the agent has
 * prompt collections)
 * - **Evaluation URL**: Direct link to view the evaluation results
 *
 * ## Use Cases
 * - **API Integration**: Trigger agents from external systems or scripts
 * - **Automation**: Schedule agent processing at specific times
 * - **Bulk Processing**: Process multiple files through the same agent
 * - **Workflow Orchestration**: Coordinate agent triggers as part of larger workflows
 * - **Testing**: Test agent configurations without sending actual emails
 */
export const createAgentRun = <ThrowOnError extends boolean = false>(
  options: Options<CreateAgentRunData, ThrowOnError>
) =>
  (options.client ?? client).post<CreateAgentRunResponses, CreateAgentRunErrors, ThrowOnError>({
    url: '/v1/app/technical/webhooks/agent/create_agent_run',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Jira Intake
 *
 * Ingest one Jira event for the intake agent the token belongs to.
 */
export const jiraIntake = <ThrowOnError extends boolean = false>(
  options: Options<JiraIntakeData, ThrowOnError>
) =>
  (options.client ?? client).post<JiraIntakeResponses, JiraIntakeErrors, ThrowOnError>({
    url: '/v1/app/technical/webhooks/jira/{token}/intake',
    ...options,
  });

/**
 * Slack Events
 *
 * Record one @mention / DM for the workspace's organisation; the worker answers it.
 */
export const slackEvents = <ThrowOnError extends boolean = false>(
  options?: Options<SlackEventsData, ThrowOnError>
) =>
  (options?.client ?? client).post<SlackEventsResponses, unknown, ThrowOnError>({
    url: '/v1/app/technical/webhooks/slack/events',
    ...options,
  });

/**
 * Slack Commands
 *
 * Open the ``/insights-submit`` modal; an ephemeral text is the answer when it cannot be opened.
 */
export const slackCommands = <ThrowOnError extends boolean = false>(
  options?: Options<SlackCommandsData, ThrowOnError>
) =>
  (options?.client ?? client).post<SlackCommandsResponses, unknown, ThrowOnError>({
    url: '/v1/app/technical/webhooks/slack/commands',
    ...options,
  });

/**
 * Slack Interactions
 *
 * Serve the modal's agent search, and turn its submission into one scheduled intake log.
 */
export const slackInteractions = <ThrowOnError extends boolean = false>(
  options?: Options<SlackInteractionsData, ThrowOnError>
) =>
  (options?.client ?? client).post<SlackInteractionsResponses, unknown, ThrowOnError>({
    url: '/v1/app/technical/webhooks/slack/interactions',
    ...options,
  });

/**
 * Youtrust Webhook Intake
 *
 * Webhook endpoint for receiving Youtrust webhook events.
 */
export const youtrustWebhookIntake = <ThrowOnError extends boolean = false>(
  options?: Options<YoutrustWebhookIntakeData, ThrowOnError>
) =>
  (options?.client ?? client).post<YoutrustWebhookIntakeResponses, unknown, ThrowOnError>({
    url: '/v1/app/technical/webhooks/youtrust/intake',
    ...options,
  });

/**
 * Gaia Youtrust Webhook Intake
 *
 * Webhook endpoint for receiving Youtrust webhook events.
 */
export const gaiaYoutrustWebhookIntake = <ThrowOnError extends boolean = false>(
  options?: Options<GaiaYoutrustWebhookIntakeData, ThrowOnError>
) =>
  (options?.client ?? client).post<GaiaYoutrustWebhookIntakeResponses, unknown, ThrowOnError>({
    url: '/v1/app/technical/webhooks/gaia_youtrust/intake',
    ...options,
  });

/**
 * Create Websocket Ticket
 *
 * Mint a single-use ticket for ``/connect``, bound to the active organisation: the ID token
 * stays in the header, out of URLs.
 */
export const createWebsocketTicket = <ThrowOnError extends boolean = false>(
  options?: Options<CreateWebsocketTicketData, ThrowOnError>
) =>
  (options?.client ?? client).post<CreateWebsocketTicketResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/technical/websocket/ticket',
    ...options,
  });

/**
 * Expose Websocket Schemas
 */
export const exposeWebsocketSchemas = <ThrowOnError extends boolean = false>(
  options: Options<ExposeWebsocketSchemasData, ThrowOnError>
) =>
  (options.client ?? client).post<
    ExposeWebsocketSchemasResponses,
    ExposeWebsocketSchemasErrors,
    ThrowOnError
  >({
    url: '/v1/app/technical/websocket/schemas',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Expose Tool Confirmation Schemas
 */
export const exposeToolConfirmationSchemas = <ThrowOnError extends boolean = false>(
  options: Options<ExposeToolConfirmationSchemasData, ThrowOnError>
) =>
  (options.client ?? client).post<
    ExposeToolConfirmationSchemasResponses,
    ExposeToolConfirmationSchemasErrors,
    ThrowOnError
  >({
    url: '/v1/app/technical/websocket/tool-confirmation-schemas',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Expose User Question Schemas
 */
export const exposeUserQuestionSchemas = <ThrowOnError extends boolean = false>(
  options: Options<ExposeUserQuestionSchemasData, ThrowOnError>
) =>
  (options.client ?? client).post<
    ExposeUserQuestionSchemasResponses,
    ExposeUserQuestionSchemasErrors,
    ThrowOnError
  >({
    url: '/v1/app/technical/websocket/user-question-schemas',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Search Threads
 *
 * List all chat threads for the current user.
 */
export const searchThreads = <ThrowOnError extends boolean = false>(
  options: Options<SearchThreadsData, ThrowOnError>
) =>
  (options.client ?? client).post<SearchThreadsResponses, SearchThreadsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/chat/general/search',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Delete Thread
 *
 * Delete a chat thread and its checkpoint data.
 */
export const deleteThread = <ThrowOnError extends boolean = false>(
  options: Options<DeleteThreadData, ThrowOnError>
) =>
  (options.client ?? client).delete<DeleteThreadResponses, DeleteThreadErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/chat/general/{thread_uid}',
    ...options,
  });

/**
 * Get Thread By Id
 *
 * Get thread metadata and paginated message history.
 */
export const getThreadById = <ThrowOnError extends boolean = false>(
  options: Options<GetThreadByIdData, ThrowOnError>
) =>
  (options.client ?? client).get<GetThreadByIdResponses, GetThreadByIdErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/chat/general/{thread_uid}',
    ...options,
  });

/**
 * Update Thread
 *
 * Update a chat thread.
 */
export const updateThread = <ThrowOnError extends boolean = false>(
  options: Options<UpdateThreadData, ThrowOnError>
) =>
  (options.client ?? client).put<UpdateThreadResponses, UpdateThreadErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/chat/general/{thread_uid}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Search Threads
 *
 * List all chat threads for the current user.
 */
export const searchThreads2 = <ThrowOnError extends boolean = false>(
  options: Options<SearchThreads2Data, ThrowOnError>
) =>
  (options.client ?? client).post<SearchThreads2Responses, SearchThreads2Errors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/chat/templating/search',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Delete Thread
 *
 * Delete a chat thread and its checkpoint data.
 */
export const deleteThread2 = <ThrowOnError extends boolean = false>(
  options: Options<DeleteThread2Data, ThrowOnError>
) =>
  (options.client ?? client).delete<DeleteThread2Responses, DeleteThread2Errors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/chat/templating/{thread_uid}',
    ...options,
  });

/**
 * Get Thread By Id
 *
 * Get thread metadata and paginated message history.
 */
export const getThreadById2 = <ThrowOnError extends boolean = false>(
  options: Options<GetThreadById2Data, ThrowOnError>
) =>
  (options.client ?? client).get<GetThreadById2Responses, GetThreadById2Errors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/chat/templating/{thread_uid}',
    ...options,
  });

/**
 * Update Thread
 *
 * Update a chat thread.
 */
export const updateThread2 = <ThrowOnError extends boolean = false>(
  options: Options<UpdateThread2Data, ThrowOnError>
) =>
  (options.client ?? client).put<UpdateThread2Responses, UpdateThread2Errors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/chat/templating/{thread_uid}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Search Project Threads
 *
 * List the chat threads of a review project visible to the current user.
 */
export const searchProjectThreads = <ThrowOnError extends boolean = false>(
  options: Options<SearchProjectThreadsData, ThrowOnError>
) =>
  (options.client ?? client).post<
    SearchProjectThreadsResponses,
    SearchProjectThreadsErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/chat/review-project/search',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Delete Thread
 *
 * Delete a chat thread and its checkpoint data.
 */
export const deleteThread3 = <ThrowOnError extends boolean = false>(
  options: Options<DeleteThread3Data, ThrowOnError>
) =>
  (options.client ?? client).delete<DeleteThread3Responses, DeleteThread3Errors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/chat/review-project/{thread_uid}',
    ...options,
  });

/**
 * Get Thread By Id
 *
 * Get thread metadata and paginated message history.
 */
export const getThreadById3 = <ThrowOnError extends boolean = false>(
  options: Options<GetThreadById3Data, ThrowOnError>
) =>
  (options.client ?? client).get<GetThreadById3Responses, GetThreadById3Errors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/chat/review-project/{thread_uid}',
    ...options,
  });

/**
 * Update Thread
 *
 * Update a chat thread.
 */
export const updateThread3 = <ThrowOnError extends boolean = false>(
  options: Options<UpdateThread3Data, ThrowOnError>
) =>
  (options.client ?? client).put<UpdateThread3Responses, UpdateThread3Errors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/chat/review-project/{thread_uid}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Create Playbook
 *
 * Create a new playbook, optionally kicking off AI generation of its evaluations.
 *
 * A file-backed request generates from the vault file's current revision; a prompt-only request
 * generates from the prompt and additionally suggests extraction evaluations. A file with no
 * current revision is not an error: the playbook is created and simply left empty.
 */
export const createPlaybook = <ThrowOnError extends boolean = false>(
  options: Options<CreatePlaybookData, ThrowOnError>
) =>
  (options.client ?? client).post<CreatePlaybookResponses, CreatePlaybookErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/playbook/playbook/new',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Create Playbook From Template
 *
 * Create a playbook from a code-defined template; it is created complete and active.
 */
export const createPlaybookFromTemplate = <ThrowOnError extends boolean = false>(
  options: Options<CreatePlaybookFromTemplateData, ThrowOnError>
) =>
  (options.client ?? client).post<
    CreatePlaybookFromTemplateResponses,
    CreatePlaybookFromTemplateErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/playbook/playbook/new-from-template/{template_key}',
    ...options,
  });

/**
 * List Playbook Templates
 *
 * List the code-defined playbook templates available to create playbooks from.
 */
export const listPlaybookTemplates = <ThrowOnError extends boolean = false>(
  options?: Options<ListPlaybookTemplatesData, ThrowOnError>
) =>
  (options?.client ?? client).get<ListPlaybookTemplatesResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/playbook/playbook/templates',
    ...options,
  });

/**
 * Search Playbook
 *
 * Search for playbooks in the active organisation.
 */
export const searchPlaybook = <ThrowOnError extends boolean = false>(
  options: Options<SearchPlaybookData, ThrowOnError>
) =>
  (options.client ?? client).post<SearchPlaybookResponses, SearchPlaybookErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/playbook/playbook/search',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Delete Playbook
 *
 * Delete a playbook with its whole definition tree and its runs.
 *
 * Requires ADMIN where the update requires WRITE — the one place in the domain where the two
 * differ, and observable for a role that grants only ``can_use_playbooks``.
 */
export const deletePlaybook = <ThrowOnError extends boolean = false>(
  options: Options<DeletePlaybookData, ThrowOnError>
) =>
  (options.client ?? client).delete<DeletePlaybookResponses, DeletePlaybookErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/playbook/playbook/{playbook_uid}',
    ...options,
  });

/**
 * Get Playbook
 *
 * Get a single playbook.
 *
 * Two pinned quirks: a caller without ``can_use_playbooks`` gets **404** here (every other
 * capability gate answers 401), and a playbook of another organisation gets **401** (every other
 * read answers 404). Both are observable client behaviour and kept deliberately.
 */
export const getPlaybook = <ThrowOnError extends boolean = false>(
  options: Options<GetPlaybookData, ThrowOnError>
) =>
  (options.client ?? client).get<GetPlaybookResponses, GetPlaybookErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/playbook/playbook/{playbook_uid}',
    ...options,
  });

/**
 * Update Playbook
 *
 * Update an existing playbook.
 */
export const updatePlaybook = <ThrowOnError extends boolean = false>(
  options: Options<UpdatePlaybookData, ThrowOnError>
) =>
  (options.client ?? client).put<UpdatePlaybookResponses, UpdatePlaybookErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/playbook/playbook/{playbook_uid}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * List Playbook Clauses
 *
 * List all clauses attached to a playbook.
 */
export const listPlaybookClauses = <ThrowOnError extends boolean = false>(
  options: Options<ListPlaybookClausesData, ThrowOnError>
) =>
  (options.client ?? client).get<
    ListPlaybookClausesResponses,
    ListPlaybookClausesErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/playbook/playbook/{playbook_uid}/clauses',
    ...options,
  });

/**
 * Update Playbook Clause
 *
 * Update a clause attached to a playbook.
 *
 * The clause is a shared library entry, so the edit is visible to every playbook referencing it —
 * the playbook only scopes the authorization.
 */
export const updatePlaybookClause = <ThrowOnError extends boolean = false>(
  options: Options<UpdatePlaybookClauseData, ThrowOnError>
) =>
  (options.client ?? client).put<
    UpdatePlaybookClauseResponses,
    UpdatePlaybookClauseErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/playbook/playbook/{playbook_uid}/clause/{clause_uid}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * List Playbook Evaluations
 *
 * List a playbook's evaluations, each with its options.
 */
export const listPlaybookEvaluations = <ThrowOnError extends boolean = false>(
  options: Options<ListPlaybookEvaluationsData, ThrowOnError>
) =>
  (options.client ?? client).get<
    ListPlaybookEvaluationsResponses,
    ListPlaybookEvaluationsErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/playbook/playbook/{playbook_uid}/evaluations',
    ...options,
  });

/**
 * Create Playbook Evaluation
 *
 * Create an evaluation on a playbook.
 *
 * A clause-validation evaluation is seeded with its three tier options and their action buckets,
 * because a run grades against every tier and resolves a missing clause to one of them. The whole
 * tree is one transaction.
 */
export const createPlaybookEvaluation = <ThrowOnError extends boolean = false>(
  options: Options<CreatePlaybookEvaluationData, ThrowOnError>
) =>
  (options.client ?? client).post<
    CreatePlaybookEvaluationResponses,
    CreatePlaybookEvaluationErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/playbook/playbook/{playbook_uid}/evaluation',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Delete Playbook Evaluation
 *
 * Delete an evaluation, together with the branch actions that target it.
 */
export const deletePlaybookEvaluation = <ThrowOnError extends boolean = false>(
  options: Options<DeletePlaybookEvaluationData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    DeletePlaybookEvaluationResponses,
    DeletePlaybookEvaluationErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/playbook/playbook/evaluation/{evaluation_uid}',
    ...options,
  });

/**
 * Update Playbook Evaluation
 *
 * Update an evaluation's shared fields.
 */
export const updatePlaybookEvaluation = <ThrowOnError extends boolean = false>(
  options: Options<UpdatePlaybookEvaluationData, ThrowOnError>
) =>
  (options.client ?? client).put<
    UpdatePlaybookEvaluationResponses,
    UpdatePlaybookEvaluationErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/playbook/playbook/evaluation/{evaluation_uid}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * List Playbook Evaluation Groups
 *
 * List a playbook's evaluation groups, each with its triggers.
 */
export const listPlaybookEvaluationGroups = <ThrowOnError extends boolean = false>(
  options: Options<ListPlaybookEvaluationGroupsData, ThrowOnError>
) =>
  (options.client ?? client).get<
    ListPlaybookEvaluationGroupsResponses,
    ListPlaybookEvaluationGroupsErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/playbook/playbook/{playbook_uid}/evaluation-groups',
    ...options,
  });

/**
 * Create Playbook Evaluation Group
 *
 * Create an evaluation group on a playbook with the given member evaluations.
 *
 * The group row and its membership are one transaction now, not two commits.
 */
export const createPlaybookEvaluationGroup = <ThrowOnError extends boolean = false>(
  options: Options<CreatePlaybookEvaluationGroupData, ThrowOnError>
) =>
  (options.client ?? client).post<
    CreatePlaybookEvaluationGroupResponses,
    CreatePlaybookEvaluationGroupErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/playbook/playbook/{playbook_uid}/evaluation-group',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Remove Playbook Evaluation Group Evaluation
 *
 * Remove a single evaluation from the group; the evaluation itself is untouched.
 *
 * Removing an evaluation that is not a member is a no-op. The group's trigger scores whichever
 * members remain, so dropping one narrows what it counts rather than breaking it — note that it can
 * leave an ``at_least`` trigger whose ``min_count`` now exceeds the membership, and so can never
 * fire. That is deliberate: re-validating here would block a legitimate membership edit.
 */
export const removePlaybookEvaluationGroupEvaluation = <ThrowOnError extends boolean = false>(
  options: Options<RemovePlaybookEvaluationGroupEvaluationData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    RemovePlaybookEvaluationGroupEvaluationResponses,
    RemovePlaybookEvaluationGroupEvaluationErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/playbook/playbook/evaluation-group/{group_uid}/evaluation/{evaluation_uid}',
    ...options,
  });

/**
 * Add Playbook Evaluation Group Evaluation
 *
 * Add a single evaluation of the group's playbook to the group.
 *
 * Adding an evaluation that already is a member is a no-op. Only the groupable evaluation types
 * are accepted, as on create.
 */
export const addPlaybookEvaluationGroupEvaluation = <ThrowOnError extends boolean = false>(
  options: Options<AddPlaybookEvaluationGroupEvaluationData, ThrowOnError>
) =>
  (options.client ?? client).post<
    AddPlaybookEvaluationGroupEvaluationResponses,
    AddPlaybookEvaluationGroupEvaluationErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/playbook/playbook/evaluation-group/{group_uid}/evaluation/{evaluation_uid}',
    ...options,
  });

/**
 * Delete Playbook Evaluation Group
 *
 * Delete an evaluation group with its triggers; member evaluations are untouched.
 */
export const deletePlaybookEvaluationGroup = <ThrowOnError extends boolean = false>(
  options: Options<DeletePlaybookEvaluationGroupData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    DeletePlaybookEvaluationGroupResponses,
    DeletePlaybookEvaluationGroupErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/playbook/playbook/evaluation-group/{group_uid}',
    ...options,
  });

/**
 * Update Playbook Evaluation Group
 *
 * Update an evaluation group's name and/or membership — one transaction, not two commits.
 *
 * An omitted ``evaluation_uids`` leaves the membership alone; an explicit empty list clears it.
 */
export const updatePlaybookEvaluationGroup = <ThrowOnError extends boolean = false>(
  options: Options<UpdatePlaybookEvaluationGroupData, ThrowOnError>
) =>
  (options.client ?? client).put<
    UpdatePlaybookEvaluationGroupResponses,
    UpdatePlaybookEvaluationGroupErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/playbook/playbook/evaluation-group/{group_uid}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Delete Playbook Group Triggers
 *
 * Delete an evaluation group's triggers; the group and its member evaluations are untouched.
 *
 * Clearing them frees the group to take a new trigger again. A group with no triggers is a no-op. To
 * delete one trigger by uid instead, use ``DELETE /playbook/trigger/{trigger_uid}``.
 */
export const deletePlaybookGroupTriggers = <ThrowOnError extends boolean = false>(
  options: Options<DeletePlaybookGroupTriggersData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    DeletePlaybookGroupTriggersResponses,
    DeletePlaybookGroupTriggersErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/playbook/playbook/evaluation-group/{group_uid}/triggers',
    ...options,
  });

/**
 * List Playbook Group Triggers
 *
 * List an evaluation group's triggers, each with its threshold and actions.
 */
export const listPlaybookGroupTriggers = <ThrowOnError extends boolean = false>(
  options: Options<ListPlaybookGroupTriggersData, ThrowOnError>
) =>
  (options.client ?? client).get<
    ListPlaybookGroupTriggersResponses,
    ListPlaybookGroupTriggersErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/playbook/playbook/evaluation-group/{group_uid}/triggers',
    ...options,
  });

/**
 * Create Playbook Group Trigger
 *
 * Create a group trigger: a risk-level threshold over the group's member evaluations.
 *
 * A member *hits* when its latest result reached ``min_risk_level`` — any matched option at/above it,
 * or any uncommons finding at/above it. ``at_least`` fires when at least ``min_count`` members hit
 * ("every member" is ``min_count == member count``); ``less_than`` fires when fewer than
 * ``min_count`` do; ``none_found`` fires when none do; ``always`` fires unconditionally, and is the
 * one mode that still fires for a group with no members.
 *
 * A group carries at most one trigger, so this conflicts once the group has one — edit that one via
 * ``PUT /playbook/group-trigger/{trigger_uid}`` instead. Attach actions to the returned trigger via
 * ``POST /playbook/trigger/{trigger_uid}/action`` — every type but suggestion, which is rejected on
 * group triggers for now.
 */
export const createPlaybookGroupTrigger = <ThrowOnError extends boolean = false>(
  options: Options<CreatePlaybookGroupTriggerData, ThrowOnError>
) =>
  (options.client ?? client).post<
    CreatePlaybookGroupTriggerResponses,
    CreatePlaybookGroupTriggerErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/playbook/playbook/evaluation-group/{group_uid}/trigger',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Update Playbook Group Trigger
 *
 * Update a group trigger's threshold; omitted fields are left unchanged.
 *
 * The group's membership is the scope, so there is nothing to rewire — only the rule changes.
 * Actions on the trigger are untouched.
 */
export const updatePlaybookGroupTrigger = <ThrowOnError extends boolean = false>(
  options: Options<UpdatePlaybookGroupTriggerData, ThrowOnError>
) =>
  (options.client ?? client).put<
    UpdatePlaybookGroupTriggerResponses,
    UpdatePlaybookGroupTriggerErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/playbook/playbook/group-trigger/{trigger_uid}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Create Playbook Option
 *
 * Create an option on an evaluation, together with its action bucket.
 *
 * Every option carries exactly one trigger — its action bucket — and the two are now one
 * transaction instead of two commits plus a refresh.
 */
export const createPlaybookOption = <ThrowOnError extends boolean = false>(
  options: Options<CreatePlaybookOptionData, ThrowOnError>
) =>
  (options.client ?? client).post<
    CreatePlaybookOptionResponses,
    CreatePlaybookOptionErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/playbook/playbook/evaluation/{evaluation_uid}/option',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Delete Playbook Option
 *
 * Delete an option; its trigger and that trigger's links go with it.
 */
export const deletePlaybookOption = <ThrowOnError extends boolean = false>(
  options: Options<DeletePlaybookOptionData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    DeletePlaybookOptionResponses,
    DeletePlaybookOptionErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/playbook/playbook/option/{option_uid}',
    ...options,
  });

/**
 * Update Playbook Option
 *
 * Update an option, optionally re-pointing a clause-validation option at another clause.
 *
 * The clause re-point and the field update land in one transaction. The validation runs *before*
 * anything is assigned, so a rejected re-point leaves none of the sibling field changes applied.
 */
export const updatePlaybookOption = <ThrowOnError extends boolean = false>(
  options: Options<UpdatePlaybookOptionData, ThrowOnError>
) =>
  (options.client ?? client).put<
    UpdatePlaybookOptionResponses,
    UpdatePlaybookOptionErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/playbook/playbook/option/{option_uid}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Create Playbook Trigger
 *
 * Create a trigger on an evaluation.
 *
 * Uncommons checks take a finding-threshold trigger over their findings. Clause-validation and
 * classification evaluations are option-based, so the trigger is an option trigger tied to the
 * option given by ``option_uid`` — returned as-is if that option already has one (every option
 * owns at most one trigger). Extraction evaluations have no triggers.
 */
export const createPlaybookTrigger = <ThrowOnError extends boolean = false>(
  options: Options<CreatePlaybookTriggerData, ThrowOnError>
) =>
  (options.client ?? client).post<
    CreatePlaybookTriggerResponses,
    CreatePlaybookTriggerErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/playbook/playbook/evaluation/{evaluation_uid}/trigger',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Create Playbook Trigger Action
 *
 * Create a typed action and attach it to a trigger — one transaction, not two commits.
 */
export const createPlaybookTriggerAction = <ThrowOnError extends boolean = false>(
  options: Options<CreatePlaybookTriggerActionData, ThrowOnError>
) =>
  (options.client ?? client).post<
    CreatePlaybookTriggerActionResponses,
    CreatePlaybookTriggerActionErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/playbook/playbook/trigger/{trigger_uid}/action',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Delete Playbook Trigger
 *
 * Delete a finding-threshold or group trigger (option triggers live and die with their option).
 */
export const deletePlaybookTrigger = <ThrowOnError extends boolean = false>(
  options: Options<DeletePlaybookTriggerData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    DeletePlaybookTriggerResponses,
    DeletePlaybookTriggerErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/playbook/playbook/trigger/{trigger_uid}',
    ...options,
  });

/**
 * Update Playbook Trigger
 *
 * Update a finding-threshold trigger's rule (option triggers carry no editable fields).
 */
export const updatePlaybookTrigger = <ThrowOnError extends boolean = false>(
  options: Options<UpdatePlaybookTriggerData, ThrowOnError>
) =>
  (options.client ?? client).put<
    UpdatePlaybookTriggerResponses,
    UpdatePlaybookTriggerErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/playbook/playbook/trigger/{trigger_uid}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * List Playbook Actions
 *
 * List a playbook's reusable actions; optionally content-deduplicated.
 *
 * Evaluation branches are excluded — they are graph edges, not reusable steps.
 */
export const listPlaybookActions = <ThrowOnError extends boolean = false>(
  options: Options<ListPlaybookActionsData, ThrowOnError>
) =>
  (options.client ?? client).get<
    ListPlaybookActionsResponses,
    ListPlaybookActionsErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/playbook/playbook/{playbook_uid}/actions',
    ...options,
  });

/**
 * Delete Playbook Action
 *
 * Delete an action.
 */
export const deletePlaybookAction = <ThrowOnError extends boolean = false>(
  options: Options<DeletePlaybookActionData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    DeletePlaybookActionResponses,
    DeletePlaybookActionErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/playbook/playbook/action/{action_uid}',
    ...options,
  });

/**
 * Update Playbook Action
 *
 * Update an action's fields; omitted fields are left unchanged.
 */
export const updatePlaybookAction = <ThrowOnError extends boolean = false>(
  options: Options<UpdatePlaybookActionData, ThrowOnError>
) =>
  (options.client ?? client).put<
    UpdatePlaybookActionResponses,
    UpdatePlaybookActionErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/playbook/playbook/action/{action_uid}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Start Playbook Run
 *
 * Start a run of a playbook against a single input (a file revision or raw text).
 *
 * The run may optionally be attached to a review project. If that project disallows duplicate runs
 * and the input revision already has a run of this playbook attached to the project, no new run is
 * started and the existing run is returned instead.
 */
export const startPlaybookRun = <ThrowOnError extends boolean = false>(
  options: Options<StartPlaybookRunData, ThrowOnError>
) =>
  (options.client ?? client).post<StartPlaybookRunResponses, StartPlaybookRunErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/playbook/playbook/{playbook_uid}/run',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Search Playbook Runs
 *
 * Search playbook runs in the active organisation, optionally scoped to one playbook.
 *
 * Every row carries its full executed tree: the table renders a column per evaluation and action
 * so results can be compared across runs, not just their metadata.
 */
export const searchPlaybookRuns = <ThrowOnError extends boolean = false>(
  options: Options<SearchPlaybookRunsData, ThrowOnError>
) =>
  (options.client ?? client).post<
    SearchPlaybookRunsResponses,
    SearchPlaybookRunsErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/playbook/playbook/run/search',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Delete Playbook Run
 *
 * Delete a playbook run.
 */
export const deletePlaybookRun = <ThrowOnError extends boolean = false>(
  options: Options<DeletePlaybookRunData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    DeletePlaybookRunResponses,
    DeletePlaybookRunErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/playbook/playbook/run/{run_uid}',
    ...options,
  });

/**
 * Get Playbook Run
 *
 * Get a single run with its full executed tree of evaluation and action results.
 */
export const getPlaybookRun = <ThrowOnError extends boolean = false>(
  options: Options<GetPlaybookRunData, ThrowOnError>
) =>
  (options.client ?? client).get<GetPlaybookRunResponses, GetPlaybookRunErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/playbook/playbook/run/{run_uid}',
    ...options,
  });

/**
 * Export Playbook Run Summary
 *
 * Download the run's summary as a markdown or PDF file.
 */
export const exportPlaybookRunSummary = <ThrowOnError extends boolean = false>(
  options: Options<ExportPlaybookRunSummaryData, ThrowOnError>
) =>
  (options.client ?? client).get<
    ExportPlaybookRunSummaryResponses,
    ExportPlaybookRunSummaryErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/playbook/playbook/run/{run_uid}/summary/export',
    ...options,
  });

/**
 * Export Playbook Run Evaluations
 *
 * Download the run's evaluation results as one spreadsheet, optionally narrowed to a selection.
 *
 * One row per evaluation, fanned out to one row per finding for the evaluations that produce them.
 */
export const exportPlaybookRunEvaluations = <ThrowOnError extends boolean = false>(
  options: Options<ExportPlaybookRunEvaluationsData, ThrowOnError>
) =>
  (options.client ?? client).post<
    ExportPlaybookRunEvaluationsResponses,
    ExportPlaybookRunEvaluationsErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/app/playbook/playbook/run/{run_uid}/evaluations/export',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Create Agent Run
 *
 * API endpoint for triggering an agent workflow (usually triggered via email).
 *
 * This endpoint allows users to programmatically trigger an agent that has been set up
 * using the interface. The agent is automatically determined through authentication,
 * eliminating the need to specify which agent to use. This enables automation and
 * integration scenarios where you want to trigger agent processing workflows via API calls.
 *
 * ## Purpose
 * - **Agent Triggering**: Start an agent workflow programmatically via API
 * - **Email Alternative**: Provides API access to functionality normally triggered by email
 * - **Integration Support**: Enables automation and third-party system integration
 * - **Workflow Control**: Gives users direct control over when and how agents are triggered
 *
 * ## Process Flow
 * 1. **Agent Authentication**:
 * - Agent is automatically determined through the `VerifiedIntakeAgent` dependency
 * - Validates that the agent exists and allows API requests
 * - Verifies the agent's organization and permissions
 *
 * 2. **Intake Scheduling** (asynchronous):
 * - Creates the agent's daily intake directory and, when the agent has prompt collections,
 * the per-request Review
 * - Creates one file-intake task per provided URL; each task downloads and stores its file,
 * extracts ZIP archives, and dispatches preprocessing plus the per-file processing tasks
 * for the agent's enabled options (review classification, equity sections, CLM import,
 * playbooks)
 * - Per-file status and errors are tracked on the organisation agent tasks
 *
 * 3. **Response Generation**:
 * - **With Review**: Returns evaluation UID and evaluation URL for tracking
 * - **Without Review**: Returns success status but no evaluation details
 *
 * ## Key Requirements
 * - **Agent Setup**: The agent must be pre-configured in the interface
 * - **Authentication**: User must be authenticated and authorized to access the specific agent
 * - **API Permissions**: Agent must have `allow_api_requests` enabled
 * - **File URLs Required**: At least one valid file URL is mandatory
 *
 * ## Response Details
 * - **Success**: Always returns status and message
 * - **With Review**: Additional evaluation_uid and evaluation_url for tracking
 * - **Evaluation UID**: Unique identifier for the created evaluation (only if the agent has
 * prompt collections)
 * - **Evaluation URL**: Direct link to view the evaluation results
 *
 * ## Use Cases
 * - **API Integration**: Trigger agents from external systems or scripts
 * - **Automation**: Schedule agent processing at specific times
 * - **Bulk Processing**: Process multiple files through the same agent
 * - **Workflow Orchestration**: Coordinate agent triggers as part of larger workflows
 * - **Testing**: Test agent configurations without sending actual emails
 */
export const createAgentRun2 = <ThrowOnError extends boolean = false>(
  options: Options<CreateAgentRun2Data, ThrowOnError>
) =>
  (options.client ?? client).post<CreateAgentRun2Responses, CreateAgentRun2Errors, ThrowOnError>({
    url: '/agent/create_agent_run',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
